function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecf77"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecf77"] = parcelRequire;
}
parcelRequire.register("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRequire.register("e94ba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c525d7dbc25949$export$2e2bcd8739ae039; });

var $cthCm = parcelRequire("cthCm");
var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cthCm.default)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRequire.register("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("3vQgY", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("2sgnw")).then(()=>parcelRequire("4ZFd2"));

});

parcelRequire.register("kIFeU", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f157e7fccaf0ddb3$export$ffb0004e005737fa; }, function (v) { return $f157e7fccaf0ddb3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f157e7fccaf0ddb3$export$5f8d39834fd61797; }, function (v) { return $f157e7fccaf0ddb3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $f157e7fccaf0ddb3$export$e2c29f18771995cb; }, function (v) { return $f157e7fccaf0ddb3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $f157e7fccaf0ddb3$export$74bf444e3cd11ea5; }, function (v) { return $f157e7fccaf0ddb3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $f157e7fccaf0ddb3$export$dca3b0875bd9a954; }, function (v) { return $f157e7fccaf0ddb3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f157e7fccaf0ddb3$export$16fa2f45be04daa8; }, function (v) { return $f157e7fccaf0ddb3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f157e7fccaf0ddb3$export$221d75b3f55bb0bd; }, function (v) { return $f157e7fccaf0ddb3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f157e7fccaf0ddb3$export$ae55be85d98224ed; }, function (v) { return $f157e7fccaf0ddb3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f157e7fccaf0ddb3$export$e530037191fcd5d7; }, function (v) { return $f157e7fccaf0ddb3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f157e7fccaf0ddb3$export$fd42f52fd3ae1109; }, function (v) { return $f157e7fccaf0ddb3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f157e7fccaf0ddb3$export$c8a8987d4410bf2d; }, function (v) { return $f157e7fccaf0ddb3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f157e7fccaf0ddb3$export$d38cd72104c1f0e9; }, function (v) { return $f157e7fccaf0ddb3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f157e7fccaf0ddb3$export$7d1e3a5e95ceca43; }, function (v) { return $f157e7fccaf0ddb3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f157e7fccaf0ddb3$export$257a8862b851cb5b; }, function (v) { return $f157e7fccaf0ddb3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f157e7fccaf0ddb3$export$a8257692ac88316c; }, function (v) { return $f157e7fccaf0ddb3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f157e7fccaf0ddb3$export$488013bae63b21da; }, function (v) { return $f157e7fccaf0ddb3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f157e7fccaf0ddb3$export$7c73462e0d25e514; }, function (v) { return $f157e7fccaf0ddb3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f157e7fccaf0ddb3$export$35808ee640e87ca7; }, function (v) { return $f157e7fccaf0ddb3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f157e7fccaf0ddb3$export$fae74005e78b1a27; }, function (v) { return $f157e7fccaf0ddb3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f157e7fccaf0ddb3$export$dc8fbce3eb94dc1e; }, function (v) { return $f157e7fccaf0ddb3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $f157e7fccaf0ddb3$export$6d9c69b0de29b591; }, function (v) { return $f157e7fccaf0ddb3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f157e7fccaf0ddb3$export$d5a552a76deda3c2; }, function (v) { return $f157e7fccaf0ddb3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f157e7fccaf0ddb3$export$e5c5a5f917a5871c; }, function (v) { return $f157e7fccaf0ddb3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f157e7fccaf0ddb3$export$1538c33de8887b59; }, function (v) { return $f157e7fccaf0ddb3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f157e7fccaf0ddb3$export$13e3392192263954; }, function (v) { return $f157e7fccaf0ddb3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f157e7fccaf0ddb3$export$b8f5890fc79d6aca; }, function (v) { return $f157e7fccaf0ddb3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f157e7fccaf0ddb3$export$60241385465d0a34; }, function (v) { return $f157e7fccaf0ddb3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $f157e7fccaf0ddb3$export$83d89fbfd8236492; }, function (v) { return $f157e7fccaf0ddb3$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f157e7fccaf0ddb3$export$ffb0004e005737fa;
var $f157e7fccaf0ddb3$export$5f8d39834fd61797;
var $f157e7fccaf0ddb3$export$e2c29f18771995cb;
var $f157e7fccaf0ddb3$export$74bf444e3cd11ea5;
var $f157e7fccaf0ddb3$export$dca3b0875bd9a954;
var $f157e7fccaf0ddb3$export$16fa2f45be04daa8;
var $f157e7fccaf0ddb3$export$221d75b3f55bb0bd;
var $f157e7fccaf0ddb3$export$ae55be85d98224ed;
var $f157e7fccaf0ddb3$export$e530037191fcd5d7;
var $f157e7fccaf0ddb3$export$fd42f52fd3ae1109;
var $f157e7fccaf0ddb3$export$c8a8987d4410bf2d;
var $f157e7fccaf0ddb3$export$d38cd72104c1f0e9;
var $f157e7fccaf0ddb3$export$7d1e3a5e95ceca43;
var $f157e7fccaf0ddb3$export$257a8862b851cb5b;
var $f157e7fccaf0ddb3$export$a8257692ac88316c;
var $f157e7fccaf0ddb3$export$488013bae63b21da;
var $f157e7fccaf0ddb3$export$7c73462e0d25e514;
var $f157e7fccaf0ddb3$export$35808ee640e87ca7;
var $f157e7fccaf0ddb3$export$fae74005e78b1a27;
var $f157e7fccaf0ddb3$export$dc8fbce3eb94dc1e;
var $f157e7fccaf0ddb3$export$6d9c69b0de29b591;
var $f157e7fccaf0ddb3$export$d5a552a76deda3c2;
var $f157e7fccaf0ddb3$export$e5c5a5f917a5871c;
var $f157e7fccaf0ddb3$export$1538c33de8887b59;
var $f157e7fccaf0ddb3$export$13e3392192263954;
var $f157e7fccaf0ddb3$export$b8f5890fc79d6aca;
var $f157e7fccaf0ddb3$export$60241385465d0a34;
var $f157e7fccaf0ddb3$export$83d89fbfd8236492;
"use strict";

var $5LEvs = parcelRequire("5LEvs");
var $f157e7fccaf0ddb3$var$n = 60103, $f157e7fccaf0ddb3$var$p = 60106;
$f157e7fccaf0ddb3$export$ffb0004e005737fa = 60107;
$f157e7fccaf0ddb3$export$5f8d39834fd61797 = 60108;
$f157e7fccaf0ddb3$export$e2c29f18771995cb = 60114;
var $f157e7fccaf0ddb3$var$q = 60109, $f157e7fccaf0ddb3$var$r = 60110, $f157e7fccaf0ddb3$var$t = 60112;
$f157e7fccaf0ddb3$export$74bf444e3cd11ea5 = 60113;
var $f157e7fccaf0ddb3$var$u = 60115, $f157e7fccaf0ddb3$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $f157e7fccaf0ddb3$var$w = Symbol.for;
    $f157e7fccaf0ddb3$var$n = $f157e7fccaf0ddb3$var$w("react.element");
    $f157e7fccaf0ddb3$var$p = $f157e7fccaf0ddb3$var$w("react.portal");
    $f157e7fccaf0ddb3$export$ffb0004e005737fa = $f157e7fccaf0ddb3$var$w("react.fragment");
    $f157e7fccaf0ddb3$export$5f8d39834fd61797 = $f157e7fccaf0ddb3$var$w("react.strict_mode");
    $f157e7fccaf0ddb3$export$e2c29f18771995cb = $f157e7fccaf0ddb3$var$w("react.profiler");
    $f157e7fccaf0ddb3$var$q = $f157e7fccaf0ddb3$var$w("react.provider");
    $f157e7fccaf0ddb3$var$r = $f157e7fccaf0ddb3$var$w("react.context");
    $f157e7fccaf0ddb3$var$t = $f157e7fccaf0ddb3$var$w("react.forward_ref");
    $f157e7fccaf0ddb3$export$74bf444e3cd11ea5 = $f157e7fccaf0ddb3$var$w("react.suspense");
    $f157e7fccaf0ddb3$var$u = $f157e7fccaf0ddb3$var$w("react.memo");
    $f157e7fccaf0ddb3$var$v = $f157e7fccaf0ddb3$var$w("react.lazy");
}
var $f157e7fccaf0ddb3$var$x = "function" === typeof Symbol && Symbol.iterator;
function $f157e7fccaf0ddb3$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f157e7fccaf0ddb3$var$x && a[$f157e7fccaf0ddb3$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $f157e7fccaf0ddb3$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f157e7fccaf0ddb3$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f157e7fccaf0ddb3$var$B = {};
function $f157e7fccaf0ddb3$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $f157e7fccaf0ddb3$var$B;
    this.updater = c || $f157e7fccaf0ddb3$var$A;
}
$f157e7fccaf0ddb3$var$C.prototype.isReactComponent = {};
$f157e7fccaf0ddb3$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($f157e7fccaf0ddb3$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f157e7fccaf0ddb3$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f157e7fccaf0ddb3$var$D() {}
$f157e7fccaf0ddb3$var$D.prototype = $f157e7fccaf0ddb3$var$C.prototype;
function $f157e7fccaf0ddb3$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $f157e7fccaf0ddb3$var$B;
    this.updater = c || $f157e7fccaf0ddb3$var$A;
}
var $f157e7fccaf0ddb3$var$F = $f157e7fccaf0ddb3$var$E.prototype = new $f157e7fccaf0ddb3$var$D;
$f157e7fccaf0ddb3$var$F.constructor = $f157e7fccaf0ddb3$var$E;
$5LEvs($f157e7fccaf0ddb3$var$F, $f157e7fccaf0ddb3$var$C.prototype);
$f157e7fccaf0ddb3$var$F.isPureReactComponent = !0;
var $f157e7fccaf0ddb3$var$G = {
    current: null
}, $f157e7fccaf0ddb3$var$H = Object.prototype.hasOwnProperty, $f157e7fccaf0ddb3$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f157e7fccaf0ddb3$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f157e7fccaf0ddb3$var$H.call(b, e) && !$f157e7fccaf0ddb3$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $f157e7fccaf0ddb3$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $f157e7fccaf0ddb3$var$G.current
    };
}
function $f157e7fccaf0ddb3$var$K(a, b) {
    return {
        $$typeof: $f157e7fccaf0ddb3$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f157e7fccaf0ddb3$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f157e7fccaf0ddb3$var$n;
}
function $f157e7fccaf0ddb3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f157e7fccaf0ddb3$var$M = /\/+/g;
function $f157e7fccaf0ddb3$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f157e7fccaf0ddb3$var$escape("" + a.key) : b.toString(36);
}
function $f157e7fccaf0ddb3$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f157e7fccaf0ddb3$var$n:
                case $f157e7fccaf0ddb3$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $f157e7fccaf0ddb3$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($f157e7fccaf0ddb3$var$M, "$&/") + "/"), $f157e7fccaf0ddb3$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($f157e7fccaf0ddb3$var$L(d) && (d = $f157e7fccaf0ddb3$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($f157e7fccaf0ddb3$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $f157e7fccaf0ddb3$var$N(k, g);
        h += $f157e7fccaf0ddb3$var$O(k, b, c, f, d);
    }
    else if (f = $f157e7fccaf0ddb3$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $f157e7fccaf0ddb3$var$N(k, g++), h += $f157e7fccaf0ddb3$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($f157e7fccaf0ddb3$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $f157e7fccaf0ddb3$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $f157e7fccaf0ddb3$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $f157e7fccaf0ddb3$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $f157e7fccaf0ddb3$var$R = {
    current: null
};
function $f157e7fccaf0ddb3$var$S() {
    var a = $f157e7fccaf0ddb3$var$R.current;
    if (null === a) throw Error($f157e7fccaf0ddb3$var$z(321));
    return a;
}
var $f157e7fccaf0ddb3$var$T = {
    ReactCurrentDispatcher: $f157e7fccaf0ddb3$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $f157e7fccaf0ddb3$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $5LEvs
};
$f157e7fccaf0ddb3$export$dca3b0875bd9a954 = {
    map: $f157e7fccaf0ddb3$var$P,
    forEach: function(a, b, c) {
        $f157e7fccaf0ddb3$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $f157e7fccaf0ddb3$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f157e7fccaf0ddb3$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f157e7fccaf0ddb3$var$L(a)) throw Error($f157e7fccaf0ddb3$var$z(143));
        return a;
    }
};
$f157e7fccaf0ddb3$export$16fa2f45be04daa8 = $f157e7fccaf0ddb3$var$C;
$f157e7fccaf0ddb3$export$221d75b3f55bb0bd = $f157e7fccaf0ddb3$var$E;
$f157e7fccaf0ddb3$export$ae55be85d98224ed = $f157e7fccaf0ddb3$var$T;
$f157e7fccaf0ddb3$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($f157e7fccaf0ddb3$var$z(267, a));
    var e = $5LEvs({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f157e7fccaf0ddb3$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f157e7fccaf0ddb3$var$H.call(b, f) && !$f157e7fccaf0ddb3$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $f157e7fccaf0ddb3$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$f157e7fccaf0ddb3$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $f157e7fccaf0ddb3$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $f157e7fccaf0ddb3$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$f157e7fccaf0ddb3$export$c8a8987d4410bf2d = $f157e7fccaf0ddb3$var$J;
$f157e7fccaf0ddb3$export$d38cd72104c1f0e9 = function(a) {
    var b = $f157e7fccaf0ddb3$var$J.bind(null, a);
    b.type = a;
    return b;
};
$f157e7fccaf0ddb3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f157e7fccaf0ddb3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f157e7fccaf0ddb3$var$t,
        render: a
    };
};
$f157e7fccaf0ddb3$export$a8257692ac88316c = $f157e7fccaf0ddb3$var$L;
$f157e7fccaf0ddb3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f157e7fccaf0ddb3$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f157e7fccaf0ddb3$var$Q
    };
};
$f157e7fccaf0ddb3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f157e7fccaf0ddb3$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f157e7fccaf0ddb3$export$35808ee640e87ca7 = function(a, b) {
    return $f157e7fccaf0ddb3$var$S().useCallback(a, b);
};
$f157e7fccaf0ddb3$export$fae74005e78b1a27 = function(a, b) {
    return $f157e7fccaf0ddb3$var$S().useContext(a, b);
};
$f157e7fccaf0ddb3$export$dc8fbce3eb94dc1e = function() {};
$f157e7fccaf0ddb3$export$6d9c69b0de29b591 = function(a, b) {
    return $f157e7fccaf0ddb3$var$S().useEffect(a, b);
};
$f157e7fccaf0ddb3$export$d5a552a76deda3c2 = function(a, b, c) {
    return $f157e7fccaf0ddb3$var$S().useImperativeHandle(a, b, c);
};
$f157e7fccaf0ddb3$export$e5c5a5f917a5871c = function(a, b) {
    return $f157e7fccaf0ddb3$var$S().useLayoutEffect(a, b);
};
$f157e7fccaf0ddb3$export$1538c33de8887b59 = function(a, b) {
    return $f157e7fccaf0ddb3$var$S().useMemo(a, b);
};
$f157e7fccaf0ddb3$export$13e3392192263954 = function(a, b, c) {
    return $f157e7fccaf0ddb3$var$S().useReducer(a, b, c);
};
$f157e7fccaf0ddb3$export$b8f5890fc79d6aca = function(a) {
    return $f157e7fccaf0ddb3$var$S().useRef(a);
};
$f157e7fccaf0ddb3$export$60241385465d0a34 = function(a) {
    return $f157e7fccaf0ddb3$var$S().useState(a);
};
$f157e7fccaf0ddb3$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("5LEvs", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $4330c3479a4da59d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4330c3479a4da59d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $4330c3479a4da59d$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $4330c3479a4da59d$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $4330c3479a4da59d$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $4330c3479a4da59d$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $4330c3479a4da59d$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($4330c3479a4da59d$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($4330c3479a4da59d$var$getOwnPropertySymbols) {
            symbols = $4330c3479a4da59d$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($4330c3479a4da59d$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRequire.register("7N52U", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $gwGOK = parcelRequire("gwGOK");
function $5ac10606822566b4$var$emptyFunction() {}
function $5ac10606822566b4$var$emptyFunctionWithReset() {}
$5ac10606822566b4$var$emptyFunctionWithReset.resetWarningCache = $5ac10606822566b4$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gwGOK) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $5ac10606822566b4$var$emptyFunctionWithReset,
        resetWarningCache: $5ac10606822566b4$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("gwGOK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c080d92a753fd8e6$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $c080d92a753fd8e6$var$ReactPropTypesSecret;

});


parcelRequire.register("55YFC", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $3b5c7b3dea5864d6$export$2b8d127b894957b9; }, function (v) { return $3b5c7b3dea5864d6$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $3b5c7b3dea5864d6$export$cea3a54a6425200c; }, function (v) { return $3b5c7b3dea5864d6$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $3b5c7b3dea5864d6$export$a7c73072b1a182ae; }, function (v) { return $3b5c7b3dea5864d6$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $3b5c7b3dea5864d6$export$9f27bc3417b4524d; }, function (v) { return $3b5c7b3dea5864d6$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $3b5c7b3dea5864d6$export$db77ccec0bb4ccac; }, function (v) { return $3b5c7b3dea5864d6$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $3b5c7b3dea5864d6$export$8392c0c9d3dcbd35; }, function (v) { return $3b5c7b3dea5864d6$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3b5c7b3dea5864d6$export$ffb0004e005737fa; }, function (v) { return $3b5c7b3dea5864d6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $3b5c7b3dea5864d6$export$b624eff549462981; }, function (v) { return $3b5c7b3dea5864d6$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $3b5c7b3dea5864d6$export$7897aa7841a5380c; }, function (v) { return $3b5c7b3dea5864d6$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $3b5c7b3dea5864d6$export$602eac185826482c; }, function (v) { return $3b5c7b3dea5864d6$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $3b5c7b3dea5864d6$export$e2c29f18771995cb; }, function (v) { return $3b5c7b3dea5864d6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3b5c7b3dea5864d6$export$5f8d39834fd61797; }, function (v) { return $3b5c7b3dea5864d6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3b5c7b3dea5864d6$export$74bf444e3cd11ea5; }, function (v) { return $3b5c7b3dea5864d6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $3b5c7b3dea5864d6$export$92387174baf9b227; }, function (v) { return $3b5c7b3dea5864d6$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $3b5c7b3dea5864d6$export$ec112efeb987d9c6; }, function (v) { return $3b5c7b3dea5864d6$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $3b5c7b3dea5864d6$export$b706b080d889d2c9; }, function (v) { return $3b5c7b3dea5864d6$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $3b5c7b3dea5864d6$export$5be5a87408f70ddc; }, function (v) { return $3b5c7b3dea5864d6$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $3b5c7b3dea5864d6$export$45a5e7f76e0caa8d; }, function (v) { return $3b5c7b3dea5864d6$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $3b5c7b3dea5864d6$export$455c2e768291efa6; }, function (v) { return $3b5c7b3dea5864d6$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $3b5c7b3dea5864d6$export$9522e17588c12572; }, function (v) { return $3b5c7b3dea5864d6$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $3b5c7b3dea5864d6$export$2110ac352bb060b9; }, function (v) { return $3b5c7b3dea5864d6$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $3b5c7b3dea5864d6$export$56885ab8b9c456ab; }, function (v) { return $3b5c7b3dea5864d6$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $3b5c7b3dea5864d6$export$d927fcb6adf8f9de; }, function (v) { return $3b5c7b3dea5864d6$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $3b5c7b3dea5864d6$export$b82d16f27459e05a; }, function (v) { return $3b5c7b3dea5864d6$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $3b5c7b3dea5864d6$export$522c17b4f5e123e8; }, function (v) { return $3b5c7b3dea5864d6$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $3b5c7b3dea5864d6$export$1aabd8a0274ecfd6; }, function (v) { return $3b5c7b3dea5864d6$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $3b5c7b3dea5864d6$export$9b621391a187a31a; }, function (v) { return $3b5c7b3dea5864d6$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $3b5c7b3dea5864d6$export$f5bbd400c2f4426f; }, function (v) { return $3b5c7b3dea5864d6$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3b5c7b3dea5864d6$export$2b8d127b894957b9;
var $3b5c7b3dea5864d6$export$cea3a54a6425200c;
var $3b5c7b3dea5864d6$export$a7c73072b1a182ae;
var $3b5c7b3dea5864d6$export$9f27bc3417b4524d;
var $3b5c7b3dea5864d6$export$db77ccec0bb4ccac;
var $3b5c7b3dea5864d6$export$8392c0c9d3dcbd35;
var $3b5c7b3dea5864d6$export$ffb0004e005737fa;
var $3b5c7b3dea5864d6$export$b624eff549462981;
var $3b5c7b3dea5864d6$export$7897aa7841a5380c;
var $3b5c7b3dea5864d6$export$602eac185826482c;
var $3b5c7b3dea5864d6$export$e2c29f18771995cb;
var $3b5c7b3dea5864d6$export$5f8d39834fd61797;
var $3b5c7b3dea5864d6$export$74bf444e3cd11ea5;
var $3b5c7b3dea5864d6$export$92387174baf9b227;
var $3b5c7b3dea5864d6$export$ec112efeb987d9c6;
var $3b5c7b3dea5864d6$export$b706b080d889d2c9;
var $3b5c7b3dea5864d6$export$5be5a87408f70ddc;
var $3b5c7b3dea5864d6$export$45a5e7f76e0caa8d;
var $3b5c7b3dea5864d6$export$455c2e768291efa6;
var $3b5c7b3dea5864d6$export$9522e17588c12572;
var $3b5c7b3dea5864d6$export$2110ac352bb060b9;
var $3b5c7b3dea5864d6$export$56885ab8b9c456ab;
var $3b5c7b3dea5864d6$export$d927fcb6adf8f9de;
var $3b5c7b3dea5864d6$export$b82d16f27459e05a;
var $3b5c7b3dea5864d6$export$522c17b4f5e123e8;
var $3b5c7b3dea5864d6$export$1aabd8a0274ecfd6;
var $3b5c7b3dea5864d6$export$9b621391a187a31a;
var $3b5c7b3dea5864d6$export$f5bbd400c2f4426f;
"use strict";
var $3b5c7b3dea5864d6$var$b = "function" === typeof Symbol && Symbol.for, $3b5c7b3dea5864d6$var$c = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.element") : 60103, $3b5c7b3dea5864d6$var$d = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.portal") : 60106, $3b5c7b3dea5864d6$var$e = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.fragment") : 60107, $3b5c7b3dea5864d6$var$f = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.strict_mode") : 60108, $3b5c7b3dea5864d6$var$g = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.profiler") : 60114, $3b5c7b3dea5864d6$var$h = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.provider") : 60109, $3b5c7b3dea5864d6$var$k = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.context") : 60110, $3b5c7b3dea5864d6$var$l = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.async_mode") : 60111, $3b5c7b3dea5864d6$var$m = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.concurrent_mode") : 60111, $3b5c7b3dea5864d6$var$n = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.forward_ref") : 60112, $3b5c7b3dea5864d6$var$p = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.suspense") : 60113, $3b5c7b3dea5864d6$var$q = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.suspense_list") : 60120, $3b5c7b3dea5864d6$var$r = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.memo") : 60115, $3b5c7b3dea5864d6$var$t = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.lazy") : 60116, $3b5c7b3dea5864d6$var$v = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.block") : 60121, $3b5c7b3dea5864d6$var$w = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.fundamental") : 60117, $3b5c7b3dea5864d6$var$x = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.responder") : 60118, $3b5c7b3dea5864d6$var$y = $3b5c7b3dea5864d6$var$b ? Symbol.for("react.scope") : 60119;
function $3b5c7b3dea5864d6$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $3b5c7b3dea5864d6$var$c:
                switch(a = a.type, a){
                    case $3b5c7b3dea5864d6$var$l:
                    case $3b5c7b3dea5864d6$var$m:
                    case $3b5c7b3dea5864d6$var$e:
                    case $3b5c7b3dea5864d6$var$g:
                    case $3b5c7b3dea5864d6$var$f:
                    case $3b5c7b3dea5864d6$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3b5c7b3dea5864d6$var$k:
                            case $3b5c7b3dea5864d6$var$n:
                            case $3b5c7b3dea5864d6$var$t:
                            case $3b5c7b3dea5864d6$var$r:
                            case $3b5c7b3dea5864d6$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $3b5c7b3dea5864d6$var$d:
                return u;
        }
    }
}
function $3b5c7b3dea5864d6$var$A(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$m;
}
$3b5c7b3dea5864d6$export$2b8d127b894957b9 = $3b5c7b3dea5864d6$var$l;
$3b5c7b3dea5864d6$export$cea3a54a6425200c = $3b5c7b3dea5864d6$var$m;
$3b5c7b3dea5864d6$export$a7c73072b1a182ae = $3b5c7b3dea5864d6$var$k;
$3b5c7b3dea5864d6$export$9f27bc3417b4524d = $3b5c7b3dea5864d6$var$h;
$3b5c7b3dea5864d6$export$db77ccec0bb4ccac = $3b5c7b3dea5864d6$var$c;
$3b5c7b3dea5864d6$export$8392c0c9d3dcbd35 = $3b5c7b3dea5864d6$var$n;
$3b5c7b3dea5864d6$export$ffb0004e005737fa = $3b5c7b3dea5864d6$var$e;
$3b5c7b3dea5864d6$export$b624eff549462981 = $3b5c7b3dea5864d6$var$t;
$3b5c7b3dea5864d6$export$7897aa7841a5380c = $3b5c7b3dea5864d6$var$r;
$3b5c7b3dea5864d6$export$602eac185826482c = $3b5c7b3dea5864d6$var$d;
$3b5c7b3dea5864d6$export$e2c29f18771995cb = $3b5c7b3dea5864d6$var$g;
$3b5c7b3dea5864d6$export$5f8d39834fd61797 = $3b5c7b3dea5864d6$var$f;
$3b5c7b3dea5864d6$export$74bf444e3cd11ea5 = $3b5c7b3dea5864d6$var$p;
$3b5c7b3dea5864d6$export$92387174baf9b227 = function(a) {
    return $3b5c7b3dea5864d6$var$A(a) || $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$l;
};
$3b5c7b3dea5864d6$export$ec112efeb987d9c6 = $3b5c7b3dea5864d6$var$A;
$3b5c7b3dea5864d6$export$b706b080d889d2c9 = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$k;
};
$3b5c7b3dea5864d6$export$5be5a87408f70ddc = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$h;
};
$3b5c7b3dea5864d6$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3b5c7b3dea5864d6$var$c;
};
$3b5c7b3dea5864d6$export$455c2e768291efa6 = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$n;
};
$3b5c7b3dea5864d6$export$9522e17588c12572 = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$e;
};
$3b5c7b3dea5864d6$export$2110ac352bb060b9 = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$t;
};
$3b5c7b3dea5864d6$export$56885ab8b9c456ab = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$r;
};
$3b5c7b3dea5864d6$export$d927fcb6adf8f9de = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$d;
};
$3b5c7b3dea5864d6$export$b82d16f27459e05a = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$g;
};
$3b5c7b3dea5864d6$export$522c17b4f5e123e8 = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$f;
};
$3b5c7b3dea5864d6$export$1aabd8a0274ecfd6 = function(a) {
    return $3b5c7b3dea5864d6$var$z(a) === $3b5c7b3dea5864d6$var$p;
};
$3b5c7b3dea5864d6$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3b5c7b3dea5864d6$var$e || a === $3b5c7b3dea5864d6$var$m || a === $3b5c7b3dea5864d6$var$g || a === $3b5c7b3dea5864d6$var$f || a === $3b5c7b3dea5864d6$var$p || a === $3b5c7b3dea5864d6$var$q || "object" === typeof a && null !== a && (a.$$typeof === $3b5c7b3dea5864d6$var$t || a.$$typeof === $3b5c7b3dea5864d6$var$r || a.$$typeof === $3b5c7b3dea5864d6$var$h || a.$$typeof === $3b5c7b3dea5864d6$var$k || a.$$typeof === $3b5c7b3dea5864d6$var$n || a.$$typeof === $3b5c7b3dea5864d6$var$w || a.$$typeof === $3b5c7b3dea5864d6$var$x || a.$$typeof === $3b5c7b3dea5864d6$var$y || a.$$typeof === $3b5c7b3dea5864d6$var$v);
};
$3b5c7b3dea5864d6$export$f5bbd400c2f4426f = $3b5c7b3dea5864d6$var$z;

});

var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;



parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
// Usage:
// import useKeydown from '../../hooks/use-keydown.hook'
// const handleEscape = React.useCallback(removeItems, []);
// useKeydown('Escape', handleEscape)

var $bh6RR = parcelRequire("bh6RR");
function $5062b72bd9e8c207$var$useKeydown(key, preventCondition, callback) {
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        function handleKeyDown(event) {
            if (event.code === key) {
                if (preventCondition) event.preventDefault();
                if (event.shiftKey) callback(event, true);
                else callback(event, false);
            }
        }
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        key,
        callback
    ]);
}
var $5062b72bd9e8c207$export$2e2bcd8739ae039 = $5062b72bd9e8c207$var$useKeydown;


const $fd5756bdc716f509$var$oldSequenceMap = {
    "big schroeder": [
        1,
        2,
        6,
        22,
        90,
        394,
        1806,
        8558,
        41586,
        206098,
        1037718,
        5293446,
        27297738
    ],
    catalan: [
        1,
        1,
        2,
        5,
        14,
        42,
        132,
        429,
        1430,
        4862,
        16796,
        58786,
        208012,
        742900,
        2674440,
        9694845,
        35357670,
        129644790,
        477638700
    ],
    "catalan sq": [
        1,
        2,
        5,
        14,
        42,
        132,
        429,
        1430,
        4862,
        16796,
        58786,
        208012,
        742900,
        2674440,
        9694845
    ],
    "catalan cubed": [
        1,
        3,
        9,
        28,
        90,
        297,
        1001,
        3432,
        11934,
        41990,
        149226,
        534888,
        1931540,
        7020405,
        25662825,
        94287120,
        347993910,
        1289624490,
        4796857230,
        17902146600,
        67016296620,
        251577050010,
        946844533674,
        3572042254128,
        13505406670700,
        51166197843852,
        194214400834356
    ],
    "central binomial": [
        1,
        2,
        6,
        20,
        70,
        252,
        924,
        3432,
        12870,
        48620,
        184756,
        705432,
        2704156
    ],
    "central trinomial": [
        1,
        1,
        3,
        7,
        19,
        51,
        141,
        393,
        1107,
        3139,
        8953,
        25653,
        73789,
        212941,
        616227,
        1787607,
        5196627
    ],
    "delannoy numbers": [
        1,
        3,
        13,
        63,
        321,
        1683,
        8989,
        48639,
        265729,
        1462563,
        8097453,
        45046719,
        251595969,
        1409933619,
        7923848253,
        44642381823,
        252055236609,
        1425834724419,
        8079317057869,
        45849429914943,
        260543813797441,
        1482376214227923,
        8443414161166173
    ],
    fibonacci: [
        1,
        1,
        2,
        3,
        5,
        8,
        13,
        21,
        34,
        55,
        89,
        144,
        233,
        377,
        610,
        987,
        1597,
        2584,
        4181,
        6765,
        10946,
        17711,
        28657,
        46368,
        75025,
        121393,
        196418,
        317811,
        514229
    ],
    "fine numbers": [
        1,
        0,
        1,
        2,
        6,
        18,
        57,
        186,
        622,
        2120,
        7338,
        25724,
        91144,
        325878,
        1174281,
        4260282
    ],
    "gamma riordan numbers": [
        1,
        0,
        1,
        1,
        3,
        6,
        15,
        36,
        91,
        232,
        603,
        1585,
        4213,
        11298,
        30537,
        83097,
        227475,
        625992,
        1730787,
        4805595
    ],
    geometric: [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    "geometric sq": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
    ],
    "hex numbers": [
        1,
        1,
        3,
        10,
        36,
        137,
        543,
        2219,
        9285,
        39587,
        171369,
        751236,
        3328218,
        14878455,
        67030785
    ],
    "little schroeder": [
        1,
        1,
        3,
        11,
        45,
        197,
        903,
        4279,
        20793,
        103049,
        518859,
        2646723
    ],
    "lucas numbers": [
        2,
        1,
        3,
        4,
        7,
        11,
        18,
        29,
        47,
        76,
        123,
        199,
        322,
        521,
        843,
        1364,
        2207,
        3571,
        5778,
        9349,
        15127,
        24476,
        39603,
        64079
    ],
    motzkin: [
        1,
        1,
        2,
        4,
        9,
        21,
        51,
        127,
        323,
        835,
        2188,
        5798,
        15511,
        41835,
        113634,
        310572,
        853467,
        2356779,
        6536382
    ],
    "motzkin-1": [
        1,
        1,
        1,
        2,
        4,
        9,
        21,
        51,
        127,
        323,
        835,
        2188,
        5798,
        15511,
        41835,
        113634,
        310572,
        853467,
        2356779,
        6536382
    ],
    "m tilde": [
        1,
        1,
        1,
        2,
        4,
        9,
        21,
        51,
        127,
        323,
        835,
        2188,
        5798,
        15511,
        41835,
        113634,
        310572,
        853467,
        2356779,
        6536382,
        18199284,
        50852019,
        142547559,
        400763223,
        1129760415,
        3192727797,
        9043402501,
        25669818476,
        73007772802,
        208023278209,
        593742784829,
        1697385471211,
        4859761676391,
        13933569346707
    ],
    ones: [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ],
    "pell p": [
        0,
        1,
        2,
        5,
        12,
        29,
        70,
        169,
        408,
        985,
        2378,
        5741,
        13860,
        33461,
        80782,
        195025,
        470832,
        1136689,
        2744210,
        6625109,
        15994428,
        38613965,
        93222358,
        225058681,
        543339720,
        1311738121,
        3166815962,
        7645370045,
        18457556052,
        44560482149,
        107578520350,
        259717522849
    ],
    "pell q": [
        1,
        1,
        3,
        7,
        17,
        41,
        99,
        239,
        577,
        1393,
        3363,
        8119,
        19601,
        47321,
        114243,
        275807,
        665857,
        1607521,
        3880899,
        9369319,
        22619537,
        54608393,
        131836323,
        318281039,
        768398401,
        1855077841,
        4478554083,
        10812186007,
        26102926097,
        63018038201,
        152139002499,
        367296043199
    ],
    "powers of two": [
        1,
        2,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512,
        1024,
        2048,
        4096,
        8192,
        16384,
        32768,
        65536,
        131072,
        262144,
        524288,
        1048576,
        2097152,
        4194304
    ],
    "r numbers": [
        1,
        0,
        1,
        1,
        3,
        6,
        15,
        36,
        91,
        232,
        603,
        1585,
        4213,
        11298,
        30537,
        83097,
        227475,
        625992,
        1730787,
        4805595
    ],
    RNA: [
        1,
        1,
        1,
        2,
        4,
        8,
        17,
        37,
        82,
        185,
        423,
        978,
        2283,
        5373,
        12735,
        30372,
        72832,
        175502,
        424748,
        1032004,
        2516347,
        6155441,
        15101701,
        37150472,
        91618049,
        226460893,
        560954047,
        1392251012,
        3461824644,
        8622571758,
        21511212261,
        53745962199,
        134474581374
    ],
    "spoiled child": [
        1,
        2,
        5,
        15,
        51,
        188,
        731,
        2950,
        12235,
        51822,
        223191,
        974427,
        4302645,
        19181100,
        86211885
    ],
    "ternary numbers": [
        1,
        1,
        3,
        12,
        55,
        273,
        1428,
        7752,
        43263,
        246675,
        1430715,
        8414640,
        50067108,
        300830572,
        1822766520,
        11124755664,
        68328754959,
        422030545335,
        2619631042665,
        16332922290300,
        102240109897695,
        642312451217745,
        4048514844039120
    ],
    "ternary squared": [
        1,
        2,
        7,
        30,
        143,
        728,
        3876,
        21318,
        120175,
        690690,
        4032015,
        23841480,
        142498692,
        859515920,
        5225264024,
        31983672534,
        196947587823,
        1219199353190,
        7583142491925,
        47365474641870,
        296983176369495,
        1868545312633440
    ],
    zeros: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]
};
const $fd5756bdc716f509$export$b3e558318ecb277d = Object.keys($fd5756bdc716f509$var$oldSequenceMap);
const $fd5756bdc716f509$export$98a7a12ae94b641 = $fd5756bdc716f509$export$b3e558318ecb277d.map((sequenceName, index)=>{
    const capitalized = sequenceName.split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    return {
        id: sequenceName.replace(" ", "-"),
        name: capitalized,
        sequence: $fd5756bdc716f509$var$oldSequenceMap[sequenceName]
    };
});




var $bh6RR = parcelRequire("bh6RR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $1c0814b68d3ed1c1$export$13470c6f1642bbce = "Logging";
const $1c0814b68d3ed1c1$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $1c0814b68d3ed1c1$export$86d53207c3c20049 = "NoHubcallbackProvidedException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $60ad4ba2ce2d6709$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})($60ad4ba2ce2d6709$export$a0472aa3a356446c || ($60ad4ba2ce2d6709$export$a0472aa3a356446c = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $39a0f4f2bf9492b0$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if ($39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.LOG_LEVEL) loggerLevelName = $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = $39a0f4f2bf9492b0$var$LOG_LEVELS[loggerLevelName];
        const typeLevel = $39a0f4f2bf9492b0$var$LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        if ($39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS) {
            if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).INFO && console.info) log = console.info.bind(console);
            if (type === (0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $60ad4ba2ce2d6709$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $1c0814b68d3ed1c1$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;
$39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS = false;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $d153492e067ac8ab$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message , name: name , recoverySuggestion: recoverySuggestion , underlyingError: underlyingError  }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $d153492e067ac8ab$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $d153492e067ac8ab$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9464725044e9d769$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $9464725044e9d769$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("Hub");
class $9464725044e9d769$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $9464725044e9d769$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback  })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $9464725044e9d769$export$aadf71dd9875dd20;
            if (!hasAccess) $9464725044e9d769$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $9464725044e9d769$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
            name: (0, $1c0814b68d3ed1c1$export$86d53207c3c20049),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel , payload: payload  } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $9464725044e9d769$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $9464725044e9d769$var$logger.error(e);
            }
        });
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const $9464725044e9d769$export$8c41bb232f1008b1 = new $9464725044e9d769$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $9464725044e9d769$export$45dde0743a4c8d6e = new $9464725044e9d769$export$6b38ef2be9abbbb9("internal-hub");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e13fb36a267dd892$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("parseAWSExports");
const $e13fb36a267dd892$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $e13fb36a267dd892$export$1ef2e9c2da492d = (config = {})=>{
    if (!Object.prototype.hasOwnProperty.call(config, "aws_project_region")) throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "InvalidParameterException",
        message: "Invalid config parameter.",
        recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey , aws_appsync_authenticationType: aws_appsync_authenticationType , aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint , aws_appsync_region: aws_appsync_region , aws_bots_config: aws_bots_config , aws_cognito_identity_pool_id: aws_cognito_identity_pool_id , aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method , aws_cognito_mfa_configuration: aws_cognito_mfa_configuration , aws_cognito_mfa_types: aws_cognito_mfa_types , aws_cognito_password_protection_settings: aws_cognito_password_protection_settings , aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms , aws_cognito_signup_attributes: aws_cognito_signup_attributes , aws_cognito_social_providers: aws_cognito_social_providers , aws_cognito_username_attributes: aws_cognito_username_attributes , aws_mandatory_sign_in: aws_mandatory_sign_in , aws_mobile_analytics_app_id: aws_mobile_analytics_app_id , aws_mobile_analytics_app_region: aws_mobile_analytics_app_region , aws_user_files_s3_bucket: aws_user_files_s3_bucket , aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region , aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing , aws_user_pools_id: aws_user_pools_id , aws_user_pools_web_client_id: aws_user_pools_web_client_id , geo: geo , oauth: oauth , predictions: predictions , aws_cloud_logic_custom: aws_cloud_logic_custom , Notifications: Notifications , modelIntrospection: modelIntrospection  } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging , Push: Push  } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId , region: region  } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId , region: region  } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                ...amplifyConfig.Notifications,
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $e13fb36a267dd892$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $e13fb36a267dd892$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>({
            ...attributes,
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$e13fb36a267dd892$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $e13fb36a267dd892$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service  } = geo;
        amplifyConfig.Geo = amazon_location_service ? {
            LocationService: {
                ...amazon_location_service,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        } : {
            ...geo
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name , endpoint: endpoint , region: region , service: service  } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId  } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $e13fb36a267dd892$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $e13fb36a267dd892$var$getOAuthConfig = ({ domain: domain , scope: scope , redirectSignIn: redirectSignIn , redirectSignOut: redirectSignOut , responseType: responseType  })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $e13fb36a267dd892$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $e13fb36a267dd892$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $e13fb36a267dd892$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $881d00c083789f41$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $881d00c083789f41$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};


function $a494572fc02f1800$export$b007d77a962aa175({ expiresAt: expiresAt , clockDrift: clockDrift  }) {
    const currentTime = Date.now();
    return currentTime + clockDrift > expiresAt;
}
class $a494572fc02f1800$export$eeff9d1a8b8c057b {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
     * with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        await this.authOptions?.credentialsProvider?.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $81f263cde83633b9$export$35210b3191d26437 = Symbol("oauth-listener");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $44174d4eb465d133$export$b412d755cfa0136 {
    constructor(){
        this.oAuthListener = undefined;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $a494572fc02f1800$export$eeff9d1a8b8c057b)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourcesConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $e13fb36a267dd892$export$1ef2e9c2da492d)(resourcesConfig);
        else resolvedResourceConfig = resourcesConfig;
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $881d00c083789f41$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("core", {
            event: "configure",
            data: this.resourcesConfig
        }, "Configure", (0, $9464725044e9d769$export$aadf71dd9875dd20));
        this.notifyOAuthListener();
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $81f263cde83633b9$export$35210b3191d26437)](listener) {
        if (this.resourcesConfig.Auth?.Cognito.loginWith?.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener(this.resourcesConfig.Auth?.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        if (!this.resourcesConfig.Auth?.Cognito.loginWith?.oauth || !this.oAuthListener) return;
        this.oAuthListener(this.resourcesConfig.Auth?.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` is responsible for orchestrating cross-category communication within the library.
 */ const $44174d4eb465d133$export$a3858a9a153cffc7 = new $44174d4eb465d133$export$b412d755cfa0136();

var $6f98ce5fa2dc1234$exports = {};
(function(global, factory) {
    $6f98ce5fa2dc1234$exports = factory();
})($6f98ce5fa2dc1234$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $cd7d6a3de8efc093$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path , domain: domain , expires: expires , sameSite: sameSite , secure: secure  } = data;
        this.domain = domain;
        this.path = path || "/";
        this.expires = Object.prototype.hasOwnProperty.call(data, "expires") ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, "secure") ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f5d3b7601afe1953$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
})($f5d3b7601afe1953$export$4e712df6b850c8d0 || ($f5d3b7601afe1953$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $a1a461091d7049fe$export$f5362e8a6666a455 extends (0, $d153492e067ac8ab$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $4acb0e8bcdcac298$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $a1a461091d7049fe$export$f5362e8a6666a455)();
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $fb3276c454108430$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $e26eadfdbe3ab4b1$export$5d9abaf8ff62cd65 = ()=>typeof window !== "undefined" && window.localStorage ? window.localStorage : new (0, $fb3276c454108430$export$e4315e25b840a0ea)();
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $e26eadfdbe3ab4b1$export$518dcc1598f87b = ()=>typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage : new (0, $fb3276c454108430$export$e4315e25b840a0ea)();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $4cc2459090bfa83f$export$bec45e7703e93690 extends (0, $4acb0e8bcdcac298$export$8536778e426ddf92) {
    constructor(){
        super((0, $e26eadfdbe3ab4b1$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $7d010781d1d47f20$export$2c4b17e1c2e0931 extends (0, $4acb0e8bcdcac298$export$8536778e426ddf92) {
    constructor(){
        super((0, $e26eadfdbe3ab4b1$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d6350db11aa681cd$export$586b30dcaeecb901 = new (0, $4cc2459090bfa83f$export$bec45e7703e93690)();
const $d6350db11aa681cd$export$f119d83aa936d634 = new (0, $7d010781d1d47f20$export$2c4b17e1c2e0931)();
const $d6350db11aa681cd$export$41feb988b3a84f03 = new (0, $4acb0e8bcdcac298$export$8536778e426ddf92)(new (0, $fb3276c454108430$export$e4315e25b840a0ea)());








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7b380da28ef680be$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $7b380da28ef680be$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $7b380da28ef680be$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $01459b747c81c3e7$export$1e303d38dab7b376 = {
    convert (input) {
        return (0, $7b380da28ef680be$export$ea737e7700106b27)()(input);
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $318f49e195f770af$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $d153492e067ac8ab$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message , recoverySuggestion: recoverySuggestion  } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $bb394460481fda70$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($bb394460481fda70$export$7b5c8b570ea8407 || ($bb394460481fda70$export$7b5c8b570ea8407 = {}));
const $bb394460481fda70$var$authConfigurationErrorMap = {
    [$bb394460481fda70$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$bb394460481fda70$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $bb394460481fda70$export$a7a9523472993e97 = (0, $318f49e195f770af$export$5cb8fc27ccbe9d40)($bb394460481fda70$var$authConfigurationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $da35d46b99b5d98d$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, $bb394460481fda70$export$a7a9523472993e97)(assertionValid, (0, $bb394460481fda70$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $da35d46b99b5d98d$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    (0, $bb394460481fda70$export$a7a9523472993e97)(validOAuthConfig, (0, $bb394460481fda70$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $da35d46b99b5d98d$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    (0, $bb394460481fda70$export$a7a9523472993e97)(validConfig, (0, $bb394460481fda70$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
function $da35d46b99b5d98d$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $01459b747c81c3e7$export$1e303d38dab7b376).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $03e5abb25dfabdd6$export$145273558d58e0ac extends (0, $d153492e067ac8ab$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $03e5abb25dfabdd6$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $03e5abb25dfabdd6$export$145273558d58e0ac.prototype);
    }
}


const $51fefc0f242b4091$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $5cbe89a4f402275f$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($5cbe89a4f402275f$export$cc5909720f29144 || ($5cbe89a4f402275f$export$cc5909720f29144 = {}));
const $5cbe89a4f402275f$var$tokenValidationErrorMap = {
    [$5cbe89a4f402275f$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $5cbe89a4f402275f$export$a7a9523472993e97 = (0, $318f49e195f770af$export$5cb8fc27ccbe9d40)($5cbe89a4f402275f$var$tokenValidationErrorMap);


class $36e2942275e8945a$export$a36be852d43d512 {
    constructor(){
        this.name = "CognitoIdentityServiceProvider"; // To be backwards compatible with V5, no migration needed
    }
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $5cbe89a4f402275f$export$a7a9523472993e97)(tokens !== undefined, (0, $5cbe89a4f402275f$export$cc5909720f29144).InvalidAuthTokens);
        await this.clearTokens();
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword ? {
            deviceKey: deviceKey ?? undefined,
            deviceGroupKey: deviceGroupKey ?? undefined,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $36e2942275e8945a$export$4647c72f6828a74d(this.name, `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${this.name}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
}
const $36e2942275e8945a$export$4647c72f6828a74d = (provider, identifier)=>{
    return $36e2942275e8945a$export$dfb8da757ca62eed((0, $51fefc0f242b4091$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $36e2942275e8945a$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9c6e28f6741ba4d6$export$dad1700b96c3a835 = {
    identityId: "identityId"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6597ba25b1800063$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("DefaultIdentityIdStore");
class $6597ba25b1800063$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $6597ba25b1800063$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) return {
                    id: storedIdentityId,
                    type: "guest"
                };
                return null;
            }
        } catch (err) {
            $6597ba25b1800063$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            this.keyValueStorage.removeItem(this._authKeys.identityId);
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $6597ba25b1800063$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $36e2942275e8945a$export$dfb8da757ca62eed)((0, $9c6e28f6741ba4d6$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};


/**
 * @internal
 */ var $b5a4ecd5156e000d$export$b2e3d6d444266a5c = 64;
var $b5a4ecd5156e000d$export$d7bd469488748c5f = 32;
var $b5a4ecd5156e000d$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $b5a4ecd5156e000d$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $b5a4ecd5156e000d$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $9683a5d1f0beed32$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $b5a4ecd5156e000d$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $b5a4ecd5156e000d$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) >= (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $b5a4ecd5156e000d$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $b5a4ecd5156e000d$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5aebd7bbf9362f55$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $d806e3bfdcadf915$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $5aebd7bbf9362f55$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $df3d483d21bdf8fb$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$d4ecdbf520e63dca$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $a8b3104de383d739$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
// Quick polyfill
var $a8b3104de383d739$var$fromUtf8 = typeof $a8b3104de383d739$require$Buffer !== "undefined" && $a8b3104de383d739$require$Buffer.from ? function(input) {
    return $a8b3104de383d739$require$Buffer.from(input, "utf8");
} : (0, $5aebd7bbf9362f55$export$c7c5cef950a4d2fc);
function $a8b3104de383d739$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $a8b3104de383d739$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $413b933ff0fcbf9e$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $5039f17952806170$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $52575d3913ebdf99$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $2127c60713693f53$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $413b933ff0fcbf9e$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $a8b3104de383d739$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $f5ed4ab2a4d1861b$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $f5ed4ab2a4d1861b$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
            var inner = $2127c60713693f53$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $2127c60713693f53$var$bufferFromSecret(secret) {
    var input = (0, $a8b3104de383d739$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $9683a5d1f0beed32$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $b5a4ecd5156e000d$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $960024b72c198b30$var$SHORT_TO_HEX = {};
const $960024b72c198b30$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $960024b72c198b30$var$SHORT_TO_HEX[i] = encodedByte;
    $960024b72c198b30$var$HEX_TO_SHORT[encodedByte] = i;
}
function $960024b72c198b30$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $960024b72c198b30$var$HEX_TO_SHORT) out[i / 2] = $960024b72c198b30$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $960024b72c198b30$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $960024b72c198b30$var$SHORT_TO_HEX[bytes[i]];
    return out;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ad9ac2a297598208$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers , statusCode: statusCode  } = response;
    return {
        ...$ad9ac2a297598208$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $ad9ac2a297598208$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $c9219ddc4f5544cf$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $c9219ddc4f5544cf$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $c9219ddc4f5544cf$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $29600698f92385b7$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We may want to allow different endpoints from given config(other than region) and input.
        // Currently S3 supports additional `useAccelerateEndpoint` option to use accelerate endpoint.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return deserializer(response);
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $5d2942164da17ff7$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $5d2942164da17ff7$export$d7c12af0c0f12206 = {
    partitions: [
        $5d2942164da17ff7$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $f91fa1e3d8be306f$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions  } = (0, $5d2942164da17ff7$export$d7c12af0c0f12206);
    for (const { regions: regions , outputs: outputs , regionRegex: regionRegex  } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $5d2942164da17ff7$export$72f3cee421ee8a74).outputs.dnsSuffix;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $802afeb1ad7c8f0f$var$DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */ const $802afeb1ad7c8f0f$export$72f002d3da1a429f = ({ maxAttempts: maxAttempts = $802afeb1ad7c8f0f$var$DEFAULT_RETRY_ATTEMPTS , retryDecider: retryDecider , computeDelay: computeDelay , abortSignal: abortSignal  })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $802afeb1ad7c8f0f$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $802afeb1ad7c8f0f$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                if (await retryDecider(response, error)) {
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $802afeb1ad7c8f0f$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $802afeb1ad7c8f0f$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $802afeb1ad7c8f0f$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput.$metadata = {
        ...nextHandlerOutput.$metadata ?? {},
        attempts: attempts
    };
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $515400266cf6cb5b$export$ff28171a05413bc5 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent" , userAgentValue: userAgentValue = ""  })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $a989f58fee6d43e0$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $bdc6a88d25bd6134$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4b0d223caa1b6173$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $4b0d223caa1b6173$export$d2573baf35521e4c = async ({ url: url , method: method , headers: headers , body: body  }, { abortSignal: abortSignal , cache: cache , withCrossDomainCredentials: withCrossDomainCredentials  })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $4b0d223caa1b6173$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        // TODO: needs to revise error handling in v6
        // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
        // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
        if (e instanceof TypeError) throw new Error("Network error");
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $bdc6a88d25bd6134$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $bdc6a88d25bd6134$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $bdc6a88d25bd6134$export$580ad1ce15092b15)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $06a5c13f13cb78e5$export$ed7e1ccf00f39c4a = (0, $a989f58fee6d43e0$export$f074d76e52925468)((0, $4b0d223caa1b6173$export$d2573baf35521e4c), [
    (0, $515400266cf6cb5b$export$ff28171a05413bc5),
    (0, $802afeb1ad7c8f0f$export$72f002d3da1a429f)
]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $55c3deaff7ce43ff$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $ebf615981b3eb20c$export$caea50bde345f648(maxDelayMs = (0, $55c3deaff7ce43ff$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $46ded7b7e9d65568$var$DEFAULT_MAX_DELAY_MS = 300000;
const $46ded7b7e9d65568$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $ebf615981b3eb20c$export$caea50bde345f648)($46ded7b7e9d65568$var$DEFAULT_MAX_DELAY_MS);
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $46ded7b7e9d65568$var$DEFAULT_MAX_DELAY_MS : delay;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $53f6ccb7532bc03d$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $53f6ccb7532bc03d$export$7b87435661177a94 = (errorCode)=>!!errorCode && $53f6ccb7532bc03d$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $006c1d5500f41923$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.code || parsedError?.name;
        const statusCode = response?.statusCode;
        return $006c1d5500f41923$var$isConnectionError(error) || $006c1d5500f41923$var$isThrottlingError(statusCode, errorCode) || (0, $53f6ccb7532bc03d$export$7b87435661177a94)(errorCode) || $006c1d5500f41923$var$isServerSideError(statusCode, errorCode);
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $006c1d5500f41923$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $006c1d5500f41923$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $006c1d5500f41923$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $006c1d5500f41923$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $006c1d5500f41923$var$isConnectionError = (error)=>error?.name === "Network error";
const $006c1d5500f41923$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $006c1d5500f41923$var$TIMEOUT_ERROR_CODES.includes(errorCode);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b0f1ea60776570d9$export$beb82d9d9136c16e = URL;
const $b0f1ea60776570d9$export$4ea7bbdac595b5fb = URLSearchParams;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $80240862ea60f1f3$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($80240862ea60f1f3$export$638889172ebce0c4 || ($80240862ea60f1f3$export$638889172ebce0c4 = {}));
var $80240862ea60f1f3$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($80240862ea60f1f3$export$3a8840c5b2ecf003 || ($80240862ea60f1f3$export$3a8840c5b2ecf003 = {}));
var $80240862ea60f1f3$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($80240862ea60f1f3$export$30c16f5c43437fd7 || ($80240862ea60f1f3$export$30c16f5c43437fd7 = {}));
var $80240862ea60f1f3$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($80240862ea60f1f3$export$126e20fdc0f0d34b || ($80240862ea60f1f3$export$126e20fdc0f0d34b = {}));
var $80240862ea60f1f3$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
})($80240862ea60f1f3$export$900b1436d7e65f4 || ($80240862ea60f1f3$export$900b1436d7e65f4 = {}));
var $80240862ea60f1f3$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($80240862ea60f1f3$export$2f5a715aba4cde93 || ($80240862ea60f1f3$export$2f5a715aba4cde93 = {}));
var $80240862ea60f1f3$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($80240862ea60f1f3$export$afafab3eb8fc6fef || ($80240862ea60f1f3$export$afafab3eb8fc6fef = {}));
var $80240862ea60f1f3$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($80240862ea60f1f3$export$c01a8c16ffda791e || ($80240862ea60f1f3$export$c01a8c16ffda791e = {}));
var $80240862ea60f1f3$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($80240862ea60f1f3$export$68e0695a774ab7fa || ($80240862ea60f1f3$export$68e0695a774ab7fa = {}));
var $80240862ea60f1f3$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($80240862ea60f1f3$export$aa89b4c447a07cee || ($80240862ea60f1f3$export$aa89b4c447a07cee = {}));
var $80240862ea60f1f3$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($80240862ea60f1f3$export$ade48b30f1e78672 || ($80240862ea60f1f3$export$ade48b30f1e78672 = {}));
var $80240862ea60f1f3$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($80240862ea60f1f3$export$2c5ee06ab9fa5040 || ($80240862ea60f1f3$export$2c5ee06ab9fa5040 = {}));
var $80240862ea60f1f3$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
})($80240862ea60f1f3$export$d4f3c54b808b00ce || ($80240862ea60f1f3$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $61dcbfd9387cc58d$export$83d89fbfd8236492 = "6.0.27";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


const $07a5cc9121afbe58$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $07a5cc9121afbe58$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $07a5cc9121afbe58$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $07a5cc9121afbe58$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $07a5cc9121afbe58$export$ba10401363d0f7f6 = ()=>{
    return typeof $391299e0893a3dfa$exports !== "undefined";
};
const $07a5cc9121afbe58$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $bcfa9edffcd864f0$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $07a5cc9121afbe58$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $bcfa9edffcd864f0$export$86269c582305790() {
    return (0, $07a5cc9121afbe58$export$ba10401363d0f7f6)() && typeof $391299e0893a3dfa$exports.env !== "undefined" && !!Object.keys($391299e0893a3dfa$exports.env).find((key)=>key.includes("react"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $4882a2b989e1c3eb$export$d91d90d62b78936d() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && (0, $07a5cc9121afbe58$export$252f88727cff70c7)(window, "__VUE");
}
function $4882a2b989e1c3eb$export$257a4c0f8294a101() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && (0, $07a5cc9121afbe58$export$252f88727cff70c7)($parcel$global, "__VUE");
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $0c517a50b1eac5d6$export$6dafc32a94edaed3() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && (0, $07a5cc9121afbe58$export$252f88727cff70c7)(window, "__SVELTE");
}
function $0c517a50b1eac5d6$export$819dcb7fe144d8b0() {
    return (0, $07a5cc9121afbe58$export$ba10401363d0f7f6)() && typeof $391299e0893a3dfa$exports.env !== "undefined" && !!Object.keys($391299e0893a3dfa$exports.env).find((key)=>key.includes("svelte"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $1b543a05b969025e$export$f8462bcf03110eff() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && window.next && typeof window.next === "object";
}
function $1b543a05b969025e$export$61c08ed144a5d4ca() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && ((0, $07a5cc9121afbe58$export$252f88727cff70c7)($parcel$global, "__next") || (0, $07a5cc9121afbe58$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $54456e2dc9ae4c87$export$bed54a4e6d9d25fb() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function $54456e2dc9ae4c87$export$fb3ce982948d27e8() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && typeof $parcel$global.__NUXT_PATHS__ !== "undefined";
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $24d63ab186dd89d1$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $07a5cc9121afbe58$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean((0, $07a5cc9121afbe58$export$daba2802a1a41c1f)() && typeof window.ng !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $24d63ab186dd89d1$export$8ab518c8987c870f() {
    return (0, $07a5cc9121afbe58$export$ba10401363d0f7f6)() && typeof $391299e0893a3dfa$exports.env === "object" && undefined?.startsWith("ng ") || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $3c908fced1c0b9b0$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $0634f71a29d835cd$export$85fd46d5e29a4f7e() {
    return (0, $07a5cc9121afbe58$export$a15eed0e463030a9)() && typeof $parcel$global.expo !== "undefined";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $4e84bc68b3a29494$export$41b1270b988065fb() {
    return (0, $07a5cc9121afbe58$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $8eae9bb90d2a57f8$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $0634f71a29d835cd$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $3c908fced1c0b9b0$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $1b543a05b969025e$export$f8462bcf03110eff)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $54456e2dc9ae4c87$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $24d63ab186dd89d1$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).React,
        detectionMethod: (0, $bcfa9edffcd864f0$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $4882a2b989e1c3eb$export$d91d90d62b78936d)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $0c517a50b1eac5d6$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $4e84bc68b3a29494$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $1b543a05b969025e$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $54456e2dc9ae4c87$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $bcfa9edffcd864f0$export$86269c582305790)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $4882a2b989e1c3eb$export$257a4c0f8294a101)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $24d63ab186dd89d1$export$8ab518c8987c870f)
    },
    {
        platform: (0, $80240862ea60f1f3$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $0c517a50b1eac5d6$export$819dcb7fe144d8b0)
    }
];
function $8eae9bb90d2a57f8$export$17b446b869dad473() {
    return $8eae9bb90d2a57f8$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $80240862ea60f1f3$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $3e4308e2a31b96d6$var$frameworkCache;
const $3e4308e2a31b96d6$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $3e4308e2a31b96d6$var$resetTriggered = false;
const $3e4308e2a31b96d6$var$SSR_RESET_TIMEOUT = 10; // ms
const $3e4308e2a31b96d6$var$WEB_RESET_TIMEOUT = 10; // ms
const $3e4308e2a31b96d6$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $3e4308e2a31b96d6$export$9ce73e459ec93b6a = ()=>{
    if (!$3e4308e2a31b96d6$var$frameworkCache) {
        $3e4308e2a31b96d6$var$frameworkCache = (0, $8eae9bb90d2a57f8$export$17b446b869dad473)();
        if ($3e4308e2a31b96d6$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($3e4308e2a31b96d6$export$d56891f33aa26edc.length)$3e4308e2a31b96d6$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $3e4308e2a31b96d6$export$d56891f33aa26edc.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $3e4308e2a31b96d6$var$resetTimeout((0, $80240862ea60f1f3$export$638889172ebce0c4).ServerSideUnknown, $3e4308e2a31b96d6$var$SSR_RESET_TIMEOUT);
        $3e4308e2a31b96d6$var$resetTimeout((0, $80240862ea60f1f3$export$638889172ebce0c4).WebUnknown, $3e4308e2a31b96d6$var$WEB_RESET_TIMEOUT);
    }
    return $3e4308e2a31b96d6$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $3e4308e2a31b96d6$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($3e4308e2a31b96d6$var$resetTriggered) return;
    $3e4308e2a31b96d6$export$d56891f33aa26edc.push(fcn);
};
function $3e4308e2a31b96d6$export$d2adf65b87e47523() {
    $3e4308e2a31b96d6$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $3e4308e2a31b96d6$var$resetTimeout(framework, delay) {
    if ($3e4308e2a31b96d6$var$frameworkCache === framework && !$3e4308e2a31b96d6$var$resetTriggered) setTimeout(()=>{
        $3e4308e2a31b96d6$export$d2adf65b87e47523();
        $3e4308e2a31b96d6$var$resetTriggered = true;
        setTimeout($3e4308e2a31b96d6$export$9ce73e459ec93b6a, $3e4308e2a31b96d6$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $3e40eb963c318bdb$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $3e40eb963c318bdb$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $3e40eb963c318bdb$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $3e40eb963c318bdb$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $3e40eb963c318bdb$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $3e40eb963c318bdb$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $3e40eb963c318bdb$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($3e40eb963c318bdb$var$customUserAgentState[input.category]).length) delete $3e40eb963c318bdb$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $3e40eb963c318bdb$export$e399dbcfd99a2928 = (category, api)=>$3e40eb963c318bdb$var$customUserAgentState[category]?.[api]?.additionalDetails;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0c7e08523dc29e90$var$BASE_USER_AGENT = `aws-amplify`;
class $0c7e08523dc29e90$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$0c7e08523dc29e90$var$BASE_USER_AGENT}/${0, $61dcbfd9387cc58d$export$83d89fbfd8236492}`;
    }
    get framework() {
        return (0, $3e4308e2a31b96d6$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $80240862ea60f1f3$export$638889172ebce0c4).ReactNative || this.framework === (0, $80240862ea60f1f3$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $3e4308e2a31b96d6$export$5d5c467ce0b213f)(fcn);
    }
}
const $0c7e08523dc29e90$export$2dffd0b5373a4389 = new $0c7e08523dc29e90$var$PlatformBuilder();
const $0c7e08523dc29e90$export$7d201307d8979e21 = ({ category: category , action: action  } = {})=>{
    const userAgent = [
        [
            $0c7e08523dc29e90$var$BASE_USER_AGENT,
            (0, $61dcbfd9387cc58d$export$83d89fbfd8236492)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $3e4308e2a31b96d6$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $3e40eb963c318bdb$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $0c7e08523dc29e90$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $0c7e08523dc29e90$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $5388bad426dc15c3$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $5388bad426dc15c3$var$endpointResolver = ({ region: region  })=>({
        url: new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(`https://cognito-identity.${region}.${(0, $f91fa1e3d8be306f$export$1c28e37cdcc37f6d)(region)}`)
    });
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $5388bad426dc15c3$var$disableCacheMiddlewareFactory = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $5388bad426dc15c3$export$8029646671d2c482 = (0, $a989f58fee6d43e0$export$f074d76e52925468)((0, $06a5c13f13cb78e5$export$ed7e1ccf00f39c4a), [
    $5388bad426dc15c3$var$disableCacheMiddlewareFactory
]);
/**
 * @internal
 */ const $5388bad426dc15c3$export$f84bd70098573c5c = {
    service: $5388bad426dc15c3$var$SERVICE_NAME,
    endpointResolver: $5388bad426dc15c3$var$endpointResolver,
    retryDecider: (0, $006c1d5500f41923$export$b919d98317a7685f)((0, $c9219ddc4f5544cf$export$be467dfcc0538e25)),
    computeDelay: (0, $46ded7b7e9d65568$export$caea50bde345f648),
    userAgentValue: (0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
(0, $3e4308e2a31b96d6$export$5d5c467ce0b213f)(()=>{
    $5388bad426dc15c3$export$f84bd70098573c5c.userAgentValue = (0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)();
});
/**
 * @internal
 */ const $5388bad426dc15c3$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
/**
 * @internal
 */ const $5388bad426dc15c3$export$a692bdb7eb624f96 = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4d75eccb58ec11d3$var$getCredentialsForIdentitySerializer = (input, endpoint)=>{
    const headers = (0, $5388bad426dc15c3$export$a46bbeaba09f7285)("GetCredentialsForIdentity");
    const body = JSON.stringify(input);
    return (0, $5388bad426dc15c3$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $4d75eccb58ec11d3$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $c9219ddc4f5544cf$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            Credentials: $4d75eccb58ec11d3$var$deserializeCredentials(body.Credentials),
            $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
        };
    }
};
const $4d75eccb58ec11d3$var$deserializeCredentials = ({ AccessKeyId: AccessKeyId , SecretKey: SecretKey , SessionToken: SessionToken , Expiration: Expiration  } = {})=>{
    return {
        AccessKeyId: AccessKeyId,
        SecretKey: SecretKey,
        SessionToken: SessionToken,
        Expiration: Expiration && new Date(Expiration * 1000)
    };
};
/**
 * @internal
 */ const $4d75eccb58ec11d3$export$a49c1c173ab96b58 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $5388bad426dc15c3$export$8029646671d2c482), $4d75eccb58ec11d3$var$getCredentialsForIdentitySerializer, $4d75eccb58ec11d3$var$getCredentialsForIdentityDeserializer, (0, $5388bad426dc15c3$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $e2042681c7604de8$export$d4a625cede2da71b(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $e2042681c7604de8$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e4cb7b306ced9230$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $e4cb7b306ced9230$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $e4cb7b306ced9230$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $e4cb7b306ced9230$export$fe46a12932d2550a = "AutoSignInException";
const $e4cb7b306ced9230$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $e4cb7b306ced9230$export$60b68b138a52e5ae = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: $e4cb7b306ced9230$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $e4cb7b306ced9230$export$27ddc47447101bcf = "InvalidOriginException";
const $e4cb7b306ced9230$export$c01b4acd6291e035 = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: $e4cb7b306ced9230$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $e4cb7b306ced9230$export$625255707e22459c = "OAuthSignOutException";
const $e4cb7b306ced9230$export$a0a904daf48e2c33 = "TokenRefreshException";
const $e4cb7b306ced9230$export$606cffc85964c24b = "UnexpectedSignInInterruptionException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $6e9371ee52a401af$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $6e9371ee52a401af$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $6e9371ee52a401af$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
const $6e9371ee52a401af$export$31fce2aaeafa4b60 = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: (0, $e4cb7b306ced9230$export$a0a904daf48e2c33),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $6e9371ee52a401af$export$35cfa8cbd2d5bcdd = new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
    name: (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3),
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
});
function $6e9371ee52a401af$export$be38b2d22222d505(tokens) {
    if ($6e9371ee52a401af$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $6e9371ee52a401af$export$31fce2aaeafa4b60;
    if (!$6e9371ee52a401af$var$isAuthenticatedWithRefreshToken(tokens)) throw $6e9371ee52a401af$export$35cfa8cbd2d5bcdd;
}
function $6e9371ee52a401af$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$740e7000ac27ebf3),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $6e9371ee52a401af$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};
function $6e9371ee52a401af$var$isAuthenticated(tokens) {
    return tokens?.accessToken || tokens?.idToken;
}
function $6e9371ee52a401af$var$isAuthenticatedWithRefreshToken(tokens) {
    return $6e9371ee52a401af$var$isAuthenticated(tokens) && tokens?.refreshToken;
}
function $6e9371ee52a401af$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $6e9371ee52a401af$var$isAuthenticated(tokens) && !tokens?.refreshToken;
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $011669ce549234aa$var$getIdSerializer = (input, endpoint)=>{
    const headers = (0, $5388bad426dc15c3$export$a46bbeaba09f7285)("GetId");
    const body = JSON.stringify(input);
    return (0, $5388bad426dc15c3$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $011669ce549234aa$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $c9219ddc4f5544cf$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            $metadata: (0, $ad9ac2a297598208$export$978f9418fe0cb26c)(response)
        };
    }
};
/**
 * @internal
 */ const $011669ce549234aa$export$218c8c3169c024d2 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $5388bad426dc15c3$export$8029646671d2c482), $011669ce549234aa$var$getIdSerializer, $011669ce549234aa$var$getIdDeserializer, (0, $5388bad426dc15c3$export$f84bd70098573c5c));






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $298e949ea1e2645e$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9d9e81c819338298$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("CognitoIdentityIdProvider");
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function $9d9e81c819338298$export$7c3e576630d5e301({ tokens: tokens , authConfig: authConfig , identityIdStore: identityIdStore  }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    let identityId = await identityIdStore.loadIdentityId();
    // Tokens are available so return primary identityId
    if (tokens) {
        // If there is existing primary identityId in-memory return that
        if (identityId && identityId.type === "primary") return identityId.id;
        else {
            const logins = tokens.idToken ? (0, $298e949ea1e2645e$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
            const generatedIdentityId = await $9d9e81c819338298$var$generateIdentityId(logins, authConfig);
            if (identityId && identityId.id === generatedIdentityId) $9d9e81c819338298$var$logger.debug(`The guest identity ${identityId.id} has become the primary identity.`);
            identityId = {
                id: generatedIdentityId,
                type: "primary"
            };
        }
    } else {
        // If there is existing guest identityId cached return that
        if (identityId && identityId.type === "guest") return identityId.id;
        else identityId = {
            id: await $9d9e81c819338298$var$generateIdentityId({}, authConfig),
            type: "guest"
        };
    }
    // Store in-memory or local storage depending on guest or primary identityId
    identityIdStore.storeIdentityId(identityId);
    return identityId.id;
}
async function $9d9e81c819338298$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $e2042681c7604de8$export$8fb32fba519c460)(identityPoolId);
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    const idResult = // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await (0, $011669ce549234aa$export$218c8c3169c024d2)({
        region: region
    }, {
        IdentityPoolId: identityPoolId,
        Logins: logins
    })).IdentityId;
    if (!idResult) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $326c9202938e7517$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("CognitoCredentialsProvider");
const $326c9202938e7517$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $326c9202938e7517$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $326c9202938e7517$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $326c9202938e7517$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens: tokens  } = getCredentialsOptions;
        const { authConfig: authConfig  } = getCredentialsOptions;
        try {
            (0, $da35d46b99b5d98d$export$8a2f5318ea3215e3)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh: forceRefresh  } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $9d9e81c819338298$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $6e9371ee52a401af$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $326c9202938e7517$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $e2042681c7604de8$export$8fb32fba519c460)(authConfig.identityPoolId);
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        const clientResult = await (0, $4d75eccb58ec11d3$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $326c9202938e7517$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $326c9202938e7517$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $298e949ea1e2645e$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $e2042681c7604de8$export$8fb32fba519c460)(authConfig.identityPoolId);
        const clientResult = await (0, $4d75eccb58ec11d3$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId,
            Logins: logins
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            this._nextCredentialsRefresh = new Date().getTime() + $326c9202938e7517$var$CREDENTIALS_TTL;
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "primary"
                });
            }
            return res;
        } else throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $c675585da73d2336$export$be43b753aec531e2 = new (0, $326c9202938e7517$export$be6550e37264dc26)(new (0, $6597ba25b1800063$export$3e97b78667a539a0)((0, $d6350db11aa681cd$export$586b30dcaeecb901)));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $b95044131c7c7bf1$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $30ec7ddce5c02788$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $f5d3b7601afe1953$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: error
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $c53ac4c0553e2359$var$SERVICE_NAME = "cognito-idp";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $c53ac4c0553e2359$var$endpointResolver = ({ region: region  })=>{
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const customURL = authConfig?.userPoolEndpoint;
    const defaultURL = new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(`https://${$c53ac4c0553e2359$var$SERVICE_NAME}.${region}.${(0, $f91fa1e3d8be306f$export$1c28e37cdcc37f6d)(region)}`);
    return {
        url: customURL ? new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(customURL) : defaultURL
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $c53ac4c0553e2359$var$disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $c53ac4c0553e2359$export$10f11e95d7a96f7b = (0, $a989f58fee6d43e0$export$f074d76e52925468)((0, $06a5c13f13cb78e5$export$ed7e1ccf00f39c4a), [
    $c53ac4c0553e2359$var$disableCacheMiddlewareFactory
]);
/**
 * @internal
 */ const $c53ac4c0553e2359$export$f84bd70098573c5c = {
    service: $c53ac4c0553e2359$var$SERVICE_NAME,
    endpointResolver: $c53ac4c0553e2359$var$endpointResolver,
    retryDecider: (0, $006c1d5500f41923$export$b919d98317a7685f)((0, $c9219ddc4f5544cf$export$be467dfcc0538e25)),
    computeDelay: (0, $46ded7b7e9d65568$export$caea50bde345f648),
    userAgentValue: (0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
/**
 * @internal
 */ const $c53ac4c0553e2359$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
/**
 * @internal
 */ const $c53ac4c0553e2359$export$a692bdb7eb624f96 = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d9f708d5fc22d533$var$buildUserPoolSerializer = (operation)=>(input, endpoint)=>{
        const headers = (0, $c53ac4c0553e2359$export$a46bbeaba09f7285)(operation);
        const body = JSON.stringify(input);
        return (0, $c53ac4c0553e2359$export$a692bdb7eb624f96)(endpoint, headers, body);
    };
const $d9f708d5fc22d533$var$buildUserPoolDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
            (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
            throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else {
            const body = await (0, $c9219ddc4f5544cf$export$759bcb35b0d1bf81)(response);
            return body;
        }
    };
};
const $d9f708d5fc22d533$var$handleEmptyResponseDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $c9219ddc4f5544cf$export$be467dfcc0538e25)(response);
            (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
            throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else return undefined;
    };
};
const $d9f708d5fc22d533$export$567b0d5ec943f827 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("InitiateAuth"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$2428f6ba65615593 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("RevokeToken"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$cf64224bcd829024 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("SignUp"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$2ce39ab6662e8c24 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ConfirmSignUp"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$66791fb2cfeec3e = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ForgotPassword"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$c7a5d0826ce3a2b2 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ConfirmForgotPassword"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$b196467a22b300ec = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("RespondToAuthChallenge"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$f24137cafeaef1a1 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ResendConfirmationCode"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$72b1124e126ff51c = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("VerifySoftwareToken"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$4531a27964554be8 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("AssociateSoftwareToken"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$b6a1b2cc7e7e6b1e = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("SetUserMFAPreference"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$7cbf767827cd68ba = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("GetUser"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$99d837dc30eb1ef7 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ChangePassword"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$3a7ad63dc35b752f = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ConfirmDevice"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$d0b7632b5e5fb312 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ForgetDevice"), $d9f708d5fc22d533$var$handleEmptyResponseDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$7d0f10f273c0438a = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("DeleteUser"), $d9f708d5fc22d533$var$handleEmptyResponseDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$3a9721eaccd0e7b3 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("GetUserAttributeVerificationCode"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$a92c2ab9b6303723 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("GlobalSignOut"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$16ff8cb4f547be0 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("UpdateUserAttributes"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$40fc6c986f86e9a5 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("VerifyUserAttribute"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$e1c4af6b7c9755a8 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("UpdateDeviceStatus"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$11154f886a75108 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("ListDevices"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));
const $d9f708d5fc22d533$export$a97f0f1c87d00e1 = (0, $29600698f92385b7$export$880429a8ae983d4d)((0, $c53ac4c0553e2359$export$10f11e95d7a96f7b), $d9f708d5fc22d533$var$buildUserPoolSerializer("DeleteUserAttributes"), $d9f708d5fc22d533$var$buildUserPoolDeserializer(), (0, $c53ac4c0553e2359$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d1d75befb3456a99$export$b6e6cdd1f90faa62({ username: username , userPoolId: userPoolId , userPoolClientId: userPoolClientId  }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $75fc96711695aa91$var$refreshAuthTokensFunction = async ({ tokens: tokens , authConfig: authConfig , username: username  })=>{
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig?.Cognito);
    const region = (0, $e2042681c7604de8$export$d4a625cede2da71b)(authConfig.Cognito.userPoolId);
    (0, $6e9371ee52a401af$export$be38b2d22222d505)(tokens);
    const refreshTokenString = tokens.refreshToken;
    const AuthParameters = {
        REFRESH_TOKEN: refreshTokenString
    };
    if (tokens.deviceMetadata?.deviceKey) AuthParameters.DEVICE_KEY = tokens.deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: authConfig.Cognito.userPoolId,
        userPoolClientId: authConfig.Cognito.userPoolClientId
    });
    const { AuthenticationResult: AuthenticationResult  } = await (0, $d9f708d5fc22d533$export$567b0d5ec943f827)({
        region: region
    }, {
        ClientId: authConfig?.Cognito?.userPoolClientId,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: AuthParameters,
        UserContextData: UserContextData
    });
    const accessToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const { iat: iat  } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: refreshTokenString,
        username: username
    };
};
const $75fc96711695aa91$export$ab413c2cb4a135d9 = (0, $b95044131c7c7bf1$export$cd8d22e3dc00ae5a)($75fc96711695aa91$var$refreshAuthTokensFunction);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $59ed5bbcecfdce0d$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $388b2d9f599c1030$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $388b2d9f599c1030$var$name = "CognitoIdentityServiceProvider";
class $388b2d9f599c1030$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($388b2d9f599c1030$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($388b2d9f599c1030$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $388b2d9f599c1030$var$createKeysForAuthStorage($388b2d9f599c1030$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $388b2d9f599c1030$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $36e2942275e8945a$export$dfb8da757ca62eed)((0, $6e9371ee52a401af$export$3820b4ff343394ea))(provider, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a3425219c0e3d9eb$export$2ed0ec267eb6cb1c = new (0, $388b2d9f599c1030$export$9b2cef5d94f9b6e8)((0, $d6350db11aa681cd$export$586b30dcaeecb901));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e96565510dd70381$var$inflightPromises = [];
const $e96565510dd70381$export$c55b09e0e9be0d04 = (resolver)=>{
    $e96565510dd70381$var$inflightPromises.push(resolver);
};
const $e96565510dd70381$export$bcb0b7a105a5df59 = ()=>{
    while($e96565510dd70381$var$inflightPromises.length)$e96565510dd70381$var$inflightPromises.pop()?.();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $9c8a217614d158ae$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = (0, $59ed5bbcecfdce0d$export$4e09c449d6c407f7)() ? async ()=>{
            if (!await (0, $a3425219c0e3d9eb$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, $e96565510dd70381$export$c55b09e0e9be0d04)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
    setAuthConfig(authConfig) {
        (0, $a3425219c0e3d9eb$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $da35d46b99b5d98d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $a494572fc02f1800$export$b007d77a962aa175)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $a494572fc02f1800$export$b007d77a962aa175)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens , username: username  }) {
        try {
            const { signInDetails: signInDetails  } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(err);
        if (err.message !== "Network error") // TODO(v6): Check errors on client
        this.clearTokens();
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
            event: "tokenRefresh_failure",
            data: {
                error: err
            }
        }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
        if (err.name.startsWith("NotAuthorizedException")) return null;
        throw err;
    }
    async setTokens({ tokens: tokens  }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $70c569d3e30fb942$export$85b743bbda58cb6c {
    constructor(){
        this.authTokenStore = new (0, $36e2942275e8945a$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $d6350db11aa681cd$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $9c8a217614d158ae$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $75fc96711695aa91$export$ab413c2cb4a135d9));
    }
    getTokens({ forceRefresh: forceRefresh  } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $14fa9bd317b4b3d6$export$18e158b80aac31a7 = new (0, $70c569d3e30fb942$export$85b743bbda58cb6c)();
const { tokenOrchestrator: $14fa9bd317b4b3d6$export$66561e66d62991d0  } = $14fa9bd317b4b3d6$export$18e158b80aac31a7;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2fcf3704ebc37489$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourceConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $e13fb36a267dd892$export$1ef2e9c2da492d)(resourceConfig);
        else resolvedResourceConfig = resourceConfig;
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) {
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions?.Auth) {
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $44174d4eb465d133$export$a3858a9a153cffc7).libraryOptions.Auth) {
            (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions?.ssr ? new (0, $cd7d6a3de8efc093$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $d6350db11aa681cd$export$586b30dcaeecb901));
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                ...libraryOptions,
                Auth: {
                    tokenProvider: (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7),
                    credentialsProvider: (0, $c675585da73d2336$export$be43b753aec531e2)
                }
            });
            return;
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) (0, $14fa9bd317b4b3d6$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions.ssr ? new (0, $cd7d6a3de8efc093$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $d6350db11aa681cd$export$586b30dcaeecb901));
            (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                Auth: (0, $44174d4eb465d133$export$a3858a9a153cffc7).libraryOptions.Auth,
                ...libraryOptions
            });
            return;
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $44174d4eb465d133$export$a3858a9a153cffc7).configure(resolvedResourceConfig);
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig();
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e5a1b34bea683c02$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})($e5a1b34bea683c02$export$12d5c695b2213c4a || ($e5a1b34bea683c02$export$12d5c695b2213c4a = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3277196cec8a3dbe$export$195137955146d376 = {
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: "challengeResponse is required to confirmSignIn"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: "username is required to confirmResetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: "code is required to confirmSignUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: "confirmationCode is required to confirmResetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: "newPassword is required to confirmResetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: "username is required to resetPassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: "password is required to signIn"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: "username is required to signIn"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: "password is required to signUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: "username is required to signUp"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
        recoverySuggestion: "Do not include a password in your signIn call."
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: "Incorrect MFA method was chosen. It should be either SMS or TOTP",
        recoverySuggestion: "Try to pass TOTP or SMS as the challengeResponse"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: "code is required to verifyTotpSetup"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: "oldPassword and newPassword are required to changePassword"
    },
    [(0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: "confirmation code is required to confirmUserAttribute"
    }
};
// TODO: delete this code when the Auth class is removed.
var $3277196cec8a3dbe$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($3277196cec8a3dbe$export$c3070468b9d65120 || ($3277196cec8a3dbe$export$c3070468b9d65120 = {}));
var $3277196cec8a3dbe$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($3277196cec8a3dbe$export$473ab0b56598aacd || ($3277196cec8a3dbe$export$473ab0b56598aacd = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $fd90eaa8008e7494$export$45936001d12f9b53(assertion, name) {
    const { message: message , recoverySuggestion: recoverySuggestion  } = (0, $3277196cec8a3dbe$export$195137955146d376)[name];
    if (!assertion) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $9816897d1d1adde4$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c81515d3d5db49f$export$695b149896bd3e2a = {
    convert (input, { urlSafe: urlSafe  } = {
        urlSafe: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $9816897d1d1adde4$export$7c746b75f47c9c7d)(input);
        const encodedStr = (0, $7b380da28ef680be$export$94f295707b435c6d)()(inputStr);
        // see details about the char replacing at https://datatracker.ietf.org/doc/html/rfc4648#section-5
        return urlSafe ? encodedStr.replace(/\+/g, "-").replace(/\//g, "_") : encodedStr;
    }
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9e23bc336cf172f0$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($9e23bc336cf172f0$export$3cc5c71ef5f25e57 || ($9e23bc336cf172f0$export$3cc5c71ef5f25e57 = {}));
var $9e23bc336cf172f0$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$4327725e8bb80c51 || ($9e23bc336cf172f0$export$4327725e8bb80c51 = {}));
var $9e23bc336cf172f0$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$87a956d0b1b725a1 || ($9e23bc336cf172f0$export$87a956d0b1b725a1 = {}));
var $9e23bc336cf172f0$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$b86a388af82085af || ($9e23bc336cf172f0$export$b86a388af82085af = {}));
var $9e23bc336cf172f0$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$2ec29642a27fd055 || ($9e23bc336cf172f0$export$2ec29642a27fd055 = {}));
var $9e23bc336cf172f0$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$c6d546f0ab5ecb26 || ($9e23bc336cf172f0$export$c6d546f0ab5ecb26 = {}));
var $9e23bc336cf172f0$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$315864c77a135492 || ($9e23bc336cf172f0$export$315864c77a135492 = {}));
var $9e23bc336cf172f0$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$622cff54bc9a0bb0 || ($9e23bc336cf172f0$export$622cff54bc9a0bb0 = {}));
var $9e23bc336cf172f0$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$cedaef1e1242f8be || ($9e23bc336cf172f0$export$cedaef1e1242f8be = {}));
var $9e23bc336cf172f0$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$8d5b6b7a140e0c94 || ($9e23bc336cf172f0$export$8d5b6b7a140e0c94 = {}));
var $9e23bc336cf172f0$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($9e23bc336cf172f0$export$506f117795ed2bb2 || ($9e23bc336cf172f0$export$506f117795ed2bb2 = {}));
var $9e23bc336cf172f0$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($9e23bc336cf172f0$export$9bff15c85d75f437 || ($9e23bc336cf172f0$export$9bff15c85d75f437 = {}));
var $9e23bc336cf172f0$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$2a6bba23fbf84d1b || ($9e23bc336cf172f0$export$2a6bba23fbf84d1b = {}));
var $9e23bc336cf172f0$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($9e23bc336cf172f0$export$3f7e490ba4e0b71e || ($9e23bc336cf172f0$export$3f7e490ba4e0b71e = {}));
var $9e23bc336cf172f0$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$43ac0110dfdad33b || ($9e23bc336cf172f0$export$43ac0110dfdad33b = {}));
var $9e23bc336cf172f0$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$8807b62ddb0e4d9d || ($9e23bc336cf172f0$export$8807b62ddb0e4d9d = {}));
var $9e23bc336cf172f0$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$da9908386393628f || ($9e23bc336cf172f0$export$da9908386393628f = {}));
var $9e23bc336cf172f0$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$23ea34859d89459d || ($9e23bc336cf172f0$export$23ea34859d89459d = {}));
var $9e23bc336cf172f0$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($9e23bc336cf172f0$export$d0816902ed99fce6 || ($9e23bc336cf172f0$export$d0816902ed99fce6 = {}));
var $9e23bc336cf172f0$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$44cb15f260897376 || ($9e23bc336cf172f0$export$44cb15f260897376 = {}));
var $9e23bc336cf172f0$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$a974f64d24be573a || ($9e23bc336cf172f0$export$a974f64d24be573a = {}));
var $9e23bc336cf172f0$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$527caabb62d14fe3 || ($9e23bc336cf172f0$export$527caabb62d14fe3 = {}));
var $9e23bc336cf172f0$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$de57be1863bdb9d6 || ($9e23bc336cf172f0$export$de57be1863bdb9d6 = {}));
var $9e23bc336cf172f0$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($9e23bc336cf172f0$export$eb8cb06bdb07bf0c || ($9e23bc336cf172f0$export$eb8cb06bdb07bf0c = {}));
const $9e23bc336cf172f0$export$ecd3eb1722b48d26 = "SetUpTOTPException";









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $92467085a98b3264$export$e5432d4c8eb97ea7 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $6e9371ee52a401af$export$77712ea5882cac9f)(tokens);
    const { "cognito:username": username , sub: sub  } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $92467085a98b3264$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $92467085a98b3264$var$getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $a96a35a57f46b2c7$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $92467085a98b3264$export$e5432d4c8eb97ea7)((0, $44174d4eb465d133$export$a3858a9a153cffc7));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7032744b11af61d7$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $0c7e08523dc29e90$export$ede38edb26c0bfdf)({
        category: (0, $80240862ea60f1f3$export$3a8840c5b2ecf003).Auth,
        action: action,
        ...customUserAgentDetails
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4cebbc81afdf787b$var$signInReducer = (state, action)=>{
    switch(action.type){
        case "SET_SIGN_IN_SESSION":
            return {
                ...state,
                signInSession: action.value
            };
        case "SET_SIGN_IN_STATE":
            return {
                ...action.value
            };
        case "SET_CHALLENGE_NAME":
            return {
                ...state,
                challengeName: action.value
            };
        case "SET_USERNAME":
            return {
                ...state,
                username: action.value
            };
        case "SET_INITIAL_STATE":
            return $4cebbc81afdf787b$var$defaultState();
        default:
            return state;
    }
};
function $4cebbc81afdf787b$var$defaultState() {
    return {
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    };
}
const $4cebbc81afdf787b$var$createStore = (reducer)=>{
    let currentState = reducer($4cebbc81afdf787b$var$defaultState(), {
        type: "SET_INITIAL_STATE"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $4cebbc81afdf787b$export$390d5da4c63a4a41 = $4cebbc81afdf787b$var$createStore($4cebbc81afdf787b$var$signInReducer);
function $4cebbc81afdf787b$export$bae72361b690e075(state) {
    $4cebbc81afdf787b$export$390d5da4c63a4a41.dispatch({
        type: "SET_SIGN_IN_STATE",
        value: state
    });
}
function $4cebbc81afdf787b$export$f3dfaa7234c98dc0() {
    $4cebbc81afdf787b$export$390d5da4c63a4a41.dispatch({
        type: "SET_INITIAL_STATE"
    });
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8f38281af144dd56$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};


/* eslint-disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $e6b0d30d639b7439$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $e6b0d30d639b7439$var$nbi() {
    return new $e6b0d30d639b7439$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $e6b0d30d639b7439$var$dbits;
// JavaScript engine analysis
const $e6b0d30d639b7439$var$canary = 0xdeadbeefcafe;
const $e6b0d30d639b7439$var$j_lm = ($e6b0d30d639b7439$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $e6b0d30d639b7439$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $e6b0d30d639b7439$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff;
    const xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $e6b0d30d639b7439$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff;
    const xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $e6b0d30d639b7439$var$inBrowser = typeof navigator !== "undefined";
if ($e6b0d30d639b7439$var$inBrowser && $e6b0d30d639b7439$var$j_lm && navigator.appName === "Microsoft Internet Explorer") {
    $e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.am = $e6b0d30d639b7439$var$am2;
    $e6b0d30d639b7439$var$dbits = 30;
} else if ($e6b0d30d639b7439$var$inBrowser && $e6b0d30d639b7439$var$j_lm && navigator.appName !== "Netscape") {
    $e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.am = $e6b0d30d639b7439$var$am1;
    $e6b0d30d639b7439$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.am = $e6b0d30d639b7439$var$am3;
    $e6b0d30d639b7439$var$dbits = 28;
}
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.DB = $e6b0d30d639b7439$var$dbits;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.DM = (1 << $e6b0d30d639b7439$var$dbits) - 1;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.DV = 1 << $e6b0d30d639b7439$var$dbits;
const $e6b0d30d639b7439$var$BI_FP = 52;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $e6b0d30d639b7439$var$BI_FP);
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.F1 = $e6b0d30d639b7439$var$BI_FP - $e6b0d30d639b7439$var$dbits;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.F2 = 2 * $e6b0d30d639b7439$var$dbits - $e6b0d30d639b7439$var$BI_FP;
// Digit conversions
const $e6b0d30d639b7439$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
const $e6b0d30d639b7439$var$BI_RC = [];
let $e6b0d30d639b7439$var$rr, $e6b0d30d639b7439$var$vv;
$e6b0d30d639b7439$var$rr = "0".charCodeAt(0);
for($e6b0d30d639b7439$var$vv = 0; $e6b0d30d639b7439$var$vv <= 9; ++$e6b0d30d639b7439$var$vv)$e6b0d30d639b7439$var$BI_RC[$e6b0d30d639b7439$var$rr++] = $e6b0d30d639b7439$var$vv;
$e6b0d30d639b7439$var$rr = "a".charCodeAt(0);
for($e6b0d30d639b7439$var$vv = 10; $e6b0d30d639b7439$var$vv < 36; ++$e6b0d30d639b7439$var$vv)$e6b0d30d639b7439$var$BI_RC[$e6b0d30d639b7439$var$rr++] = $e6b0d30d639b7439$var$vv;
$e6b0d30d639b7439$var$rr = "A".charCodeAt(0);
for($e6b0d30d639b7439$var$vv = 10; $e6b0d30d639b7439$var$vv < 36; ++$e6b0d30d639b7439$var$vv)$e6b0d30d639b7439$var$BI_RC[$e6b0d30d639b7439$var$rr++] = $e6b0d30d639b7439$var$vv;
function $e6b0d30d639b7439$var$int2char(n) {
    return $e6b0d30d639b7439$var$BI_RM.charAt(n);
}
function $e6b0d30d639b7439$var$intAt(s, i) {
    const c = $e6b0d30d639b7439$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $e6b0d30d639b7439$var$bnpCopyTo(r) {
    for(let i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $e6b0d30d639b7439$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $e6b0d30d639b7439$var$nbv(i) {
    const r = $e6b0d30d639b7439$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $e6b0d30d639b7439$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    let i = s.length;
    let mi = false;
    let sh = 0;
    while(--i >= 0){
        const x = $e6b0d30d639b7439$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === "-") mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $e6b0d30d639b7439$var$bnpClamp() {
    const c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $e6b0d30d639b7439$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    let k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    const km = (1 << k) - 1;
    let d;
    let m = false;
    let r = "";
    let i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $e6b0d30d639b7439$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $e6b0d30d639b7439$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $e6b0d30d639b7439$var$bnNegate() {
    const r = $e6b0d30d639b7439$var$nbi();
    $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $e6b0d30d639b7439$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $e6b0d30d639b7439$var$bnCompareTo(a) {
    let r = this.s - a.s;
    if (r != 0) return r;
    let i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $e6b0d30d639b7439$var$nbits(x) {
    let r = 1;
    let t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $e6b0d30d639b7439$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $e6b0d30d639b7439$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $e6b0d30d639b7439$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $e6b0d30d639b7439$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $e6b0d30d639b7439$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    const ds = Math.floor(n / this.DB);
    let c = this.s << bs & this.DM;
    let i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $e6b0d30d639b7439$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $e6b0d30d639b7439$var$bnpSubTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $e6b0d30d639b7439$var$bnpMultiplyTo(a, r) {
    const x = this.abs();
    const y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $e6b0d30d639b7439$var$bnpSquareTo(r) {
    const x = this.abs();
    let i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        const c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $e6b0d30d639b7439$var$bnpDivRemTo(m, q, r) {
    const pm = m.abs();
    if (pm.t <= 0) return;
    const pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $e6b0d30d639b7439$var$nbi();
    const y = $e6b0d30d639b7439$var$nbi();
    const ts = this.s;
    const ms = m.s;
    const nsh = this.DB - $e6b0d30d639b7439$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt;
    const d2 = (1 << this.F1) / yt;
    const e = 1 << this.F2;
    let i = r.t;
    let j = i - ys;
    const t = q === null ? $e6b0d30d639b7439$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $e6b0d30d639b7439$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        let qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $e6b0d30d639b7439$var$bnMod(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $e6b0d30d639b7439$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    const x = this[0];
    if ((x & 1) === 0) return 0;
    let y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $e6b0d30d639b7439$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $e6b0d30d639b7439$var$bnpAddTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $e6b0d30d639b7439$var$bnAdd(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $e6b0d30d639b7439$var$bnSubtract(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $e6b0d30d639b7439$var$bnMultiply(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $e6b0d30d639b7439$var$bnDivide(a) {
    const r = $e6b0d30d639b7439$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $e6b0d30d639b7439$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $e6b0d30d639b7439$var$montConvert(x) {
    const r = $e6b0d30d639b7439$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $e6b0d30d639b7439$var$montRevert(x) {
    const r = $e6b0d30d639b7439$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $e6b0d30d639b7439$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(let i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        let j = x[i] & 0x7fff;
        const u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $e6b0d30d639b7439$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $e6b0d30d639b7439$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$e6b0d30d639b7439$var$Montgomery.prototype.convert = $e6b0d30d639b7439$var$montConvert;
$e6b0d30d639b7439$var$Montgomery.prototype.revert = $e6b0d30d639b7439$var$montRevert;
$e6b0d30d639b7439$var$Montgomery.prototype.reduce = $e6b0d30d639b7439$var$montReduce;
$e6b0d30d639b7439$var$Montgomery.prototype.mulTo = $e6b0d30d639b7439$var$montMulTo;
$e6b0d30d639b7439$var$Montgomery.prototype.sqrTo = $e6b0d30d639b7439$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $e6b0d30d639b7439$var$bnModPow(e, m, callback) {
    let i = e.bitLength();
    let k;
    let r = $e6b0d30d639b7439$var$nbv(1);
    const z = new $e6b0d30d639b7439$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    const g = [];
    let n = 3;
    const k1 = k - 1;
    const km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $e6b0d30d639b7439$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $e6b0d30d639b7439$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1;
    let w;
    let is1 = true;
    let r2 = $e6b0d30d639b7439$var$nbi();
    let t;
    i = $e6b0d30d639b7439$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    const result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.copyTo = $e6b0d30d639b7439$var$bnpCopyTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.fromInt = $e6b0d30d639b7439$var$bnpFromInt;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.fromString = $e6b0d30d639b7439$var$bnpFromString;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.clamp = $e6b0d30d639b7439$var$bnpClamp;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.dlShiftTo = $e6b0d30d639b7439$var$bnpDLShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.drShiftTo = $e6b0d30d639b7439$var$bnpDRShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.lShiftTo = $e6b0d30d639b7439$var$bnpLShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.rShiftTo = $e6b0d30d639b7439$var$bnpRShiftTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.subTo = $e6b0d30d639b7439$var$bnpSubTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.multiplyTo = $e6b0d30d639b7439$var$bnpMultiplyTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.squareTo = $e6b0d30d639b7439$var$bnpSquareTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.divRemTo = $e6b0d30d639b7439$var$bnpDivRemTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.invDigit = $e6b0d30d639b7439$var$bnpInvDigit;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.addTo = $e6b0d30d639b7439$var$bnpAddTo;
// public
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.toString = $e6b0d30d639b7439$var$bnToString;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.negate = $e6b0d30d639b7439$var$bnNegate;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.abs = $e6b0d30d639b7439$var$bnAbs;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.compareTo = $e6b0d30d639b7439$var$bnCompareTo;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.bitLength = $e6b0d30d639b7439$var$bnBitLength;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.mod = $e6b0d30d639b7439$var$bnMod;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.equals = $e6b0d30d639b7439$var$bnEquals;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.add = $e6b0d30d639b7439$var$bnAdd;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.subtract = $e6b0d30d639b7439$var$bnSubtract;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.multiply = $e6b0d30d639b7439$var$bnMultiply;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.divide = $e6b0d30d639b7439$var$bnDivide;
$e6b0d30d639b7439$export$2e2bcd8739ae039.prototype.modPow = $e6b0d30d639b7439$var$bnModPow;
// "constants"
$e6b0d30d639b7439$export$2e2bcd8739ae039.ZERO = $e6b0d30d639b7439$var$nbv(0);
$e6b0d30d639b7439$export$2e2bcd8739ae039.ONE = $e6b0d30d639b7439$var$nbv(1);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $1cef16b1857519e3$export$f7340100dd3acd38 = async ({ a: a , g: g , k: k , x: x , B: B , N: N , U: U  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $97958120efb925b4$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $97958120efb925b4$export$a0f75f7d2f3bd702 = {};
const $97958120efb925b4$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $97958120efb925b4$export$a0f75f7d2f3bd702[i] = encodedByte;
    $97958120efb925b4$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $ec5820220853a812$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $97958120efb925b4$export$fcb552daf117d7e3)) out[i / 2] = (0, $97958120efb925b4$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $eed88bdc1fb343aa$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $97958120efb925b4$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $7977b7713864e546$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $eed88bdc1fb343aa$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join("0") + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $2bae7d4adcab7fc5$export$8b112e065a8843a = (hexStr)=>(0, $7977b7713864e546$export$629ee8d7d3ebacd1)((0, $ec5820220853a812$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $2e4ceaf61b2d9c67$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $2e4ceaf61b2d9c67$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $e6b0d30d639b7439$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
    const isNegative = bigInt.compareTo((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $2e4ceaf61b2d9c67$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split("").map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return "0123456789ABCDEF".charAt(invertedNibble);
        }).join("");
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $8f1acab179b9ebe1$export$e2f40082638513e7 = ({ A: A , B: B  })=>{
    const U = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(A) + (0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $1da3d3222e2071df$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $1dc42b32eec063da$export$d265930babe23ca5() {
    const crypto = (0, $7b380da28ef680be$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $fbcfeae1e1a35b5c$var$hexStringify(wordArray) {
    // Shortcuts
    const { words: words  } = wordArray;
    const { sigBytes: sigBytes  } = wordArray;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
class $fbcfeae1e1a35b5c$export$4cd4919e303276a6 {
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $1dc42b32eec063da$export$d265930babe23ca5)());
        return new $fbcfeae1e1a35b5c$export$4cd4919e303276a6(words, nBytes);
    }
    toString() {
        return $fbcfeae1e1a35b5c$var$hexStringify(this);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $9a6cff41abc04edc$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $fbcfeae1e1a35b5c$export$4cd4919e303276a6)().random(nBytes).toString();
    return (0, $ec5820220853a812$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $59388e0cd726a085$export$8c487394e1c35fbe = ()=>(0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert((0, $9a6cff41abc04edc$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $62713a0581f3e14f$export$2e2bcd8739ae039 {
    constructor({ userPoolName: userPoolName , a: a , g: g , A: A , N: N  }){
        this.encoder = (0, $8f38281af144dd56$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)(`${(0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(N)}${(0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(g)}`), 16);
    }
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyBigIntegerRandomPassword",
            message: "random password is empty"
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyBigIntegersaltToHashDevices",
            message: "saltToHashDevices is empty"
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: "EmptyBigIntegerVerifierDevices",
            message: "verifyDevices is empty"
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $59388e0cd726a085$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $7977b7713864e546$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $eed88bdc1fb343aa$export$22a20ab34c1d7a2b)((0, $9a6cff41abc04edc$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username , password: password , serverBValue: serverBValue , salt: salt  }) {
        if (serverBValue.mod(this.N).equals((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        const U = (0, $8f1acab179b9ebe1$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $7977b7713864e546$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $2bae7d4adcab7fc5$export$8b112e065a8843a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $1cef16b1857519e3$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert("Caldera Derived Key");
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $1da3d3222e2071df$export$295a0a5429217d03)((0, $ec5820220853a812$export$b772e43c3daf2e7a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(S)), (0, $ec5820220853a812$export$b772e43c3daf2e7a)((0, $2e4ceaf61b2d9c67$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $9a00d3dce34e0c65$export$53a55138f9e96c65 = async ({ a: a , g: g , N: N  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $e6b0d30d639b7439$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error("Illegal parameter. A mod N cannot be 0."));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $4b0015cdb42a07f3$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)((0, $97958120efb925b4$export$baab4dd8c7240846), 16);
    const g = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)("2", 16);
    const a = $4b0015cdb42a07f3$var$generateRandomBigInteger();
    const A = await (0, $9a00d3dce34e0c65$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $62713a0581f3e14f$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $4b0015cdb42a07f3$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $eed88bdc1fb343aa$export$22a20ab34c1d7a2b)((0, $9a6cff41abc04edc$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(hexRandom, 16);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $327b34006d7a710d$var$MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $327b34006d7a710d$var$WEEK_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $327b34006d7a710d$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $327b34006d7a710d$var$WEEK_NAMES[now.getUTCDay()];
    const month = $327b34006d7a710d$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2a9d2dc2f8ef941d$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName , username: username , challengeParameters: challengeParameters , dateNow: dateNow , hkdf: hkdf  })=>{
    const bufUPIDaToB = (0, $8f38281af144dd56$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $8f38281af144dd56$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $2a9d2dc2f8ef941d$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $8f38281af144dd56$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $2127c60713693f53$export$3b58ea8124ac5e28)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $2a9d2dc2f8ef941d$var$urlB64ToUint8Array = (base64String)=>{
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = (0, $01459b747c81c3e7$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d3c3238cf7b10401$var$USER_ATTRIBUTES = "userAttributes.";
async function $d3c3238cf7b10401$export$6fe6331471b54d26({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$9b78cd405a35bccd({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , deviceName: deviceName , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username
    };
    const { Session: Session  } = await (0, $d9f708d5fc22d533$export$72b1124e126ff51c)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        UserCode: challengeResponse,
        Session: session,
        FriendlyDeviceName: deviceName
    });
    (0, $4cebbc81afdf787b$export$390d5da4c63a4a41).dispatch({
        type: "SET_SIGN_IN_SESSION",
        value: Session
    });
    const jsonReq = {
        ChallengeName: "MFA_SETUP",
        ChallengeResponses: challengeResponses,
        Session: Session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId
    };
    return (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId)
    }, jsonReq);
}
async function $d3c3238cf7b10401$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(challengeResponse === "TOTP" || challengeResponse === "SMS", (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $d3c3238cf7b10401$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SELECT_MFA_TYPE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d3c3238cf7b10401$export$3eab958abdf5e22d({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username,
        SMS_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SMS_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d3c3238cf7b10401$export$b89ff5a8f5e11286({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username,
        SOFTWARE_TOKEN_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SOFTWARE_TOKEN_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d3c3238cf7b10401$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , requiredAttributes: requiredAttributes , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        ...$d3c3238cf7b10401$export$c7c9603a6b1fd815(requiredAttributes),
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d3c3238cf7b10401$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId  } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_PASSWORD_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $d9f708d5fc22d533$export$567b0d5ec943f827)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? response.ChallengeParameters?.USER_ID_FOR_SRP ?? username;
    $d3c3238cf7b10401$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_SRP_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const resp = await (0, $d9f708d5fc22d533$export$567b0d5ec943f827)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters , Session: session  } = resp;
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $d3c3238cf7b10401$export$fecfbc200868d412(activeUsername);
    return $d3c3238cf7b10401$export$30f932fe98713ccc($d3c3238cf7b10401$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $d3c3238cf7b10401$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId  } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $d9f708d5fc22d533$export$567b0d5ec943f827)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    $d3c3238cf7b10401$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: "SRP_A"
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const { ChallengeParameters: challengeParameters , Session: session  } = await (0, $d9f708d5fc22d533$export$567b0d5ec943f827)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $d3c3238cf7b10401$export$fecfbc200868d412(activeUsername);
    return $d3c3238cf7b10401$export$30f932fe98713ccc($d3c3238cf7b10401$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $d3c3238cf7b10401$var$handleDeviceSRPAuth({ username: username , config: config , clientMetadata: clientMetadata , session: session , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId  } = config;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $6e9371ee52a401af$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const { ChallengeParameters: respondedChallengeParameters , Session: Session  } = await (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    return $d3c3238cf7b10401$var$handleDevicePasswordVerifier(username, respondedChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $d3c3238cf7b10401$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId , userPoolClientId: userPoolClientId  }, tokenOrchestrator) {
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $6e9371ee52a401af$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const { deviceKey: deviceKey  } = deviceMetadata;
    const { deviceGroupKey: deviceGroupKey  } = deviceMetadata;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $327b34006d7a710d$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: challengeParameters?.USERNAME ?? username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $2a9d2dc2f8ef941d$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    return (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
}
async function $d3c3238cf7b10401$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const serverBValue = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $e6b0d30d639b7439$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const username = challengeParameters?.USER_ID_FOR_SRP;
    if (!username) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: "EmptyUserIdForSRPException",
        message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $327b34006d7a710d$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $2a9d2dc2f8ef941d$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "PASSWORD_VERIFIER",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $d9f708d5fc22d533$export$b196467a22b300ec)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $d3c3238cf7b10401$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d3c3238cf7b10401$export$cf152400b58b8e65(params) {
    const { challengeName: challengeName , challengeParameters: challengeParameters  } = params;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case "CUSTOM_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
                    additionalInfo: challengeParameters
                }
            };
        case "MFA_SETUP":
            {
                const { signInSession: signInSession , username: username  } = (0, $4cebbc81afdf787b$export$390d5da4c63a4a41).getState();
                if (!$d3c3238cf7b10401$export$aac29c972ddf3e91(challengeParameters, "TOTP")) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                    name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
                    message: `Cannot initiate MFA setup from available types: ${$d3c3238cf7b10401$export$d70c792e078766ea($d3c3238cf7b10401$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP))}`
                });
                const { Session: Session , SecretCode: secretCode  } = await (0, $d9f708d5fc22d533$export$4531a27964554be8)({
                    region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(authConfig.userPoolId)
                }, {
                    Session: signInSession
                });
                (0, $4cebbc81afdf787b$export$390d5da4c63a4a41).dispatch({
                    type: "SET_SIGN_IN_SESSION",
                    value: Session
                });
                return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
                        totpSetupDetails: $d3c3238cf7b10401$export$b105c3e8e4f5ce91(secretCode, username)
                    }
                };
            }
        case "NEW_PASSWORD_REQUIRED":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                    missingAttributes: $d3c3238cf7b10401$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case "SELECT_MFA_TYPE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
                    allowedMFATypes: $d3c3238cf7b10401$export$d70c792e078766ea($d3c3238cf7b10401$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case "SMS_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "SOFTWARE_TOKEN_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
        message: "An error occurred during the sign in process. " + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $d3c3238cf7b10401$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName ?? username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $b0f1ea60776570d9$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $d3c3238cf7b10401$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $9e23bc336cf172f0$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "RESET_PASSWORD"
        }
    };
    else if (errorName === (0, $9e23bc336cf172f0$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "CONFIRM_SIGN_UP"
        }
    };
}
function $d3c3238cf7b10401$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($d3c3238cf7b10401$var$USER_ATTRIBUTES) ? att.replace($d3c3238cf7b10401$var$USER_ATTRIBUTES, "") : att);
    return parsedAttributes;
}
function $d3c3238cf7b10401$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$d3c3238cf7b10401$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $d3c3238cf7b10401$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options?.userAttributes;
    const deviceName = options?.friendlyDeviceName;
    switch(challengeName){
        case "SMS_MFA":
            return $d3c3238cf7b10401$export$3eab958abdf5e22d({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "SELECT_MFA_TYPE":
            return $d3c3238cf7b10401$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "MFA_SETUP":
            return $d3c3238cf7b10401$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case "NEW_PASSWORD_REQUIRED":
            return $d3c3238cf7b10401$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case "CUSTOM_CHALLENGE":
            return $d3c3238cf7b10401$export$30f932fe98713ccc($d3c3238cf7b10401$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case "SOFTWARE_TOKEN_MFA":
            return $d3c3238cf7b10401$export$b89ff5a8f5e11286({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
    }
    // TODO: remove this error message for production apps
    throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $3277196cec8a3dbe$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process. 
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $d3c3238cf7b10401$export$7e7902092e38fcff(mfa) {
    let mfaType = "SMS_MFA";
    if (mfa === "TOTP") mfaType = "SOFTWARE_TOKEN_MFA";
    return mfaType;
}
function $d3c3238cf7b10401$export$6ce04ce89055b1fe(type) {
    if (type === "SMS_MFA") return "SMS";
    if (type === "SOFTWARE_TOKEN_MFA") return "TOTP";
// TODO: log warning for unknown MFA type
}
function $d3c3238cf7b10401$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($d3c3238cf7b10401$export$6ce04ce89055b1fe).filter(Boolean);
}
function $d3c3238cf7b10401$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $d3c3238cf7b10401$export$aac29c972ddf3e91(challengeParams, mfaType) {
    const { MFAS_CAN_SETUP: MFAS_CAN_SETUP  } = challengeParams;
    const mfaTypes = $d3c3238cf7b10401$export$d70c792e078766ea($d3c3238cf7b10401$export$4055ded9e78438ba(MFAS_CAN_SETUP));
    if (!mfaTypes) return false;
    return mfaTypes.includes(mfaType);
}
async function $d3c3238cf7b10401$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $a96a35a57f46b2c7$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$bdd0e7e9babcd5c8),
        message: "There is already a signed in user.",
        recoverySuggestion: "Call signOut before calling signIn again."
    });
}
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $d3c3238cf7b10401$export$5fd317fac33d34b1(userPoolId, newDeviceMetadata, accessToken) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $4b0015cdb42a07f3$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata?.DeviceKey;
    const deviceGroupKey = newDeviceMetadata?.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey ?? "", deviceKey ?? "");
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert((0, $ec5820220853a812$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $2c81515d3d5db49f$export$695b149896bd3e2a).convert((0, $ec5820220853a812$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        await (0, $d9f708d5fc22d533$export$3a7ad63dc35b752f)({
            region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceKey: newDeviceMetadata?.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $d3c3238cf7b10401$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $03e5abb25dfabdd6$export$145273558d58e0ac) && error.name === "ResourceNotFoundException" && error.message.includes("Device does not exist.")) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return func(...args);
        }
        throw error;
    }
}
function $d3c3238cf7b10401$export$fecfbc200868d412(username) {
    const { dispatch: dispatch  } = (0, $4cebbc81afdf787b$export$390d5da4c63a4a41);
    dispatch({
        type: "SET_USERNAME",
        value: username
    });
}
function $d3c3238cf7b10401$export$cc3585de146a51be(username) {
    const state = (0, $4cebbc81afdf787b$export$390d5da4c63a4a41).getState();
    return state.username ?? username;
}











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $da35d46b99b5d98d$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult?.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult?.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $d153492e067ac8ab$export$37321a6dace1881c)({
        message: "Invalid tokens",
        name: "InvalidTokens",
        recoverySuggestion: "Check Cognito UserPool settings"
    });
}











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0386d0d0091ba4c9$export$3f27bc10068ef877 = "Unable to get user session following successful sign-in.";
const $0386d0d0091ba4c9$export$4d78d2ee899572ab = async ()=>{
    try {
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedIn",
            data: await (0, $a96a35a57f46b2c7$export$e5432d4c8eb97ea7)()
        }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
    } catch (error) {
        if (error.name === (0, $e4cb7b306ced9230$export$d29d1996d6b6f5e3)) throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: (0, $e4cb7b306ced9230$export$606cffc85964c24b),
            message: $0386d0d0091ba4c9$export$3f27bc10068ef877,
            recoverySuggestion: "This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server."
        });
        throw error;
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $1ab8b470a2769d6c$export$7f948971bcf643ff(input) {
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITHOUT_SRP"
    };
    const metadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: retriedChallengeName , ChallengeParameters: retiredChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$30f932fe98713ccc)((0, $d3c3238cf7b10401$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $14fa9bd317b4b3d6$export$66561e66d62991d0)
        ], username, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $4cebbc81afdf787b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retriedChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: retriedChallengeName,
            challengeParameters: retiredChallengeParameters
        });
    } catch (error) {
        (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $37425683072d566a$export$2c0317ed1bbb0787(input) {
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITH_SRP"
    };
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $4cebbc81afdf787b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $6293e3dd6397aac6$export$728178cf826a5ab9(input) {
    const { username: username , password: password  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_SRP_AUTH"
    };
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const clientMetaData = input.options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $4cebbc81afdf787b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $5257e4d42585adf4$export$200af5a623414b2b(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_PASSWORD_AUTH"
    };
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: retiredChallengeName , ChallengeParameters: retriedChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $d3c3238cf7b10401$export$30f932fe98713ccc)((0, $d3c3238cf7b10401$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $14fa9bd317b4b3d6$export$66561e66d62991d0)
        ], username, (0, $14fa9bd317b4b3d6$export$66561e66d62991d0));
        const activeUsername = (0, $d3c3238cf7b10401$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $4cebbc81afdf787b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retiredChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f1b09a3c3b2ae67d$export$729df6fdd19b8b0d)({
                ...AuthenticationResult,
                username: activeUsername,
                NewDeviceMetadata: await (0, $d3c3238cf7b10401$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
            await (0, $0386d0d0091ba4c9$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d3c3238cf7b10401$export$cf152400b58b8e65)({
            challengeName: retiredChallengeName,
            challengeParameters: retriedChallengeParameters
        });
    } catch (error) {
        (0, $4cebbc81afdf787b$export$f3dfaa7234c98dc0)();
        (0, $30ec7ddce5c02788$export$5b3890f50cd4853f)(error);
        const result = (0, $d3c3238cf7b10401$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $8a12ffc5dc959a57$export$9670d83f11d4b64a(input) {
    const authFlowType = input.options?.authFlowType;
    await (0, $d3c3238cf7b10401$export$8061cd07f982ef08)();
    switch(authFlowType){
        case "USER_SRP_AUTH":
            return (0, $6293e3dd6397aac6$export$728178cf826a5ab9)(input);
        case "USER_PASSWORD_AUTH":
            return (0, $5257e4d42585adf4$export$200af5a623414b2b)(input);
        case "CUSTOM_WITHOUT_SRP":
            return (0, $1ab8b470a2769d6c$export$7f948971bcf643ff)(input);
        case "CUSTOM_WITH_SRP":
            return (0, $37425683072d566a$export$2c0317ed1bbb0787)(input);
        default:
            return (0, $6293e3dd6397aac6$export$728178cf826a5ab9)(input);
    }
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e010ce5326316812$var$initialAutoSignIn = async ()=>{
    throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
        name: (0, $e4cb7b306ced9230$export$fe46a12932d2550a),
        message: "The autoSignIn flow has not started, or has been cancelled/completed.",
        recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ // TODO(Eslint): can this be refactored not using `let` on exported member?
// eslint-disable-next-line import/no-mutable-exports
let $e010ce5326316812$export$c5378dc7d6787fa5 = $e010ce5326316812$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $e010ce5326316812$export$7dcbf67a23c27835(callback) {
    $e010ce5326316812$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $e010ce5326316812$export$1ffa2742ce5c589b() {
    $e010ce5326316812$export$c5378dc7d6787fa5 = $e010ce5326316812$var$initialAutoSignIn;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $094a6ff85dcbbb8a$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $094a6ff85dcbbb8a$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $9464725044e9d769$export$45dde0743a4c8d6e).listen("auth-internal", async ({ payload: payload  })=>{
        switch(payload.event){
            case "confirmSignUp":
                {
                    const response = payload.data;
                    if (response?.isSignUpComplete) {
                        (0, $9464725044e9d769$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                            event: "autoSignIn"
                        });
                        (0, $e010ce5326316812$export$7dcbf67a23c27835)($094a6ff85dcbbb8a$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        $094a6ff85dcbbb8a$export$be9e824afabf429b(false);
        clearTimeout(timeOutId);
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
    }, $094a6ff85dcbbb8a$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $094a6ff85dcbbb8a$var$debounce(fun, delay) {
    let timer;
    return (args)=>{
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $094a6ff85dcbbb8a$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $094a6ff85dcbbb8a$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            $094a6ff85dcbbb8a$export$be9e824afabf429b(false);
            reject(new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
                name: (0, $e4cb7b306ced9230$export$fe46a12932d2550a),
                message: "The account was not confirmed on time.",
                recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            }));
            (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
        } else try {
            const signInOutput = await (0, $8a12ffc5dc959a57$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_UP") {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                $094a6ff85dcbbb8a$export$be9e824afabf429b(false);
                (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            $094a6ff85dcbbb8a$export$be9e824afabf429b(false);
            reject(error);
            (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $094a6ff85dcbbb8a$var$debouncedAutoSignInWithLink = $094a6ff85dcbbb8a$var$debounce($094a6ff85dcbbb8a$var$handleAutoSignInWithLink, 300);
const $094a6ff85dcbbb8a$var$debouncedAutoSignWithCodeOrUserConfirmed = $094a6ff85dcbbb8a$var$debounce($094a6ff85dcbbb8a$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
let $094a6ff85dcbbb8a$var$autoSignInStarted = false;
let $094a6ff85dcbbb8a$var$usernameUsedForAutoSignIn;
function $094a6ff85dcbbb8a$export$9542ecebf2267645(username) {
    $094a6ff85dcbbb8a$var$usernameUsedForAutoSignIn = username;
}
function $094a6ff85dcbbb8a$export$2eb7cf6e92e4b85f(username) {
    return $094a6ff85dcbbb8a$var$usernameUsedForAutoSignIn === username;
}
function $094a6ff85dcbbb8a$export$ae4fc21c931f7784() {
    return $094a6ff85dcbbb8a$var$autoSignInStarted;
}
function $094a6ff85dcbbb8a$export$be9e824afabf429b(value) {
    if (value === false) $094a6ff85dcbbb8a$export$9542ecebf2267645(undefined);
    $094a6ff85dcbbb8a$var$autoSignInStarted = value;
}
function $094a6ff85dcbbb8a$export$9fd29532e325aae0(output) {
    return !!output.UserConfirmed;
}
function $094a6ff85dcbbb8a$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $094a6ff85dcbbb8a$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $094a6ff85dcbbb8a$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        const output = await (0, $8a12ffc5dc959a57$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $e010ce5326316812$export$1ffa2742ce5c589b)();
    }
}
function $094a6ff85dcbbb8a$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $094a6ff85dcbbb8a$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $094a6ff85dcbbb8a$export$9ec2c3d010185172 = $094a6ff85dcbbb8a$var$autoSignInWithCode;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $9c3de9596e817bc7$export$2ce39ab6662e8c24(input) {
    const { username: username , confirmationCode: confirmationCode , options: options  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = authConfig;
    const clientMetadata = options?.clientMetadata;
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!confirmationCode, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $d1d75befb3456a99$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    await (0, $d9f708d5fc22d533$export$2ce39ab6662e8c24)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options?.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "DONE"
                }
            };
            if (!(0, $094a6ff85dcbbb8a$export$ae4fc21c931f7784)() || !(0, $094a6ff85dcbbb8a$export$2eb7cf6e92e4b85f)(username)) {
                resolve(signUpOut);
                return;
            }
            const stopListener = (0, $9464725044e9d769$export$45dde0743a4c8d6e).listen("auth-internal", ({ payload: payload  })=>{
                switch(payload.event){
                    case "autoSignIn":
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: "COMPLETE_AUTO_SIGN_IN"
                            }
                        });
                        (0, $094a6ff85dcbbb8a$export$be9e824afabf429b)(false);
                        stopListener();
                }
            });
            (0, $9464725044e9d769$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                event: "confirmSignUp",
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $99a0826aa0b12fc7$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c68f73318e91dfc9$export$39430dfe49142ae = (options)=>{
    return (0, $99a0826aa0b12fc7$export$39430dfe49142ae)((0, $44174d4eb465d133$export$a3858a9a153cffc7), options);
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $989e07b151f5455b$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $989e07b151f5455b$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes?.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $dd63226066db75fc$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    const { tokens: tokens  } = await (0, $99a0826aa0b12fc7$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $6e9371ee52a401af$export$77712ea5882cac9f)(tokens);
    const { UserAttributes: UserAttributes  } = await (0, $d9f708d5fc22d533$export$7cbf767827cd68ba)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $989e07b151f5455b$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $b94443d14601a306$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $dd63226066db75fc$export$5dc95ecf3f16c6c9)((0, $44174d4eb465d133$export$a3858a9a153cffc7));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $e863fa8082f45809$export$d1b63878dfcc70a6() {
    return (0, $44174d4eb465d133$export$a3858a9a153cffc7).Auth.clearCredentials();
}



















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $872756867fb3a1a7$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).clearTokens();
    await (0, $e863fa8082f45809$export$d1b63878dfcc70a6)();
    (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedOut"
    }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ef51fed5140dc4d1$export$a673d54799039714 = async (url)=>{
    if (!window?.location) return;
    // enforce HTTPS
    window.location.href = url.replace("http://", "https://");
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $cbadbba8ed1b5a8c$export$93832c3affb240d3(redirects) {
    const redirectUrlFromTheSameOrigin = redirects?.find($cbadbba8ed1b5a8c$var$isSameOriginAndPathName) ?? redirects?.find($cbadbba8ed1b5a8c$var$isTheSameDomain);
    const redirectUrlFromDifferentOrigin = redirects?.find($cbadbba8ed1b5a8c$var$isHttps) ?? redirects?.find($cbadbba8ed1b5a8c$var$isHttp);
    if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
    else if (redirectUrlFromDifferentOrigin) throw 0, $e4cb7b306ced9230$export$c01b4acd6291e035;
    throw 0, $e4cb7b306ced9230$export$60b68b138a52e5ae;
}
// origin + pathname => https://example.com/app
const $cbadbba8ed1b5a8c$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(String((window.location.origin + window.location.pathname) ?? "/"));
// domain => outlook.live.com, github.com
const $cbadbba8ed1b5a8c$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $cbadbba8ed1b5a8c$var$isHttp = (redirect)=>redirect.startsWith("http://");
const $cbadbba8ed1b5a8c$var$isHttps = (redirect)=>redirect.startsWith("https://");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $de1604557ee99f23$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false)=>{
    (0, $da35d46b99b5d98d$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith , userPoolClientId: userPoolClientId  } = authConfig;
    const { domain: domain , redirectSignOut: redirectSignOut  } = loginWith.oauth;
    const signoutUri = (0, $cbadbba8ed1b5a8c$export$93832c3affb240d3)(redirectSignOut);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join("&")}`;
    return (0, $ef51fed5140dc4d1$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0911740e79fabe84$export$74290142c99a2f64 = async (cognitoConfig, store)=>{
    const { isOAuthSignIn: isOAuthSignIn  } = await store.loadOAuthSignIn();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $872756867fb3a1a7$export$f8a4fedaab76b065)(store);
    if (isOAuthSignIn) // On web, this will always end up being a void action
    return (0, $de1604557ee99f23$export$a20426d3d43ad21f)(cognitoConfig);
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ce6bf905214da226$var$logger = new (0, $39a0f4f2bf9492b0$export$ba6a9c7ac8291f7f)("Auth");
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $ce6bf905214da226$export$b0ac3a1c242cb1ea(input) {
    const cognitoConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(cognitoConfig);
    if (input?.global) await $ce6bf905214da226$var$globalSignOut(cognitoConfig);
    else await $ce6bf905214da226$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $da35d46b99b5d98d$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        const oAuthStore = new (0, $388b2d9f599c1030$export$9b2cef5d94f9b6e8)((0, $d6350db11aa681cd$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        const { type: type  } = await (0, $0911740e79fabe84$export$74290142c99a2f64)(cognitoConfig, oAuthStore) ?? {};
        if (type === "error") throw new (0, $03e5abb25dfabdd6$export$145273558d58e0ac)({
            name: (0, $e4cb7b306ced9230$export$625255707e22459c),
            message: "An error occurred when attempting to log out from OAuth provider."
        });
    } else {
        // complete sign out
        (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).clearTokens();
        await (0, $e863fa8082f45809$export$d1b63878dfcc70a6)();
        (0, $9464725044e9d769$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedOut"
        }, "Auth", (0, $9464725044e9d769$export$aadf71dd9875dd20));
    }
}
async function $ce6bf905214da226$var$clientSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $6e9371ee52a401af$export$be38b2d22222d505)(authTokens);
        if ($ce6bf905214da226$var$isSessionRevocable(authTokens.accessToken)) await (0, $d9f708d5fc22d533$export$2428f6ba65615593)({
            region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignOut)
        }, {
            ClientId: cognitoConfig.userPoolClientId,
            Token: authTokens.refreshToken
        });
    } catch (err) {
        // this shouldn't throw
        $ce6bf905214da226$var$logger.debug("Client signOut error caught but will proceed with token removal");
    }
}
async function $ce6bf905214da226$var$globalSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $14fa9bd317b4b3d6$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $6e9371ee52a401af$export$77712ea5882cac9f)(authTokens);
        await (0, $d9f708d5fc22d533$export$a92c2ab9b6303723)({
            region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $ce6bf905214da226$var$logger.debug("Global signOut error caught but will proceed with token removal");
    }
}
const $ce6bf905214da226$var$isSessionRevocable = (token)=>!!token?.payload?.origin_jti;











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $cbf5ba3463998b72$export$cf64224bcd829024(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $44174d4eb465d133$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signUpVerificationMethod = authConfig?.signUpVerificationMethod ?? "code";
    const { clientMetadata: clientMetadata , validationData: validationData , autoSignIn: autoSignIn  } = input.options ?? {};
    (0, $da35d46b99b5d98d$export$80c92581e59ed502)(authConfig);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!username, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpUsername);
    (0, $fd90eaa8008e7494$export$45936001d12f9b53)(!!password, (0, $e5a1b34bea683c02$export$12d5c695b2213c4a).EmptySignUpPassword);
    const signInServiceOptions = typeof autoSignIn !== "boolean" ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if (signInServiceOptions?.authFlowType !== "CUSTOM_WITHOUT_SRP") signInInput.password = password;
    if (signInServiceOptions || autoSignIn === true) {
        (0, $094a6ff85dcbbb8a$export$9542ecebf2267645)(username);
        (0, $094a6ff85dcbbb8a$export$be9e824afabf429b)(true);
    }
    const clientOutput = await (0, $d9f708d5fc22d533$export$cf64224bcd829024)({
        region: (0, $e2042681c7604de8$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $7032744b11af61d7$export$d6cd780379f37dae)((0, $80240862ea60f1f3$export$900b1436d7e65f4).SignUp)
    }, {
        Username: username,
        Password: password,
        UserAttributes: options?.userAttributes && (0, $989e07b151f5455b$export$720a7caa078a04b0)(options?.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $989e07b151f5455b$export$720a7caa078a04b0)(validationData),
        ClientId: authConfig.userPoolClientId
    });
    const { UserSub: UserSub , CodeDeliveryDetails: CodeDeliveryDetails  } = clientOutput;
    if ((0, $094a6ff85dcbbb8a$export$9fd29532e325aae0)(clientOutput) && (0, $094a6ff85dcbbb8a$export$ae4fc21c931f7784)()) {
        (0, $e010ce5326316812$export$7dcbf67a23c27835)((0, $094a6ff85dcbbb8a$export$9ec2c3d010185172)(signInInput));
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN"
            },
            userId: UserSub
        };
    } else if ((0, $094a6ff85dcbbb8a$export$9fd29532e325aae0)(clientOutput) && !(0, $094a6ff85dcbbb8a$export$ae4fc21c931f7784)()) return {
        isSignUpComplete: true,
        nextStep: {
            signUpStep: "DONE"
        },
        userId: UserSub
    };
    else if (!(0, $094a6ff85dcbbb8a$export$9fd29532e325aae0)(clientOutput) && (0, $094a6ff85dcbbb8a$export$ae4fc21c931f7784)() && signUpVerificationMethod === "code") (0, $094a6ff85dcbbb8a$export$385d6b43f72ecccf)(signInInput);
    else if (!(0, $094a6ff85dcbbb8a$export$9fd29532e325aae0)(clientOutput) && (0, $094a6ff85dcbbb8a$export$ae4fc21c931f7784)() && signUpVerificationMethod === "link") {
        (0, $e010ce5326316812$export$7dcbf67a23c27835)((0, $094a6ff85dcbbb8a$export$feaed4858b71e8a)(signInInput));
        return {
            isSignUpComplete: false,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN",
                codeDeliveryDetails: {
                    deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                    destination: CodeDeliveryDetails?.Destination,
                    attributeName: CodeDeliveryDetails?.AttributeName
                }
            },
            userId: UserSub
        };
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: "CONFIRM_SIGN_UP",
            codeDeliveryDetails: {
                deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                destination: CodeDeliveryDetails?.Destination,
                attributeName: CodeDeliveryDetails?.AttributeName
            }
        },
        userId: UserSub
    };
}


const $dfc697a5db8ce601$var$awsmobile = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_yhdxywO4A",
    aws_user_pools_web_client_id: "7n98lj1fda2au0rvmb6hg4ucau",
    oauth: {},
    aws_cognito_username_attributes: [
        "EMAIL"
    ],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: [
        "EMAIL"
    ],
    aws_cognito_verification_mechanisms: [
        "EMAIL"
    ]
};
var $dfc697a5db8ce601$export$2e2bcd8739ae039 = $dfc697a5db8ce601$var$awsmobile;


(0, $2fcf3704ebc37489$export$11ac3725994bec7b).configure((0, $dfc697a5db8ce601$export$2e2bcd8739ae039));
const $5a12233f233e4186$export$38ee920e59704589 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
const $5a12233f233e4186$var$ENDPOINT = "https://yar08qypp7.execute-api.us-east-1.amazonaws.com/dev/";
const $5a12233f233e4186$var$AUTH_ENDPOINT = "https://31mb8vbzh2.execute-api.us-east-1.amazonaws.com/dev/";
const $5a12233f233e4186$var$API_KEY = "EwULDyHjTn8iy8cQutA7n8vdFdWv2ejn8ixzYdiI";
function $5a12233f233e4186$var$UserProvider({ children: children  }) {
    const [isAuthenticated, setIsAuthenticated] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [authUpdated, setAuthUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [user, setUser] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [token, setToken] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [isAuthModalOpen, setIsAuthModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [userQueries, setUserQueries] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [userSequences, setUserSequences] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [userDefaultHiddenSequences, setUserDefaultHiddenSequences] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [infiniteScrollToken, setInfiniteScrollToken] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [stats, setStats] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const getUserData = async ()=>{
            try {
                const { username: username , userId: userId , signInDetails: signInDetails  } = await (0, $a96a35a57f46b2c7$export$e5432d4c8eb97ea7)();
                const userAttributes = await (0, $b94443d14601a306$export$5dc95ecf3f16c6c9)();
                setIsAuthenticated(true);
                setUser(username);
                setName(userAttributes["given_name"]);
                const { tokens: tokens  } = await (0, $c68f73318e91dfc9$export$39430dfe49142ae)({
                    forceRefresh: true
                });
                const idToken = tokens.idToken.toString();
                setToken(idToken);
            } catch (err) {
                // console.log(err);
                setIsAuthenticated(false);
            }
        };
        getUserData();
    }, [
        authUpdated
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const getUserHistory = async ()=>{
            if (!isAuthenticated) return;
            if (!token) return;
            const URL = $5a12233f233e4186$var$AUTH_ENDPOINT + "queries";
            const HEADERS = {
                "Content-Type": "application/json",
                Authorization: token
            };
            const request = new Request(URL, {
                method: "GET",
                headers: HEADERS,
                timeout: 100000
            });
            const response = await fetch(request);
            const json = await response.json();
            const items = json.Items;
            setUserQueries(items);
        };
        getUserHistory();
    }, [
        isAuthenticated,
        user,
        token
    ]);
    function processUserSequences(sequences) {
        if (!sequences || Object.keys(sequences).length === 0) return [];
        return sequences.map((sequence)=>{
            const sequenceName = sequence.SK1.S.split("#")[1];
            const sequenceId = `custom#${sequenceName.replace(/ /g, "_")}`;
            const sequenceValues = JSON.parse(sequence.VALUES.S);
            return {
                name: sequenceName,
                id: sequenceId,
                sequence: sequenceValues
            };
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const getUserSequenceDefaults = async ()=>{
            if (!isAuthenticated) return;
            if (!token) return;
            const URL = $5a12233f233e4186$var$AUTH_ENDPOINT + "sequence";
            const HEADERS = {
                "Content-Type": "application/json",
                Authorization: token
            };
            const request = new Request(URL, {
                method: "GET",
                headers: HEADERS,
                timeout: 100000
            });
            const response = await fetch(request);
            const json = await response.json();
            const defaultHiddenSequences = json["default_hidden_sequences"];
            const customSequences = json["custom_sequences"];
            const processed = processUserSequences(customSequences);
            setUserSequences(processed);
            setUserDefaultHiddenSequences(defaultHiddenSequences);
        };
        getUserSequenceDefaults();
    }, [
        isAuthenticated,
        user,
        token
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const getStats = async ()=>{
            if (isAuthenticated && !token) return;
            const URL = isAuthenticated ? $5a12233f233e4186$var$AUTH_ENDPOINT + `stats` : $5a12233f233e4186$var$ENDPOINT + `stats`;
            const HEADERS = isAuthenticated ? {
                "Content-Type": "application/json",
                Authorization: token
            } : {
                "Content-Type": "application/json",
                "x-api-key": $5a12233f233e4186$var$API_KEY
            };
            const request = new Request(URL, {
                method: "GET",
                headers: HEADERS,
                timeout: 100000
            });
            const response = await fetch(request);
            const json = await response.json();
            setStats(json);
        };
        getStats();
    }, [
        isAuthenticated,
        user,
        token
    ]);
    const deleteQuery = async (queryId)=>{
        const oldQuery = userQueries.filter((query)=>{
            return query.MATRIX_SHAREID.S === queryId;
        })[0];
        const oldUlid = oldQuery.MATRIX_ULID.S;
        setUserQueries((oldValue)=>{
            return oldValue.filter((query)=>{
                return query.MATRIX_SHAREID.S !== queryId;
            });
        });
        const URL = $5a12233f233e4186$var$AUTH_ENDPOINT + `query?id=${queryId}&ulid=${oldUlid}`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const request = new Request(URL, {
            method: "DELETE",
            headers: HEADERS,
            timeout: 100000
        });
        const response = await fetch(request);
        const json = await response.json();
    };
    const deleteSequence = async (sequenceId)=>{
        const oldSequence = userSequences.filter((sequence)=>{
            return sequence.id === sequenceId;
        })[0];
        const sequenceTitle = oldSequence.name;
        const payload = {
            title: sequenceTitle
        };
        const URL = $5a12233f233e4186$var$AUTH_ENDPOINT + `sequence`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const request = new Request(URL, {
            method: "DELETE",
            headers: HEADERS,
            body: JSON.stringify(payload),
            timeout: 100000
        });
        const response = await fetch(request);
        const json = await response.json();
    };
    const handleLogout = async ()=>{
        try {
            await (0, $ce6bf905214da226$export$b0ac3a1c242cb1ea)();
            setIsAuthenticated(false);
            setUser("");
            setName("");
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {
        // console.log(err);
        }
    };
    const handleLogin = async (email, password)=>{
        try {
            const input = {
                username: email,
                password: password
            };
            const response = await (0, $8a12ffc5dc959a57$export$9670d83f11d4b64a)(input);
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {
        // console.log(err);
        }
    };
    const handleSignUp = async (email, password, firstname, lastname)=>{
        try {
            const input = {
                username: email,
                password: password,
                options: {
                    userAttributes: {
                        email: email,
                        given_name: firstname,
                        family_name: lastname
                    }
                }
            };
            const signUpResponse = await (0, $cbf5ba3463998b72$export$cf64224bcd829024)(input);
        } catch (err) {
        // console.log(err);
        }
    };
    const handleConfirmSignUp = async (email, code)=>{
        try {
            const { isSignUpComplete: isSignUpComplete , nextStep: nextStep  } = await (0, $9c3de9596e817bc7$export$2ce39ab6662e8c24)({
                username: email,
                confirmationCode: code
            });
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (error) {
        // console.log('error confirming sign up', error);
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5a12233f233e4186$export$38ee920e59704589.Provider, {
        value: {
            isAuthenticated: isAuthenticated,
            setIsAuthenticated: setIsAuthenticated,
            user: user,
            handleLogout: handleLogout,
            handleLogin: handleLogin,
            handleSignUp: handleSignUp,
            handleConfirmSignUp: handleConfirmSignUp,
            isAuthModalOpen: isAuthModalOpen,
            setIsAuthModalOpen: setIsAuthModalOpen,
            token: token,
            userQueries: userQueries,
            stats: stats,
            deleteQuery: deleteQuery,
            name: name,
            userSequences: userSequences,
            userDefaultHiddenSequences: userDefaultHiddenSequences,
            setUserSequences: setUserSequences,
            setUserDefaultHiddenSequences: setUserDefaultHiddenSequences,
            deleteSequence: deleteSequence
        },
        children: children
    });
}
var $5a12233f233e4186$export$2e2bcd8739ae039 = $5a12233f233e4186$var$UserProvider;




const $7ead3b1a9a673b0a$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
const $7ead3b1a9a673b0a$var$ENDPOINT = "https://yar08qypp7.execute-api.us-east-1.amazonaws.com/dev/";
const $7ead3b1a9a673b0a$var$AUTH_ENDPOINT = "https://31mb8vbzh2.execute-api.us-east-1.amazonaws.com/dev/";
const $7ead3b1a9a673b0a$var$API_KEY = "EwULDyHjTn8iy8cQutA7n8vdFdWv2ejn8ixzYdiI";
function $7ead3b1a9a673b0a$var$DataProvider({ children: children  }) {
    const [sequenceLength, setSequenceLength] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(8);
    const [targetBoxIndex, setTargetBoxIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(-1);
    const [gSequence, setGSequence] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState((0, $fd5756bdc716f509$export$98a7a12ae94b641)[1].sequence);
    const [fSequence, setFSequence] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([
        0,
        ...(0, $fd5756bdc716f509$export$98a7a12ae94b641)[1].sequence.slice(0, -1)
    ]);
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("normal");
    const [metaMode, setMetaMode] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("classic");
    const [matrix, setMatrix] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [computeWasRequested, setComputeWasRequested] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [matrixWasFetched, setMatrixWasFetched] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [currentGSelection, setCurrentGSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("catalan");
    const [currentFSelection, setCurrentFSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("catalan");
    const [tabWasPressed, setTabWasPressed] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [fJustIncreased, setFJustIncreased] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [gJustIncreased, setGJustIncreased] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [matrixCreator, setMatrixCreator] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [title, setTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [comment, setComment] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [matrixId, setMatrixId] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [shareMatrixId, setShareMatrixId] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [createdAt, setCreatedAt] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [creatorName, setCreatorName] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [customSequenceTitle, setCustomSequenceTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [customSequence, setCustomSequence] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]);
    const [customSequenceLength, setCustomSequenceLength] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(10);
    const { isAuthenticated: isAuthenticated , isAuthModalOpen: isAuthModalOpen , token: token , userSequences: userSequences  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    function getDerivativeSequence(fSequence) {
        if (metaMode === "exponential") return fSequence.slice(1);
        return fSequence.slice(1).map((elem, idx)=>{
            return elem * (idx + 1);
        });
    }
    function getAssociatedSequence(fSequence) {
        const newGSequence = Array(fSequence.length).fill(0);
        newGSequence[0] = 1;
        return newGSequence;
    }
    function getBellSequence(gSequence) {
        return [
            0,
            ...gSequence
        ];
    }
    function getTwoBellSequence(gSequence) {
        const gSquared = Array(gSequence.length).fill(0);
        let i = 0;
        for(i = 0; i < gSquared.length; i++){
            const array_1 = gSequence.slice(0, i + 1);
            const array_2 = gSequence.slice(0, i + 1).reverse();
            const unreducedProduct = array_1.map((elem, idx)=>{
                return elem * array_2[idx];
            });
            gSquared[i] = unreducedProduct.reduce(function(a, b) {
                return a + b;
            }, 0);
        }
        return [
            0,
            ...gSquared
        ];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        async function fetchMatrix(sequenceLength, gSequence, fSequence, mode, metaMode) {
            let fSequenceSubmit = fSequence;
            let gSequenceSubmit = gSequence;
            // if (mode === 'bell') {
            //   fSequenceSubmit = [0].concat(gSequence.slice(0, sequenceLength)).join();
            // } else if (mode === 'derivative' && metaMode === 'exponential') {
            //   const derivative = fSequence.slice(1);
            //   gSequenceSubmit = derivative.join();
            // } else if (mode === 'appell') {
            //   const newFSequence = Array(gSequence.length).fill(0);
            //   newFSequence[1] = 1;
            //   fSequenceSubmit = newFSequence.join();
            // } else if (mode === 'associated') {
            //   const newGSequence = Array(fSequence.length).fill(0);
            //   newGSequence[0] = 1;
            //   gSequenceSubmit = newGSequence.join();
            // } else if (mode === 'twobell') {
            //   let gSquared = Array(gSequence.length).fill(0);
            //   let i = 0;
            //   for (i = 0; i < gSquared.length; i++) {
            //     const array_1 = gSequence.slice(0, i + 1);
            //     const array_2 = gSequence.slice(0, i + 1).reverse();
            //     const unreducedProduct = array_1.map((elem, idx) => {
            //       return elem * array_2[idx];
            //     });
            //     gSquared[i] = unreducedProduct.reduce(function (a, b) {
            //       return a + b;
            //     }, 0);
            //     const newFSequence = [0].concat(gSquared);
            //     fSequenceSubmit = newFSequence.join();
            //   }
            // }
            const payload = {
                g: gSequenceSubmit.slice(0, sequenceLength),
                f: fSequenceSubmit.slice(0, sequenceLength),
                gSequenceId: currentGSelection,
                fSequenceId: currentFSelection,
                sequenceLength: sequenceLength,
                mode: mode,
                metaMode: metaMode
            };
            const URL = isAuthenticated ? $7ead3b1a9a673b0a$var$AUTH_ENDPOINT + "queries" : $7ead3b1a9a673b0a$var$ENDPOINT + "queries";
            const HEADERS = isAuthenticated ? {
                "Content-Type": "application/json",
                Authorization: token
            } : {
                "Content-Type": "application/json",
                "x-api-key": $7ead3b1a9a673b0a$var$API_KEY
            };
            const request = new Request(URL, {
                method: "PUT",
                headers: HEADERS,
                body: JSON.stringify(payload),
                timeout: 100000
            });
            const response = await fetch(request);
            const json = await response.json();
            setMatrix((oldData)=>json);
            const parsedJson = JSON.parse(json);
            const shareId = parsedJson["shareid"];
            setShareMatrixId(shareId);
            return json;
        }
        if (computeWasRequested && !matrixWasFetched) {
            fetchMatrix(sequenceLength, gSequence, fSequence, mode, metaMode);
            setComputeWasRequested(false);
            setMatrixWasFetched(true);
        }
    }, [
        computeWasRequested,
        matrixWasFetched
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        async function fetchPrecomputedMatrix(matrixIdentifier) {
            const URL = isAuthenticated ? $7ead3b1a9a673b0a$var$AUTH_ENDPOINT + `query?id=${matrixIdentifier}` : $7ead3b1a9a673b0a$var$ENDPOINT + `query?id=${matrixIdentifier}`;
            const HEADERS = isAuthenticated ? {
                "Content-Type": "application/json",
                Authorization: token
            } : {
                "Content-Type": "application/json",
                "x-api-key": $7ead3b1a9a673b0a$var$API_KEY
            };
            const request = new Request(URL, {
                method: "GET",
                headers: HEADERS,
                timeout: 100000
            });
            const response = await fetch(request);
            const json = await response.json();
            // setMatrix((oldData) => json);
            const retrievedGSequenceId = json["G_SEQUENCE_ID"]["S"];
            const retrievedFSequenceId = json["F_SEQUENCE_ID"]["S"];
            const retrievedSequenceLength = parseInt(json["SEQUENCE_LENGTH"]["S"]);
            let retrievedGSequence = JSON.parse(json["G_SEQUENCE"]["S"]);
            let retrievedFSequence = JSON.parse(json["F_SEQUENCE"]["S"]);
            setCreatedAt(json["CREATED_AT"]["S"]);
            setCreatorName(json["CREATOR_NAME"]["S"]);
            setSequenceLength(retrievedSequenceLength);
            setCurrentGSelection(retrievedGSequenceId);
            setCurrentFSelection(retrievedFSequenceId);
            setMatrixCreator(json["CREATED_BY"]["S"]);
            if (json["TITLE"]) setTitle(json["TITLE"]["S"]);
            if (json["COMMENT"]) setComment(json["COMMENT"]["S"]);
            if (retrievedGSequenceId !== "custom") {
                const result = (0, $fd5756bdc716f509$export$98a7a12ae94b641).filter((item)=>item.id === retrievedGSequenceId)[0].sequence;
                retrievedGSequence = result;
            }
            if (retrievedFSequenceId !== "custom") retrievedFSequence = [
                0,
                ...(0, $fd5756bdc716f509$export$98a7a12ae94b641).filter((item)=>item.id === retrievedFSequenceId)[0].sequence
            ];
            let maxSequenceLength = Math.max(retrievedGSequence.length, retrievedFSequence.length);
            if (maxSequenceLength === retrievedSequenceLength) maxSequenceLength += 7;
            if (retrievedGSequence.length < maxSequenceLength) {
                const zeroesToAdd = Array(maxSequenceLength - retrievedGSequence.length).fill(0);
                retrievedGSequence = [
                    ...retrievedGSequence,
                    ...zeroesToAdd
                ];
            }
            if (retrievedFSequence.length < maxSequenceLength) {
                const zeroesToAdd = Array(maxSequenceLength - retrievedFSequence.length).fill(0);
                retrievedFSequence = [
                    ...retrievedFSequence,
                    ...zeroesToAdd
                ];
            }
            setGSequence(retrievedGSequence);
            setFSequence(retrievedFSequence);
            setMode(json["MODE"]["S"]);
            setMetaMode(json["METAMODE"]["S"]);
            setMatrix(json["MATRIX_DATA"]["S"]);
            return json;
        }
        if (matrixId) fetchPrecomputedMatrix(matrixId);
    }, [
        matrixId,
        token
    ]);
    // get ? search params from the URL and print them
    const searchParam = window.location.search;
    if (matrixId === "" && searchParam.length > 1) {
        setMatrixId(searchParam.slice(1));
        if (!matrix) setShareMatrixId(searchParam.slice(1));
    }
    function handleCompute() {
        setComputeWasRequested(true);
        setMatrixWasFetched(false);
    }
    // Note incorporate functionality back into handleSequenceChange
    // function handleAddZero(targetSequence) {
    //   const setSequence = targetSequence === 'g' ? setGSequence : setFSequence;
    //   const increasedSetter =
    //     targetSequence === 'g' ? setGJustIncreased : setFJustIncreased;
    //   setSequence((oldSequence) => {
    //     handleSequenceChange(targetSequence, [0, ...oldSequence]);
    //   });
    //   increasedSetter(true);
    // }
    // Note incorporate functionality back into handleSequenceChange
    // function handleLeftShift(targetSequence) {
    //   const setSequence = targetSequence === 'g' ? setGSequence : setFSequence;
    //   setSequence((oldSequence) => [...oldSequence.slice(1)]);
    //   if (Math.min(gSequence.length, fSequence.length) < sequenceLength) {
    //     setSequenceLength(Math.min(gSequence.length, fSequence.length));
    //   }
    //   setGJustIncreased(false);
    //   setFJustIncreased(false);
    // }
    function handleSelectSequence(targetSequence, selectedSequence) {
        const setCurrentSelection = targetSequence === "g" ? setCurrentGSelection : setCurrentFSelection;
        setCurrentSelection(selectedSequence);
        if (selectedSequence === "custom") {
            if (mode !== "normal") {
                setCurrentGSelection("custom");
                setCurrentFSelection("custom");
            }
            return;
        }
        // const setSequence = targetSequence === 'g' ? setGSequence : setFSequence;
        const allSequences = [
            ...(0, $fd5756bdc716f509$export$98a7a12ae94b641),
            ...userSequences
        ];
        const sequence = allSequences.filter((item)=>item.id === selectedSequence)[0].sequence;
        const finalSequence = targetSequence === "g" ? sequence : [
            0,
            ...sequence
        ];
        // setSequence(finalSequence);
        handleSequenceChange(targetSequence, finalSequence, false);
    }
    function handleSequenceChange(sequenceId, newSequence, isCustom = true) {
        const setSequence = sequenceId === "g" ? setGSequence : setFSequence;
        const oldSequence = sequenceId === "g" ? gSequence : fSequence;
        const increasedSetter = sequenceId === "g" ? setGJustIncreased : setFJustIncreased;
        if (newSequence.length > oldSequence.length) increasedSetter(true);
        else {
            setGJustIncreased(false);
            setFJustIncreased(false);
        }
        // const setAlternate = sequenceId === 'g' ? setFSequence : setGSequence;
        if (mode === "normal") setSequence(newSequence);
        else if (mode === "bell") {
            setGSequence(newSequence);
            const bellSequence = getBellSequence(newSequence);
            setFSequence(bellSequence);
        } else if (mode === "appell") setGSequence(newSequence);
        else if (mode === "derivative") {
            setFSequence(newSequence);
            const derivativeSequence = getDerivativeSequence(newSequence);
            setGSequence(derivativeSequence);
        } else if (mode === "associated") {
            setFSequence(newSequence);
            const associatedSequence = getAssociatedSequence(newSequence);
            setGSequence(associatedSequence);
        }
        if (mode === "twobell") {
            setGSequence(newSequence);
            const twoBellSequence = getTwoBellSequence(newSequence);
            setFSequence(twoBellSequence);
        }
    }
    function handleSelectMode(selectedMode) {
        setMode(selectedMode);
        if (selectedMode === "bell") setFSequence(getBellSequence(gSequence));
        else if (selectedMode === "appell") {
            const appellArray = new Array(gSequence.length).fill(0);
            appellArray[1] = 1;
            setFSequence(appellArray);
        } else if (selectedMode === "derivative") {
            const derivativeSequence = getDerivativeSequence(fSequence);
            setGSequence(derivativeSequence);
        } else if (selectedMode === "associated") {
            const associatedSequence = getAssociatedSequence(fSequence);
            setGSequence(associatedSequence);
        } else if (selectedMode === "twobell") {
            const twoBellSequence = getTwoBellSequence(gSequence);
            setFSequence(twoBellSequence);
        }
    }
    function handleAugmentSequence() {
        setSequenceLength((oldValue)=>oldValue + 1);
        setGJustIncreased(false);
        setFJustIncreased(false);
    }
    function handleTruncateSequence() {
        setSequenceLength((oldValue)=>oldValue - 1);
        setGJustIncreased(false);
        setFJustIncreased(false);
    }
    function tabFocus(event, bothShiftAndTabWerePressed) {
        if (isAuthModalOpen) return;
        const increment = bothShiftAndTabWerePressed ? -1 : 1;
        setTabWasPressed(true);
        setTargetBoxIndex((oldValue)=>{
            let result = 0;
            let divisor = sequenceLength * 2;
            let delta = 0;
            if ([
                "bell",
                "appell",
                "twobell"
            ].includes(mode)) divisor = sequenceLength;
            else if ([
                "derivative",
                "associated"
            ].includes(mode)) {
                divisor = sequenceLength;
                delta = sequenceLength;
            }
            result = (oldValue + increment) % divisor;
            if (result < 0) result += divisor + delta;
            else if (result < divisor) result += delta;
            if (result === sequenceLength && result > 0) result += 1;
            return result;
        });
    }
    const addCustomSequence = async (sequenceValues, sequenceTitle)=>{
        const URL = $7ead3b1a9a673b0a$var$AUTH_ENDPOINT + `sequence`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const payload = {
            title: sequenceTitle,
            values: sequenceValues
        };
        const request = new Request(URL, {
            method: "PUT",
            headers: HEADERS,
            body: JSON.stringify(payload),
            timeout: 100000
        });
        const response = await fetch(request);
        const json = await response.json();
    };
    // const handleTab = React.useCallback(tabFocus, []);
    (0, $5062b72bd9e8c207$export$2e2bcd8739ae039)("Tab", !isAuthModalOpen, (event, bothShiftAndTabWerePressed)=>{
        if (!isAuthModalOpen) tabFocus(event, bothShiftAndTabWerePressed);
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7ead3b1a9a673b0a$export$58d75f9829cbe158.Provider, {
        value: {
            sequenceLength: sequenceLength,
            setSequenceLength: setSequenceLength,
            targetBoxIndex: targetBoxIndex,
            setTargetBoxIndex: setTargetBoxIndex,
            gSequence: gSequence,
            fSequence: fSequence,
            mode: mode,
            handleAugmentSequence: // handleAddZero,
            handleAugmentSequence,
            handleTruncateSequence: handleTruncateSequence,
            handleSelectSequence: // handleLeftShift,
            handleSelectSequence,
            handleSelectMode: handleSelectMode,
            metaMode: metaMode,
            matrix: matrix,
            setMetaMode: setMetaMode,
            handleCompute: handleCompute,
            computeWasRequested: computeWasRequested,
            matrixWasFetched: matrixWasFetched,
            handleSequenceChange: handleSequenceChange,
            currentGSelection: currentGSelection,
            currentFSelection: currentFSelection,
            tabWasPressed: tabWasPressed,
            setTabWasPressed: setTabWasPressed,
            fJustIncreased: fJustIncreased,
            setFJustIncreased: setFJustIncreased,
            gJustIncreased: gJustIncreased,
            setGJustIncreased: setGJustIncreased,
            matrixId: matrixId,
            matrixCreator: matrixCreator,
            title: title,
            comment: comment,
            createdAt: createdAt,
            creatorName: creatorName,
            shareMatrixId: shareMatrixId,
            customSequence: customSequence,
            setCustomSequence: setCustomSequence,
            customSequenceLength: customSequenceLength,
            setCustomSequenceLength: setCustomSequenceLength,
            addCustomSequence: addCustomSequence,
            customSequenceTitle: customSequenceTitle,
            setCustomSequenceTitle: setCustomSequenceTitle
        },
        children: children
    });
}
var $7ead3b1a9a673b0a$export$2e2bcd8739ae039 = $7ead3b1a9a673b0a$var$DataProvider;







var $bh6RR = parcelRequire("bh6RR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5606419dfe2e9b1b$var$extendStatics = function(d, b) {
    $5606419dfe2e9b1b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5606419dfe2e9b1b$var$extendStatics(d, b);
};
function $5606419dfe2e9b1b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5606419dfe2e9b1b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5606419dfe2e9b1b$export$18ce0697a983be9b = function() {
    $5606419dfe2e9b1b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5606419dfe2e9b1b$export$18ce0697a983be9b.apply(this, arguments);
};
function $5606419dfe2e9b1b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5606419dfe2e9b1b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5606419dfe2e9b1b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5606419dfe2e9b1b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5606419dfe2e9b1b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5606419dfe2e9b1b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5606419dfe2e9b1b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5606419dfe2e9b1b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5606419dfe2e9b1b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5606419dfe2e9b1b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5606419dfe2e9b1b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5606419dfe2e9b1b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5606419dfe2e9b1b$export$45d3717a4c69092e(o, m, p);
}
function $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5606419dfe2e9b1b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5606419dfe2e9b1b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5606419dfe2e9b1b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5606419dfe2e9b1b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5606419dfe2e9b1b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5606419dfe2e9b1b$export$10c90e4f7922046c(v) {
    return this instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? (this.v = v, this) : new $5606419dfe2e9b1b$export$10c90e4f7922046c(v);
}
function $5606419dfe2e9b1b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5606419dfe2e9b1b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5606419dfe2e9b1b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5606419dfe2e9b1b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5606419dfe2e9b1b$export$19a8beecd37a4c45 === "function" ? $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5606419dfe2e9b1b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5606419dfe2e9b1b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5606419dfe2e9b1b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5606419dfe2e9b1b$export$45d3717a4c69092e(result, mod, k);
    }
    $5606419dfe2e9b1b$var$__setModuleDefault(result, mod);
    return result;
}
function $5606419dfe2e9b1b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5606419dfe2e9b1b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5606419dfe2e9b1b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5606419dfe2e9b1b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


parcelRequire("e94ba");

var $bh6RR = parcelRequire("bh6RR");
var $53a106364dbd0a1b$exports = {};
//
$53a106364dbd0a1b$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $783faa7ec18221fc$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$783faa7ec18221fc$export$4659b591c19bdf3d(e, r);
    });
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$590e8b2c435046d9(e) {
    while(e.root)e = $783faa7ec18221fc$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $783faa7ec18221fc$export$10d8903dec122b9d(e, e.siblings);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var m = "";
    var x = c;
    var y = s;
    var j = n;
    var A = m;
    while(w)switch(h = g, g = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(A, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(A += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $783faa7ec18221fc$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            A += $783faa7ec18221fc$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            A += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            A += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    A += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(A) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) A = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(A, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(A) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(A + ";", n, a, l - 1, i) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(A, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    A += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(j = $783faa7ec18221fc$export$3307ffa7023ede1e(A, r, a, f, o, c, u, m, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(A, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(A, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, j, j, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, m, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(A, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, m = A = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(A), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(A += $783faa7ec18221fc$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (A += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(A) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) A += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(m = A += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(A) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $783faa7ec18221fc$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $783faa7ec18221fc$export$2f35ab04d2335697(e, p + 1, p = $783faa7ec18221fc$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $783faa7ec18221fc$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span", 0) ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch", 0) ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            if (!$783faa7ec18221fc$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $78b52bced097bc64$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $78b52bced097bc64$export$2e2bcd8739ae039 = $78b52bced097bc64$var$unitlessKeys;



var $e484c752f3f06549$var$f = ("undefined" != typeof $391299e0893a3dfa$exports && void 0 !== $391299e0893a3dfa$exports.env && undefined, "data-styled"), $e484c752f3f06549$var$m = "active", $e484c752f3f06549$var$y = "data-styled-version", $e484c752f3f06549$export$83d89fbfd8236492 = "6.1.8", $e484c752f3f06549$var$g = "/*!sc*/\n", $e484c752f3f06549$var$S = "undefined" != typeof window && "HTMLElement" in window, $e484c752f3f06549$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, "undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, false)), $e484c752f3f06549$var$b = {}, $e484c752f3f06549$var$E = /invalid hook call/i, $e484c752f3f06549$var$N = new Set, $e484c752f3f06549$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e484c752f3f06549$var$_ = Object.freeze([]), $e484c752f3f06549$var$C = Object.freeze({});
function $e484c752f3f06549$var$I(e, t, n) {
    return void 0 === n && (n = $e484c752f3f06549$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e484c752f3f06549$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e484c752f3f06549$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e484c752f3f06549$var$D = /(^-|-$)/g;
function $e484c752f3f06549$var$R(e) {
    return e.replace($e484c752f3f06549$var$O, "-").replace($e484c752f3f06549$var$D, "");
}
var $e484c752f3f06549$var$T = /(a)(d)/gi, $e484c752f3f06549$var$k = 52, $e484c752f3f06549$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e484c752f3f06549$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e484c752f3f06549$var$k; t = t / $e484c752f3f06549$var$k | 0)n = $e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n;
    return ($e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n).replace($e484c752f3f06549$var$T, "$1-$2");
}
var $e484c752f3f06549$var$V, $e484c752f3f06549$var$F = 5381, $e484c752f3f06549$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e484c752f3f06549$var$$ = function(e) {
    return $e484c752f3f06549$var$M($e484c752f3f06549$var$F, e);
};
function $e484c752f3f06549$var$z(e) {
    return $e484c752f3f06549$var$x($e484c752f3f06549$var$$(e) >>> 0);
}
function $e484c752f3f06549$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e484c752f3f06549$var$L(e) {
    return "string" == typeof e && true;
}
var $e484c752f3f06549$var$G = "function" == typeof Symbol && Symbol.for, $e484c752f3f06549$var$Y = $e484c752f3f06549$var$G ? Symbol.for("react.memo") : 60115, $e484c752f3f06549$var$W = $e484c752f3f06549$var$G ? Symbol.for("react.forward_ref") : 60112, $e484c752f3f06549$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e484c752f3f06549$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$J = (($e484c752f3f06549$var$V = {})[$e484c752f3f06549$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e484c752f3f06549$var$V[$e484c752f3f06549$var$Y] = $e484c752f3f06549$var$U, $e484c752f3f06549$var$V);
function $e484c752f3f06549$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e484c752f3f06549$var$Y ? $e484c752f3f06549$var$U : "$$typeof" in e ? $e484c752f3f06549$var$J[e.$$typeof] : $e484c752f3f06549$var$q;
}
var $e484c752f3f06549$var$Z = Object.defineProperty, $e484c752f3f06549$var$K = Object.getOwnPropertyNames, $e484c752f3f06549$var$Q = Object.getOwnPropertySymbols, $e484c752f3f06549$var$ee = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$te = Object.getPrototypeOf, $e484c752f3f06549$var$ne = Object.prototype;
function $e484c752f3f06549$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e484c752f3f06549$var$ne) {
            var o = $e484c752f3f06549$var$te(t);
            o && o !== $e484c752f3f06549$var$ne && $e484c752f3f06549$var$oe(e, o, n);
        }
        var r = $e484c752f3f06549$var$K(t);
        $e484c752f3f06549$var$Q && (r = r.concat($e484c752f3f06549$var$Q(t)));
        for(var s = $e484c752f3f06549$var$X(e), i = $e484c752f3f06549$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e484c752f3f06549$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e484c752f3f06549$var$ee(t, c);
                try {
                    $e484c752f3f06549$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e484c752f3f06549$var$re(e) {
    return "function" == typeof e;
}
function $e484c752f3f06549$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e484c752f3f06549$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e484c752f3f06549$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e484c752f3f06549$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e484c752f3f06549$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e484c752f3f06549$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    else if ($e484c752f3f06549$var$ce(t)) for(var o in t)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    return e;
}
function $e484c752f3f06549$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e484c752f3f06549$var$pe = {};
function $e484c752f3f06549$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e484c752f3f06549$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e484c752f3f06549$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e484c752f3f06549$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e484c752f3f06549$var$g);
        return t;
    }, e;
}(), $e484c752f3f06549$var$me = new Map, $e484c752f3f06549$var$ye = new Map, $e484c752f3f06549$var$ve = 1, $e484c752f3f06549$var$ge = function(e) {
    if ($e484c752f3f06549$var$me.has(e)) return $e484c752f3f06549$var$me.get(e);
    for(; $e484c752f3f06549$var$ye.has($e484c752f3f06549$var$ve);)$e484c752f3f06549$var$ve++;
    var t = $e484c752f3f06549$var$ve++;
    return $e484c752f3f06549$var$me.set(e, t), $e484c752f3f06549$var$ye.set(t, e), t;
}, $e484c752f3f06549$var$Se = function(e, t) {
    $e484c752f3f06549$var$ve = t + 1, $e484c752f3f06549$var$me.set(e, t), $e484c752f3f06549$var$ye.set(t, e);
}, $e484c752f3f06549$var$we = "style[".concat($e484c752f3f06549$var$f, "][").concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"]'), $e484c752f3f06549$var$be = new RegExp("^".concat($e484c752f3f06549$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e484c752f3f06549$var$Ee = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e484c752f3f06549$var$Ne = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e484c752f3f06549$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e484c752f3f06549$var$be);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e484c752f3f06549$var$Se(u, l), $e484c752f3f06549$var$Ee(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $e484c752f3f06549$var$Pe() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e484c752f3f06549$var$_e = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e484c752f3f06549$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e484c752f3f06549$var$f, $e484c752f3f06549$var$m), o.setAttribute($e484c752f3f06549$var$y, $e484c752f3f06549$export$83d89fbfd8236492);
    var i = $e484c752f3f06549$var$Pe();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e484c752f3f06549$var$Ce = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$_e(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e484c752f3f06549$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e484c752f3f06549$var$Ie = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$_e(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e484c752f3f06549$var$Ae = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e484c752f3f06549$var$Oe = $e484c752f3f06549$var$S, $e484c752f3f06549$var$De = {
    isServer: !$e484c752f3f06549$var$S,
    useCSSOMInjection: !$e484c752f3f06549$var$w
}, $e484c752f3f06549$var$Re = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e484c752f3f06549$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, $e484c752f3f06549$var$De), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$Oe && ($e484c752f3f06549$var$Oe = !1, function(e) {
            for(var t = document.querySelectorAll($e484c752f3f06549$var$we), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute($e484c752f3f06549$var$f) !== $e484c752f3f06549$var$m && ($e484c752f3f06549$var$Ne(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $e484c752f3f06549$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e484c752f3f06549$var$ye.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($e484c752f3f06549$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e484c752f3f06549$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e484c752f3f06549$var$ge(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e484c752f3f06549$var$Ae(n) : t ? new $e484c752f3f06549$var$Ce(n) : new $e484c752f3f06549$var$Ie(n);
        }(this.options), new $e484c752f3f06549$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e484c752f3f06549$var$ge(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e484c752f3f06549$var$ge(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e484c752f3f06549$var$ge(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e484c752f3f06549$var$Te = /&/g, $e484c752f3f06549$var$ke = /^\s*\/\/.*$/gm;
function $e484c752f3f06549$var$je(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e484c752f3f06549$var$je(e.children, t)), e;
    });
}
function $e484c752f3f06549$var$xe(e) {
    var t, n, o, r = void 0 === e ? $e484c752f3f06549$var$C : e, s = r.options, i = void 0 === s ? $e484c752f3f06549$var$C : s, a = r.plugins, c = void 0 === a ? $e484c752f3f06549$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $783faa7ec18221fc$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e484c752f3f06549$var$Te, n).replace(o, l));
    }), i.prefix && u.push($783faa7ec18221fc$export$e08c7d021b829b7a), u.push($783faa7ec18221fc$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e484c752f3f06549$var$ke, ""), l = $783faa7ec18221fc$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e484c752f3f06549$var$je(l, i.namespace));
        var p = [];
        return $783faa7ec18221fc$export$dfdc1655ccc5b9cb(l, $783faa7ec18221fc$export$5a7767152ae0305f(u.concat($783faa7ec18221fc$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e484c752f3f06549$var$he(15), $e484c752f3f06549$var$M(e, t.name);
    }, $e484c752f3f06549$var$F).toString() : "", p;
}
var $e484c752f3f06549$var$Ve = new $e484c752f3f06549$var$Re, $e484c752f3f06549$var$Fe = $e484c752f3f06549$var$xe(), $e484c752f3f06549$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e484c752f3f06549$var$Ve,
    stylis: $e484c752f3f06549$var$Fe
}), $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer, $e484c752f3f06549$var$ze = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $e484c752f3f06549$var$Be() {
    return (0, $bh6RR.useContext)($e484c752f3f06549$export$8c190ef828af4c86);
}
function $e484c752f3f06549$export$a473771da2f0ff7c(e) {
    var t = (0, $bh6RR.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e484c752f3f06549$var$Be().styleSheet, l = (0, $bh6RR.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $bh6RR.useMemo)(function() {
        return $e484c752f3f06549$var$xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $bh6RR.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($53a106364dbd0a1b$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $bh6RR.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$var$ze.Provider, {
        value: u
    }, e.children));
}
var $e484c752f3f06549$var$Ge = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e484c752f3f06549$var$Fe);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e484c752f3f06549$var$ue(this, function() {
            throw $e484c752f3f06549$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e484c752f3f06549$var$Fe), this.name + e.hash;
    }, e;
}(), $e484c752f3f06549$var$Ye = function(e) {
    return e >= "A" && e <= "Z";
};
function $e484c752f3f06549$var$We(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e484c752f3f06549$var$Ye(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e484c752f3f06549$var$qe = function(e) {
    return null == e || !1 === e || "" === e;
}, $e484c752f3f06549$var$He = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e484c752f3f06549$var$qe(i) && (Array.isArray(i) && i.isCss || $e484c752f3f06549$var$re(i) ? r.push("".concat($e484c752f3f06549$var$We(s), ":"), i, ";") : $e484c752f3f06549$var$ce(i) ? r.push.apply(r, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)((0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e484c752f3f06549$var$He(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e484c752f3f06549$var$We(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $78b52bced097bc64$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e484c752f3f06549$var$Ue(e, t, n, o) {
    if ($e484c752f3f06549$var$qe(e)) return [];
    if ($e484c752f3f06549$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e484c752f3f06549$var$re(e)) {
        if (!$e484c752f3f06549$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e484c752f3f06549$var$Ue(r, t, n, o);
    }
    var s;
    return e instanceof $e484c752f3f06549$var$Ge ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e484c752f3f06549$var$ce(e) ? $e484c752f3f06549$var$He(e) : Array.isArray(e) ? Array.prototype.concat.apply($e484c752f3f06549$var$_, e.map(function(e) {
        return $e484c752f3f06549$var$Ue(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e484c752f3f06549$var$Je(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e484c752f3f06549$var$re(n) && !$e484c752f3f06549$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e484c752f3f06549$var$Xe = $e484c752f3f06549$var$$($e484c752f3f06549$export$83d89fbfd8236492), $e484c752f3f06549$var$Ze = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e484c752f3f06549$var$Je(e), this.componentId = t, this.baseHash = $e484c752f3f06549$var$M($e484c752f3f06549$var$Xe, t), this.baseStyle = n, $e484c752f3f06549$var$Re.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e484c752f3f06549$var$ie(o, this.staticRulesId);
            else {
                var r = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Ue(this.rules, e, t, n)), s = $e484c752f3f06549$var$x($e484c752f3f06549$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e484c752f3f06549$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e484c752f3f06549$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Ue(u, e, t, n));
                    a = $e484c752f3f06549$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e484c752f3f06549$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e484c752f3f06549$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e484c752f3f06549$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0), $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
function $e484c752f3f06549$export$93d4e7f90805808f() {
    var e = (0, $bh6RR.useContext)($e484c752f3f06549$export$2c657da244d00bd6);
    if (!e) throw $e484c752f3f06549$var$he(18);
    return e;
}
function $e484c752f3f06549$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, $bh6RR.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e484c752f3f06549$var$he(14);
            if ($e484c752f3f06549$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e484c752f3f06549$var$he(8);
            return n ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e484c752f3f06549$var$nt = {}, $e484c752f3f06549$var$ot = new Set;
function $e484c752f3f06549$var$rt(e, r, s) {
    var i = $e484c752f3f06549$export$7ba318d8d2f06c76(e), a = e, c = !$e484c752f3f06549$var$L(e), p = r.attrs, d = void 0 === p ? $e484c752f3f06549$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e484c752f3f06549$var$R(e);
        $e484c752f3f06549$var$nt[n] = ($e484c752f3f06549$var$nt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e484c752f3f06549$var$z($e484c752f3f06549$export$83d89fbfd8236492 + n + $e484c752f3f06549$var$nt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e484c752f3f06549$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e484c752f3f06549$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e484c752f3f06549$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e484c752f3f06549$var$Ze(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), m = $e484c752f3f06549$var$Be(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e484c752f3f06549$var$I(r, f, c) || $e484c752f3f06549$var$C, g = function(e, n, o) {
                for(var r, s = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e484c752f3f06549$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e484c752f3f06549$var$ie(s[c], a[c]) : "style" === c ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e484c752f3f06549$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e484c752f3f06549$var$Be(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e484c752f3f06549$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e484c752f3f06549$var$L(S) && !$e484c752f3f06549$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $bh6RR.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e484c752f3f06549$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e484c752f3f06549$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e484c752f3f06549$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e484c752f3f06549$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e484c752f3f06549$var$st(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e484c752f3f06549$var$it = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e484c752f3f06549$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e484c752f3f06549$var$re(t) || $e484c752f3f06549$var$ce(t)) return $e484c752f3f06549$var$it($e484c752f3f06549$var$Ue($e484c752f3f06549$var$st($e484c752f3f06549$var$_, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e484c752f3f06549$var$Ue(r) : $e484c752f3f06549$var$it($e484c752f3f06549$var$Ue($e484c752f3f06549$var$st(r, n)));
}
function $e484c752f3f06549$var$ct(n, o, r) {
    if (void 0 === r && (r = $e484c752f3f06549$var$C), !o) throw $e484c752f3f06549$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e484c752f3f06549$var$ct(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e484c752f3f06549$var$ct(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e484c752f3f06549$var$lt = function(e) {
    return $e484c752f3f06549$var$ct($e484c752f3f06549$var$rt, e);
}, $e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$lt;
$e484c752f3f06549$var$A.forEach(function(e) {
    $e484c752f3f06549$export$2e2bcd8739ae039[e] = $e484c752f3f06549$var$lt(e);
});
var $e484c752f3f06549$var$pt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e484c752f3f06549$var$Je(e), $e484c752f3f06549$var$Re.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e484c752f3f06549$var$ae($e484c752f3f06549$var$Ue(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e484c752f3f06549$var$Re.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e484c752f3f06549$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e484c752f3f06549$var$z(JSON.stringify(i))), c = new $e484c752f3f06549$var$pt(i, a);
    var l = function(e) {
        var t = $e484c752f3f06549$var$Be(), n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e484c752f3f06549$var$b, o, s);
        else {
            var i = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                theme: $e484c752f3f06549$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(l);
}
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e484c752f3f06549$var$ae($e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e484c752f3f06549$var$z(r);
    return new $e484c752f3f06549$var$Ge(s, r);
}
function $e484c752f3f06549$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(n, r) {
        var s = $e484c752f3f06549$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(e, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e484c752f3f06549$var$B(e), ")"), $e484c752f3f06549$var$oe(n, e);
}
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $e484c752f3f06549$var$Pe(), o = $e484c752f3f06549$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e484c752f3f06549$var$f, '="true"'),
                "".concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            var r = ((n = {})[$e484c752f3f06549$var$f] = "", n[$e484c752f3f06549$var$y] = $e484c752f3f06549$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $e484c752f3f06549$var$Pe();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e484c752f3f06549$var$Re({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e484c752f3f06549$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e484c752f3f06549$var$he(3);
    }, e;
}(), $e484c752f3f06549$export$5c87cfe6c475f500 = {
    StyleSheet: $e484c752f3f06549$var$Re,
    mainSheet: $e484c752f3f06549$var$Ve
};
var $e484c752f3f06549$var$vt = "__sc-".concat($e484c752f3f06549$var$f, "__");



function $13cf12438684a2af$var$Backdrop() {
    const { matrix: matrix  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [height, setHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("100vh");
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("100%");
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        function handleResize() {
            const totalHeight = document.body.scrollHeight;
            const totalHeightPx = `${totalHeight}px`;
            setHeight(totalHeightPx);
            const totalWidth = Math.max(window.innerWidth, document.body.scrollWidth);
            const totalWidthPx = `${totalWidth}px`;
            setWidth(totalWidthPx);
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        matrix
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($13cf12438684a2af$var$StyledBackdrop, {
        height: height,
        width: width
    });
}
var $13cf12438684a2af$export$2e2bcd8739ae039 = $13cf12438684a2af$var$Backdrop;
const $13cf12438684a2af$var$StyledBackdrop = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  min-height: ${(p)=>p.height};
  width: ${(p)=>p.width};
  background-image: linear-gradient(
    var(--background-gradient-top),
    var(--background-gradient-bottom)
  );
  z-index: -1000;
`;






var $bh6RR = parcelRequire("bh6RR");


function $d3236c1ff5808711$var$DeepBackdrop() {
    const { matrix: matrix  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [height, setHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("100vh");
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("100%");
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        function handleResize() {
            const totalHeight = document.body.scrollHeight;
            const totalHeightPx = `${totalHeight}px`;
            setHeight(totalHeightPx);
            const totalWidth = Math.max(window.innerWidth, document.body.scrollWidth);
            const totalWidthPx = `${totalWidth}px`;
            setWidth(totalWidthPx);
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleResize);
        };
    }, [
        matrix
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d3236c1ff5808711$var$StyledBackdrop, {
        height: height,
        width: width
    });
}
var $d3236c1ff5808711$export$2e2bcd8739ae039 = $d3236c1ff5808711$var$DeepBackdrop;
const $d3236c1ff5808711$var$StyledBackdrop = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  min-height: ${(p)=>p.height};
  width: ${(p)=>p.width};
  background-color: var(--background-gradient-bottom);
  z-index: -2000;
`;






var $bh6RR = parcelRequire("bh6RR");
const $ab089d1227010d1f$export$8faa12814783780b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
function $ab089d1227010d1f$var$SoundProvider({ children: children  }) {
    const [volume, setVolume] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>{
        const savedVolume = localStorage.getItem("volume");
        return savedVolume !== null ? Number(savedVolume) : 1;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        localStorage.setItem("volume", volume);
    }, [
        volume
    ]);
    function toggleMute() {
        setVolume((oldValue)=>(oldValue + 1) % 2);
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ab089d1227010d1f$export$8faa12814783780b.Provider, {
        value: {
            volume: volume,
            setVolume: setVolume,
            toggleMute: toggleMute
        },
        children: children
    });
}
var $ab089d1227010d1f$export$2e2bcd8739ae039 = $ab089d1227010d1f$var$SoundProvider;





parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39ab41060f0dd572$export$2e2bcd8739ae039.apply(this, arguments);
}



var $bh6RR = parcelRequire("bh6RR");
function $93dfa6b8fe6a3629$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($e52f713866128e60$export$43e446d32b3d21af(...refs), refs);
}



var $bh6RR = parcelRequire("bh6RR");
function $1cecd1d75f085228$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $8b7ab17803b8e6f8$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};


const $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId = $bh6RR["useId".toString()] || (()=>undefined);
let $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count = 0;
function $d172fcbd2da23bac$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $c901973c35f9b07b$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $bh6RR.useRef)(callback);
    (0, $bh6RR.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $bh6RR.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $dfcfc7aa8980054c$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $bh6RR.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0, $bh6RR.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $bh6RR.useRef)(value);
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    (0, $bh6RR.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$18fd289ffa468154$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $e52f713866128e60$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $18fd289ffa468154$export$d9f1ccf0bdb05d45;
}
function $18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $18fd289ffa468154$export$be92b6f5f03c0fe9 = $18fd289ffa468154$export$8c6ed5c666ac1360;


const $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$250ffa63cdc0d034 = $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $18fd289ffa468154$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $793b1a0f4d9647b1$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$be92b6f5f03c0fe9 = $793b1a0f4d9647b1$export$250ffa63cdc0d034;





var $bh6RR = parcelRequire("bh6RR");

/**
 * Listens for when the escape key is down
 */ function $879e0a3f7f60ef06$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $bh6RR.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $8473b83e333b07d4$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $bh6RR.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $bh6RR.useState)({});
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $879e0a3f7f60ef06$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $bh6RR.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$177fb62ff3ec1f22, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $8473b83e333b07d4$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$4d5eb2109db14228, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    const handleClickRef = (0, $bh6RR.useRef)(()=>{});
    (0, $bh6RR.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $793b1a0f4d9647b1$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $8473b83e333b07d4$export$be92b6f5f03c0fe9 = $8473b83e333b07d4$export$177fb62ff3ec1f22;
const $8473b83e333b07d4$export$aecb2ddcb55c95be = $8473b83e333b07d4$export$4d5eb2109db14228;




var $bh6RR = parcelRequire("bh6RR");



const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $0757534448b5e4bf$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0, $bh6RR.useState)(null);
    const onMountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $bh6RR.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $bh6RR.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (container1) {
            $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusFirst($0757534448b5e4bf$var$$d3863c46a17e8a28$var$removeLinks($0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $bh6RR.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($0757534448b5e4bf$export$20e40289641fbbb6, {
    displayName: $0757534448b5e4bf$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$0757534448b5e4bf$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $0757534448b5e4bf$export$be92b6f5f03c0fe9 = $0757534448b5e4bf$export$20e40289641fbbb6;




var $bh6RR = parcelRequire("bh6RR");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $252b3d40eb00b07a$export$602eac185826482c = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).createPortal(/*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($252b3d40eb00b07a$export$602eac185826482c, {
    displayName: $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$export$be92b6f5f03c0fe9 = $252b3d40eb00b07a$export$602eac185826482c;



var $bh6RR = parcelRequire("bh6RR");



function $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $bh6RR.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $e651d1dc516f7371$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $bh6RR.Children).only(children);
    const ref = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(child, {
        ref: ref
    }) : null;
};
$e651d1dc516f7371$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $bh6RR.useState)();
    const stylesRef = (0, $bh6RR.useRef)({});
    const prevPresentRef = (0, $bh6RR.useRef)(present);
    const prevAnimationNameRef = (0, $bh6RR.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $47cfd4084854a574$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $bh6RR.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}




var $bh6RR = parcelRequire("bh6RR");
/** Number of components which have requested interest to have focus guards */ let $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count = 0;
function $39ae7ab2790868b6$export$ac5b58043b79449b(props) {
    $39ae7ab2790868b6$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $39ae7ab2790868b6$export$b7ece24a22aeda8c() {
    (0, $bh6RR.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $39ae7ab2790868b6$export$be92b6f5f03c0fe9 = $39ae7ab2790868b6$export$ac5b58043b79449b;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $dbb3c33b31cdcfb1$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $dbb3c33b31cdcfb1$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $dbb3c33b31cdcfb1$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $bh6RR = parcelRequire("bh6RR");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $83a050b8f7e61fc1$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $bh6RR = parcelRequire("bh6RR");
function $bcea459d6fe13dac$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $bh6RR.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $59e9bf7262dc1a6d$var$currentValues = new WeakMap();
function $59e9bf7262dc1a6d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $bcea459d6fe13dac$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $59e9bf7262dc1a6d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $59e9bf7262dc1a6d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $0647093a1b1c5afc$var$ItoI(a) {
    return a;
}
function $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $0647093a1b1c5afc$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    return $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware);
}
function $0647093a1b1c5afc$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $0647093a1b1c5afc$var$innerCreateMedium(null);
    medium.options = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $1e32631777ba14da$export$e27363444bedfeac = (0, $0647093a1b1c5afc$export$e13ec7dd7a14088d)();


var $1c1f9cd94bee4822$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $1c1f9cd94bee4822$export$22940b497e769dee = $bh6RR.forwardRef(function(props, parentRef) {
    var ref = $bh6RR.useRef(null);
    var _a = $bh6RR.useState({
        onScrollCapture: $1c1f9cd94bee4822$var$nothing,
        onWheelCapture: $1c1f9cd94bee4822$var$nothing,
        onTouchMoveCapture: $1c1f9cd94bee4822$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $59e9bf7262dc1a6d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest), callbacks);
    return $bh6RR.createElement($bh6RR.Fragment, null, enabled && $bh6RR.createElement(SideCar, {
        sideCar: (0, $1e32631777ba14da$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $bh6RR.cloneElement($bh6RR.Children.only(children), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $bh6RR.createElement(Container, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$1c1f9cd94bee4822$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$1c1f9cd94bee4822$export$22940b497e769dee.classNames = {
    fullWidth: (0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e),
    zeroRight: (0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3)
};




var $bh6RR = parcelRequire("bh6RR");
var $db1654befbc8d676$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $bh6RR.createElement(Target, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest));
};
$db1654befbc8d676$var$SideCar.isSideCarExport = true;
function $db1654befbc8d676$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $db1654befbc8d676$var$SideCar;
}




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $c1a97cf4bee7a747$var$currentNonce;
var $c1a97cf4bee7a747$export$c5f670b24c0ae95a = function(nonce) {
    $c1a97cf4bee7a747$var$currentNonce = nonce;
};
var $c1a97cf4bee7a747$export$2b85b721e524d74b = function() {
    if ($c1a97cf4bee7a747$var$currentNonce) return $c1a97cf4bee7a747$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $ec0bd1fbc8093bb3$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c1a97cf4bee7a747$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $ec0bd1fbc8093bb3$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ec0bd1fbc8093bb3$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $ec0bd1fbc8093bb3$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $ec0bd1fbc8093bb3$var$makeStyleTag()) {
                    $ec0bd1fbc8093bb3$var$injectStyles(stylesheet, style);
                    $ec0bd1fbc8093bb3$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $388d9750a20580a4$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $ec0bd1fbc8093bb3$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $bh6RR.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $8f0cc34b8d78d287$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $388d9750a20580a4$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $c24b64e0e48f5c2b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $c24b64e0e48f5c2b$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $c24b64e0e48f5c2b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $c24b64e0e48f5c2b$var$parse(left),
        $c24b64e0e48f5c2b$var$parse(top),
        $c24b64e0e48f5c2b$var$parse(right)
    ];
};
var $c24b64e0e48f5c2b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $c24b64e0e48f5c2b$export$efed13b5d0ca3386;
    var offsets = $c24b64e0e48f5c2b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $a1bca04d3c994e31$var$Style = (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
var $a1bca04d3c994e31$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $a1bca04d3c994e31$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $dbb3c33b31cdcfb1$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    ").concat((0, $dbb3c33b31cdcfb1$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $a1bca04d3c994e31$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($a1bca04d3c994e31$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $a1bca04d3c994e31$export$a1939b1f9f9b02dc = function() {
    $bh6RR.useEffect(function() {
        document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, ($a1bca04d3c994e31$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $a1bca04d3c994e31$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($a1bca04d3c994e31$export$65254d5f26cb9564);
            else document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $a1bca04d3c994e31$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $a1bca04d3c994e31$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $bh6RR.useMemo(function() {
        return (0, $c24b64e0e48f5c2b$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $bh6RR.createElement($a1bca04d3c994e31$var$Style, {
        styles: $a1bca04d3c994e31$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $c3d5eca92c5827bc$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $c3d5eca92c5827bc$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $c3d5eca92c5827bc$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
    // @ts-ignore
    window.removeEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
} catch (err) {
    $c3d5eca92c5827bc$var$passiveSupported = false;
}
var $c3d5eca92c5827bc$export$10a6e88623fa9454 = $c3d5eca92c5827bc$var$passiveSupported ? {
    passive: false
} : false;


var $b2f037382e9b8811$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $b2f037382e9b8811$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$b2f037382e9b8811$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $b2f037382e9b8811$var$elementCouldBeVScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowY");
};
var $b2f037382e9b8811$var$elementCouldBeHScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowX");
};
var $b2f037382e9b8811$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $b2f037382e9b8811$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $b2f037382e9b8811$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $b2f037382e9b8811$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $b2f037382e9b8811$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $b2f037382e9b8811$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$elementCouldBeVScrolled(node) : $b2f037382e9b8811$var$elementCouldBeHScrolled(node);
};
var $b2f037382e9b8811$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$getVScrollVariables(node) : $b2f037382e9b8811$var$getHScrollVariables(node);
};
var $b2f037382e9b8811$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $b2f037382e9b8811$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $b2f037382e9b8811$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $b2f037382e9b8811$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($b2f037382e9b8811$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $0012650a668228df$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0012650a668228df$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0012650a668228df$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $0012650a668228df$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0012650a668228df$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0012650a668228df$var$idCounter = 0;
var $0012650a668228df$var$lockStack = [];
function $0012650a668228df$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $bh6RR.useRef([]);
    var touchStartRef = $bh6RR.useRef([
        0,
        0
    ]);
    var activeAxis = $bh6RR.useRef();
    var id = $bh6RR.useState($0012650a668228df$var$idCounter++)[0];
    var Style = $bh6RR.useState(function() {
        return (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $bh6RR.useRef(props);
    $bh6RR.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $bh6RR.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($0012650a668228df$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $bh6RR.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $0012650a668228df$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $b2f037382e9b8811$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $bh6RR.useCallback(function(_event) {
        var event = _event;
        if (!$0012650a668228df$var$lockStack.length || $0012650a668228df$var$lockStack[$0012650a668228df$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $0012650a668228df$export$39efaa2ca254a28d(event) : $0012650a668228df$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $0012650a668228df$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0012650a668228df$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $bh6RR.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $bh6RR.useCallback(function(event) {
        touchStartRef.current = $0012650a668228df$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $bh6RR.useEffect(function() {
        $0012650a668228df$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        return function() {
            $0012650a668228df$var$lockStack = $0012650a668228df$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $bh6RR.createElement($bh6RR.Fragment, null, inert ? $bh6RR.createElement(Style, {
        styles: $0012650a668228df$var$generateStyle(id)
    }) : null, removeScrollBar ? $bh6RR.createElement((0, $a1bca04d3c994e31$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $32fbe4a10a756a07$export$2e2bcd8739ae039 = (0, $db1654befbc8d676$export$6cacc8fb0a9b94ce)((0, $1e32631777ba14da$export$e27363444bedfeac), (0, $0012650a668228df$export$a09dbff87b5da2d));


var $2a904e957609af53$var$ReactRemoveScroll = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement((0, $1c1f9cd94bee4822$export$22940b497e769dee), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $32fbe4a10a756a07$export$2e2bcd8739ae039)
    }));
});
$2a904e957609af53$var$ReactRemoveScroll.classNames = (0, $1c1f9cd94bee4822$export$22940b497e769dee).classNames;
var $2a904e957609af53$export$2e2bcd8739ae039 = $2a904e957609af53$var$ReactRemoveScroll;


var $43e375177e5001c1$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $43e375177e5001c1$var$counterMap = new WeakMap();
var $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
var $43e375177e5001c1$var$markerMap = {};
var $43e375177e5001c1$var$lockCount = 0;
var $43e375177e5001c1$var$unwrapHost = function(node) {
    return node && (node.host || $43e375177e5001c1$var$unwrapHost(node.parentNode));
};
var $43e375177e5001c1$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $43e375177e5001c1$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $43e375177e5001c1$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $43e375177e5001c1$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$43e375177e5001c1$var$markerMap[markerName]) $43e375177e5001c1$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $43e375177e5001c1$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($43e375177e5001c1$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $43e375177e5001c1$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $43e375177e5001c1$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $43e375177e5001c1$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $43e375177e5001c1$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $43e375177e5001c1$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$43e375177e5001c1$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $43e375177e5001c1$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $43e375177e5001c1$var$lockCount--;
        if (!$43e375177e5001c1$var$lockCount) {
            // clear
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
            $43e375177e5001c1$var$markerMap = {};
        }
    };
};
var $43e375177e5001c1$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $43e375177e5001c1$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $43e375177e5001c1$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $43e375177e5001c1$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $43e375177e5001c1$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $43e375177e5001c1$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($43e375177e5001c1$export$cc95fea82d705fca() ? $43e375177e5001c1$export$59151cc8db999a24 : $43e375177e5001c1$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$createDialogContext, $919b3aedf69a16e5$export$cc702773b8ea3e41] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogProvider, $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$createDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $919b3aedf69a16e5$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = (0, $bh6RR.useRef)(null);
    const contentRef = (0, $bh6RR.useRef)(null);
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        titleId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        descriptionId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $bh6RR.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$3ddf2d174ce01153, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $919b3aedf69a16e5$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$2e1e1122cf0cba88, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PortalProvider, $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$createDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $919b3aedf69a16e5$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $bh6RR.Children).map(children, (child)=>/*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$dad7c95542bacce0, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $919b3aedf69a16e5$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$usePortalContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$bd1d06c79be19e17, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $bh6RR.createElement)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: (0, $18fd289ffa468154$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $919b3aedf69a16e5$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$usePortalContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$b6d9565de1e068cf, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $bh6RR.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $bh6RR.useRef)(false);
    const hasPointerDownOutsideRef = (0, $bh6RR.useRef)(false);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $919b3aedf69a16e5$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).h2, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$16f7638e4a34b909, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $919b3aedf69a16e5$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).p, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$94e94c2ec2c954d5, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $919b3aedf69a16e5$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useDialogContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($919b3aedf69a16e5$export$fba2fb7cd781b7ac, {
    displayName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$919b3aedf69a16e5$export$69b62a49393917d6, $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $1cecd1d75f085228$export$fd42f52fd3ae1109)($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useWarningContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $bh6RR.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$useWarningContext($919b3aedf69a16e5$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $bh6RR.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $919b3aedf69a16e5$export$be92b6f5f03c0fe9 = $919b3aedf69a16e5$export$3ddf2d174ce01153;
const $919b3aedf69a16e5$export$41fb9f06171c75f4 = $919b3aedf69a16e5$export$2e1e1122cf0cba88;
const $919b3aedf69a16e5$export$602eac185826482c = $919b3aedf69a16e5$export$dad7c95542bacce0;
const $919b3aedf69a16e5$export$c6fdb837b070b4ff = $919b3aedf69a16e5$export$bd1d06c79be19e17;
const $919b3aedf69a16e5$export$7c6e2c02157bb7d2 = $919b3aedf69a16e5$export$b6d9565de1e068cf;
const $919b3aedf69a16e5$export$f99233281efd08a0 = $919b3aedf69a16e5$export$16f7638e4a34b909;
const $919b3aedf69a16e5$export$393edc798c47379d = $919b3aedf69a16e5$export$94e94c2ec2c954d5;
const $919b3aedf69a16e5$export$f39c2d165cd861fe = $919b3aedf69a16e5$export$fba2fb7cd781b7ac;



var $bh6RR = parcelRequire("bh6RR");
function $45e7c250d3003265$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $45e7c250d3003265$var$_excluded = [
    "color"
];
var $45e7c250d3003265$export$12f5813a529780ed = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877197 7.49984C0.877197 3.84216 3.84234 0.877014 7.50003 0.877014C11.1577 0.877014 14.1229 3.84216 14.1229 7.49984C14.1229 11.1575 11.1577 14.1227 7.50003 14.1227C3.84234 14.1227 0.877197 11.1575 0.877197 7.49984ZM7.50003 1.82701C4.36702 1.82701 1.8272 4.36683 1.8272 7.49984C1.8272 10.6328 4.36702 13.1727 7.50003 13.1727C10.633 13.1727 13.1729 10.6328 13.1729 7.49984C13.1729 4.36683 10.633 1.82701 7.50003 1.82701ZM7.12457 9.00001C7.06994 9.12735 6.33165 11.9592 6.33165 11.9592C6.26018 12.226 5.98601 12.3843 5.71928 12.3128C5.45255 12.2413 5.29425 11.9672 5.36573 11.7004C5.36573 11.7004 6.24661 8.87268 6.24661 8.27007V6.80099L4.28763 6.27608C4.0209 6.20461 3.86261 5.93045 3.93408 5.66371C4.00555 5.39698 4.27972 5.23869 4.54645 5.31016C4.54645 5.31016 6.20042 5.87268 6.84579 5.87268H8.15505C8.80042 5.87268 10.4534 5.31042 10.4534 5.31042C10.7202 5.23895 10.9943 5.39724 11.0658 5.66397C11.1373 5.93071 10.979 6.20487 10.7122 6.27635L8.74661 6.80303V8.27007C8.74661 8.87268 9.62663 11.6971 9.62663 11.6971C9.6981 11.9639 9.5398 12.238 9.27307 12.3095C9.00634 12.381 8.73217 12.2227 8.6607 11.956C8.6607 11.956 7.91994 9.12735 7.86866 9.00001C7.81994 8.87268 7.65006 8.87268 7.65006 8.87268H7.34317C7.34317 8.87268 7.16994 8.87268 7.12457 9.00001ZM7.50043 5.12007C8.12175 5.12007 8.62543 4.61639 8.62543 3.99507C8.62543 3.37375 8.12175 2.87007 7.50043 2.87007C6.87911 2.87007 6.37543 3.37375 6.37543 3.99507C6.37543 4.61639 6.87911 5.12007 7.50043 5.12007Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1 = [
    "color"
];
var $45e7c250d3003265$export$c40c07f3e63e590d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2 = [
    "color"
];
var $45e7c250d3003265$export$315d3fae607b3916 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10.5 1.75003C10.7107 1.75003 10.8988 1.88217 10.9703 2.08042L13.9703 10.4C14.064 10.6598 13.9293 10.9463 13.6696 11.04C13.4098 11.1336 13.1233 10.999 13.0296 10.7392L12.0477 8.01606H8.95227L7.97031 10.7392C7.87664 10.999 7.59012 11.1336 7.33035 11.04C7.07058 10.9463 6.93593 10.6598 7.0296 10.4L10.0296 2.08042C10.1011 1.88217 10.2892 1.75003 10.5 1.75003ZM10.5 3.72402L11.7411 7.16606H9.25877L10.5 3.72402ZM2.49949 2.09997C2.7204 2.09997 2.89949 2.27906 2.89949 2.49997L2.89949 9.53428L4.21664 8.21713C4.37285 8.06092 4.62612 8.06092 4.78233 8.21713C4.93854 8.37334 4.93854 8.6266 4.78233 8.78281L2.78233 10.7828C2.70732 10.8578 2.60557 10.9 2.49949 10.9C2.3934 10.9 2.29166 10.8578 2.21664 10.7828L0.216645 8.78281C0.0604349 8.6266 0.0604349 8.37334 0.216645 8.21713C0.372854 8.06092 0.62612 8.06092 0.78233 8.21713L2.09949 9.53428L2.09949 2.49997C2.09949 2.27906 2.27857 2.09997 2.49949 2.09997ZM0.0999695 13.5001C0.0999695 13.2791 0.279056 13.1001 0.499969 13.1001H14.5C14.7209 13.1001 14.9 13.2791 14.9 13.5001C14.9 13.721 14.7209 13.9001 14.5 13.9001H0.499969C0.279056 13.9001 0.0999695 13.721 0.0999695 13.5001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3 = [
    "color"
];
var $45e7c250d3003265$export$28c63a2a77a6b6ba = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9 3C9 2.44772 8.55229 2 8 2H7C6.44772 2 6 2.44772 6 3L6 14H1.5C1.22386 14 1 14.2239 1 14.5C1 14.7761 1.22386 15 1.5 15L6 15H9H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14H9V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4 = [
    "color"
];
var $45e7c250d3003265$export$5284d356b9eb3ea0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.99988 6C1.44759 6 0.999877 6.44772 0.999877 7L0.999877 8C0.999877 8.55228 1.44759 9 1.99988 9L6.99988 9L6.99988 13.5C6.99988 13.7761 7.22374 14 7.49988 14C7.77602 14 7.99988 13.7761 7.99988 13.5L7.99988 9L12.9999 9C13.5522 9 13.9999 8.55228 13.9999 8L13.9999 7C13.9999 6.44772 13.5522 6 12.9999 6L7.99988 6L7.99988 1.5C7.99988 1.22386 7.77602 1 7.49988 1C7.22373 1 6.99988 1.22386 6.99988 1.5L6.99988 6L1.99988 6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$5 = [
    "color"
];
var $45e7c250d3003265$export$a87e0381c7863d70 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$5);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.99988 1C6.44759 1 5.99988 1.44772 5.99988 2V7H1.49988C1.22374 7 0.999878 7.22386 0.999878 7.5C0.999878 7.77614 1.22374 8 1.49988 8H5.99988V13C5.99988 13.5523 6.44759 14 6.99988 14H7.99988C8.55216 14 8.99988 13.5523 8.99988 13V8H13.4999C13.776 8 13.9999 7.77614 13.9999 7.5C13.9999 7.22386 13.776 7 13.4999 7H8.99988V2C8.99988 1.44772 8.55216 1 7.99988 1L6.99988 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$6 = [
    "color"
];
var $45e7c250d3003265$export$43a2a6205c884160 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$6);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.499995 0.999995C0.223855 0.999995 -5.58458e-07 1.22385 -5.46388e-07 1.49999L-2.18554e-08 13.4999C-9.78492e-09 13.776 0.223855 13.9999 0.499995 13.9999C0.776136 13.9999 0.999991 13.776 0.999991 13.4999L0.999991 8.99993L12 8.99993C12.5523 8.99993 13 8.55222 13 7.99993L13 6.99994C13 6.44766 12.5523 5.99995 12 5.99995L0.999991 5.99995L0.999991 1.49999C0.999991 1.22385 0.776135 0.999995 0.499995 0.999995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$7 = [
    "color"
];
var $45e7c250d3003265$export$589ba7400e24d687 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$7);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14.4999 1C14.2237 1 13.9999 1.22386 13.9999 1.5L13.9999 6L2.99988 6C2.44759 6 1.99988 6.44772 1.99988 7L1.99988 8C1.99988 8.55228 2.44759 9 2.99988 9L13.9999 9L13.9999 13.5C13.9999 13.7761 14.2237 14 14.4999 14C14.776 14 14.9999 13.7761 14.9999 13.5L14.9999 9L14.9999 6L14.9999 1.5C14.9999 1.22386 14.776 1 14.4999 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$8 = [
    "color"
];
var $45e7c250d3003265$export$359aaf594ac84c59 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$8);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.5 0C1.22386 0 1 0.223858 1 0.5C1 0.776142 1.22386 1 1.5 1H6V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V1H13.5C13.7761 1 14 0.776142 14 0.5C14 0.223858 13.7761 0 13.5 0H9H6H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$9 = [
    "color"
];
var $45e7c250d3003265$export$c5eda4f4203e72ab = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$9);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 0.75L9.75 3H5.25L7.5 0.75ZM7.5 14.25L9.75 12H5.25L7.5 14.25ZM3 5.25L0.75 7.5L3 9.75V5.25ZM14.25 7.5L12 5.25V9.75L14.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$a = [
    "color"
];
var $45e7c250d3003265$export$c3671dfffcc20189 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$a);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.8914 2.1937C9.1158 2.35464 9.16725 2.66701 9.00631 2.89141L2.47388 12H13.5C13.7761 12 14 12.2239 14 12.5C14 12.7762 13.7761 13 13.5 13H1.5C1.31254 13 1.14082 12.8952 1.0552 12.7284C0.969578 12.5616 0.984438 12.361 1.09369 12.2086L8.19369 2.30862C8.35462 2.08422 8.667 2.03277 8.8914 2.1937ZM11.1 6.50001C11.1 6.22387 11.3238 6.00001 11.6 6.00001C11.8761 6.00001 12.1 6.22387 12.1 6.50001C12.1 6.77615 11.8761 7.00001 11.6 7.00001C11.3238 7.00001 11.1 6.77615 11.1 6.50001ZM10.4 4.00001C10.1239 4.00001 9.90003 4.22387 9.90003 4.50001C9.90003 4.77615 10.1239 5.00001 10.4 5.00001C10.6762 5.00001 10.9 4.77615 10.9 4.50001C10.9 4.22387 10.6762 4.00001 10.4 4.00001ZM12.1 8.50001C12.1 8.22387 12.3238 8.00001 12.6 8.00001C12.8761 8.00001 13.1 8.22387 13.1 8.50001C13.1 8.77615 12.8761 9.00001 12.6 9.00001C12.3238 9.00001 12.1 8.77615 12.1 8.50001ZM13.4 10C13.1239 10 12.9 10.2239 12.9 10.5C12.9 10.7761 13.1239 11 13.4 11C13.6762 11 13.9 10.7761 13.9 10.5C13.9 10.2239 13.6762 10 13.4 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$b = [
    "color"
];
var $45e7c250d3003265$export$64abfa02d870a554 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$b);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$c = [
    "color"
];
var $45e7c250d3003265$export$ba8ee9ef4800b4a5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$c);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.3536 3.64644C11.5488 3.8417 11.5488 4.15828 11.3536 4.35354L4.70711 11L9 11C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12L3.5 12C3.36739 12 3.24021 11.9473 3.14645 11.8536C3.05268 11.7598 3 11.6326 3 11.5L3 5.99999C3 5.72385 3.22386 5.49999 3.5 5.49999C3.77614 5.49999 4 5.72385 4 5.99999V10.2929L10.6464 3.64643C10.8417 3.45117 11.1583 3.45117 11.3536 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$d = [
    "color"
];
var $45e7c250d3003265$export$1a0b00ff4e10643e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$d);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.64645 3.64644C3.45118 3.8417 3.45118 4.15828 3.64645 4.35354L10.2929 11L6 11C5.72386 11 5.5 11.2239 5.5 11.5C5.5 11.7761 5.72386 12 6 12L11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5L12 5.99999C12 5.72385 11.7761 5.49999 11.5 5.49999C11.2239 5.49999 11 5.72385 11 5.99999V10.2929L4.35355 3.64643C4.15829 3.45117 3.84171 3.45117 3.64645 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$e = [
    "color"
];
var $45e7c250d3003265$export$1c939d3c9b6931b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$e);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$f = [
    "color"
];
var $45e7c250d3003265$export$8afed21ef5c2afa5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$f);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$g = [
    "color"
];
var $45e7c250d3003265$export$9ca09caa9c849d9c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$g);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$h = [
    "color"
];
var $45e7c250d3003265$export$9f5fe8cc556ac1f3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$h);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6465L4.70711 4L9 4C9.27614 4 9.5 3.77614 9.5 3.5C9.5 3.22386 9.27614 3 9 3L3.5 3C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24022 3 3.36739 3 3.5L3 9.00001C3 9.27615 3.22386 9.50001 3.5 9.50001C3.77614 9.50001 4 9.27615 4 9.00001V4.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$i = [
    "color"
];
var $45e7c250d3003265$export$64a9bd58f7494197 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$i);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$j = [
    "color"
];
var $45e7c250d3003265$export$f1a507b991affc46 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$j);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$k = [
    "color"
];
var $45e7c250d3003265$export$843c734d18c2237 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$k);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.5 2H12.5C12.7761 2 13 2.22386 13 2.5V12.5C13 12.7761 12.7761 13 12.5 13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5ZM7.5 4C7.77614 4 8 3.77614 8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4ZM8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5ZM7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM10 7.5C10 7.77614 9.77614 8 9.5 8C9.22386 8 9 7.77614 9 7.5C9 7.22386 9.22386 7 9.5 7C9.77614 7 10 7.22386 10 7.5ZM11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$l = [
    "color"
];
var $45e7c250d3003265$export$b1f22795a41806ac = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$l);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$m = [
    "color"
];
var $45e7c250d3003265$export$a7965fbad5d67169 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$m);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$n = [
    "color"
];
var $45e7c250d3003265$export$e32f68df2d27987 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$n);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.5 6H11.5C12.3284 6 13 6.67157 13 7.5C13 8.32843 12.3284 9 11.5 9H3.5C2.67157 9 2 8.32843 2 7.5C2 6.67157 2.67157 6 3.5 6ZM1 7.5C1 6.11929 2.11929 5 3.5 5H11.5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10H3.5C2.11929 10 1 8.88071 1 7.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$o = [
    "color"
];
var $45e7c250d3003265$export$472946dc5493045a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$o);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$p = [
    "color"
];
var $45e7c250d3003265$export$2235404cc2cfe93c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$p);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.60124 1.25086C8.60124 1.75459 8.26278 2.17927 7.80087 2.30989C10.1459 2.4647 12 4.41582 12 6.79999V10.25C12 11.0563 12.0329 11.7074 12.7236 12.0528C12.931 12.1565 13.0399 12.3892 12.9866 12.6149C12.9333 12.8406 12.7319 13 12.5 13H8.16144C8.36904 13.1832 8.49997 13.4513 8.49997 13.75C8.49997 14.3023 8.05226 14.75 7.49997 14.75C6.94769 14.75 6.49997 14.3023 6.49997 13.75C6.49997 13.4513 6.63091 13.1832 6.83851 13H2.49999C2.2681 13 2.06664 12.8406 2.01336 12.6149C1.96009 12.3892 2.06897 12.1565 2.27638 12.0528C2.96708 11.7074 2.99999 11.0563 2.99999 10.25V6.79999C2.99999 4.41537 4.85481 2.46396 7.20042 2.3098C6.73867 2.17908 6.40036 1.75448 6.40036 1.25086C6.40036 0.643104 6.89304 0.150421 7.5008 0.150421C8.10855 0.150421 8.60124 0.643104 8.60124 1.25086ZM7.49999 3.29999C5.56699 3.29999 3.99999 4.86699 3.99999 6.79999V10.25L4.00002 10.3009C4.0005 10.7463 4.00121 11.4084 3.69929 12H11.3007C10.9988 11.4084 10.9995 10.7463 11 10.3009L11 10.25V6.79999C11 4.86699 9.43299 3.29999 7.49999 3.29999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$q = [
    "color"
];
var $45e7c250d3003265$export$cd91dad3f7d2f1be = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 9C3 6.5 4.5 4.25 7.5 1.5C10.5 4.25 12 6.5 12 9C12 11.4853 9.98528 13.5 7.5 13.5C5.01472 13.5 3 11.4853 3 9ZM10.9524 8.30307C9.67347 7.82121 8.2879 8.46208 6.98956 9.06259C5.9327 9.55142 4.93365 10.0135 4.09695 9.82153C4.03357 9.55804 4 9.28294 4 9C4 7.11203 5.02686 5.27195 7.5 2.87357C9.66837 4.97639 10.725 6.65004 10.9524 8.30307Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$r = [
    "color"
];
var $45e7c250d3003265$export$93cb139c864b0aec = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$r);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H11.5C11.7761 2 12 2.22386 12 2.5V13.5C12 13.6818 11.9014 13.8492 11.7424 13.9373C11.5834 14.0254 11.3891 14.0203 11.235 13.924L7.5 11.5896L3.765 13.924C3.61087 14.0203 3.41659 14.0254 3.25762 13.9373C3.09864 13.8492 3 13.6818 3 13.5V2.5ZM4 3V12.5979L6.97 10.7416C7.29427 10.539 7.70573 10.539 8.03 10.7416L11 12.5979V3H4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$s = [
    "color"
];
var $45e7c250d3003265$export$77df11a9db3bfb4e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$s);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.6818 3.09864 13.8492 3.25762 13.9373C3.41659 14.0254 3.61087 14.0203 3.765 13.924L7.5 11.5896L11.235 13.924C11.3891 14.0203 11.5834 14.0254 11.7424 13.9373C11.9014 13.8492 12 13.6818 12 13.5V2.5C12 2.22386 11.7761 2 11.5 2H3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$t = [
    "color"
];
var $45e7c250d3003265$export$2b8bb78df07fc3c1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$t);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H14C14.4142 0.25 14.75 0.585786 14.75 1V14C14.75 14.4142 14.4142 14.75 14 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14V1ZM1.75 1.75V13.25H13.25V1.75H1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$u = [
    "color"
];
var $45e7c250d3003265$export$1986587b5169c3d1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$u);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 13.25L14 13.25V14.75L1 14.75V13.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "5",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "3",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "9",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "11",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$v = [
    "color"
];
var $45e7c250d3003265$export$9e3588048b381346 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$v);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$w = [
    "color"
];
var $45e7c250d3003265$export$db4fc3403d513c1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$w);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$x = [
    "color"
];
var $45e7c250d3003265$export$90857351d8240996 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$x);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.75 1L1.75 14L0.249999 14L0.25 1L1.75 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("rect", {
        x: "10",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "10",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "12",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "12",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 5)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 5)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 3)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 3)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 9)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 9)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 11)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 11)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "6",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "6",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "4",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "4",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "10",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "12",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "6",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "4",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 1)",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$y = [
    "color"
];
var $45e7c250d3003265$export$fc99bfbabe8fe100 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "5",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "5",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "3",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "3",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "9",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "9",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "11",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "11",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$z = [
    "color"
];
var $45e7c250d3003265$export$d19e24a090b81f38 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.25 1L13.25 14L14.75 14L14.75 1L13.25 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 5)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 5)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 3)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 3)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 9)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 9)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 11)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 11)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 7)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 13)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 1)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 1)",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$A = [
    "color"
];
var $45e7c250d3003265$export$ca09e5ae294d45cc = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$A);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$B = [
    "color"
];
var $45e7c250d3003265$export$fbe2d4727aba00b7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$B);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 1.49994C1 1.2238 1.22386 0.999939 1.5 0.999939H6V1.99994H2V5.99994H1V1.49994ZM13 1.99994H9V0.999939H13.5C13.7761 0.999939 14 1.2238 14 1.49994V5.99994H13V1.99994ZM1 13.4999V8.99994H2V12.9999H6V13.9999H1.5C1.22386 13.9999 1 13.7761 1 13.4999ZM13 12.9999V8.99994H14V13.4999C14 13.7761 13.7761 13.9999 13.5 13.9999H9.5V12.9999H13Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$C = [
    "color"
];
var $45e7c250d3003265$export$99084cce0e645aeb = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$C);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12C11.2239 12 11 11.7761 11 11.5ZM13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H8.5C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7H6.5ZM11 7.5C11 7.22386 11.2239 7 11.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11.5C11.2239 8 11 7.77614 11 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$D = [
    "color"
];
var $45e7c250d3003265$export$c244c53943ad4d08 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$D);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14 1.75L1 1.75L1 0.249999L14 0.25L14 1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 10)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "2",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 10)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 12)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "2",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 12)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 8)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 14)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "2",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 8)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "2",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 14)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "10",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 8)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "10",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 14)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "12",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 8)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "12",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 14)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "6",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 8)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "6",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 14)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "4",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 8)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "4",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 14)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 6)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "2",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 6)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "8",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 4)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "2",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 4)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 10)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 12)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 8)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 14)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 6)",
        fill: color
    }), (0, $bh6RR.createElement)("rect", {
        x: "14",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 4)",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$E = [
    "color"
];
var $45e7c250d3003265$export$26dc332286fcc660 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$E);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 3H14V4H1V3ZM1 6H14V8H1V6ZM14 10.25H1V12.75H14V10.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$F = [
    "color"
];
var $45e7c250d3003265$export$adedf1569d7107de = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$F);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$G = [
    "color"
];
var $45e7c250d3003265$export$742ea6014cb11378 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$G);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$H = [
    "color"
];
var $45e7c250d3003265$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$H);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$I = [
    "color"
];
var $45e7c250d3003265$export$5fda1783bb83f57b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$I);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12.5C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H4V1.5C4 1.22386 4.22386 1 4.5 1ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H12.5C12.7761 3 13 3.22386 13 3.5V5H2V3.5C2 3.22386 2.22386 3 2.5 3H4V3.5C4 3.77614 4.22386 4 4.5 4C4.77614 4 5 3.77614 5 3.5V3H10ZM2 6V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6H2ZM7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7ZM11 7.5C11 7.22386 11.2239 7 11.5 7C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8C11.2239 8 11 7.77614 11 7.5ZM11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5ZM7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9ZM5 9.5C5 9.22386 5.22386 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C5.22386 10 5 9.77614 5 9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$J = [
    "color"
];
var $45e7c250d3003265$export$1bd12807c2fea239 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$J);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H13C13.5523 12 14 11.5523 14 11V4C14 3.44772 13.5523 3 13 3H2ZM0 4C0 2.89543 0.895431 2 2 2H13C14.1046 2 15 2.89543 15 4V11C15 12.1046 14.1046 13 13 13H2C0.895431 13 0 12.1046 0 11V4ZM2 4.25C2 4.11193 2.11193 4 2.25 4H4.75C4.88807 4 5 4.11193 5 4.25V5.75454C5 5.89261 4.88807 6.00454 4.75 6.00454H2.25C2.11193 6.00454 2 5.89261 2 5.75454V4.25ZM12.101 7.58421C12.101 9.02073 10.9365 10.1853 9.49998 10.1853C8.06346 10.1853 6.89893 9.02073 6.89893 7.58421C6.89893 6.14769 8.06346 4.98315 9.49998 4.98315C10.9365 4.98315 12.101 6.14769 12.101 7.58421ZM13.101 7.58421C13.101 9.57302 11.4888 11.1853 9.49998 11.1853C7.51117 11.1853 5.89893 9.57302 5.89893 7.58421C5.89893 5.5954 7.51117 3.98315 9.49998 3.98315C11.4888 3.98315 13.101 5.5954 13.101 7.58421Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$K = [
    "color"
];
var $45e7c250d3003265$export$16dbc2701f60a606 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$K);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$L = [
    "color"
];
var $45e7c250d3003265$export$cf8d533bd52e80e3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$L);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H12.5C12.7761 10 13 9.77614 13 9.5V3.5C13 3.22386 12.7761 3 12.5 3H2.5ZM1 9.5C1 10.1531 1.4174 10.7087 2 10.9146V11.5C2 12.3284 2.67157 13 3.5 13H11.5C12.3284 13 13 12.3284 13 11.5V10.9146C13.5826 10.7087 14 10.1531 14 9.5V3.5C14 2.67157 13.3284 2 12.5 2H2.5C1.67157 2 1 2.67157 1 3.5V9.5ZM12 11.5V11H3V11.5C3 11.7761 3.22386 12 3.5 12H11.5C11.7761 12 12 11.7761 12 11.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H9.5C9.77614 7 10 6.77614 10 6.5C10 6.22386 9.77614 6 9.5 6H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$M = [
    "color"
];
var $45e7c250d3003265$export$e590b2572239e122 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$M);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12ZM5 6.5C5 6.22386 5.22386 6 5.5 6H7V4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6H9.5C9.77614 6 10 6.22386 10 6.5C10 6.77614 9.77614 7 9.5 7H8V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V7H5.5C5.22386 7 5 6.77614 5 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$N = [
    "color"
];
var $45e7c250d3003265$export$73a4c78a4a00962 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$N);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$O = [
    "color"
];
var $45e7c250d3003265$export$810196a5854768f3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$O);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$P = [
    "color"
];
var $45e7c250d3003265$export$5e4a7579d3e78657 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$P);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$Q = [
    "color"
];
var $45e7c250d3003265$export$432020ae7f5a1085 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$Q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$R = [
    "color"
];
var $45e7c250d3003265$export$7d1b8b90f61377d1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$R);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$S = [
    "color"
];
var $45e7c250d3003265$export$83414514025c111b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$S);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$T = [
    "color"
];
var $45e7c250d3003265$export$7dd004358974b05d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$T);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$U = [
    "color"
];
var $45e7c250d3003265$export$54060461b8d0e637 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$U);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$V = [
    "color"
];
var $45e7c250d3003265$export$c0a1936901b0e55 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$V);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 3H12V12H3L3 3ZM2 3C2 2.44771 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44771 13 2 12.5523 2 12V3ZM10.3498 5.51105C10.506 5.28337 10.4481 4.97212 10.2204 4.81587C9.99275 4.65961 9.6815 4.71751 9.52525 4.94519L6.64048 9.14857L5.19733 7.40889C5.02102 7.19635 4.7058 7.16699 4.49327 7.34329C4.28073 7.5196 4.25137 7.83482 4.42767 8.04735L6.2934 10.2964C6.39348 10.4171 6.54437 10.4838 6.70097 10.4767C6.85757 10.4695 7.00177 10.3894 7.09047 10.2601L10.3498 5.51105Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$W = [
    "color"
];
var $45e7c250d3003265$export$4857d3f3f5f8319b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$W);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$X = [
    "color"
];
var $45e7c250d3003265$export$20bc5960c3c9eebb = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$X);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$Y = [
    "color"
];
var $45e7c250d3003265$export$b837bd7eac09a33e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$Y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$Z = [
    "color"
];
var $45e7c250d3003265$export$7f01a6cbee61a0f2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$Z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$_ = [
    "color"
];
var $45e7c250d3003265$export$9c1c3f5a4a271817 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$_);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.49991C0.877075 3.84222 3.84222 0.877075 7.49991 0.877075C11.1576 0.877075 14.1227 3.84222 14.1227 7.49991C14.1227 11.1576 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1576 0.877075 7.49991ZM7.49991 1.82708C4.36689 1.82708 1.82708 4.36689 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49991C13.1727 4.36689 10.6329 1.82708 7.49991 1.82708Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$$ = [
    "color"
];
var $45e7c250d3003265$export$10324e86d7995e4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$$);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM3.85768 3.15057C4.84311 2.32448 6.11342 1.82708 7.49991 1.82708C10.6329 1.82708 13.1727 4.36689 13.1727 7.49991C13.1727 8.88638 12.6753 10.1567 11.8492 11.1421L3.85768 3.15057ZM3.15057 3.85768C2.32448 4.84311 1.82708 6.11342 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C8.88638 13.1727 10.1567 12.6753 11.1421 11.8492L3.15057 3.85768Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$10 = [
    "color"
];
var $45e7c250d3003265$export$60f3f00eeba09710 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$10);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$11 = [
    "color"
];
var $45e7c250d3003265$export$1a4dc243f6e39802 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$11);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$12 = [
    "color"
];
var $45e7c250d3003265$export$8099ab97743c966c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$12);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$13 = [
    "color"
];
var $45e7c250d3003265$export$8036f09137bee589 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$13);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$14 = [
    "color"
];
var $45e7c250d3003265$export$32cdc32ad6ae0658 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$14);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.71144 0.796902C7.57741 0.734357 7.42257 0.734357 7.28855 0.796902L1.28855 3.5969C1.11251 3.67905 0.999993 3.85573 0.999993 4.04999V10.95C0.999993 11.1443 1.11251 11.3209 1.28855 11.4031L7.28855 14.2031C7.42257 14.2656 7.57741 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.04999C14 3.85573 13.8875 3.67905 13.7114 3.5969L7.71144 0.796902ZM7.49999 3.15674L5.98039 2.51091L7.49999 1.80176L9.01959 2.51091L7.49999 3.15674ZM7.69556 4.16018L10.2382 3.07958L12.2719 4.02865L7.49999 6.05671L2.72808 4.02865L4.76181 3.07958L7.30442 4.16018C7.42939 4.2133 7.57059 4.2133 7.69556 4.16018ZM7.99999 6.93078L13 4.80578V7.92966L11.0821 8.8119C10.7273 8.97509 10.5 9.32988 10.5 9.72039V11.7982L7.99999 12.9649V6.93078ZM11.5 11.3316L13 10.6316V9.03039L11.5 9.72039V11.3316ZM6.99999 6.93078V12.9649L4.50231 11.7993V9.72036C4.50231 9.32985 4.27499 8.97506 3.92022 8.81187L1.99999 7.92856V4.80578L6.99999 6.93078ZM1.99999 10.6316L3.50231 11.3326L3.50231 9.72036L1.99999 9.02929V10.6316Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$15 = [
    "color"
];
var $45e7c250d3003265$export$bda33a04439dd942 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$15);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.49985C0.877075 3.84216 3.84222 0.877014 7.49991 0.877014C11.1576 0.877014 14.1227 3.84216 14.1227 7.49985C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49985ZM3.78135 3.21565C4.68298 2.43239 5.83429 1.92904 7.09998 1.84089V6.53429L3.78135 3.21565ZM3.21567 3.78134C2.43242 4.68298 1.92909 5.83428 1.84095 7.09997H6.5343L3.21567 3.78134ZM6.5343 7.89997H1.84097C1.92916 9.16562 2.43253 10.3169 3.21579 11.2185L6.5343 7.89997ZM3.78149 11.7842C4.6831 12.5673 5.83435 13.0707 7.09998 13.1588V8.46566L3.78149 11.7842ZM7.89998 8.46566V13.1588C9.16559 13.0706 10.3168 12.5673 11.2184 11.7841L7.89998 8.46566ZM11.7841 11.2184C12.5673 10.3168 13.0707 9.16558 13.1588 7.89997H8.46567L11.7841 11.2184ZM8.46567 7.09997H13.1589C13.0707 5.83432 12.5674 4.68305 11.7842 3.78143L8.46567 7.09997ZM11.2185 3.21573C10.3169 2.43246 9.16565 1.92909 7.89998 1.8409V6.53429L11.2185 3.21573Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$16 = [
    "color"
];
var $45e7c250d3003265$export$bfc20b5a7dea0537 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$16);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.00012 1.5C8.00012 1.22386 7.77626 1 7.50012 1C7.22398 1 7.00012 1.22386 7.00012 1.5V13.5C7.00012 13.7761 7.22398 14 7.50012 14C7.77626 14 8.00012 13.7761 8.00012 13.5V1.5ZM3.31812 5.818C3.49386 5.64227 3.49386 5.35734 3.31812 5.18161C3.14239 5.00587 2.85746 5.00587 2.68173 5.18161L0.681729 7.18161C0.505993 7.35734 0.505993 7.64227 0.681729 7.818L2.68173 9.818C2.85746 9.99374 3.14239 9.99374 3.31812 9.818C3.49386 9.64227 3.49386 9.35734 3.31812 9.18161L2.08632 7.9498H5.50017C5.7487 7.9498 5.95017 7.74833 5.95017 7.4998C5.95017 7.25128 5.7487 7.0498 5.50017 7.0498H2.08632L3.31812 5.818ZM12.3181 5.18161C12.1424 5.00587 11.8575 5.00587 11.6817 5.18161C11.506 5.35734 11.506 5.64227 11.6817 5.818L12.9135 7.0498H9.50017C9.25164 7.0498 9.05017 7.25128 9.05017 7.4998C9.05017 7.74833 9.25164 7.9498 9.50017 7.9498H12.9135L11.6817 9.18161C11.506 9.35734 11.506 9.64227 11.6817 9.818C11.8575 9.99374 12.1424 9.99374 12.3181 9.818L14.3181 7.818C14.4939 7.64227 14.4939 7.35734 14.3181 7.18161L12.3181 5.18161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$17 = [
    "color"
];
var $45e7c250d3003265$export$38f001d9cffdd080 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$17);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.14998 14V1H0.849976V14H2.14998ZM6.14998 14V1H4.84998V14H6.14998ZM10.15 1V14H8.84998V1H10.15ZM14.15 14V1H12.85V14H14.15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$18 = [
    "color"
];
var $45e7c250d3003265$export$13d9ab7fa696f910 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$18);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.94969 7.49989C9.94969 8.85288 8.85288 9.94969 7.49989 9.94969C6.14691 9.94969 5.0501 8.85288 5.0501 7.49989C5.0501 6.14691 6.14691 5.0501 7.49989 5.0501C8.85288 5.0501 9.94969 6.14691 9.94969 7.49989ZM10.8632 8C10.6213 9.64055 9.20764 10.8997 7.49989 10.8997C5.79214 10.8997 4.37847 9.64055 4.13662 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H4.13659C4.37835 5.35935 5.79206 4.1001 7.49989 4.1001C9.20772 4.1001 10.6214 5.35935 10.8632 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H10.8632Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$19 = [
    "color"
];
var $45e7c250d3003265$export$a8e03ddff565be2c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$19);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.67129 3.14634C4.47603 3.34161 4.47603 3.65819 4.67129 3.85345L7.14616 6.32833C7.34142 6.52359 7.65801 6.52359 7.85327 6.32833L10.3281 3.85345C10.5234 3.65819 10.5234 3.34161 10.3281 3.14634L7.85327 0.671471C7.65801 0.476209 7.34142 0.476209 7.14616 0.671471L4.67129 3.14634ZM7.49971 5.26766L5.73195 3.4999L7.49971 1.73213L9.26748 3.4999L7.49971 5.26766ZM8.67129 7.14634C8.47603 7.34161 8.47603 7.65819 8.67129 7.85345L11.1462 10.3283C11.3414 10.5236 11.658 10.5236 11.8533 10.3283L14.3281 7.85345C14.5234 7.65819 14.5234 7.34161 14.3281 7.14634L11.8533 4.67147C11.658 4.47621 11.3414 4.47621 11.1462 4.67147L8.67129 7.14634ZM11.4997 9.26766L9.73195 7.4999L11.4997 5.73213L13.2675 7.4999L11.4997 9.26766ZM4.67129 11.8535C4.47603 11.6582 4.47603 11.3416 4.67129 11.1463L7.14616 8.67147C7.34142 8.47621 7.65801 8.47621 7.85327 8.67147L10.3281 11.1463C10.5234 11.3416 10.5234 11.6582 10.3281 11.8535L7.85327 14.3283C7.65801 14.5236 7.34142 14.5236 7.14616 14.3283L4.67129 11.8535ZM5.73195 11.4999L7.49971 13.2677L9.26748 11.4999L7.49971 9.73213L5.73195 11.4999ZM0.671288 7.14649C0.476026 7.34175 0.476026 7.65834 0.671288 7.8536L3.14616 10.3285C3.34142 10.5237 3.65801 10.5237 3.85327 10.3285L6.32814 7.8536C6.5234 7.65834 6.5234 7.34175 6.32814 7.14649L3.85327 4.67162C3.65801 4.47636 3.34142 4.47636 3.14616 4.67162L0.671288 7.14649ZM3.49972 9.26781L1.73195 7.50005L3.49972 5.73228L5.26748 7.50005L3.49972 9.26781Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1a = [
    "color"
];
var $45e7c250d3003265$export$467c6b1dbd59bc1e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1a);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1b = [
    "color"
];
var $45e7c250d3003265$export$8b4f0e3d2d9d0b5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1b);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1c = [
    "color"
];
var $45e7c250d3003265$export$4edbb1daceb32596 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1c);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.1465 1.48959C7.34176 1.29432 7.65835 1.29432 7.85361 1.48959L13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355L7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104L1.48965 7.85355C1.29439 7.65829 1.29439 7.3417 1.48965 7.14644L7.1465 1.48959ZM7.50005 2.55025L2.55031 7.49999L7.50005 12.4497L12.4498 7.49999L7.50005 2.55025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1d = [
    "color"
];
var $45e7c250d3003265$export$8a42855f849911b4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1d);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959L1.48965 7.14644C1.29439 7.3417 1.29439 7.65829 1.48965 7.85355L3.9645 10.3284L1.64644 12.6464C1.45118 12.8417 1.45118 13.1583 1.64644 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.6716 11.0355L7.1465 13.5104C7.34176 13.7057 7.65835 13.7057 7.85361 13.5104L13.5105 7.85355C13.7057 7.65829 13.7057 7.3417 13.5105 7.14644L11.0356 4.67154L13.3535 2.35355C13.5488 2.15829 13.5488 1.84171 13.3535 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.3285 3.96443L7.85361 1.48959ZM9.62135 4.67154L7.50005 2.55025L2.55031 7.49999L4.6716 9.62129L9.62135 4.67154ZM5.37871 10.3284L7.50005 12.4497L12.4498 7.49999L10.3285 5.37865L5.37871 10.3284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1e = [
    "color"
];
var $45e7c250d3003265$export$39c9cf5aa1336b1f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1e);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.8034 7.14644C12.9986 6.95118 13.3152 6.95118 13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355C13.3152 8.04881 12.9986 8.04881 12.8034 7.85355C12.6081 7.65828 12.6081 7.3417 12.8034 7.14644ZM12.0962 8.56065C12.2915 8.75592 12.2915 9.0725 12.0962 9.26776C11.901 9.46302 11.5844 9.46302 11.3891 9.26776C11.1939 9.0725 11.1939 8.75592 11.3891 8.56065C11.5844 8.36539 11.901 8.36539 12.0962 8.56065ZM10.682 9.97487C10.8773 10.1701 10.8773 10.4867 10.682 10.682C10.4868 10.8772 10.1702 10.8772 9.97493 10.682C9.77967 10.4867 9.77967 10.1701 9.97493 9.97487C10.1702 9.7796 10.4868 9.7796 10.682 9.97487ZM9.26782 11.3891C9.46308 11.5843 9.46308 11.9009 9.26782 12.0962C9.07256 12.2915 8.75598 12.2915 8.56071 12.0962C8.36545 11.9009 8.36545 11.5843 8.56072 11.3891C8.75598 11.1938 9.07256 11.1938 9.26782 11.3891ZM7.1465 13.5104C6.95124 13.3151 6.95124 12.9986 7.1465 12.8033C7.17091 12.7789 7.19721 12.7575 7.22494 12.7392C7.41901 12.6111 7.68275 12.6324 7.85361 12.8033C8.04887 12.9986 8.04887 13.3151 7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.90386 8.56065C2.7086 8.75592 2.7086 9.0725 2.90386 9.26776 3.09912 9.46302 3.41571 9.46302 3.61097 9.26776 3.80623 9.0725 3.80623 8.75592 3.61097 8.56065 3.41571 8.36539 3.09912 8.36539 2.90386 8.56065zM4.31807 9.97487C4.12281 10.1701 4.12281 10.4867 4.31807 10.682 4.51334 10.8772 4.82992 10.8772 5.02518 10.682 5.22044 10.4867 5.22044 10.1701 5.02518 9.97487 4.82992 9.7796 4.51334 9.7796 4.31807 9.97487zM5.73229 11.3891C5.53703 11.5843 5.53703 11.9009 5.73229 12.0962 5.92755 12.2914 6.24413 12.2915 6.43939 12.0962 6.63466 11.9009 6.63466 11.5843 6.43939 11.3891 6.24413 11.1938 5.92755 11.1938 5.73229 11.3891zM2.19675 7.85355C2.36761 7.68269 2.38897 7.41895 2.26082 7.22488 2.09046 6.96684 1.71063 6.92546 1.48965 7.14644 1.29439 7.3417 1.29439 7.65829 1.48965 7.85355 1.68491 8.04881 2.00149 8.04881 2.19675 7.85355zM3.61097 5.73223C3.41571 5.53696 3.09912 5.53696 2.90386 5.73223 2.7086 5.92749 2.7086 6.24407 2.90386 6.43933 3.09912 6.6346 3.41571 6.6346 3.61097 6.43933 3.80623 6.24407 3.80623 5.92749 3.61097 5.73223zM5.02518 4.31801C4.82992 4.12275 4.51334 4.12275 4.31807 4.31801 4.12281 4.51328 4.12281 4.82986 4.31807 5.02512 4.51334 5.22038 4.82992 5.22038 5.02518 5.02512 5.22044 4.82986 5.22044 4.51328 5.02518 4.31801zM6.43939 2.9038C6.24413 2.70854 5.92755 2.70854 5.73229 2.9038 5.53703 3.09906 5.53703 3.41564 5.73229 3.61091 5.92755 3.80617 6.24413 3.80617 6.43939 3.61091 6.63466 3.41564 6.63466 3.09906 6.43939 2.9038zM7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959 6.95124 1.68485 6.95124 2.00143 7.1465 2.19669 7.34176 2.39196 7.65835 2.39196 7.85361 2.19669 8.04887 2.00143 8.04887 1.68485 7.85361 1.48959zM9.26782 2.9038C9.07256 2.70854 8.75598 2.70854 8.56071 2.9038 8.36545 3.09906 8.36545 3.41564 8.56071 3.61091 8.75598 3.80617 9.07256 3.80617 9.26782 3.61091 9.46308 3.41564 9.46308 3.09906 9.26782 2.9038zM10.682 4.31801C10.4868 4.12275 10.1702 4.12275 9.97493 4.31801 9.77967 4.51328 9.77967 4.82986 9.97493 5.02512 10.1702 5.22038 10.4868 5.22038 10.682 5.02512 10.8773 4.82986 10.8773 4.51328 10.682 4.31801zM12.0962 5.73223C11.901 5.53696 11.5844 5.53696 11.3891 5.73223 11.1939 5.92749 11.1939 6.24407 11.3891 6.43933 11.5844 6.6346 11.901 6.6346 12.0962 6.43933 12.2915 6.24407 12.2915 5.92749 12.0962 5.73223z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$1f = [
    "color"
];
var $45e7c250d3003265$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1f);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM5 13H10V2L5 2L5 13ZM4 13C4 13.5523 4.44772 14 5 14H10C10.5523 14 11 13.5523 11 13V2C11 1.44772 10.5523 1 10 1H5C4.44772 1 4 1.44771 4 2V13ZM13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM2 3.5C2 3.77614 1.77614 4 1.5 4C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3C1.77614 3 2 3.22386 2 3.5ZM13.5 4C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3C13.2239 3 13 3.22386 13 3.5C13 3.77614 13.2239 4 13.5 4ZM2 5.5C2 5.77614 1.77614 6 1.5 6C1.22386 6 1 5.77614 1 5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5ZM13.5 6C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5C13.2239 5 13 5.22386 13 5.5C13 5.77614 13.2239 6 13.5 6ZM2 7.5C2 7.77614 1.77614 8 1.5 8C1.22386 8 1 7.77614 1 7.5C1 7.22386 1.22386 7 1.5 7C1.77614 7 2 7.22386 2 7.5ZM13.5 8C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8ZM2 9.5C2 9.77614 1.77614 10 1.5 10C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9C1.77614 9 2 9.22386 2 9.5ZM13.5 10C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5C13 9.77614 13.2239 10 13.5 10ZM2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5ZM13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12ZM2 13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5C1 13.2239 1.22386 13 1.5 13C1.77614 13 2 13.2239 2 13.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1g = [
    "color"
];
var $45e7c250d3003265$export$4231f341127e9d59 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1g);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.0697 1.76746C12.4807 1.21947 11.4605 0.454311 11.0495 1.0023C10.6385 1.55028 11.6588 2.31544 12.0697 1.76746ZM8.39263 1.07811C7.15585 0.950602 5.7823 1.16348 4.58433 1.70937C3.38552 2.25563 2.32735 3.15309 1.78844 4.41832C1.37574 5.38724 1.01715 6.28113 1.00088 7.44354C0.984724 8.59844 1.30522 9.96898 2.13174 11.928C2.61142 13.0649 4.03963 13.5446 5.13895 13.8079C6.40836 14.1119 7.80857 14.1914 8.6644 14.0742C9.36515 13.9782 10.1448 13.8284 10.7987 13.297C11.8977 12.4039 12.9009 11.3955 13.4994 10.3393C14.104 9.27221 14.3256 8.09207 13.7216 6.95324C13.5628 6.65373 13.316 6.57734 13.0412 6.4923C12.9374 6.46016 12.8295 6.42678 12.7209 6.37966C11.6211 5.90234 10.9646 5.34963 10.9135 5.02876C10.8656 4.72808 10.9221 4.51463 10.9811 4.29181C11.0129 4.17199 11.0453 4.04947 11.0626 3.90922C11.0838 3.73737 11.0814 3.33319 10.6996 3.12761C10.4048 2.96888 10.2164 2.65843 10.0407 2.36904C9.99742 2.29775 9.95492 2.22773 9.9118 2.16158C9.62634 1.72367 9.20769 1.16213 8.39263 1.07811ZM4.99899 2.61935C3.96483 3.09058 3.12554 3.83097 2.70846 4.81018C2.29808 5.77368 2.01406 6.50873 2.00079 7.45753C1.98741 8.41385 2.25043 9.6368 3.0531 11.5393C3.39181 12.3421 4.62167 12.6557 5.37186 12.8354C6.5493 13.1174 7.822 13.1802 8.52868 13.0834C9.21271 12.9897 9.74568 12.8642 10.1681 12.5209C11.229 11.6587 12.121 10.7435 12.6293 9.84635C12.9349 9.30709 13.5141 7.7028 12.6292 7.3873C10.7539 6.71875 10.262 6.06669 9.99011 5.41268C9.80915 4.97744 9.82868 4.52282 9.95741 4.07885L9.95741 4.07884C9.97662 4.0126 9.99538 3.94791 10.0334 3.88882C9.81857 3.73676 9.6515 3.55195 9.51464 3.3715C9.42876 3.25828 9.3469 3.12099 9.26197 2.97856C9.01866 2.57052 8.75018 2.12027 8.29008 2.07283C7.22889 1.96343 6.03398 2.14772 4.99899 2.61935ZM13.2081 3.77471C13.441 3.22671 12.4547 2.63606 12.0822 3.10163C11.5817 3.72732 12.9029 4.49281 13.2081 3.77471ZM14.3672 2.26031C14.9668 2.27493 15.1551 1.11603 14.5718 0.949371C13.8076 0.731026 13.5918 2.24139 14.3672 2.26031ZM14.2857 5.09098C14.8644 5.10004 15.0462 4.38222 14.4832 4.27899C13.7455 4.14375 13.5373 5.07927 14.2857 5.09098ZM6.9075 4.28672C6.46898 4.66754 6.0522 4.15185 5.97983 3.7365C5.86848 3.09744 6.33696 2.56856 6.94823 2.91156C7.43344 3.18382 7.26678 3.97471 6.9075 4.28672ZM4.94455 5.88184C5.40885 5.41754 4.59567 4.57013 4.11425 5.05154C3.83338 5.33242 4.00936 5.65376 4.23744 5.88184C4.43271 6.0771 4.74929 6.0771 4.94455 5.88184ZM6.97716 6.71984C7.31181 7.38914 8.48804 6.79159 7.99413 6.14788C7.86519 5.97983 7.68657 5.9494 7.62145 5.94207C7.21217 5.89601 6.76349 6.2925 6.97716 6.71984ZM6.98798 8.72461C7.14066 9.1188 7.51122 9.3187 7.91915 9.1633C8.27434 9.02799 8.33186 8.39689 8.17175 8.07427C8.02331 7.77514 7.63956 7.67793 7.33747 7.79417C6.98512 7.92976 6.85672 8.38708 6.98576 8.71889L6.98798 8.72461ZM10.3885 8.84081C10.7575 8.6566 11.4617 8.82771 11.4617 9.31199C11.4617 9.71286 10.9587 10.2165 10.5634 10.2826C10.1813 10.3465 9.70515 9.97581 9.76648 9.57718C9.81445 9.26539 10.1217 8.97401 10.3885 8.84081ZM7.56704 10.8432C7.33461 10.7502 7.14353 10.8601 7.11437 10.8769L7.11279 10.8778C6.90782 10.9949 6.71383 11.2439 6.6747 11.4842C6.59018 12.0034 7.13199 12.1239 7.52661 12.0987C8.2074 12.0553 8.06547 11.0426 7.56704 10.8432ZM4.8805 10.8932C5.0674 10.7723 5.15658 10.5363 5.08293 10.3153C4.93046 9.79687 4.3246 9.71252 3.96561 10.1297C3.79336 10.3299 3.80749 10.6274 3.99214 10.8105L3.99495 10.814L3.9979 10.8176C4.22025 11.0942 4.63624 11.1857 4.8805 10.8932ZM3.04695 7.81318C3.33147 8.0977 3.60077 8.15067 3.98443 8.05859C4.60826 7.90887 4.13814 6.24299 3.047 6.87296C2.70939 7.06788 2.86716 7.63339 3.04695 7.81318Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1h = [
    "color"
];
var $45e7c250d3003265$export$51b6cd98f8778f0d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1h);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1i = [
    "color"
];
var $45e7c250d3003265$export$53250eb5c8bd1390 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1i);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.87737 12H9.9H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H9.9C8.77164 11 7.95545 10.9996 7.31352 10.9472C6.67744 10.8952 6.25662 10.7946 5.91103 10.6185C5.25247 10.283 4.71703 9.74753 4.38148 9.08897C4.20539 8.74338 4.10481 8.32256 4.05284 7.68648C4.00039 7.04455 4 6.22836 4 5.1V3.5C4 3.22386 3.77614 3 3.5 3C3.22386 3 3 3.22386 3 3.5V5.1V5.12263C3 6.22359 3 7.08052 3.05616 7.76791C3.11318 8.46584 3.23058 9.0329 3.49047 9.54296C3.9219 10.3897 4.61031 11.0781 5.45704 11.5095C5.9671 11.7694 6.53416 11.8868 7.23209 11.9438C7.91948 12 8.77641 12 9.87737 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1j = [
    "color"
];
var $45e7c250d3003265$export$13d7020d49a403c9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1j);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.12263 12H5.1H3.5C3.22386 12 3 11.7761 3 11.5C3 11.2239 3.22386 11 3.5 11H5.1C6.22836 11 7.04455 10.9996 7.68648 10.9472C8.32256 10.8952 8.74338 10.7946 9.08897 10.6185C9.74753 10.283 10.283 9.74753 10.6185 9.08897C10.7946 8.74338 10.8952 8.32256 10.9472 7.68648C10.9996 7.04455 11 6.22836 11 5.1V3.5C11 3.22386 11.2239 3 11.5 3C11.7761 3 12 3.22386 12 3.5V5.1V5.12263C12 6.22359 12 7.08052 11.9438 7.76791C11.8868 8.46584 11.7694 9.0329 11.5095 9.54296C11.0781 10.3897 10.3897 11.0781 9.54296 11.5095C9.0329 11.7694 8.46584 11.8868 7.76791 11.9438C7.08052 12 6.22359 12 5.12263 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1k = [
    "color"
];
var $45e7c250d3003265$export$e709160419ee2246 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1k);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.87737 3H9.9H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H9.9C8.77164 4 7.95545 4.00039 7.31352 4.05284C6.67744 4.10481 6.25662 4.20539 5.91103 4.38148C5.25247 4.71703 4.71703 5.25247 4.38148 5.91103C4.20539 6.25662 4.10481 6.67744 4.05284 7.31352C4.00039 7.95545 4 8.77164 4 9.9V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.9V9.87737C3 8.77641 3 7.91948 3.05616 7.23209C3.11318 6.53416 3.23058 5.9671 3.49047 5.45704C3.9219 4.61031 4.61031 3.9219 5.45704 3.49047C5.9671 3.23058 6.53416 3.11318 7.23209 3.05616C7.91948 3 8.77641 3 9.87737 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1l = [
    "color"
];
var $45e7c250d3003265$export$8e3e82083a0db3ff = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1l);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.12263 3H5.1H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H5.1C6.22836 4 7.04455 4.00039 7.68648 4.05284C8.32256 4.10481 8.74338 4.20539 9.08897 4.38148C9.74753 4.71703 10.283 5.25247 10.6185 5.91103C10.7946 6.25662 10.8952 6.67744 10.9472 7.31352C10.9996 7.95545 11 8.77164 11 9.9V11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5V9.9V9.87737C12 8.77641 12 7.91948 11.9438 7.23209C11.8868 6.53416 11.7694 5.9671 11.5095 5.45704C11.0781 4.61031 10.3897 3.9219 9.54296 3.49047C9.0329 3.23058 8.46584 3.11318 7.76791 3.05616C7.08052 3 6.22359 3 5.12263 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1m = [
    "color"
];
var $45e7c250d3003265$export$3473a9c28d168741 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1m);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.5 2L4.87935 2C4.47687 1.99999 4.14469 1.99999 3.87409 2.0221C3.59304 2.04506 3.33469 2.09434 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.09434 3.33469 2.04506 3.59304 2.0221 3.87409C1.99999 4.14468 1.99999 4.47686 2 4.87933V4.87935V5.5C2 5.77614 2.22386 6 2.5 6C2.77614 6 3 5.77614 3 5.5V4.9C3 4.47171 3.00039 4.18056 3.01878 3.95552C3.03669 3.73631 3.06915 3.62421 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.62421 3.06915 3.73631 3.03669 3.95552 3.01878C4.18056 3.00039 4.47171 3 4.9 3H5.5C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2ZM13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V10.1C12 10.5283 11.9996 10.8194 11.9812 11.0445C11.9633 11.2637 11.9309 11.3758 11.891 11.454C11.7951 11.6422 11.6422 11.7951 11.454 11.891C11.3758 11.9309 11.2637 11.9633 11.0445 11.9812C10.8194 11.9996 10.5283 12 10.1 12H9.5C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H10.1206C10.5231 13 10.8553 13 11.1259 12.9779C11.407 12.9549 11.6653 12.9057 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C12.9057 11.6653 12.9549 11.407 12.9779 11.1259C13 10.8553 13 10.5232 13 10.1207V10.1207V10.1207V10.1206V9.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V10.1C3 10.5283 3.00039 10.8194 3.01878 11.0445C3.03669 11.2637 3.06915 11.3758 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.62421 11.9309 3.73631 11.9633 3.95552 11.9812C4.18056 11.9996 4.47171 12 4.9 12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H4.87935C4.47687 13 4.14469 13 3.87409 12.9779C3.59304 12.9549 3.33469 12.9057 3.09202 12.782C2.7157 12.5903 2.40973 12.2843 2.21799 11.908C2.09434 11.6653 2.04506 11.407 2.0221 11.1259C1.99999 10.8553 1.99999 10.5231 2 10.1207V10.1206V10.1V9.5C2 9.22386 2.22386 9 2.5 9ZM10.1 3C10.5283 3 10.8194 3.00039 11.0445 3.01878C11.2637 3.03669 11.3758 3.06915 11.454 3.10899C11.6422 3.20487 11.7951 3.35785 11.891 3.54601C11.9309 3.62421 11.9633 3.73631 11.9812 3.95552C11.9996 4.18056 12 4.47171 12 4.9V5.5C12 5.77614 12.2239 6 12.5 6C12.7761 6 13 5.77614 13 5.5V4.87935V4.87934C13 4.47686 13 4.14468 12.9779 3.87409C12.9549 3.59304 12.9057 3.33469 12.782 3.09202C12.5903 2.7157 12.2843 2.40973 11.908 2.21799C11.6653 2.09434 11.407 2.04506 11.1259 2.0221C10.8553 1.99999 10.5231 1.99999 10.1206 2L10.1 2H9.5C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H10.1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1n = [
    "color"
];
var $45e7c250d3003265$export$d947354b0bb44dfa = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1n);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.7217 1.84998 3.34851 3.90636 2.76336 4.99997H4.5C4.77614 4.99997 5 5.22383 5 5.49997C5 5.77611 4.77614 5.99997 4.5 5.99997H1.5C1.22386 5.99997 1 5.77611 1 5.49997V2.49997C1 2.22383 1.22386 1.99997 1.5 1.99997C1.77614 1.99997 2 2.22383 2 2.49997V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7 10V5.00001H8V10H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1o = [
    "color"
];
var $45e7c250d3003265$export$92a2757a17018399 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1o);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1p = [
    "color"
];
var $45e7c250d3003265$export$9816aad82d905e6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1p);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.5 8.00684e-07C3.77614 7.88614e-07 4 0.223859 4 0.500001L4 3.00006L11.5 3.00006C11.7761 3.00006 12 3.22392 12 3.50006L12 11.0001L14.5 11C14.7761 11 15 11.2238 15 11.5C15 11.7761 14.7762 12 14.5 12L12 12.0001L12 14.5C12 14.7761 11.7761 15 11.5 15C11.2239 15 11 14.7761 11 14.5L11 12.0001L3.5 12.0001C3.22386 12.0001 3 11.7762 3 11.5001L3 4.00005L0.499989 4C0.223847 4 -6.10541e-06 3.77613 -5.02576e-07 3.49999C5.13006e-06 3.22385 0.223867 3 0.50001 3L3 3.00005L3 0.500001C3 0.223859 3.22386 8.12755e-07 3.5 8.00684e-07ZM4 4.00006L4 11.0001L11 11.0001L11 4.00006L4 4.00006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1q = [
    "color"
];
var $45e7c250d3003265$export$8c97d895bfadca90 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1r = [
    "color"
];
var $45e7c250d3003265$export$b7fa469a3cb3cd4f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1r);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1s = [
    "color"
];
var $45e7c250d3003265$export$8710c0d3947fcfc3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1s);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1t = [
    "color"
];
var $45e7c250d3003265$export$d5c5855fccded9fe = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1t);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.50207C0.877075 3.84319 3.84319 0.877075 7.50208 0.877075C11.1609 0.877075 14.1271 3.84319 14.1271 7.50207C14.1271 11.1609 11.1609 14.1271 7.50208 14.1271C3.84319 14.1271 0.877075 11.1609 0.877075 7.50207ZM1.84898 7.00003C2.0886 4.26639 4.26639 2.0886 7.00003 1.84898V4.50003C7.00003 4.77617 7.22388 5.00003 7.50003 5.00003C7.77617 5.00003 8.00003 4.77617 8.00003 4.50003V1.84862C10.7356 2.08643 12.9154 4.26502 13.1552 7.00003H10.5C10.2239 7.00003 10 7.22388 10 7.50003C10 7.77617 10.2239 8.00003 10.5 8.00003H13.1555C12.9176 10.7369 10.7369 12.9176 8.00003 13.1555V10.5C8.00003 10.2239 7.77617 10 7.50003 10C7.22388 10 7.00003 10.2239 7.00003 10.5V13.1552C4.26502 12.9154 2.08643 10.7356 1.84862 8.00003H4.50003C4.77617 8.00003 5.00003 7.77617 5.00003 7.50003C5.00003 7.22388 4.77617 7.00003 4.50003 7.00003H1.84898Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1u = [
    "color"
];
var $45e7c250d3003265$export$d0fffbce0e008b09 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1u);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V1.80687C10.6922 2.0935 12.8167 4.28012 13.0068 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H12.9888C12.7094 10.6244 10.6244 12.7094 8 12.9888V14.5C8 14.7761 7.77614 15 7.5 15C7.22386 15 7 14.7761 7 14.5V13.0068C4.28012 12.8167 2.0935 10.6922 1.80687 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H1.78886C1.98376 4.21166 4.21166 1.98376 7 1.78886V0.5C7 0.223858 7.22386 0 7.5 0ZM8 12.0322V9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V12.054C4.80517 11.8689 3.04222 10.1668 2.76344 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.7417C2.93252 4.73662 4.73662 2.93252 7 2.7417V5.5C7 5.77614 7.22386 6 7.5 6C7.77614 6 8 5.77614 8 5.5V2.76344C10.1668 3.04222 11.8689 4.80517 12.054 7H9.5C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H12.0322C11.7621 10.0991 10.0991 11.7621 8 12.0322Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1v = [
    "color"
];
var $45e7c250d3003265$export$18abdbf97bad2a11 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1v);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.60913 0.0634287C4.39082 0.0088505 4.16575 0.12393 4.08218 0.332867L3.1538 2.6538L0.832866 3.58218C0.702884 3.63417 0.604504 3.7437 0.566705 3.87849C0.528906 4.01329 0.555994 4.158 0.639992 4.26999L2.01148 6.09864L1.06343 9.89085C1.00944 10.1068 1.12145 10.3298 1.32691 10.4154L4.20115 11.613L5.62557 13.7496C5.73412 13.9124 5.93545 13.9864 6.12362 13.9327L9.62362 12.9327C9.62988 12.9309 9.63611 12.929 9.64229 12.9269L12.6423 11.9269C12.7923 11.8769 12.905 11.7519 12.9393 11.5976L13.9393 7.09761C13.9776 6.92506 13.9114 6.74605 13.77 6.63999L11.95 5.27499V2.99999C11.95 2.82955 11.8537 2.67373 11.7012 2.5975L8.70124 1.0975C8.67187 1.08282 8.64098 1.07139 8.60913 1.06343L4.60913 0.0634287ZM11.4323 6.01173L12.7748 7.01858L10.2119 9.15429C10.1476 9.20786 10.0995 9.2783 10.0731 9.35769L9.25382 11.8155L7.73849 10.8684C7.52774 10.7367 7.25011 10.8007 7.11839 11.0115C6.98667 11.2222 7.05074 11.4999 7.26149 11.6316L8.40341 12.3453L6.19221 12.9771L4.87441 11.0004C4.82513 10.9265 4.75508 10.8688 4.67307 10.8346L2.03046 9.73352L2.85134 6.44999H4.99999C5.24852 6.44999 5.44999 6.24852 5.44999 5.99999C5.44999 5.75146 5.24852 5.54999 4.99999 5.54999H2.72499L1.7123 4.19974L3.51407 3.47903L6.35769 4.4269C6.53655 4.48652 6.73361 4.42832 6.85138 4.28111L8.62413 2.06518L11.05 3.27811V5.19533L8.83287 6.08218C8.70996 6.13134 8.61494 6.23212 8.57308 6.35769L8.07308 7.85769C7.99449 8.09346 8.12191 8.34831 8.35769 8.4269C8.59346 8.50549 8.84831 8.37807 8.9269 8.14229L9.3609 6.84029L11.4323 6.01173ZM7.71052 1.76648L6.34462 3.47386L4.09505 2.724L4.77192 1.03183L7.71052 1.76648ZM10.2115 11.7885L12.116 11.1537L12.7745 8.19034L10.8864 9.76374L10.2115 11.7885Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1w = [
    "color"
];
var $45e7c250d3003265$export$315ae6298b7de94 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1w);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1x = [
    "color"
];
var $45e7c250d3003265$export$4e8767be554cec68 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1x);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1y = [
    "color"
];
var $45e7c250d3003265$export$d665abe9390574dd = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2C5.42215 2 6.0399 2.23054 6.42075 2.56379C6.79286 2.88939 7 3.36626 7 4V7H5.75C5.47386 7 5.25 7.22386 5.25 7.5C5.25 7.77614 5.47386 8 5.75 8H7V11C7 11.6337 6.79286 12.1106 6.42075 12.4362C6.0399 12.7695 5.42215 13 4.5 13C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14C5.57785 14 6.4601 13.7305 7.07925 13.1888C7.24168 13.0467 7.38169 12.8896 7.5 12.7198C7.61832 12.8896 7.75832 13.0467 7.92075 13.1888C8.5399 13.7305 9.42215 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.57785 13 8.9601 12.7695 8.57925 12.4362C8.20714 12.1106 8 11.6337 8 11V8H9.25C9.52614 8 9.75 7.77614 9.75 7.5C9.75 7.22386 9.52614 7 9.25 7H8V4C8 3.36626 8.20714 2.88939 8.57925 2.56379C8.9601 2.23054 9.57785 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.42215 1 8.5399 1.26946 7.92075 1.81121C7.75832 1.95333 7.61832 2.11043 7.5 2.28023C7.38168 2.11043 7.24168 1.95333 7.07925 1.81121C6.4601 1.26946 5.57785 1 4.5 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1z = [
    "color"
];
var $45e7c250d3003265$export$a2bc8cb49334c5d1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1A = [
    "color"
];
var $45e7c250d3003265$export$8fd9d8340b1bb79a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1A);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.8 1L2.74967 0.99997C2.52122 0.999752 2.32429 0.999564 2.14983 1.04145C1.60136 1.17312 1.17312 1.60136 1.04145 2.14983C0.999564 2.32429 0.999752 2.52122 0.99997 2.74967L1 2.8V5.2L0.99997 5.25033C0.999752 5.47878 0.999564 5.67572 1.04145 5.85017C1.17312 6.39864 1.60136 6.82688 2.14983 6.95856C2.32429 7.00044 2.52122 7.00025 2.74967 7.00003L2.8 7H5.2L5.25033 7.00003C5.47878 7.00025 5.67572 7.00044 5.85017 6.95856C6.39864 6.82688 6.82688 6.39864 6.95856 5.85017C7.00044 5.67572 7.00025 5.47878 7.00003 5.25033L7 5.2V2.8L7.00003 2.74967C7.00025 2.52122 7.00044 2.32429 6.95856 2.14983C6.82688 1.60136 6.39864 1.17312 5.85017 1.04145C5.67572 0.999564 5.47878 0.999752 5.25033 0.99997L5.2 1H2.8ZM2.38328 2.01382C2.42632 2.00348 2.49222 2 2.8 2H5.2C5.50779 2 5.57369 2.00348 5.61672 2.01382C5.79955 2.05771 5.94229 2.20045 5.98619 2.38328C5.99652 2.42632 6 2.49222 6 2.8V5.2C6 5.50779 5.99652 5.57369 5.98619 5.61672C5.94229 5.79955 5.79955 5.94229 5.61672 5.98619C5.57369 5.99652 5.50779 6 5.2 6H2.8C2.49222 6 2.42632 5.99652 2.38328 5.98619C2.20045 5.94229 2.05771 5.79955 2.01382 5.61672C2.00348 5.57369 2 5.50779 2 5.2V2.8C2 2.49222 2.00348 2.42632 2.01382 2.38328C2.05771 2.20045 2.20045 2.05771 2.38328 2.01382ZM9.8 1L9.74967 0.99997C9.52122 0.999752 9.32429 0.999564 9.14983 1.04145C8.60136 1.17312 8.17312 1.60136 8.04145 2.14983C7.99956 2.32429 7.99975 2.52122 7.99997 2.74967L8 2.8V5.2L7.99997 5.25033C7.99975 5.47878 7.99956 5.67572 8.04145 5.85017C8.17312 6.39864 8.60136 6.82688 9.14983 6.95856C9.32429 7.00044 9.52122 7.00025 9.74967 7.00003L9.8 7H12.2L12.2503 7.00003C12.4788 7.00025 12.6757 7.00044 12.8502 6.95856C13.3986 6.82688 13.8269 6.39864 13.9586 5.85017C14.0004 5.67572 14.0003 5.47878 14 5.25033L14 5.2V2.8L14 2.74967C14.0003 2.52122 14.0004 2.32429 13.9586 2.14983C13.8269 1.60136 13.3986 1.17312 12.8502 1.04145C12.6757 0.999564 12.4788 0.999752 12.2503 0.99997L12.2 1H9.8ZM9.38328 2.01382C9.42632 2.00348 9.49222 2 9.8 2H12.2C12.5078 2 12.5737 2.00348 12.6167 2.01382C12.7995 2.05771 12.9423 2.20045 12.9862 2.38328C12.9965 2.42632 13 2.49222 13 2.8V5.2C13 5.50779 12.9965 5.57369 12.9862 5.61672C12.9423 5.79955 12.7995 5.94229 12.6167 5.98619C12.5737 5.99652 12.5078 6 12.2 6H9.8C9.49222 6 9.42632 5.99652 9.38328 5.98619C9.20045 5.94229 9.05771 5.79955 9.01382 5.61672C9.00348 5.57369 9 5.50779 9 5.2V2.8C9 2.49222 9.00348 2.42632 9.01382 2.38328C9.05771 2.20045 9.20045 2.05771 9.38328 2.01382ZM2.74967 7.99997L2.8 8H5.2L5.25033 7.99997C5.47878 7.99975 5.67572 7.99956 5.85017 8.04145C6.39864 8.17312 6.82688 8.60136 6.95856 9.14983C7.00044 9.32429 7.00025 9.52122 7.00003 9.74967L7 9.8V12.2L7.00003 12.2503C7.00025 12.4788 7.00044 12.6757 6.95856 12.8502C6.82688 13.3986 6.39864 13.8269 5.85017 13.9586C5.67572 14.0004 5.47878 14.0003 5.25033 14L5.2 14H2.8L2.74967 14C2.52122 14.0003 2.32429 14.0004 2.14983 13.9586C1.60136 13.8269 1.17312 13.3986 1.04145 12.8502C0.999564 12.6757 0.999752 12.4788 0.99997 12.2503L1 12.2V9.8L0.99997 9.74967C0.999752 9.52122 0.999564 9.32429 1.04145 9.14983C1.17312 8.60136 1.60136 8.17312 2.14983 8.04145C2.32429 7.99956 2.52122 7.99975 2.74967 7.99997ZM2.8 9C2.49222 9 2.42632 9.00348 2.38328 9.01382C2.20045 9.05771 2.05771 9.20045 2.01382 9.38328C2.00348 9.42632 2 9.49222 2 9.8V12.2C2 12.5078 2.00348 12.5737 2.01382 12.6167C2.05771 12.7995 2.20045 12.9423 2.38328 12.9862C2.42632 12.9965 2.49222 13 2.8 13H5.2C5.50779 13 5.57369 12.9965 5.61672 12.9862C5.79955 12.9423 5.94229 12.7995 5.98619 12.6167C5.99652 12.5737 6 12.5078 6 12.2V9.8C6 9.49222 5.99652 9.42632 5.98619 9.38328C5.94229 9.20045 5.79955 9.05771 5.61672 9.01382C5.57369 9.00348 5.50779 9 5.2 9H2.8ZM9.8 8L9.74967 7.99997C9.52122 7.99975 9.32429 7.99956 9.14983 8.04145C8.60136 8.17312 8.17312 8.60136 8.04145 9.14983C7.99956 9.32429 7.99975 9.52122 7.99997 9.74967L8 9.8V12.2L7.99997 12.2503C7.99975 12.4788 7.99956 12.6757 8.04145 12.8502C8.17312 13.3986 8.60136 13.8269 9.14983 13.9586C9.32429 14.0004 9.52122 14.0003 9.74967 14L9.8 14H12.2L12.2503 14C12.4788 14.0003 12.6757 14.0004 12.8502 13.9586C13.3986 13.8269 13.8269 13.3986 13.9586 12.8502C14.0004 12.6757 14.0003 12.4788 14 12.2503L14 12.2V9.8L14 9.74967C14.0003 9.52122 14.0004 9.32429 13.9586 9.14983C13.8269 8.60136 13.3986 8.17312 12.8502 8.04145C12.6757 7.99956 12.4788 7.99975 12.2503 7.99997L12.2 8H9.8ZM9.38328 9.01382C9.42632 9.00348 9.49222 9 9.8 9H12.2C12.5078 9 12.5737 9.00348 12.6167 9.01382C12.7995 9.05771 12.9423 9.20045 12.9862 9.38328C12.9965 9.42632 13 9.49222 13 9.8V12.2C13 12.5078 12.9965 12.5737 12.9862 12.6167C12.9423 12.7995 12.7995 12.9423 12.6167 12.9862C12.5737 12.9965 12.5078 13 12.2 13H9.8C9.49222 13 9.42632 12.9965 9.38328 12.9862C9.20045 12.9423 9.05771 12.7995 9.01382 12.6167C9.00348 12.5737 9 12.5078 9 12.2V9.8C9 9.49222 9.00348 9.42632 9.01382 9.38328C9.05771 9.20045 9.20045 9.05771 9.38328 9.01382Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1B = [
    "color"
];
var $45e7c250d3003265$export$78a6319cfd8cd037 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1B);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 3.25C1 3.11193 1.11193 3 1.25 3H13.75C13.8881 3 14 3.11193 14 3.25V10.75C14 10.8881 13.8881 11 13.75 11H1.25C1.11193 11 1 10.8881 1 10.75V3.25ZM1.25 2C0.559643 2 0 2.55964 0 3.25V10.75C0 11.4404 0.559644 12 1.25 12H5.07341L4.82991 13.2986C4.76645 13.6371 5.02612 13.95 5.37049 13.95H9.62951C9.97389 13.95 10.2336 13.6371 10.1701 13.2986L9.92659 12H13.75C14.4404 12 15 11.4404 15 10.75V3.25C15 2.55964 14.4404 2 13.75 2H1.25ZM9.01091 12H5.98909L5.79222 13.05H9.20778L9.01091 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1C = [
    "color"
];
var $45e7c250d3003265$export$63405b713b830f28 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1C);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1D = [
    "color"
];
var $45e7c250d3003265$export$e9e14b59da099a2a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1D);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM1.82708 7.49991C1.82708 4.36689 4.36689 1.82707 7.49991 1.82707C10.6329 1.82707 13.1727 4.36689 13.1727 7.49991C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49991ZM8.37287 7.50006C8.37287 7.98196 7.98221 8.37263 7.5003 8.37263C7.01839 8.37263 6.62773 7.98196 6.62773 7.50006C6.62773 7.01815 7.01839 6.62748 7.5003 6.62748C7.98221 6.62748 8.37287 7.01815 8.37287 7.50006ZM9.32287 7.50006C9.32287 8.50664 8.50688 9.32263 7.5003 9.32263C6.49372 9.32263 5.67773 8.50664 5.67773 7.50006C5.67773 6.49348 6.49372 5.67748 7.5003 5.67748C8.50688 5.67748 9.32287 6.49348 9.32287 7.50006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1E = [
    "color"
];
var $45e7c250d3003265$export$bf776c57f6d5a7c1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1E);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$1F = [
    "color"
];
var $45e7c250d3003265$export$67e4f137381994a7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1F);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1G = [
    "color"
];
var $45e7c250d3003265$export$4941448a902289ea = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1G);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1H = [
    "color"
];
var $45e7c250d3003265$export$1638d451d4588271 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1H);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1I = [
    "color"
];
var $45e7c250d3003265$export$5ce415a59e297ace = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1I);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$1J = [
    "color"
];
var $45e7c250d3003265$export$9789fa787c2a8e33 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1J);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1K = [
    "color"
];
var $45e7c250d3003265$export$f50786ff8e0cdf62 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1K);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1L = [
    "color"
];
var $45e7c250d3003265$export$de42cbda950c1561 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1L);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.85355 2.14645C3.65829 1.95118 3.34171 1.95118 3.14645 2.14645C2.95118 2.34171 2.95118 2.65829 3.14645 2.85355L7.14645 6.85355C7.34171 7.04882 7.65829 7.04882 7.85355 6.85355L11.8536 2.85355C12.0488 2.65829 12.0488 2.34171 11.8536 2.14645C11.6583 1.95118 11.3417 1.95118 11.1464 2.14645L7.5 5.79289L3.85355 2.14645ZM3.85355 8.14645C3.65829 7.95118 3.34171 7.95118 3.14645 8.14645C2.95118 8.34171 2.95118 8.65829 3.14645 8.85355L7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L11.8536 8.85355C12.0488 8.65829 12.0488 8.34171 11.8536 8.14645C11.6583 7.95118 11.3417 7.95118 11.1464 8.14645L7.5 11.7929L3.85355 8.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1M = [
    "color"
];
var $45e7c250d3003265$export$8f14af9007650906 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1M);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1N = [
    "color"
];
var $45e7c250d3003265$export$90b329a415b2a5d4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1N);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1O = [
    "color"
];
var $45e7c250d3003265$export$4625b0d11d3861cc = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1O);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.1464 6.85355C11.3417 7.04882 11.6583 7.04882 11.8536 6.85355C12.0488 6.65829 12.0488 6.34171 11.8536 6.14645L7.85355 2.14645C7.65829 1.95118 7.34171 1.95118 7.14645 2.14645L3.14645 6.14645C2.95118 6.34171 2.95118 6.65829 3.14645 6.85355C3.34171 7.04882 3.65829 7.04882 3.85355 6.85355L7.5 3.20711L11.1464 6.85355ZM11.1464 12.8536C11.3417 13.0488 11.6583 13.0488 11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464L7.85355 8.14645C7.65829 7.95118 7.34171 7.95118 7.14645 8.14645L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L7.5 9.20711L11.1464 12.8536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1P = [
    "color"
];
var $45e7c250d3003265$export$4e54df4252b4a99c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1P);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1Q = [
    "color"
];
var $45e7c250d3003265$export$209fdd70701c1b6e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1Q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("circle", {
        cx: "4.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "4.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "4.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "4.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "4.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "4.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "6.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "6.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "6.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "6.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "6.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "6.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "8.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "8.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "8.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "8.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "8.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "8.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "10.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "10.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "10.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "10.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "10.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $bh6RR.createElement)("circle", {
        cx: "10.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$1R = [
    "color"
];
var $45e7c250d3003265$export$829e9de7006febc4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1R);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1S = [
    "color"
];
var $45e7c250d3003265$export$e6848a231b25a576 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1S);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.49998 4.09998C2.27906 4.09998 2.09998 4.27906 2.09998 4.49998C2.09998 4.72089 2.27906 4.89998 2.49998 4.89998H12.5C12.7209 4.89998 12.9 4.72089 12.9 4.49998C12.9 4.27906 12.7209 4.09998 12.5 4.09998H2.49998ZM2.49998 6.09998C2.27906 6.09998 2.09998 6.27906 2.09998 6.49998C2.09998 6.72089 2.27906 6.89998 2.49998 6.89998H12.5C12.7209 6.89998 12.9 6.72089 12.9 6.49998C12.9 6.27906 12.7209 6.09998 12.5 6.09998H2.49998ZM2.09998 8.49998C2.09998 8.27906 2.27906 8.09998 2.49998 8.09998H12.5C12.7209 8.09998 12.9 8.27906 12.9 8.49998C12.9 8.72089 12.7209 8.89998 12.5 8.89998H2.49998C2.27906 8.89998 2.09998 8.72089 2.09998 8.49998ZM2.49998 10.1C2.27906 10.1 2.09998 10.2791 2.09998 10.5C2.09998 10.7209 2.27906 10.9 2.49998 10.9H12.5C12.7209 10.9 12.9 10.7209 12.9 10.5C12.9 10.2791 12.7209 10.1 12.5 10.1H2.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1T = [
    "color"
];
var $45e7c250d3003265$export$b72a86f6a31cd8d8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1T);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.09998 12.5C4.09998 12.7209 4.27906 12.9 4.49998 12.9C4.72089 12.9 4.89998 12.7209 4.89998 12.5L4.89998 2.50002C4.89998 2.27911 4.72089 2.10003 4.49998 2.10003C4.27906 2.10003 4.09998 2.27911 4.09998 2.50002L4.09998 12.5ZM6.09998 12.5C6.09998 12.7209 6.27906 12.9 6.49998 12.9C6.72089 12.9 6.89998 12.7209 6.89998 12.5L6.89998 2.50002C6.89998 2.27911 6.72089 2.10003 6.49998 2.10003C6.27906 2.10003 6.09998 2.27911 6.09998 2.50002L6.09998 12.5ZM8.49998 12.9C8.27906 12.9 8.09998 12.7209 8.09998 12.5L8.09998 2.50002C8.09998 2.27911 8.27906 2.10002 8.49998 2.10002C8.72089 2.10002 8.89998 2.27911 8.89998 2.50002L8.89998 12.5C8.89998 12.7209 8.72089 12.9 8.49998 12.9ZM10.1 12.5C10.1 12.7209 10.2791 12.9 10.5 12.9C10.7209 12.9 10.9 12.7209 10.9 12.5L10.9 2.50002C10.9 2.27911 10.7209 2.10002 10.5 2.10002C10.2791 2.10002 10.1 2.27911 10.1 2.50002L10.1 12.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1U = [
    "color"
];
var $45e7c250d3003265$export$d678e82375a26dcf = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1U);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10.3285 1.13607C10.1332 0.940809 9.81662 0.940808 9.62136 1.13607C9.42609 1.33133 9.42609 1.64792 9.62136 1.84318L10.2744 2.49619L5.42563 6.13274L4.31805 5.02516C4.12279 4.8299 3.80621 4.8299 3.61095 5.02516C3.41569 5.22042 3.41569 5.537 3.61095 5.73226L5.02516 7.14648L6.08582 8.20714L2.81545 11.4775C2.62019 11.6728 2.62019 11.9894 2.81545 12.1846C3.01072 12.3799 3.3273 12.3799 3.52256 12.1846L6.79293 8.91425L7.85359 9.97491L9.2678 11.3891C9.46306 11.5844 9.77965 11.5844 9.97491 11.3891C10.1702 11.1939 10.1702 10.8773 9.97491 10.682L8.86733 9.57443L12.5039 4.7257L13.1569 5.37871C13.3522 5.57397 13.6687 5.57397 13.864 5.37871C14.0593 5.18345 14.0593 4.86687 13.864 4.6716L12.8033 3.61094L11.3891 2.19673L10.3285 1.13607ZM6.13992 6.84702L10.9887 3.21047L11.7896 4.01142L8.15305 8.86015L6.13992 6.84702Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1V = [
    "color"
];
var $45e7c250d3003265$export$c6212c739d4cf8da = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1V);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1W = [
    "color"
];
var $45e7c250d3003265$export$e5daec7136b0534 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1W);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1X = [
    "color"
];
var $45e7c250d3003265$export$296bea1be8b4086a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1X);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1Y = [
    "color"
];
var $45e7c250d3003265$export$5886b995403a6540 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1Y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1Z = [
    "color"
];
var $45e7c250d3003265$export$c81ccc0bdd70284 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1Z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1_ = [
    "color"
];
var $45e7c250d3003265$export$808857d2db6c57a2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1_);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.94721 0.164594C7.66569 0.0238299 7.33431 0.0238302 7.05279 0.164594L0.552786 3.41459C0.214002 3.58399 0 3.93025 0 4.30902V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V4.30902C15 3.93025 14.786 3.58399 14.4472 3.41459L7.94721 0.164594ZM13.5689 4.09349L7.5 1.05902L1.43105 4.09349L7.5 7.29136L13.5689 4.09349ZM1 4.88366V12H14V4.88366L7.70977 8.19813C7.57848 8.26731 7.42152 8.26731 7.29023 8.19813L1 4.88366Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$1$ = [
    "color"
];
var $45e7c250d3003265$export$b6c544816d254f36 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$1$);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.36052 0.72921C8.55578 0.533948 8.87236 0.533948 9.06763 0.72921L14.2708 5.93235C14.466 6.12761 14.466 6.4442 14.2708 6.63946L8.95513 11.9551L7.3466 13.5636C6.76081 14.1494 5.81106 14.1494 5.22528 13.5636L1.43635 9.7747C0.850563 9.18891 0.850563 8.23917 1.43635 7.65338L3.04488 6.04485L8.36052 0.72921ZM8.71407 1.78987L4.10554 6.3984L8.60157 10.8944L13.2101 6.28591L8.71407 1.78987ZM7.89447 11.6015L3.39843 7.10551L2.14346 8.36049C1.94819 8.55575 1.94819 8.87233 2.14346 9.06759L5.93238 12.8565C6.12765 13.0518 6.44423 13.0518 6.63949 12.8565L7.89447 11.6015Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$20 = [
    "color"
];
var $45e7c250d3003265$export$b409b230b61d4724 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$20);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$21 = [
    "color"
];
var $45e7c250d3003265$export$72b807c0098a555f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$21);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$22 = [
    "color"
];
var $45e7c250d3003265$export$7e82c66e763fb043 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$22);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.5 2C5.77614 2 6 2.22386 6 2.5V5.5C6 5.77614 5.77614 6 5.5 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM9.5 2C9.77614 2 10 2.22386 10 2.5V5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H9.5C9.22386 6 9 5.77614 9 5.5V2.5C9 2.22386 9.22386 2 9.5 2ZM2 9.5C2 9.22386 2.22386 9 2.5 9H5.5C5.77614 9 6 9.22386 6 9.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V10H2.5C2.22386 10 2 9.77614 2 9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$23 = [
    "color"
];
var $45e7c250d3003265$export$9bd11592bfa362e7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$23);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$24 = [
    "color"
];
var $45e7c250d3003265$export$f2c2531e46a6c1ea = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$24);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$25 = [
    "color"
];
var $45e7c250d3003265$export$3547759c3ff9b44c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$25);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$26 = [
    "color"
];
var $45e7c250d3003265$export$620653f31aa3377e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$26);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$27 = [
    "color"
];
var $45e7c250d3003265$export$b8f42e9471d5f647 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$27);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82708 7.49972C1.82708 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82708 10.6327 1.82708 7.49972ZM5.03747 9.21395C4.87949 8.98746 4.56782 8.93193 4.34133 9.08991C4.11484 9.24789 4.05931 9.55956 4.21729 9.78605C4.93926 10.8211 6.14033 11.5 7.50004 11.5C8.85974 11.5 10.0608 10.8211 10.7828 9.78605C10.9408 9.55956 10.8852 9.24789 10.6587 9.08991C10.4323 8.93193 10.1206 8.98746 9.9626 9.21395C9.41963 9.99238 8.51907 10.5 7.50004 10.5C6.481 10.5 5.58044 9.99238 5.03747 9.21395ZM5.37503 6.84998C5.85828 6.84998 6.25003 6.45815 6.25003 5.97498C6.25003 5.4918 5.85828 5.09998 5.37503 5.09998C4.89179 5.09998 4.50003 5.4918 4.50003 5.97498C4.50003 6.45815 4.89179 6.84998 5.37503 6.84998ZM10.5 5.97498C10.5 6.45815 10.1083 6.84998 9.62503 6.84998C9.14179 6.84998 8.75003 6.45815 8.75003 5.97498C8.75003 5.4918 9.14179 5.09998 9.62503 5.09998C10.1083 5.09998 10.5 5.4918 10.5 5.97498Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$28 = [
    "color"
];
var $45e7c250d3003265$export$2b3d0ca2fe16e98c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$28);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$29 = [
    "color"
];
var $45e7c250d3003265$export$8c1a3d13e85d78b7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$29);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM9 2.70711L11.2929 5H9V2.70711ZM2 2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2a = [
    "color"
];
var $45e7c250d3003265$export$3c5dbe056aa7c94f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2a);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.29289L12 4.70711V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.60355C13 4.40464 12.921 4.21388 12.7803 4.07322L9.85355 1.14645C9.75979 1.05268 9.63261 1 9.5 1H3.5ZM5.25 7C4.97386 7 4.75 7.22386 4.75 7.5C4.75 7.77614 4.97386 8 5.25 8H9.75C10.0261 8 10.25 7.77614 10.25 7.5C10.25 7.22386 10.0261 7 9.75 7H5.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2b = [
    "color"
];
var $45e7c250d3003265$export$ca191b730434e9b4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2b);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V4.70711L9.29289 2H3.5ZM2 2.5C2 1.67157 2.67157 1 3.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645L12.7803 4.07322C12.921 4.21388 13 4.40464 13 4.60355V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5ZM4.75 7.5C4.75 7.22386 4.97386 7 5.25 7H7V5.25C7 4.97386 7.22386 4.75 7.5 4.75C7.77614 4.75 8 4.97386 8 5.25V7H9.75C10.0261 7 10.25 7.22386 10.25 7.5C10.25 7.77614 10.0261 8 9.75 8H8V9.75C8 10.0261 7.77614 10.25 7.5 10.25C7.22386 10.25 7 10.0261 7 9.75V8H5.25C4.97386 8 4.75 7.77614 4.75 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2c = [
    "color"
];
var $45e7c250d3003265$export$605674723bcc715c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2c);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2d = [
    "color"
];
var $45e7c250d3003265$export$1a2ae984f27cf526 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2d);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$2e = [
    "color"
];
var $45e7c250d3003265$export$79d8792587f7aca5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2e);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$2f = [
    "color"
];
var $45e7c250d3003265$export$f5ac866b2a77627a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2f);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2g = [
    "color"
];
var $45e7c250d3003265$export$9f94aa21504b3fcd = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2g);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.79993 3.50017C4.79993 3.25164 5.0014 3.05017 5.24993 3.05017H9.74993C9.99845 3.05017 10.1999 3.25164 10.1999 3.50017C10.1999 3.7487 9.99845 3.95017 9.74993 3.95017H8.09993V11.05H9.74994C9.99847 11.05 10.1999 11.2515 10.1999 11.5C10.1999 11.7486 9.99847 11.95 9.74994 11.95H5.24994C5.00141 11.95 4.79994 11.7486 4.79994 11.5C4.79994 11.2515 5.00141 11.05 5.24994 11.05H6.89993V3.95017H5.24993C5.0014 3.95017 4.79993 3.7487 4.79993 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2h = [
    "color"
];
var $45e7c250d3003265$export$88890ea574fb3a19 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2h);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2i = [
    "color"
];
var $45e7c250d3003265$export$805712ff48c03e2e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2i);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.03791 9.98075C0.934777 9.6583 1.11603 9.37719 1.40005 9.24871C1.68408 9.12022 2.09463 9.13412 2.27071 9.45426C2.85393 10.5147 3.64599 10.7282 4.48665 10.7282C5.52721 10.7282 6.29659 10.2615 6.29659 9.45426C6.29659 8.8047 5.9119 8.46416 4.87134 8.14253L4.15872 7.92181C2.64518 7.44883 1.88842 6.69206 1.88842 5.45601C1.88842 3.79743 3.27583 2.6875 5.24342 2.6875C6.91733 2.6875 7.97409 3.33536 8.43833 4.31065C8.57087 4.58909 8.57614 4.91294 8.22794 5.19114C7.87974 5.46934 7.52351 5.34799 7.23327 5.03839C6.47215 4.22653 5.99545 4.04968 5.25604 4.04968C4.1398 4.04968 3.547 4.63618 3.547 5.27943C3.547 5.86592 3.96322 6.23169 4.94702 6.5344L5.67856 6.76143C7.22994 7.23441 7.97409 7.95964 7.97409 9.17047C7.97409 10.7723 6.69389 12.0903 4.46143 12.0903C2.86612 12.0903 1.40005 11.1131 1.03791 9.98075ZM11.8491 8.77985C10.661 8.39543 10.1649 7.86114 10.1649 6.98805C10.1649 5.86736 11.1636 5.04639 12.6128 5.04639C13.8546 5.04639 14.6629 5.63345 14.9778 6.6346C15.0443 6.84599 14.9593 6.98006 14.7475 7.0491C14.5394 7.11697 14.3176 7.09974 14.238 6.89611C13.9356 6.12273 13.352 5.76311 12.5998 5.76311C11.6467 5.76311 11.0135 6.25178 11.0135 6.91638C11.0135 7.45066 11.3464 7.75038 12.2473 8.04358L12.8348 8.23254C14.062 8.62999 14.5516 9.13821 14.5516 10.0178C14.5516 11.1972 13.481 12.0442 11.9927 12.0442C10.6439 12.0442 9.65644 11.2809 9.41979 10.3361C9.36535 10.1188 9.41192 10.0287 9.70039 9.96184C9.98886 9.89499 10.0714 9.89918 10.1715 10.1369C10.4555 10.8114 11.1531 11.3275 12.0318 11.3275C12.9914 11.3275 13.6834 10.7802 13.6834 10.0634C13.6834 9.53567 13.3961 9.28807 12.4366 8.97532L11.8491 8.77985Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2j = [
    "color"
];
var $45e7c250d3003265$export$bbfc12447ec5dbe8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2j);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V4H5V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H4V10H1.5C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H4V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V11H10V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H11V5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11V1.5ZM10 10V5H5V10H10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2k = [
    "color"
];
var $45e7c250d3003265$export$49fa3bb64381879 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2k);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.3825 1.29567C3.46241 1.11432 3.64188 0.997284 3.84005 0.997284H11.5C11.7761 0.997284 12 1.22114 12 1.49728V5.5C12 5.77614 11.7761 6 11.5 6H8.63521L11.5288 9.16247C11.6626 9.3087 11.6974 9.52015 11.6175 9.70154C11.5376 9.88293 11.3582 10 11.16 10H8V13.5C8 13.7022 7.87818 13.8845 7.69134 13.9619C7.5045 14.0393 7.28945 13.9966 7.14645 13.8536L3.14645 9.85355C3.05268 9.75979 3 9.63261 3 9.5V5.5C3 5.22386 3.22386 5 3.5 5H6.36531L3.47105 1.83468C3.33732 1.68844 3.30259 1.47701 3.3825 1.29567ZM7.72032 5L4.97474 1.99728H11V5H7.72032ZM7.27978 6H4V9H7.5H10.0247L7.27978 6ZM4.70711 10L7 12.2929V10H4.70711Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2l = [
    "color"
];
var $45e7c250d3003265$export$70208e77f6c45b17 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2l);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.07095 0.650238C6.67391 0.650238 6.32977 0.925096 6.24198 1.31231L6.0039 2.36247C5.6249 2.47269 5.26335 2.62363 4.92436 2.81013L4.01335 2.23585C3.67748 2.02413 3.23978 2.07312 2.95903 2.35386L2.35294 2.95996C2.0722 3.2407 2.0232 3.6784 2.23493 4.01427L2.80942 4.92561C2.62307 5.2645 2.47227 5.62594 2.36216 6.00481L1.31209 6.24287C0.924883 6.33065 0.650024 6.6748 0.650024 7.07183V7.92897C0.650024 8.32601 0.924883 8.67015 1.31209 8.75794L2.36228 8.99603C2.47246 9.375 2.62335 9.73652 2.80979 10.0755L2.2354 10.9867C2.02367 11.3225 2.07267 11.7602 2.35341 12.041L2.95951 12.6471C3.24025 12.9278 3.67795 12.9768 4.01382 12.7651L4.92506 12.1907C5.26384 12.377 5.62516 12.5278 6.0039 12.6379L6.24198 13.6881C6.32977 14.0753 6.67391 14.3502 7.07095 14.3502H7.92809C8.32512 14.3502 8.66927 14.0753 8.75705 13.6881L8.99505 12.6383C9.37411 12.5282 9.73573 12.3773 10.0748 12.1909L10.986 12.7653C11.3218 12.977 11.7595 12.928 12.0403 12.6473L12.6464 12.0412C12.9271 11.7604 12.9761 11.3227 12.7644 10.9869L12.1902 10.076C12.3768 9.73688 12.5278 9.37515 12.638 8.99596L13.6879 8.75794C14.0751 8.67015 14.35 8.32601 14.35 7.92897V7.07183C14.35 6.6748 14.0751 6.33065 13.6879 6.24287L12.6381 6.00488C12.528 5.62578 12.3771 5.26414 12.1906 4.92507L12.7648 4.01407C12.9766 3.6782 12.9276 3.2405 12.6468 2.95975L12.0407 2.35366C11.76 2.07292 11.3223 2.02392 10.9864 2.23565L10.0755 2.80989C9.73622 2.62328 9.37437 2.47229 8.99505 2.36209L8.75705 1.31231C8.66927 0.925096 8.32512 0.650238 7.92809 0.650238H7.07095ZM4.92053 3.81251C5.44724 3.44339 6.05665 3.18424 6.71543 3.06839L7.07095 1.50024H7.92809L8.28355 3.06816C8.94267 3.18387 9.5524 3.44302 10.0794 3.81224L11.4397 2.9547L12.0458 3.56079L11.1882 4.92117C11.5573 5.44798 11.8164 6.0575 11.9321 6.71638L13.5 7.07183V7.92897L11.932 8.28444C11.8162 8.94342 11.557 9.55301 11.1878 10.0798L12.0453 11.4402L11.4392 12.0462L10.0787 11.1886C9.55192 11.5576 8.94241 11.8166 8.28355 11.9323L7.92809 13.5002H7.07095L6.71543 11.932C6.0569 11.8162 5.44772 11.5572 4.92116 11.1883L3.56055 12.046L2.95445 11.4399L3.81213 10.0794C3.4431 9.55266 3.18403 8.94326 3.06825 8.2845L1.50002 7.92897V7.07183L3.06818 6.71632C3.18388 6.05765 3.44283 5.44833 3.81171 4.92165L2.95398 3.561L3.56008 2.95491L4.92053 3.81251ZM9.02496 7.50008C9.02496 8.34226 8.34223 9.02499 7.50005 9.02499C6.65786 9.02499 5.97513 8.34226 5.97513 7.50008C5.97513 6.65789 6.65786 5.97516 7.50005 5.97516C8.34223 5.97516 9.02496 6.65789 9.02496 7.50008ZM9.92496 7.50008C9.92496 8.83932 8.83929 9.92499 7.50005 9.92499C6.1608 9.92499 5.07513 8.83932 5.07513 7.50008C5.07513 6.16084 6.1608 5.07516 7.50005 5.07516C8.83929 5.07516 9.92496 6.16084 9.92496 7.50008Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2m = [
    "color"
];
var $45e7c250d3003265$export$9a0862960670d05c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2m);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2n = [
    "color"
];
var $45e7c250d3003265$export$a70e2e549144f66 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2n);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49996 1.80002C4.35194 1.80002 1.79996 4.352 1.79996 7.50002C1.79996 10.648 4.35194 13.2 7.49996 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.352 10.648 1.80002 7.49996 1.80002ZM0.899963 7.50002C0.899963 3.85494 3.85488 0.900024 7.49996 0.900024C11.145 0.900024 14.1 3.85494 14.1 7.50002C14.1 11.1451 11.145 14.1 7.49996 14.1C3.85488 14.1 0.899963 11.1451 0.899963 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.4999 7.89998H1.49994V7.09998H13.4999V7.89998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.09991 13.5V1.5H7.89991V13.5H7.09991zM10.375 7.49998C10.375 5.32724 9.59364 3.17778 8.06183 1.75656L8.53793 1.24341C10.2396 2.82218 11.075 5.17273 11.075 7.49998 11.075 9.82724 10.2396 12.1778 8.53793 13.7566L8.06183 13.2434C9.59364 11.8222 10.375 9.67273 10.375 7.49998zM3.99969 7.5C3.99969 5.17611 4.80786 2.82678 6.45768 1.24719L6.94177 1.75281C5.4582 3.17323 4.69969 5.32389 4.69969 7.5 4.6997 9.67611 5.45822 11.8268 6.94179 13.2472L6.45769 13.7528C4.80788 12.1732 3.9997 9.8239 3.99969 7.5z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49996 3.95801C9.66928 3.95801 11.8753 4.35915 13.3706 5.19448 13.5394 5.28875 13.5998 5.50197 13.5055 5.67073 13.4113 5.83948 13.198 5.89987 13.0293 5.8056 11.6794 5.05155 9.60799 4.65801 7.49996 4.65801 5.39192 4.65801 3.32052 5.05155 1.97064 5.8056 1.80188 5.89987 1.58866 5.83948 1.49439 5.67073 1.40013 5.50197 1.46051 5.28875 1.62927 5.19448 3.12466 4.35915 5.33063 3.95801 7.49996 3.95801zM7.49996 10.85C9.66928 10.85 11.8753 10.4488 13.3706 9.6135 13.5394 9.51924 13.5998 9.30601 13.5055 9.13726 13.4113 8.9685 13.198 8.90812 13.0293 9.00238 11.6794 9.75643 9.60799 10.15 7.49996 10.15 5.39192 10.15 3.32052 9.75643 1.97064 9.00239 1.80188 8.90812 1.58866 8.9685 1.49439 9.13726 1.40013 9.30601 1.46051 9.51924 1.62927 9.6135 3.12466 10.4488 5.33063 10.85 7.49996 10.85z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2o = [
    "color"
];
var $45e7c250d3003265$export$fa17e9a974485717 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2o);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.5 2H8V7H13V2.5C13 2.22386 12.7761 2 12.5 2ZM13 8H8V13H12.5C12.7761 13 13 12.7761 13 12.5V8ZM7 7V2H2.5C2.22386 2 2 2.22386 2 2.5V7H7ZM2 8V12.5C2 12.7761 2.22386 13 2.5 13H7V8H2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2p = [
    "color"
];
var $45e7c250d3003265$export$97eeb400c5f33310 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2p);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.44995 0.949951C1.31734 0.949951 1.19016 1.00263 1.0964 1.0964C1.00263 1.19017 0.949951 1.31735 0.949951 1.44995L0.949966 3.44995C0.949969 3.7261 1.17383 3.94995 1.44997 3.94995C1.72611 3.94995 1.94997 3.72609 1.94997 3.44995L1.94995 1.94995H3.44997C3.72611 1.94995 3.94997 1.72609 3.94997 1.44995C3.94997 1.17381 3.72611 0.949951 3.44997 0.949951H1.44995ZM5.94995 0.949951C5.67381 0.949951 5.44995 1.17381 5.44995 1.44995C5.44995 1.72609 5.67381 1.94995 5.94995 1.94995H8.94995C9.22609 1.94995 9.44995 1.72609 9.44995 1.44995C9.44995 1.17381 9.22609 0.949951 8.94995 0.949951H5.94995ZM5.44995 13.45C5.44995 13.1738 5.67381 12.95 5.94995 12.95H8.94995C9.22609 12.95 9.44995 13.1738 9.44995 13.45C9.44995 13.7261 9.22609 13.95 8.94995 13.95H5.94995C5.67381 13.95 5.44995 13.7261 5.44995 13.45ZM1.94995 5.94995C1.94995 5.67381 1.72609 5.44995 1.44995 5.44995C1.17381 5.44995 0.949951 5.67381 0.949951 5.94995V8.94995C0.949951 9.22609 1.17381 9.44995 1.44995 9.44995C1.72609 9.44995 1.94995 9.22609 1.94995 8.94995V5.94995ZM13.45 5.44995C13.7261 5.44995 13.95 5.67381 13.95 5.94995V8.94995C13.95 9.22609 13.7261 9.44995 13.45 9.44995C13.1738 9.44995 12.95 9.22609 12.95 8.94995V5.94995C12.95 5.67381 13.1738 5.44995 13.45 5.44995ZM11.45 0.949951C11.1738 0.949951 10.95 1.17381 10.95 1.44995C10.95 1.72609 11.1738 1.94995 11.45 1.94995H12.9499V3.44995C12.9499 3.72609 13.1738 3.94995 13.4499 3.94995C13.7261 3.94995 13.9499 3.72609 13.9499 3.44995V1.44995C13.9499 1.17381 13.7252 0.949951 13.449 0.949951H11.45ZM1.44995 10.95C1.72609 10.95 1.94995 11.1738 1.94995 11.45V12.95H3.44997C3.72611 12.95 3.94997 13.1738 3.94997 13.45C3.94997 13.7261 3.72611 13.95 3.44997 13.95H1.44995C1.17381 13.95 0.949951 13.7261 0.949951 13.45V11.45C0.949951 11.1738 1.17381 10.95 1.44995 10.95ZM13.95 11.45C13.95 11.1738 13.7261 10.95 13.45 10.95C13.1738 10.9499 12.95 11.1738 12.95 11.4499L12.9491 12.95H11.45C11.1738 12.95 10.95 13.1738 10.95 13.45C10.95 13.7261 11.1738 13.95 11.45 13.95H13.4499C13.7261 13.95 13.9499 13.7261 13.9499 13.45L13.95 11.45Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2q = [
    "color"
];
var $45e7c250d3003265$export$1106febb4d651860 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.00003 1.84861C4.10114 2.1017 1.82707 4.53515 1.82707 7.49972C1.82707 10.4643 4.10114 12.8977 7.00003 13.1508V1.84861ZM8.00003 13.1508C10.8988 12.8976 13.1727 10.4642 13.1727 7.49972C13.1727 4.53524 10.8988 2.10185 8.00003 1.84864V13.1508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2r = [
    "color"
];
var $45e7c250d3003265$export$991e44cd0549467c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2r);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.49988 1.82689C4.36688 1.8269 1.82707 4.36672 1.82707 7.49972C1.82707 10.6327 4.36688 13.1725 7.49988 13.1726V1.82689Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2s = [
    "color"
];
var $45e7c250d3003265$export$ea8e5ed9f4a6e89d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2s);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2t = [
    "color"
];
var $45e7c250d3003265$export$f9eb84fdaa009a42 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2t);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.8113 1.64706C6.62188 2.87918 6.68268 3.88523 6.76848 5.30499C6.78415 5.56426 6.80065 5.83732 6.81661 6.12808C6.83111 6.39208 6.63758 6.62172 6.37495 6.65217C6.11232 6.68262 5.87138 6.50334 5.82509 6.24304L5.74754 5.80698C5.64402 5.16529 5.48355 4.25481 5.17807 3.44741C4.86241 2.61312 4.4486 2.04121 3.93436 1.86044C3.64994 1.76104 3.41901 1.84279 3.25868 2.01052C3.08746 2.18962 2.9976 2.47065 3.0627 2.75399C3.2146 3.34424 3.44627 3.9167 3.69836 4.51802C3.72082 4.57158 3.74346 4.62543 3.76621 4.67954C3.9954 5.22457 4.23619 5.7972 4.41644 6.39081L4.41691 6.39238C4.562 6.87586 4.65646 7.2595 4.73086 7.56165C4.76034 7.68138 4.78667 7.78831 4.81175 7.88359C4.86768 8.09606 4.77836 8.32014 4.59161 8.43588C4.40486 8.55161 4.16445 8.53188 3.99907 8.38725C3.73749 8.15848 3.515 7.92784 3.31817 7.71802C3.27627 7.67335 3.23602 7.63018 3.19705 7.58838C3.04777 7.42826 2.91712 7.28812 2.78334 7.16029C2.45989 6.85122 2.18398 6.68004 1.80585 6.64369L1.80324 6.64343C1.56117 6.61888 1.41402 6.66441 1.31756 6.72627C1.21899 6.78947 1.11988 6.90414 1.03784 7.1123C0.976576 7.28492 1.01515 7.62987 1.1929 7.96911L1.19728 7.97747C1.40086 8.38452 1.74475 8.81587 2.18141 9.29299C2.39739 9.52898 2.62872 9.76849 2.86934 10.0174L2.87966 10.0281C3.11546 10.2721 3.35962 10.5247 3.59713 10.7827C4.4288 11.6863 5.27706 12.7538 5.4627 14H11.5087C11.5636 12.4353 11.8756 11.268 12.2875 10.1346C12.4454 9.70041 12.6121 9.28412 12.7826 8.85829C13.1097 8.04139 13.4509 7.18937 13.7705 6.10824C14.0989 4.99737 14.0097 4.37033 13.8613 4.03984C13.717 3.71858 13.4914 3.61786 13.3816 3.59606C13.1381 3.54774 13.0384 3.60947 12.9698 3.67901C12.867 3.78316 12.7698 3.98273 12.6921 4.30269C12.6166 4.61345 12.5752 4.96517 12.533 5.32501L12.5298 5.35285C12.4924 5.67242 12.4505 6.03016 12.3665 6.30098C12.3383 6.40699 12.2819 6.50407 12.1979 6.57539C12.1382 6.6261 12.0104 6.70818 11.8309 6.69312C11.5424 6.66891 11.3712 6.42143 11.365 6.14783C11.356 5.75454 11.3883 5.35864 11.4074 4.96608C11.4428 4.23646 11.477 3.5337 11.4245 2.8342L11.4242 2.82934C11.3916 2.32997 11.0493 2.00228 10.7007 1.9228C10.5305 1.88401 10.369 1.90601 10.2347 1.9835C10.103 2.05946 9.95535 2.21318 9.8574 2.51394L9.85631 2.51726C9.81525 2.6404 9.77298 2.87753 9.73606 3.2124C9.70044 3.53542 9.67337 3.91279 9.65156 4.29418C9.6329 4.62033 9.61785 4.9584 9.60434 5.26194C9.58728 5.64529 9.57267 5.97357 9.55633 6.1532C9.54983 6.22459 9.52939 6.29493 9.49501 6.35785C9.47356 6.39711 9.36115 6.60947 9.07106 6.61843C8.77917 6.62744 8.63975 6.40057 8.61698 6.35919C8.55634 6.24899 8.55066 6.11807 8.54754 5.99283C8.54474 5.88064 8.54294 5.71798 8.54174 5.54767C8.53935 5.20582 8.53935 4.81919 8.53935 4.70952C8.53935 3.6657 8.53838 2.65372 8.44714 1.64372C8.39183 1.24127 8.06278 1.00455 7.6436 1.00005C7.22399 0.995552 6.87918 1.22704 6.8113 1.64706ZM9.41219 1.3617C9.21469 0.448484 8.39913 0.00810324 7.65433 0.00011154C6.86452 -0.00836308 5.98761 0.465881 5.82365 1.49037L5.82318 1.49334C5.78239 1.7584 5.75229 2.01481 5.7309 2.26652C5.39423 1.67364 4.92622 1.14894 4.2655 0.916859C3.58661 0.679312 2.9492 0.887087 2.53582 1.31952C2.13415 1.73971 1.94438 2.36742 2.09031 2.98746L2.09269 2.99713C2.26478 3.66808 2.52396 4.30316 2.77613 4.90465C2.79814 4.95717 2.8201 5.00941 2.84194 5.06139C3.02139 5.48842 3.19378 5.89866 3.33871 6.31256C2.96404 5.98142 2.51925 5.70796 1.90276 5.6484C1.48865 5.60663 1.10391 5.67536 0.777805 5.88444C0.454239 6.0919 0.240671 6.40405 0.104187 6.75406L0.100868 6.76281C-0.10184 7.31286 0.0663312 7.97157 0.304895 8.42897C0.573704 8.96474 0.996104 9.47904 1.44372 9.96813C1.67046 10.2159 1.91136 10.4652 2.15033 10.7124L2.15682 10.7191C2.39524 10.9658 2.63217 11.2109 2.86134 11.4599C3.80937 12.49 4.50002 13.4632 4.50002 14.5C4.50002 14.7761 4.72388 15 5.00002 15H12C12.2762 15 12.5 14.7761 12.5 14.5C12.5 12.8212 12.8021 11.6462 13.2274 10.4762C13.3653 10.0968 13.5216 9.70579 13.6868 9.29247C14.0238 8.44922 14.398 7.51298 14.7295 6.39175C15.0956 5.15324 15.0559 4.25904 14.7735 3.63017C14.487 2.99208 13.9798 2.6953 13.5763 2.6152C13.1276 2.52614 12.7367 2.60475 12.4268 2.83081C12.4253 2.80773 12.4236 2.78468 12.4219 2.76167C12.3587 1.8105 11.6907 1.12285 10.923 0.947821C10.5346 0.859287 10.1111 0.900393 9.73509 1.11724C9.61852 1.18446 9.51055 1.26623 9.41219 1.3617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2u = [
    "color"
];
var $45e7c250d3003265$export$635e9dadffe43ee = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2u);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2v = [
    "color"
];
var $45e7c250d3003265$export$16f03ed71cfb60c9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2v);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.89346 2.35248C3.49195 2.35248 2.35248 3.49359 2.35248 4.90532C2.35248 6.38164 3.20954 7.9168 4.37255 9.33522C5.39396 10.581 6.59464 11.6702 7.50002 12.4778C8.4054 11.6702 9.60608 10.581 10.6275 9.33522C11.7905 7.9168 12.6476 6.38164 12.6476 4.90532C12.6476 3.49359 11.5081 2.35248 10.1066 2.35248C9.27059 2.35248 8.81894 2.64323 8.5397 2.95843C8.27877 3.25295 8.14623 3.58566 8.02501 3.88993C8.00391 3.9429 7.98315 3.99501 7.96211 4.04591C7.88482 4.23294 7.7024 4.35494 7.50002 4.35494C7.29765 4.35494 7.11523 4.23295 7.03793 4.04592C7.01689 3.99501 6.99612 3.94289 6.97502 3.8899C6.8538 3.58564 6.72126 3.25294 6.46034 2.95843C6.18109 2.64323 5.72945 2.35248 4.89346 2.35248ZM1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.0084 1.35248 6.73504 1.76049 7.20884 2.2953C7.32062 2.42147 7.41686 2.55382 7.50002 2.68545C7.58318 2.55382 7.67941 2.42147 7.79119 2.2953C8.265 1.76049 8.99164 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2w = [
    "color"
];
var $45e7c250d3003265$export$b4120a3a3b5e8fcd = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2w);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.25769 1.35248 6.86058 1.92336 7.50002 2.93545C8.13946 1.92336 8.74235 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2x = [
    "color"
];
var $45e7c250d3003265$export$141e350c1bf9e61a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2x);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.1813 1.68179C7.35704 1.50605 7.64196 1.50605 7.8177 1.68179L10.3177 4.18179C10.4934 4.35753 10.4934 4.64245 10.3177 4.81819C10.142 4.99392 9.85704 4.99392 9.6813 4.81819L7.9495 3.08638L7.9495 11.9136L9.6813 10.1818C9.85704 10.0061 10.142 10.0061 10.3177 10.1818C10.4934 10.3575 10.4934 10.6424 10.3177 10.8182L7.8177 13.3182C7.73331 13.4026 7.61885 13.45 7.4995 13.45C7.38015 13.45 7.26569 13.4026 7.1813 13.3182L4.6813 10.8182C4.50557 10.6424 4.50557 10.3575 4.6813 10.1818C4.85704 10.0061 5.14196 10.0061 5.3177 10.1818L7.0495 11.9136L7.0495 3.08638L5.3177 4.81819C5.14196 4.99392 4.85704 4.99392 4.6813 4.81819C4.50557 4.64245 4.50557 4.35753 4.6813 4.18179L7.1813 1.68179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2y = [
    "color"
];
var $45e7c250d3003265$export$9360f6250c6c6a8c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.3536 13.3536C12.1583 13.5488 11.8417 13.5488 11.6465 13.3536L6.39645 8.10355C6.36478 8.07188 6.33824 8.03702 6.31685 8H5.00002C4.78719 8 4.59769 7.86528 4.52777 7.66426L2.12777 0.764277C2.05268 0.548387 2.13355 0.309061 2.3242 0.182972C2.51486 0.0568819 2.76674 0.0761337 2.93602 0.229734L8.336 5.12972C8.44044 5.22449 8.50001 5.35897 8.50001 5.5V5.81684C8.53702 5.83824 8.57189 5.86478 8.60356 5.89645L13.8536 11.1464C14.0488 11.3417 14.0488 11.6583 13.8536 11.8536L12.3536 13.3536ZM8.25 6.95711L7.45711 7.75L12 12.2929L12.7929 11.5L8.25 6.95711ZM3.71669 2.28845L5.35549 7H6.2929L7.50001 5.79289V5.72146L3.71669 2.28845Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2z = [
    "color"
];
var $45e7c250d3003265$export$92c8767b874048d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.07926 0.222253C7.31275 -0.007434 7.6873 -0.007434 7.92079 0.222253L14.6708 6.86227C14.907 7.09465 14.9101 7.47453 14.6778 7.71076C14.4454 7.947 14.0655 7.95012 13.8293 7.71773L13 6.90201V12.5C13 12.7761 12.7762 13 12.5 13H2.50002C2.22388 13 2.00002 12.7761 2.00002 12.5V6.90201L1.17079 7.71773C0.934558 7.95012 0.554672 7.947 0.32229 7.71076C0.0899079 7.47453 0.0930283 7.09465 0.32926 6.86227L7.07926 0.222253ZM7.50002 1.49163L12 5.91831V12H10V8.49999C10 8.22385 9.77617 7.99999 9.50002 7.99999H6.50002C6.22388 7.99999 6.00002 8.22385 6.00002 8.49999V12H3.00002V5.91831L7.50002 1.49163ZM7.00002 12H9.00002V8.99999H7.00002V12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2A = [
    "color"
];
var $45e7c250d3003265$export$13a4588734565757 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2A);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 0.0032959C6.80473 0.0032959 6.24953 0.281106 6.25 0.749995C6.25 0.997258 6.42446 1.12014 6.57687 1.22749C6.69507 1.31074 6.8 1.38465 6.8 1.5C6.8 1.7071 6.06224 1.74264 5.19789 1.78427C3.97553 1.84314 2.5 1.91421 2.5 2.5C2.5 2.77614 2.72386 3 3 3H12C12.2761 3 12.5 2.77614 12.5 2.5C12.5 1.91421 11.0245 1.84314 9.80211 1.78427C8.93776 1.74264 8.2 1.7071 8.2 1.5C8.2 1.38465 8.30493 1.31074 8.42313 1.22749C8.57554 1.12014 8.75 0.997258 8.75 0.749995C8.75047 0.281106 8.19527 0.0032959 7.5 0.0032959ZM2.89451 6.12266C2.25806 6.52471 1.90417 7.31118 2.02473 8.0556L2.83588 12.4772C3.00993 13.3562 3.7629 14 4.66061 14H10.3373C11.2354 14 11.9884 13.3562 12.1625 12.4772L12.9736 8.05607C13.089 7.32358 12.8284 6.53276 12.1331 6.09373C11.7283 5.83013 11.6412 5.33231 12.1331 5.12796C12.8284 4.86435 12.6948 4 12 4H10.3001H6.80005H2.99996C2.30469 4 2.19878 4.89328 2.89451 5.15689C3.38642 5.33231 3.29939 5.83013 2.89451 6.12266ZM8.20006 6.25C8.20006 5.81769 8.08572 5.37615 7.90635 5L4.11093 5C4.20626 5.21312 4.2419 5.43889 4.22904 5.65521C4.19522 6.22412 3.84587 6.66899 3.48016 6.93322L3.45492 6.95146L3.42858 6.9681C3.13407 7.15414 2.95801 7.53989 3.01058 7.88749L3.81797 12.2886C3.90513 12.7154 4.26148 13 4.66061 13H10.3373C10.737 13 11.0932 12.7153 11.1804 12.2886L11.9874 7.8898C12.048 7.48247 11.8954 7.12631 11.5992 6.93927L11.5875 6.93184L11.5875 6.93176C11.1947 6.67602 10.8331 6.22785 10.7986 5.64798C10.7846 5.412 10.8264 5.19397 10.9112 5H9.05517C9.01987 5.14611 9.00006 5.31201 9.00006 5.5C9.00006 5.9745 9.21679 6.37127 9.44367 6.78662C9.69284 7.24278 9.95425 7.72136 9.95425 8.34993C9.95425 9.2698 9.49868 9.84205 8.62189 9.84205C8.13206 9.84205 7.57818 9.46097 7.57818 8.75781C7.57818 8.35279 7.71558 8.01646 7.86121 7.65998C8.0254 7.25806 8.20006 6.83051 8.20006 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2B = [
    "color"
];
var $45e7c250d3003265$export$583b57cdbe59a84e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2B);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2C = [
    "color"
];
var $45e7c250d3003265$export$4a122bafaa48b23d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2C);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2D = [
    "color"
];
var $45e7c250d3003265$export$7a1b52edf33ca2d9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2D);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2E = [
    "color"
];
var $45e7c250d3003265$export$f8fea9f50a4bfae6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2E);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2F = [
    "color"
];
var $45e7c250d3003265$export$632f10cfe13035ff = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2F);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$2G = [
    "color"
];
var $45e7c250d3003265$export$97dac707ecee26f6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2G);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 4H1.5C1.22386 4 1 4.22386 1 4.5V10.5C1 10.7761 1.22386 11 1.5 11H13.5C13.7761 11 14 10.7761 14 10.5V4.5C14 4.22386 13.7761 4 13.5 4ZM1.5 3C0.671573 3 0 3.67157 0 4.5V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V4.5C15 3.67157 14.3284 3 13.5 3H1.5ZM2 5H3V6H2V5ZM5 5H4V6H5V5ZM6 5H7V6H6V5ZM9 5H8V6H9V5ZM10 5H11V6H10V5ZM13 5H12V6H13V5ZM11 7H12V8H11V7ZM13 9H12V10H13V9ZM9 7H10V8H9V7ZM8 7H7V8H8V7ZM5 7H6V8H5V7ZM4 7H3V8H4V7ZM2 9H3V10H2V9ZM11 9H4V10H11V9Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$2H = [
    "color"
];
var $45e7c250d3003265$export$73ea89eab1c37fa2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2H);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2I = [
    "color"
];
var $45e7c250d3003265$export$b94473071ddf9fbf = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2I);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 4.25C2 4.11193 2.11193 4 2.25 4H12.75C12.8881 4 13 4.11193 13 4.25V11.5H2V4.25ZM2.25 3C1.55964 3 1 3.55964 1 4.25V12H0V12.5C0 12.7761 0.223858 13 0.5 13H14.5C14.7761 13 15 12.7761 15 12.5V12H14V4.25C14 3.55964 13.4404 3 12.75 3H2.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2J = [
    "color"
];
var $45e7c250d3003265$export$a00948e6c38bedc8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2J);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2K = [
    "color"
];
var $45e7c250d3003265$export$b5c6e0b0c099878a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2K);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9 2H6V13H9V2ZM10 2V13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2H10ZM2.5 2H5V13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2L = [
    "color"
];
var $45e7c250d3003265$export$2d8928fe752eaf76 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2L);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2M = [
    "color"
];
var $45e7c250d3003265$export$ba5807ad0c0f9980 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2M);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2N = [
    "color"
];
var $45e7c250d3003265$export$7e8527e8d8b03e5e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2N);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.2895 2.75C11.4964 2.74979 11.6821 2.87701 11.7565 3.07003L14.9664 11.39C15.0657 11.6477 14.9375 11.9371 14.6798 12.0365C14.4222 12.1359 14.1328 12.0076 14.0334 11.75L12.9822 9.02537H9.61106L8.56672 11.749C8.46786 12.0068 8.1787 12.1357 7.92086 12.0369C7.66302 11.938 7.53415 11.6488 7.63301 11.391L10.8232 3.07099C10.8972 2.87782 11.0826 2.75021 11.2895 2.75ZM11.2915 4.64284L12.6543 8.17537H9.93698L11.2915 4.64284ZM2.89895 5.20703C1.25818 5.20703 0.00915527 6.68569 0.00915527 8.60972C0.00915527 10.6337 1.35818 12.0124 2.89895 12.0124C3.72141 12.0124 4.57438 11.6692 5.15427 11.0219V11.53C5.15427 11.7785 5.35574 11.98 5.60427 11.98C5.8528 11.98 6.05427 11.7785 6.05427 11.53V5.72C6.05427 5.47147 5.8528 5.27 5.60427 5.27C5.35574 5.27 5.15427 5.47147 5.15427 5.72V6.22317C4.60543 5.60095 3.79236 5.20703 2.89895 5.20703ZM5.15427 9.79823V7.30195C4.76393 6.58101 3.94144 6.05757 3.08675 6.05757C2.10885 6.05757 1.03503 6.96581 1.03503 8.60955C1.03503 10.1533 2.00885 11.1615 3.08675 11.1615C3.97011 11.1615 4.77195 10.4952 5.15427 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2O = [
    "color"
];
var $45e7c250d3003265$export$9395c236dc77b2d2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2O);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2P = [
    "color"
];
var $45e7c250d3003265$export$b5d24f94d82d9f2b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2P);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.55293 0.999969C4.75295 0.999969 4.93372 1.11917 5.0125 1.30301L8.01106 8.29982C8.11984 8.55363 8.00226 8.84757 7.74844 8.95635C7.49463 9.06512 7.20069 8.94754 7.09191 8.69373L6.11613 6.41685H2.98973L2.01395 8.69373C1.90517 8.94754 1.61123 9.06512 1.35742 8.95635C1.1036 8.84757 0.986023 8.55363 1.0948 8.29982L4.09336 1.30301C4.17214 1.11917 4.35291 0.999969 4.55293 0.999969ZM4.55293 2.76929L5.75186 5.56685H3.354L4.55293 2.76929ZM11.0562 9.00214C11.2617 9.00214 11.4463 8.87633 11.5215 8.68502L14.2733 1.68299C14.3743 1.42598 14.2478 1.13575 13.9908 1.03475C13.7338 0.933747 13.4436 1.06021 13.3426 1.31722L11.0562 7.13514L8.76973 1.31722C8.66873 1.06021 8.3785 0.933747 8.1215 1.03475C7.86449 1.13575 7.73802 1.42598 7.83902 1.68299L10.5908 8.68502C10.666 8.87633 10.8506 9.00214 11.0562 9.00214ZM14.9537 12.4999C14.9537 12.606 14.9115 12.7077 14.8365 12.7828L12.8365 14.7828C12.6803 14.939 12.4271 14.939 12.2708 14.7828C12.1146 14.6265 12.1146 14.3733 12.2708 14.2171L13.588 12.8999H1.51937L2.83653 14.2171C2.99274 14.3733 2.99274 14.6265 2.83653 14.7828C2.68032 14.939 2.42705 14.939 2.27084 14.7828L0.270843 12.7828C0.195828 12.7077 0.153687 12.606 0.153687 12.4999C0.153687 12.3938 0.195828 12.2921 0.270843 12.2171L2.27084 10.2171C2.42705 10.0609 2.68032 10.0609 2.83653 10.2171C2.99274 10.3733 2.99274 10.6265 2.83653 10.7828L1.51937 12.0999L13.588 12.0999L12.2708 10.7828C12.1146 10.6265 12.1146 10.3733 12.2708 10.2171C12.4271 10.0609 12.6803 10.0609 12.8365 10.2171L14.8365 12.2171C14.9115 12.2921 14.9537 12.3938 14.9537 12.4999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2Q = [
    "color"
];
var $45e7c250d3003265$export$afee984ac0331725 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2Q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2R = [
    "color"
];
var $45e7c250d3003265$export$9b61d117ad943959 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2R);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.78233 2.21713C3.70732 2.14212 3.60557 2.09998 3.49949 2.09998C3.3934 2.09998 3.29166 2.14212 3.21664 2.21713L1.21664 4.21713C1.06044 4.37334 1.06044 4.62661 1.21664 4.78282C1.37285 4.93903 1.62612 4.93903 1.78233 4.78282L3.09949 3.46566L3.09949 11.5343L1.78233 10.2171C1.62612 10.0609 1.37285 10.0609 1.21664 10.2171C1.06043 10.3733 1.06043 10.6266 1.21664 10.7828L3.21664 12.7828C3.29166 12.8578 3.3934 12.9 3.49949 12.9C3.60557 12.9 3.70731 12.8578 3.78233 12.7828L5.78233 10.7828C5.93854 10.6266 5.93854 10.3733 5.78233 10.2171C5.62612 10.0609 5.37285 10.0609 5.21664 10.2171L3.89949 11.5343L3.89949 3.46566L5.21664 4.78282C5.37285 4.93903 5.62612 4.93903 5.78233 4.78282C5.93854 4.62661 5.93854 4.37334 5.78233 4.21713L3.78233 2.21713ZM8.49998 3.99997C8.22383 3.99997 7.99998 4.22382 7.99998 4.49997C7.99998 4.77611 8.22383 4.99997 8.49998 4.99997H14.5C14.7761 4.99997 15 4.77611 15 4.49997C15 4.22382 14.7761 3.99997 14.5 3.99997H8.49998ZM7.99998 7.49997C7.99998 7.22382 8.22383 6.99997 8.49998 6.99997H14.5C14.7761 6.99997 15 7.22382 15 7.49997C15 7.77611 14.7761 7.99997 14.5 7.99997H8.49998C8.22383 7.99997 7.99998 7.77611 7.99998 7.49997ZM8.49998 9.99997C8.22383 9.99997 7.99998 10.2238 7.99998 10.5C7.99998 10.7761 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2238 14.7761 9.99997 14.5 9.99997H8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2S = [
    "color"
];
var $45e7c250d3003265$export$c99cd348175308cb = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2S);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.62471 4.00001L4.56402 4.00001C4.04134 3.99993 3.70687 3.99988 3.4182 4.055C2.2379 4.28039 1.29846 5.17053 1.05815 6.33035C0.999538 6.61321 0.999604 6.93998 0.999703 7.43689L0.999711 7.50001L0.999703 7.56313C0.999604 8.06004 0.999538 8.38681 1.05815 8.66967C1.29846 9.8295 2.2379 10.7196 3.4182 10.945C3.70688 11.0001 4.04135 11.0001 4.56403 11L4.62471 11H5.49971C5.77585 11 5.99971 10.7762 5.99971 10.5C5.99971 10.2239 5.77585 10 5.49971 10H4.62471C4.02084 10 3.78907 9.99777 3.60577 9.96277C2.80262 9.8094 2.19157 9.21108 2.03735 8.46678C2.00233 8.29778 1.99971 8.08251 1.99971 7.50001C1.99971 6.91752 2.00233 6.70225 2.03735 6.53324C2.19157 5.78895 2.80262 5.19062 3.60577 5.03725C3.78907 5.00225 4.02084 5.00001 4.62471 5.00001H5.49971C5.77585 5.00001 5.99971 4.77615 5.99971 4.50001C5.99971 4.22387 5.77585 4.00001 5.49971 4.00001H4.62471ZM10.3747 5.00001C10.9786 5.00001 11.2104 5.00225 11.3937 5.03725C12.1968 5.19062 12.8079 5.78895 12.9621 6.53324C12.9971 6.70225 12.9997 6.91752 12.9997 7.50001C12.9997 8.08251 12.9971 8.29778 12.9621 8.46678C12.8079 9.21108 12.1968 9.8094 11.3937 9.96277C11.2104 9.99777 10.9786 10 10.3747 10H9.49971C9.22357 10 8.99971 10.2239 8.99971 10.5C8.99971 10.7762 9.22357 11 9.49971 11H10.3747L10.4354 11C10.9581 11.0001 11.2925 11.0001 11.5812 10.945C12.7615 10.7196 13.701 9.8295 13.9413 8.66967C13.9999 8.38681 13.9998 8.06005 13.9997 7.56314L13.9997 7.50001L13.9997 7.43688C13.9998 6.93998 13.9999 6.61321 13.9413 6.33035C13.701 5.17053 12.7615 4.28039 11.5812 4.055C11.2925 3.99988 10.9581 3.99993 10.4354 4.00001L10.3747 4.00001H9.49971C9.22357 4.00001 8.99971 4.22387 8.99971 4.50001C8.99971 4.77615 9.22357 5.00001 9.49971 5.00001H10.3747ZM5.00038 7C4.72424 7 4.50038 7.22386 4.50038 7.5C4.50038 7.77614 4.72424 8 5.00038 8H10.0004C10.2765 8 10.5004 7.77614 10.5004 7.5C10.5004 7.22386 10.2765 7 10.0004 7H5.00038Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2T = [
    "color"
];
var $45e7c250d3003265$export$a0f93c0a3250ca9d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2T);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2U = [
    "color"
];
var $45e7c250d3003265$export$c2a4804b810abd59 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2U);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L13.3536 2.35355ZM2.03735 8.46678C2.17398 9.12619 2.66918 9.67103 3.33886 9.89338L2.57833 10.6539C1.80843 10.2534 1.23784 9.53693 1.05815 8.66967C0.999538 8.38681 0.999604 8.06004 0.999703 7.56313L0.999711 7.50001L0.999703 7.43689C0.999604 6.93998 0.999538 6.61321 1.05815 6.33035C1.29846 5.17053 2.2379 4.28039 3.4182 4.055C3.70687 3.99988 4.04134 3.99993 4.56402 4.00001L4.62471 4.00001H5.49971C5.77585 4.00001 5.99971 4.22387 5.99971 4.50001C5.99971 4.77615 5.77585 5.00001 5.49971 5.00001H4.62471C4.02084 5.00001 3.78907 5.00225 3.60577 5.03725C2.80262 5.19062 2.19157 5.78895 2.03735 6.53324C2.00233 6.70225 1.99971 6.91752 1.99971 7.50001C1.99971 8.08251 2.00233 8.29778 2.03735 8.46678ZM12.9621 6.53324C12.8255 5.87397 12.3304 5.32922 11.661 5.10679L12.4215 4.34631C13.1912 4.74686 13.7616 5.46323 13.9413 6.33035C13.9999 6.61321 13.9998 6.93998 13.9997 7.43688L13.9997 7.50001L13.9997 7.56314C13.9998 8.06005 13.9999 8.38681 13.9413 8.66967C13.701 9.8295 12.7615 10.7196 11.5812 10.945C11.2925 11.0001 10.9581 11.0001 10.4354 11L10.3747 11H9.49971C9.22357 11 8.99971 10.7762 8.99971 10.5C8.99971 10.2239 9.22357 10 9.49971 10H10.3747C10.9786 10 11.2104 9.99777 11.3937 9.96277C12.1968 9.8094 12.8079 9.21108 12.9621 8.46678C12.9971 8.29778 12.9997 8.08251 12.9997 7.50001C12.9997 6.91752 12.9971 6.70225 12.9621 6.53324Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2V = [
    "color"
];
var $45e7c250d3003265$export$c8d5b415f7d58ebc = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2V);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2W = [
    "color"
];
var $45e7c250d3003265$export$928cb2cfdd1b2e72 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2W);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.56427 3.99988C4.58422 3.99989 4.60445 3.99989 4.62496 3.99989H5.49996C5.7761 3.99989 5.99996 4.22375 5.99996 4.49989C5.99996 4.77603 5.7761 4.99989 5.49996 4.99989H4.62496C4.02108 4.99989 3.78932 5.00213 3.60601 5.03713C2.80287 5.1905 2.19181 5.78883 2.03759 6.53312C2.00257 6.70212 1.99996 6.91739 1.99996 7.49989C1.99996 8.08239 2.00257 8.29766 2.03759 8.46666C2.19181 9.21095 2.80287 9.80928 3.60601 9.96265C3.78932 9.99765 4.02108 9.99989 4.62496 9.99989H5.49996C5.7761 9.99989 5.99996 10.2237 5.99996 10.4999C5.99996 10.776 5.7761 10.9999 5.49996 10.9999H4.62496C4.60445 10.9999 4.58422 10.9999 4.56427 10.9999C4.04159 11 3.70712 11 3.41845 10.9449C2.23814 10.7195 1.29871 9.82937 1.05839 8.66955C0.999782 8.38669 0.999848 8.05992 0.999947 7.56301C0.999951 7.54227 0.999955 7.52123 0.999955 7.49989C0.999955 7.47855 0.999951 7.45751 0.999947 7.43677C0.999848 6.93986 0.999782 6.61309 1.05839 6.33023C1.29871 5.17041 2.23814 4.28027 3.41845 4.05488C3.70712 3.99976 4.04159 3.99981 4.56427 3.99988ZM11.3939 5.03713C11.2106 5.00213 10.9788 4.99989 10.375 4.99989H9.49996C9.22381 4.99989 8.99996 4.77603 8.99996 4.49989C8.99996 4.22375 9.22381 3.99989 9.49996 3.99989H10.375C10.3955 3.99989 10.4157 3.99989 10.4356 3.99988C10.9583 3.99981 11.2928 3.99976 11.5815 4.05488C12.7618 4.28027 13.7012 5.17041 13.9415 6.33023C14.0001 6.61309 14.0001 6.93985 14 7.43676C14 7.4575 14 7.47854 14 7.49989C14 7.52124 14 7.54228 14 7.56302C14.0001 8.05992 14.0001 8.38669 13.9415 8.66955C13.7012 9.82937 12.7618 10.7195 11.5815 10.9449C11.2928 11 10.9583 11 10.4356 10.9999C10.4157 10.9999 10.3955 10.9999 10.375 10.9999H9.49996C9.22381 10.9999 8.99996 10.776 8.99996 10.4999C8.99996 10.2237 9.22381 9.99989 9.49996 9.99989H10.375C10.9788 9.99989 11.2106 9.99765 11.3939 9.96265C12.197 9.80928 12.8081 9.21095 12.9623 8.46666C12.9973 8.29766 13 8.08239 13 7.49989C13 6.91739 12.9973 6.70212 12.9623 6.53312C12.8081 5.78883 12.197 5.1905 11.3939 5.03713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2X = [
    "color"
];
var $45e7c250d3003265$export$36a31df0698e942 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2X);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10.6788 2.95419C10.0435 2.53694 9.18829 2.54594 8.51194 3.00541C8.35757 3.11027 8.1921 3.27257 7.7651 3.69957L7.14638 4.31829C6.95112 4.51355 6.63454 4.51355 6.43928 4.31829C6.24401 4.12303 6.24401 3.80645 6.43928 3.61119L7.058 2.99247C7.0725 2.97797 7.08679 2.96366 7.1009 2.94955C7.47044 2.57991 7.70691 2.34336 7.95001 2.17822C8.94398 1.50299 10.2377 1.46813 11.2277 2.11832C11.4692 2.27689 11.7002 2.508 12.0515 2.85942C12.0662 2.8741 12.081 2.88898 12.0961 2.90408C12.1112 2.91917 12.1261 2.93405 12.1408 2.94871C12.4922 3.30001 12.7233 3.53102 12.8819 3.77248C13.5321 4.76252 13.4972 6.05623 12.822 7.0502C12.6568 7.2933 12.4203 7.52976 12.0507 7.89929C12.0366 7.9134 12.0222 7.92771 12.0077 7.94221L11.389 8.56093C11.1938 8.7562 10.8772 8.7562 10.6819 8.56093C10.4867 8.36567 10.4867 8.04909 10.6819 7.85383L11.3006 7.23511C11.7276 6.80811 11.8899 6.64264 11.9948 6.48827C12.4543 5.81192 12.4633 4.95675 12.046 4.32141C11.9513 4.17714 11.8009 4.02307 11.389 3.61119C10.9771 3.1993 10.8231 3.04893 10.6788 2.95419ZM4.31796 6.43961C4.51322 6.63487 4.51322 6.95146 4.31796 7.14672L3.69924 7.76544C3.27224 8.19244 3.10993 8.35791 3.00507 8.51227C2.54561 9.18863 2.53661 10.0438 2.95385 10.6791C3.0486 10.8234 3.19896 10.9775 3.61085 11.3894C4.02274 11.8012 4.17681 11.9516 4.32107 12.0464C4.95642 12.4636 5.81158 12.4546 6.48794 11.9951C6.6423 11.8903 6.80777 11.728 7.23477 11.301L7.85349 10.6823C8.04875 10.487 8.36533 10.487 8.5606 10.6823C8.75586 10.8775 8.75586 11.1941 8.5606 11.3894L7.94188 12.0081C7.92738 12.0226 7.91307 12.0369 7.89897 12.051C7.52943 12.4206 7.29296 12.6572 7.04986 12.8223C6.05589 13.4976 4.76219 13.5324 3.77214 12.8822C3.53068 12.7237 3.29967 12.4925 2.94837 12.1411C2.93371 12.1264 2.91883 12.1116 2.90374 12.0965C2.88865 12.0814 2.87377 12.0665 2.8591 12.0518C2.50766 11.7005 2.27656 11.4695 2.11799 11.2281C1.4678 10.238 1.50265 8.94432 2.17788 7.95035C2.34303 7.70724 2.57957 7.47077 2.94922 7.10124C2.96333 7.08713 2.97763 7.07283 2.99213 7.05833L3.61085 6.43961C3.80611 6.24435 4.12269 6.24435 4.31796 6.43961Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2Y = [
    "color"
];
var $45e7c250d3003265$export$8ec07838913349db = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2Y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 1C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V2C14 1.44772 13.5523 1 13 1H2ZM3.05 6H4.95V12H3.05V6ZM5.075 4.005C5.075 4.59871 4.59371 5.08 4 5.08C3.4063 5.08 2.925 4.59871 2.925 4.005C2.925 3.41129 3.4063 2.93 4 2.93C4.59371 2.93 5.075 3.41129 5.075 4.005ZM12 8.35713C12 6.55208 10.8334 5.85033 9.67449 5.85033C9.29502 5.83163 8.91721 5.91119 8.57874 6.08107C8.32172 6.21007 8.05265 6.50523 7.84516 7.01853H7.79179V6.00044H6V12.0047H7.90616V8.8112C7.8786 8.48413 7.98327 8.06142 8.19741 7.80987C8.41156 7.55832 8.71789 7.49825 8.95015 7.46774H9.02258C9.62874 7.46774 10.0786 7.84301 10.0786 8.78868V12.0047H11.9847L12 8.35713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2Z = [
    "color"
];
var $45e7c250d3003265$export$9b1a2d77017d0edb = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2Z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2_ = [
    "color"
];
var $45e7c250d3003265$export$f53936b98653a113 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2_);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$2$ = [
    "color"
];
var $45e7c250d3003265$export$5f7f9efc246369d3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$2$);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.4986 0C6.3257 0 5.36107 0.38943 4.73753 1.19361C4.23745 1.83856 4 2.68242 4 3.63325H5C5 2.84313 5.19691 2.23312 5.5278 1.80636C5.91615 1.30552 6.55152 1 7.4986 1C8.35683 1 8.96336 1.26502 9.35846 1.68623C9.75793 2.11211 10 2.76044 10 3.63601V6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44771 12.5523 6 12 6H11V3.63601C11 2.58135 10.7065 1.66167 10.0878 1.0021C9.46477 0.337871 8.57061 0 7.4986 0ZM3 7H12V13H3V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$30 = [
    "color"
];
var $45e7c250d3003265$export$fea8b3d7473481c5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$30);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$31 = [
    "color"
];
var $45e7c250d3003265$export$ab1b7565a980cdcc = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$31);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.35355 1.85355C3.54882 1.65829 3.54882 1.34171 3.35355 1.14645C3.15829 0.951184 2.84171 0.951184 2.64645 1.14645L0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355L2.64645 5.85355C2.84171 6.04882 3.15829 6.04882 3.35355 5.85355C3.54882 5.65829 3.54882 5.34171 3.35355 5.14645L2.20711 4H9.5C11.433 4 13 5.567 13 7.5C13 7.77614 13.2239 8 13.5 8C13.7761 8 14 7.77614 14 7.5C14 5.01472 11.9853 3 9.5 3H2.20711L3.35355 1.85355ZM2 7.5C2 7.22386 1.77614 7 1.5 7C1.22386 7 1 7.22386 1 7.5C1 9.98528 3.01472 12 5.5 12H12.7929L11.6464 13.1464C11.4512 13.3417 11.4512 13.6583 11.6464 13.8536C11.8417 14.0488 12.1583 14.0488 12.3536 13.8536L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464L12.3536 9.14645C12.1583 8.95118 11.8417 8.95118 11.6464 9.14645C11.4512 9.34171 11.4512 9.65829 11.6464 9.85355L12.7929 11H5.5C3.567 11 2 9.433 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$32 = [
    "color"
];
var $45e7c250d3003265$export$bd662a7321ab10c4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$32);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$33 = [
    "color"
];
var $45e7c250d3003265$export$f7658c347b037c3f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$33);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$34 = [
    "color"
];
var $45e7c250d3003265$export$fca30e52ebed3683 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$34);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$35 = [
    "color"
];
var $45e7c250d3003265$export$afa4b2f99a1f67c0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$35);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 2H14V13H1L1 2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V13C15 13.5523 14.5523 14 14 14H1C0.447715 14 0 13.5523 0 13V2ZM4.875 7.5C4.875 6.05025 6.05025 4.875 7.5 4.875C8.94975 4.875 10.125 6.05025 10.125 7.5C10.125 8.94975 8.94975 10.125 7.5 10.125C6.05025 10.125 4.875 8.94975 4.875 7.5ZM7.5 3.875C5.49797 3.875 3.875 5.49797 3.875 7.5C3.875 9.50203 5.49797 11.125 7.5 11.125C9.50203 11.125 11.125 9.50203 11.125 7.5C11.125 5.49797 9.50203 3.875 7.5 3.875Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$36 = [
    "color"
];
var $45e7c250d3003265$export$34d98fe14bf296c1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$36);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 1C0.447715 1 0 1.44772 0 2V13C0 13.5523 0.447715 14 1 14H14C14.5523 14 15 13.5523 15 13V2C15 1.44772 14.5523 1 14 1H1ZM7.5 10.625C9.22589 10.625 10.625 9.22589 10.625 7.5C10.625 5.77411 9.22589 4.375 7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5C4.375 9.22589 5.77411 10.625 7.5 10.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$37 = [
    "color"
];
var $45e7c250d3003265$export$cb808a3c41736d8e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$37);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$38 = [
    "color"
];
var $45e7c250d3003265$export$80cd35ac42af1413 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$38);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$39 = [
    "color"
];
var $45e7c250d3003265$export$7829447535316b17 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$39);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.14921 3.99996C2.14921 2.97778 2.97784 2.14915 4.00002 2.14915C5.02219 2.14915 5.85083 2.97778 5.85083 3.99996C5.85083 5.02213 5.02219 5.85077 4.00002 5.85077C2.97784 5.85077 2.14921 5.02213 2.14921 3.99996ZM4.00002 1.24915C2.48079 1.24915 1.24921 2.48073 1.24921 3.99996C1.24921 5.51919 2.48079 6.75077 4.00002 6.75077C5.51925 6.75077 6.75083 5.51919 6.75083 3.99996C6.75083 2.48073 5.51925 1.24915 4.00002 1.24915ZM5.82034 11.0001L2.49998 12.8369V9.16331L5.82034 11.0001ZM2.63883 8.21159C2.17228 7.9535 1.59998 8.29093 1.59998 8.82411V13.1761C1.59998 13.7093 2.17228 14.0467 2.63883 13.7886L6.57235 11.6126C7.05389 11.3462 7.05389 10.654 6.57235 10.3876L2.63883 8.21159ZM8.30001 9.00003C8.30001 8.61343 8.61341 8.30003 9.00001 8.30003H13C13.3866 8.30003 13.7 8.61343 13.7 9.00003V13C13.7 13.3866 13.3866 13.7 13 13.7H9.00001C8.61341 13.7 8.30001 13.3866 8.30001 13V9.00003ZM9.20001 9.20003V12.8H12.8V9.20003H9.20001ZM13.4432 2.19311C13.6189 2.01737 13.6189 1.73245 13.4432 1.55671C13.2675 1.38098 12.9826 1.38098 12.8068 1.55671L11 3.36353L9.19321 1.55674C9.01748 1.381 8.73255 1.381 8.55682 1.55674C8.38108 1.73247 8.38108 2.0174 8.55682 2.19313L10.3636 3.99992L8.55682 5.80671C8.38108 5.98245 8.38108 6.26737 8.55682 6.44311C8.73255 6.61885 9.01748 6.61885 9.19321 6.44311L11 4.63632L12.8068 6.44314C12.9826 6.61887 13.2675 6.61887 13.4432 6.44314C13.6189 6.2674 13.6189 5.98247 13.4432 5.80674L11.6364 3.99992L13.4432 2.19311Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3a = [
    "color"
];
var $45e7c250d3003265$export$5560e721cf131890 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3a);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3b = [
    "color"
];
var $45e7c250d3003265$export$8154ac77932ca099 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3b);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5L4 7C4 7.01671 4.00082 7.03323 4.00242 7.04952C2.86009 7.28022 2 8.28967 2 9.5C2 10.7103 2.86009 11.7198 4.00242 11.9505C4.00082 11.9668 4 11.9833 4 12V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V12C5 11.9833 4.99918 11.9668 4.99758 11.9505C6.1399 11.7198 7 10.7103 7 9.5C7 8.28967 6.1399 7.28022 4.99758 7.04952C4.99918 7.03323 5 7.01671 5 7L5 1.5ZM11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3C10 3.01671 10.0008 3.03323 10.0024 3.04952C8.8601 3.28022 8 4.28967 8 5.5C8 6.71033 8.8601 7.71978 10.0024 7.95048C10.0008 7.96677 10 7.98329 10 8V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V8C11 7.98329 10.9992 7.96677 10.9976 7.95048C12.1399 7.71978 13 6.71033 13 5.5C13 4.28967 12.1399 3.28022 10.9976 3.04952C10.9992 3.03323 11 3.01671 11 3V1.5ZM4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8ZM9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3c = [
    "color"
];
var $45e7c250d3003265$export$4484d2284bbfa969 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3c);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4 2.5C4 2.22386 4.22386 2 4.5 2H10.5C10.7761 2 11 2.22386 11 2.5V12.5C11 12.7761 10.7761 13 10.5 13H4.5C4.22386 13 4 12.7761 4 12.5V2.5ZM4.5 1C3.67157 1 3 1.67157 3 2.5V12.5C3 13.3284 3.67157 14 4.5 14H10.5C11.3284 14 12 13.3284 12 12.5V2.5C12 1.67157 11.3284 1 10.5 1H4.5ZM6 11.65C5.8067 11.65 5.65 11.8067 5.65 12C5.65 12.1933 5.8067 12.35 6 12.35H9C9.1933 12.35 9.35 12.1933 9.35 12C9.35 11.8067 9.1933 11.65 9 11.65H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3d = [
    "color"
];
var $45e7c250d3003265$export$a2a3256d1cc3a69a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3d);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.25925 3.16667L4.37036 5.33333V1L7.25925 3.16667ZM1 8.22222L3.88889 6.05555L1 3.88889V8.22222ZM1 14L3.88889 11.8333L1 9.66666V14ZM7.74072 8.22222L10.6296 6.05555L7.74072 3.88889V8.22222ZM14 3.16667L11.1111 5.33333V1L14 3.16667ZM11.1111 11.1111L14 8.94444L11.1111 6.77777V11.1111ZM3.88889 11.1111L1 8.94444L3.88889 6.77777V11.1111ZM4.37036 6.05555L7.25925 8.22222V3.88889L4.37036 6.05555ZM3.88889 5.33333L1 3.16667L3.88889 1V5.33333ZM7.74072 3.16667L10.6296 5.33333V1L7.74072 3.16667ZM14 8.22222L11.1111 6.05555L14 3.88889V8.22222ZM11.1111 11.8333L14 14V9.66666L11.1111 11.8333Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3e = [
    "color"
];
var $45e7c250d3003265$export$41051b6be05d5fb0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3e);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3f = [
    "color"
];
var $45e7c250d3003265$export$3e0409b11e4da6d2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3f);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.81819 0.93179C7.64245 0.756054 7.35753 0.756054 7.18179 0.93179L5.43179 2.68179C5.25605 2.85753 5.25605 3.14245 5.43179 3.31819C5.60753 3.49392 5.89245 3.49392 6.06819 3.31819L6.99999 2.38638V5.49999C6.99999 5.77613 7.22385 5.99999 7.49999 5.99999C7.77613 5.99999 7.99999 5.77613 7.99999 5.49999V2.38638L8.93179 3.31819C9.10753 3.49392 9.39245 3.49392 9.56819 3.31819C9.74392 3.14245 9.74392 2.85753 9.56819 2.68179L7.81819 0.93179ZM7.99999 9.49999C7.99999 9.22385 7.77613 8.99999 7.49999 8.99999C7.22385 8.99999 6.99999 9.22385 6.99999 9.49999V12.6136L6.06819 11.6818C5.89245 11.5061 5.60753 11.5061 5.43179 11.6818C5.25605 11.8575 5.25605 12.1424 5.43179 12.3182L7.18179 14.0682C7.35753 14.2439 7.64245 14.2439 7.81819 14.0682L9.56819 12.3182C9.74392 12.1424 9.74392 11.8575 9.56819 11.6818C9.39245 11.5061 9.10753 11.5061 8.93179 11.6818L7.99999 12.6136V9.49999ZM8.99999 7.49999C8.99999 7.22385 9.22385 6.99999 9.49999 6.99999H12.6136L11.6818 6.06819C11.5061 5.89245 11.5061 5.60753 11.6818 5.43179C11.8575 5.25605 12.1424 5.25605 12.3182 5.43179L14.0682 7.18179C14.2439 7.35753 14.2439 7.64245 14.0682 7.81819L12.3182 9.56819C12.1424 9.74392 11.8575 9.74392 11.6818 9.56819C11.5061 9.39245 11.5061 9.10753 11.6818 8.93179L12.6136 7.99999H9.49999C9.22385 7.99999 8.99999 7.77613 8.99999 7.49999ZM3.31819 6.06819L2.38638 6.99999H5.49999C5.77613 6.99999 5.99999 7.22385 5.99999 7.49999C5.99999 7.77613 5.77613 7.99999 5.49999 7.99999H2.38638L3.31819 8.93179C3.49392 9.10753 3.49392 9.39245 3.31819 9.56819C3.14245 9.74392 2.85753 9.74392 2.68179 9.56819L0.93179 7.81819C0.756054 7.64245 0.756054 7.35753 0.93179 7.18179L2.68179 5.43179C2.85753 5.25605 3.14245 5.25605 3.31819 5.43179C3.49392 5.60753 3.49392 5.89245 3.31819 6.06819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3g = [
    "color"
];
var $45e7c250d3003265$export$f8668531034d5b61 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3g);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.25781 3.11684C3.67771 3.45796 3.83523 3.43193 4.62369 3.37933L12.0571 2.93299C12.2147 2.93299 12.0836 2.77571 12.0311 2.74957L10.7965 1.85711C10.56 1.67347 10.2448 1.46315 9.64083 1.51576L2.44308 2.04074C2.18059 2.06677 2.12815 2.19801 2.2327 2.30322L3.25781 3.11684ZM3.7041 4.84917V12.6704C3.7041 13.0907 3.91415 13.248 4.38693 13.222L12.5562 12.7493C13.0292 12.7233 13.0819 12.4341 13.0819 12.0927V4.32397C13.0819 3.98306 12.9508 3.79921 12.6612 3.82545L4.12422 4.32397C3.80918 4.35044 3.7041 4.50803 3.7041 4.84917ZM11.7688 5.26872C11.8212 5.50518 11.7688 5.74142 11.5319 5.76799L11.1383 5.84641V11.6205C10.7965 11.8042 10.4814 11.9092 10.2188 11.9092C9.79835 11.9092 9.69305 11.7779 9.37812 11.3844L6.80345 7.34249V11.2532L7.61816 11.437C7.61816 11.437 7.61816 11.9092 6.96086 11.9092L5.14879 12.0143C5.09615 11.9092 5.14879 11.647 5.33259 11.5944L5.80546 11.4634V6.29276L5.1489 6.24015C5.09625 6.00369 5.22739 5.66278 5.5954 5.63631L7.53935 5.50528L10.2188 9.5998V5.97765L9.53564 5.89924C9.4832 5.61018 9.69305 5.40028 9.95576 5.37425L11.7688 5.26872ZM1.83874 1.33212L9.32557 0.780787C10.245 0.701932 10.4815 0.754753 11.0594 1.17452L13.4492 2.85424C13.8436 3.14309 13.975 3.22173 13.975 3.53661V12.7493C13.975 13.3266 13.7647 13.6681 13.0293 13.7203L4.33492 14.2454C3.78291 14.2717 3.52019 14.193 3.23111 13.8253L1.47116 11.5419C1.1558 11.1216 1.02466 10.8071 1.02466 10.4392V2.25041C1.02466 1.77825 1.23504 1.38441 1.83874 1.33212Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$3h = [
    "color"
];
var $45e7c250d3003265$export$8af0311c2e327563 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3h);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 1.5C4.5 4.25 3 6.5 3 9C3 11.4853 5.01472 13.5 7.5 13.5C9.98528 13.5 12 11.4853 12 9C12 6.5 10.5 4.25 7.5 1.5ZM11 9C11 7.11203 9.97315 5.27195 7.5 2.87357C5.02686 5.27195 4 7.11203 4 9C4 10.933 5.567 12.5 7.5 12.5C9.433 12.5 11 10.933 11 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3i = [
    "color"
];
var $45e7c250d3003265$export$31dd750d53ed8eca = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3i);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$3j = [
    "color"
];
var $45e7c250d3003265$export$cc1d3fa780ad61dc = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3j);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.49985 1.10001C3.27894 1.10001 3.09985 1.27909 3.09985 1.50001C3.09985 1.72092 3.27894 1.90001 3.49985 1.90001H11.4999C11.7208 1.90001 11.8999 1.72092 11.8999 1.50001C11.8999 1.27909 11.7208 1.10001 11.4999 1.10001H3.49985ZM4.99995 4.25001C4.99995 3.97387 4.77609 3.75001 4.49995 3.75001C4.22381 3.75001 3.99995 3.97387 3.99995 4.25001V9.55001C3.99995 11.483 5.56695 13.05 7.49995 13.05C9.43295 13.05 11 11.483 11 9.55001V4.25001C11 3.97387 10.7761 3.75001 10.5 3.75001C10.2238 3.75001 9.99995 3.97387 9.99995 4.25001V9.55001C9.99995 10.9307 8.88066 12.05 7.49995 12.05C6.11924 12.05 4.99995 10.9307 4.99995 9.55001V4.25001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3k = [
    "color"
];
var $45e7c250d3003265$export$2ff5a181c2f67fef = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3k);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.85714 2H12.1429C12.6162 2 13 2.38376 13 2.85714V12.1429C13 12.6162 12.6162 13 12.1429 13H2.85714C2.38376 13 2 12.6162 2 12.1429V2.85714C2 2.38376 2.38376 2 2.85714 2ZM1 2.85714C1 1.83147 1.83147 1 2.85714 1H12.1429C13.1685 1 14 1.83147 14 2.85714V12.1429C14 13.1685 13.1685 14 12.1429 14H2.85714C1.83147 14 1 13.1685 1 12.1429V2.85714ZM7.49988 5.00012C7.77602 5.00012 7.99988 4.77626 7.99988 4.50012C7.99988 4.22398 7.77602 4.00012 7.49988 4.00012C7.22374 4.00012 6.99988 4.22398 6.99988 4.50012C6.99988 4.77626 7.22374 5.00012 7.49988 5.00012ZM4.49988 11.0001C4.77602 11.0001 4.99988 10.7763 4.99988 10.5001C4.99988 10.224 4.77602 10.0001 4.49988 10.0001C4.22374 10.0001 3.99988 10.224 3.99988 10.5001C3.99988 10.7763 4.22374 11.0001 4.49988 11.0001ZM4.99988 7.50012C4.99988 7.77626 4.77602 8.00012 4.49988 8.00012C4.22374 8.00012 3.99988 7.77626 3.99988 7.50012C3.99988 7.22398 4.22374 7.00012 4.49988 7.00012C4.77602 7.00012 4.99988 7.22398 4.99988 7.50012ZM4.49988 5.00012C4.77602 5.00012 4.99988 4.77626 4.99988 4.50012C4.99988 4.22398 4.77602 4.00012 4.49988 4.00012C4.22374 4.00012 3.99988 4.22398 3.99988 4.50012C3.99988 4.77626 4.22374 5.00012 4.49988 5.00012ZM10.9999 10.5001C10.9999 10.7763 10.776 11.0001 10.4999 11.0001C10.2237 11.0001 9.99988 10.7763 9.99988 10.5001C9.99988 10.224 10.2237 10.0001 10.4999 10.0001C10.776 10.0001 10.9999 10.224 10.9999 10.5001ZM10.4999 8.00012C10.776 8.00012 10.9999 7.77626 10.9999 7.50012C10.9999 7.22398 10.776 7.00012 10.4999 7.00012C10.2237 7.00012 9.99988 7.22398 9.99988 7.50012C9.99988 7.77626 10.2237 8.00012 10.4999 8.00012ZM10.9999 4.50012C10.9999 4.77626 10.776 5.00012 10.4999 5.00012C10.2237 5.00012 9.99988 4.77626 9.99988 4.50012C9.99988 4.22398 10.2237 4.00012 10.4999 4.00012C10.776 4.00012 10.9999 4.22398 10.9999 4.50012ZM7.49988 11.0001C7.77602 11.0001 7.99988 10.7763 7.99988 10.5001C7.99988 10.224 7.77602 10.0001 7.49988 10.0001C7.22374 10.0001 6.99988 10.224 6.99988 10.5001C6.99988 10.7763 7.22374 11.0001 7.49988 11.0001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3l = [
    "color"
];
var $45e7c250d3003265$export$7e727ef41af0217d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3l);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3m = [
    "color"
];
var $45e7c250d3003265$export$9b47433640e5db3a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3m);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3n = [
    "color"
];
var $45e7c250d3003265$export$41c6eabacaa37313 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3n);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1465 1.14645L3.71455 8.57836C3.62459 8.66832 3.55263 8.77461 3.50251 8.89155L2.04044 12.303C1.9599 12.491 2.00189 12.709 2.14646 12.8536C2.29103 12.9981 2.50905 13.0401 2.69697 12.9596L6.10847 11.4975C6.2254 11.4474 6.3317 11.3754 6.42166 11.2855L13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645L11.8536 1.14645ZM4.42166 9.28547L11.5 2.20711L12.7929 3.5L5.71455 10.5784L4.21924 11.2192L3.78081 10.7808L4.42166 9.28547Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3o = [
    "color"
];
var $45e7c250d3003265$export$bedf874c76d8ae34 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3o);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3p = [
    "color"
];
var $45e7c250d3003265$export$7dcc8f518762622d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3p);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3q = [
    "color"
];
var $45e7c250d3003265$export$b86b18d4ddcc0181 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.85001 7.50043C1.85001 4.37975 4.37963 1.85001 7.50001 1.85001C10.6204 1.85001 13.15 4.37975 13.15 7.50043C13.15 10.6211 10.6204 13.1509 7.50001 13.1509C4.37963 13.1509 1.85001 10.6211 1.85001 7.50043ZM7.50001 0.850006C3.82728 0.850006 0.850006 3.82753 0.850006 7.50043C0.850006 11.1733 3.82728 14.1509 7.50001 14.1509C11.1727 14.1509 14.15 11.1733 14.15 7.50043C14.15 3.82753 11.1727 0.850006 7.50001 0.850006ZM7.00001 8.00001V3.12811C7.16411 3.10954 7.33094 3.10001 7.50001 3.10001C9.93006 3.10001 11.9 5.07014 11.9 7.50043C11.9 7.66935 11.8905 7.83604 11.872 8.00001H7.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3r = [
    "color"
];
var $45e7c250d3003265$export$d5d0c446063e1490 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3r);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3 5.5C3 7.983 4.99169 9 7 9V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V9V3.1H9V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V3.1H11.5C11.8038 3.1 12.05 2.85376 12.05 2.55C12.05 2.24624 11.8038 2 11.5 2H9.5H8H7.5H7C4.99169 2 3 3.017 3 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3s = [
    "color"
];
var $45e7c250d3003265$export$f65249e0566edf55 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3s);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.5 13.95C13.7485 13.95 13.95 13.7485 13.95 13.5C13.95 13.2514 13.7485 13.05 13.5 13.05L1.49995 13.05C1.25142 13.05 1.04995 13.2514 1.04995 13.5C1.04995 13.7485 1.25142 13.95 1.49995 13.95L13.5 13.95ZM11.0681 7.5683C11.2439 7.39257 11.2439 7.10764 11.0681 6.93191C10.8924 6.75617 10.6075 6.75617 10.4317 6.93191L7.94993 9.41371L7.94993 1.49998C7.94993 1.25146 7.74846 1.04998 7.49993 1.04998C7.2514 1.04998 7.04993 1.25146 7.04993 1.49998L7.04993 9.41371L4.56813 6.93191C4.39239 6.75617 4.10746 6.75617 3.93173 6.93191C3.75599 7.10764 3.75599 7.39257 3.93173 7.5683L7.18173 10.8183C7.35746 10.994 7.64239 10.994 7.81812 10.8183L11.0681 7.5683Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3t = [
    "color"
];
var $45e7c250d3003265$export$d57f0cfd6aca7ffa = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3t);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3u = [
    "color"
];
var $45e7c250d3003265$export$fe9311722b59190b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3u);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.95 1.50005C12.95 1.25152 12.7485 1.05005 12.5 1.05005C12.2514 1.05005 12.05 1.25152 12.05 1.50005L12.05 13.5C12.05 13.7486 12.2514 13.95 12.5 13.95C12.7485 13.95 12.95 13.7486 12.95 13.5L12.95 1.50005ZM6.5683 3.93188C6.39257 3.75614 6.10764 3.75614 5.93191 3.93188C5.75617 4.10761 5.75617 4.39254 5.93191 4.56827L8.41371 7.05007L0.499984 7.05007C0.251456 7.05007 0.0499847 7.25155 0.0499847 7.50007C0.0499846 7.7486 0.251457 7.95007 0.499984 7.95007L8.41371 7.95007L5.93191 10.4319C5.75617 10.6076 5.75617 10.8925 5.93191 11.0683C6.10764 11.244 6.39257 11.244 6.56831 11.0683L9.8183 7.81827C9.99404 7.64254 9.99404 7.35761 9.8183 7.18188L6.5683 3.93188Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3v = [
    "color"
];
var $45e7c250d3003265$export$71e4148884d34eff = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3v);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.50005 1.05005C1.25152 1.05005 1.05005 1.25152 1.05005 1.50005C1.05005 1.74858 1.25152 1.95005 1.50005 1.95005L13.5 1.95005C13.7486 1.95005 13.95 1.74858 13.95 1.50005C13.95 1.25152 13.7486 1.05005 13.5 1.05005H1.50005ZM3.93188 7.43169C3.75614 7.60743 3.75614 7.89236 3.93188 8.06809C4.10761 8.24383 4.39254 8.24383 4.56827 8.06809L7.05007 5.58629V13.5C7.05007 13.7485 7.25155 13.95 7.50007 13.95C7.7486 13.95 7.95007 13.7485 7.95007 13.5L7.95007 5.58629L10.4319 8.06809C10.6076 8.24383 10.8925 8.24383 11.0683 8.06809C11.244 7.89235 11.244 7.60743 11.0683 7.43169L7.81827 4.18169C7.64254 4.00596 7.35761 4.00596 7.18188 4.18169L3.93188 7.43169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3w = [
    "color"
];
var $45e7c250d3003265$export$a6630b90defda83f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3w);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.24182 2.32181C3.3919 2.23132 3.5784 2.22601 3.73338 2.30781L12.7334 7.05781C12.8974 7.14436 13 7.31457 13 7.5C13 7.68543 12.8974 7.85564 12.7334 7.94219L3.73338 12.6922C3.5784 12.774 3.3919 12.7687 3.24182 12.6782C3.09175 12.5877 3 12.4252 3 12.25V2.75C3 2.57476 3.09175 2.4123 3.24182 2.32181ZM4 3.57925V11.4207L11.4288 7.5L4 3.57925Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3x = [
    "color"
];
var $45e7c250d3003265$export$f21ab0717a89c77f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3x);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3y = [
    "color"
];
var $45e7c250d3003265$export$75a23c9e49a976a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3z = [
    "color"
];
var $45e7c250d3003265$export$58a334b597cee6d6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3A = [
    "color"
];
var $45e7c250d3003265$export$2548f56a2855ec74 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3A);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3B = [
    "color"
];
var $45e7c250d3003265$export$62bd98fc131b5caa = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3B);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3C = [
    "color"
];
var $45e7c250d3003265$export$c617f5f26da0904b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3C);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 11.1575 3.84216 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1575 0.877045 7.49985 0.877045ZM1.82701 7.49988C1.82701 4.36686 4.36683 1.82704 7.49985 1.82704C10.6328 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6328 13.1727 7.49985 13.1727C4.36683 13.1727 1.82701 10.6329 1.82701 7.49988ZM7.49999 9.49999C8.60456 9.49999 9.49999 8.60456 9.49999 7.49999C9.49999 6.39542 8.60456 5.49999 7.49999 5.49999C6.39542 5.49999 5.49999 6.39542 5.49999 7.49999C5.49999 8.60456 6.39542 9.49999 7.49999 9.49999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3D = [
    "color"
];
var $45e7c250d3003265$export$b6cede2da0e4d831 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3D);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3E = [
    "color"
];
var $45e7c250d3003265$export$ca36f1a1d2d1ca14 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3E);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3F = [
    "color"
];
var $45e7c250d3003265$export$7637ad60dd86d3b1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3F);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3G = [
    "color"
];
var $45e7c250d3003265$export$199745d7f18c0761 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3G);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.04995 2.74995C3.04995 2.44619 2.80371 2.19995 2.49995 2.19995C2.19619 2.19995 1.94995 2.44619 1.94995 2.74995V12.25C1.94995 12.5537 2.19619 12.8 2.49995 12.8C2.80371 12.8 3.04995 12.5537 3.04995 12.25V2.74995ZM5.73333 2.30776C5.57835 2.22596 5.39185 2.23127 5.24177 2.32176C5.0917 2.41225 4.99995 2.57471 4.99995 2.74995V12.25C4.99995 12.4252 5.0917 12.5877 5.24177 12.6781C5.39185 12.7686 5.57835 12.7739 5.73333 12.6921L14.7333 7.94214C14.8973 7.85559 15 7.68539 15 7.49995C15 7.31452 14.8973 7.14431 14.7333 7.05776L5.73333 2.30776ZM5.99995 11.4207V3.5792L13.4287 7.49995L5.99995 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3H = [
    "color"
];
var $45e7c250d3003265$export$8e0d2500d5bd92ef = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3H);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3I = [
    "color"
];
var $45e7c250d3003265$export$f0960ce3e1a6f234 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3I);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.59664 2.93628C7.76085 3.06401 8.00012 2.94698 8.00012 2.73895V1.99998C9.98143 2 11.1848 2.3637 11.9105 3.08945C12.6363 3.81522 13 5.0186 13 6.99998C13 7.27613 13.2239 7.49998 13.5 7.49998C13.7761 7.49998 14 7.27613 14 6.99998C14 4.9438 13.6325 3.39719 12.6176 2.38234C11.6028 1.36752 10.0562 0.999999 8.00012 0.999984V0.261266C8.00012 0.0532293 7.76085 -0.0637944 7.59664 0.063928L6.00384 1.30277C5.87516 1.40286 5.87516 1.59735 6.00384 1.69744L7.59664 2.93628ZM9.5 5H2.5C2.22386 5 2 5.22386 2 5.5V12.5C2 12.7761 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7761 10 12.5V5.5C10 5.22386 9.77614 5 9.5 5ZM2.5 4C1.67157 4 1 4.67157 1 5.5V12.5C1 13.3284 1.67157 14 2.5 14H9.5C10.3284 14 11 13.3284 11 12.5V5.5C11 4.67157 10.3284 4 9.5 4H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3J = [
    "color"
];
var $45e7c250d3003265$export$f0399077805ff597 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3J);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.81832 0.68179C7.64258 0.506054 7.35766 0.506054 7.18192 0.68179L5.18192 2.68179C5.00619 2.85753 5.00619 3.14245 5.18192 3.31819C5.35766 3.49392 5.64258 3.49392 5.81832 3.31819L7.05012 2.08638L7.05012 5.50023C7.05012 5.74876 7.25159 5.95023 7.50012 5.95023C7.74865 5.95023 7.95012 5.74876 7.95012 5.50023L7.95012 2.08638L9.18192 3.31819C9.35766 3.49392 9.64258 3.49392 9.81832 3.31819C9.99406 3.14245 9.99406 2.85753 9.81832 2.68179L7.81832 0.68179ZM7.95012 12.9136V9.50023C7.95012 9.2517 7.74865 9.05023 7.50012 9.05023C7.25159 9.05023 7.05012 9.2517 7.05012 9.50023V12.9136L5.81832 11.6818C5.64258 11.5061 5.35766 11.5061 5.18192 11.6818C5.00619 11.8575 5.00619 12.1424 5.18192 12.3182L7.18192 14.3182C7.26632 14.4026 7.38077 14.45 7.50012 14.45C7.61947 14.45 7.73393 14.4026 7.81832 14.3182L9.81832 12.3182C9.99406 12.1424 9.99406 11.8575 9.81832 11.6818C9.64258 11.5061 9.35766 11.5061 9.18192 11.6818L7.95012 12.9136ZM1.49994 7.00017C1.2238 7.00017 0.999939 7.22403 0.999939 7.50017C0.999939 7.77631 1.2238 8.00017 1.49994 8.00017L13.4999 8.00017C13.7761 8.00017 13.9999 7.77631 13.9999 7.50017C13.9999 7.22403 13.7761 7.00017 13.4999 7.00017L1.49994 7.00017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3K = [
    "color"
];
var $45e7c250d3003265$export$472271f3e918e2f4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3K);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14 12.85L1 12.85L1 14.15L14 14.15L14 12.85ZM14 8.85002L1 8.85002L1 10.15L14 10.15L14 8.85002ZM1 4.85003L14 4.85003L14 6.15003L1 6.15002L1 4.85003ZM14 0.850025L1 0.850025L1 2.15002L14 2.15002L14 0.850025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3L = [
    "color"
];
var $45e7c250d3003265$export$c3403272e8c8becf = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3L);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3M = [
    "color"
];
var $45e7c250d3003265$export$e940813548ac56bd = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3M);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.5 0C0.223858 0 0 0.223858 0 0.5V14.5C0 14.7761 0.223858 15 0.5 15H4.5C4.77614 15 5 14.7761 5 14.5V5H14.5C14.7761 5 15 4.77614 15 4.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM1 4.07505L1 1H4.07502C4.07502 1 4.07502 1 4.07502 1L4.07505 4.07507L1 4.07505ZM0.999997 4.92505L1 14H4V12.925H2.75002C2.5153 12.925 2.32502 12.7348 2.32502 12.5C2.32502 12.2653 2.5153 12.075 2.75002 12.075H4V10.925H2.25002C2.0153 10.925 1.82502 10.7347 1.82502 10.5C1.82502 10.2653 2.0153 10.075 2.25002 10.075H4V8.92504L2.75002 8.92502C2.5153 8.92502 2.32502 8.73474 2.32502 8.50002C2.32503 8.26529 2.51531 8.07502 2.75003 8.07502L4 8.07504V6.92502L2.74999 6.925C2.51527 6.925 2.325 6.73472 2.325 6.5C2.325 6.26528 2.51529 6.075 2.75001 6.075L4 6.07502V4.92507L0.999997 4.92505ZM4.92505 4H6.075V2.75006C6.075 2.51534 6.26528 2.32506 6.5 2.32506C6.73472 2.32506 6.925 2.51534 6.925 2.75006V4H8.07502V2.75005C8.07502 2.51533 8.2653 2.32505 8.50002 2.32505C8.73474 2.32505 8.92502 2.51533 8.92502 2.75005V4H10.0751V2.25005C10.0751 2.01533 10.2653 1.82505 10.5001 1.82505C10.7348 1.82505 10.9251 2.01533 10.9251 2.25005V4H12.0751V2.75005C12.0751 2.51533 12.2654 2.32505 12.5001 2.32505C12.7348 2.32505 12.9251 2.51533 12.9251 2.75005V4H14V1H4.92502L4.92505 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3N = [
    "color"
];
var $45e7c250d3003265$export$ca010e7ed4ef0790 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3N);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.949988 4.48455C0.949988 5.34059 1.64395 6.03455 2.49999 6.03455C3.35603 6.03455 4.04999 5.34059 4.04999 4.48455C4.04999 3.6285 3.35603 2.93455 2.49999 2.93455C1.64395 2.93455 0.949988 3.6285 0.949988 4.48455ZM2.49999 6.93455C1.14689 6.93455 0.0499878 5.83764 0.0499878 4.48455C0.0499878 3.13145 1.14689 2.03455 2.49999 2.03455C3.85309 2.03455 4.94999 3.13145 4.94999 4.48455C4.94999 4.80813 4.88726 5.11707 4.77329 5.39985L5.73655 6.04413C5.72943 6.06656 5.72269 6.08914 5.71635 6.11188L5.56288 6.66186L5.21005 6.89773L4.21554 6.23366C3.77357 6.6672 3.168 6.93455 2.49999 6.93455ZM0.949991 10.5C0.949991 9.64394 1.64395 8.94998 2.49999 8.94998C3.35603 8.94998 4.04999 9.64394 4.04999 10.5C4.04999 11.356 3.35603 12.05 2.49999 12.05C1.64395 12.05 0.949991 11.356 0.949991 10.5ZM2.49999 8.04998C1.14689 8.04998 0.0499908 9.14688 0.0499908 10.5C0.0499908 11.8531 1.14689 12.95 2.49999 12.95C3.85309 12.95 4.94999 11.8531 4.94999 10.5C4.94999 10.1803 4.88877 9.87497 4.77743 9.595L15 2.75737L14.0486 2.85737C12.7077 2.9983 11.4091 3.40895 10.231 4.06461L7.15646 5.77564C6.92307 5.90553 6.75134 6.12339 6.67955 6.38066L6.42653 7.28737L4.22437 8.75957C3.78166 8.32091 3.17246 8.04998 2.49999 8.04998ZM7.14435 9.2149L7.15646 9.22176L10.231 10.9328C11.4091 11.5884 12.7077 11.9991 14.0486 12.14L15 12.24L8.81072 8.1003L7.14435 9.2149Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3O = [
    "color"
];
var $45e7c250d3003265$export$ab8815222a429372 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3O);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM2 5L2 10H13V5H2ZM2 4C1.44772 4 1 4.44772 1 5V10C1 10.5523 1.44772 11 2 11H13C13.5523 11 14 10.5523 14 10V5C14 4.44772 13.5523 4 13 4H2ZM1.5 14C1.77614 14 2 13.7761 2 13.5C2 13.2239 1.77614 13 1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14ZM4 1.5C4 1.77614 3.77614 2 3.5 2C3.22386 2 3 1.77614 3 1.5C3 1.22386 3.22386 1 3.5 1C3.77614 1 4 1.22386 4 1.5ZM3.5 14C3.77614 14 4 13.7761 4 13.5C4 13.2239 3.77614 13 3.5 13C3.22386 13 3 13.2239 3 13.5C3 13.7761 3.22386 14 3.5 14ZM6 1.5C6 1.77614 5.77614 2 5.5 2C5.22386 2 5 1.77614 5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14ZM8 1.5C8 1.77614 7.77614 2 7.5 2C7.22386 2 7 1.77614 7 1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5ZM7.5 14C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14ZM10 1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5C9 1.22386 9.22386 1 9.5 1C9.77614 1 10 1.22386 10 1.5ZM9.5 14C9.77614 14 10 13.7761 10 13.5C10 13.2239 9.77614 13 9.5 13C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14ZM12 1.5C12 1.77614 11.7761 2 11.5 2C11.2239 2 11 1.77614 11 1.5C11 1.22386 11.2239 1 11.5 1C11.7761 1 12 1.22386 12 1.5ZM11.5 14C11.7761 14 12 13.7761 12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14ZM14 1.5C14 1.77614 13.7761 2 13.5 2C13.2239 2 13 1.77614 13 1.5C13 1.22386 13.2239 1 13.5 1C13.7761 1 14 1.22386 14 1.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3P = [
    "color"
];
var $45e7c250d3003265$export$9a1f3409566e1d35 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3P);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6 3.5C6 2.67157 6.67157 2 7.5 2C8.32843 2 9 2.67157 9 3.5C9 4.32843 8.32843 5 7.5 5C6.67157 5 6 4.32843 6 3.5ZM8 5.94999C9.14112 5.71836 10 4.70948 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.70948 5.85888 5.71836 7 5.94999V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V5.94999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3Q = [
    "color"
];
var $45e7c250d3003265$export$8217100f92ae3d76 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3Q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10 3.5C10 4.70948 9.14112 5.71836 8 5.94999V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.94999C5.85888 5.71836 5 4.70948 5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3R = [
    "color"
];
var $45e7c250d3003265$export$30dea8f5f241e3b3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3R);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3S = [
    "color"
];
var $45e7c250d3003265$export$c7400a1254b7566e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3S);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".05",
        d: "M12.1619 3.85182C8.35817 4.88918 4.88936 8.358 3.85199 12.1617L3.3696 12.0301C4.45356 8.05564 8.05581 4.45339 12.0303 3.36943L12.1619 3.85182Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".1",
        d: "M11.8807 3.42707C8.03441 4.50542 4.50561 8.03422 3.42726 11.8805L2.94582 11.7456C4.07129 7.73121 7.7314 4.0711 11.7458 2.94563L11.8807 3.42707Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".15",
        d: "M11.5201 3.02556C7.69092 4.16199 4.16779 7.68323 3.02805 11.512L2.54883 11.3694C3.73676 7.37869 7.38659 3.73076 11.3778 2.54623L11.5201 3.02556Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".2",
        d: "M11.0468 2.66169C7.31117 3.87664 3.87918 7.3079 2.66298 11.0434L2.18754 10.8886C3.45324 7.00109 7.00445 3.45062 10.8921 2.18621L11.0468 2.66169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".25",
        d: "M10.5201 2.32365C6.92091 3.61447 3.62391 6.90876 2.32845 10.5073L1.858 10.338C3.20398 6.59909 6.61155 3.19424 10.3513 1.85301L10.5201 2.32365Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".3",
        d: "M9.90222 2.03122C6.50003 3.39465 3.39968 6.49367 2.03399 9.89551L1.56998 9.70924C2.98651 6.18076 6.18728 2.98133 9.71622 1.5671L9.90222 2.03122Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".35",
        d: "M9.20727 1.78873C6.06136 3.20349 3.21103 6.05203 1.79331 9.19738L1.33747 8.99192C2.80536 5.73528 5.74485 2.7976 9.0022 1.33272L9.20727 1.78873Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".4",
        d: "M8.40713 1.62085C5.59323 3.05117 3.05794 5.58509 1.62544 8.39847L1.17987 8.1716C2.66036 5.26397 5.27232 2.6534 8.18057 1.17513L8.40713 1.62085Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".45",
        d: "M7.46207 1.56747C5.08689 2.94695 2.95362 5.07912 1.57249 7.45379L1.14028 7.20241C2.56503 4.75273 4.7607 2.55818 7.21096 1.1351L7.46207 1.56747Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".5",
        d: "M6.30407 1.70487C4.51964 2.91063 2.90983 4.52061 1.7043 6.30513L1.28998 6.02524C2.5313 4.18773 4.18673 2.53214 6.02413 1.29059L6.30407 1.70487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3T = [
    "color"
];
var $45e7c250d3003265$export$126350cae9fbd558 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3T);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 9.1488 1.47969 10.657 2.4767 11.8162L1.64647 12.6464C1.45121 12.8417 1.45121 13.1583 1.64647 13.3535C1.84173 13.5488 2.15832 13.5488 2.35358 13.3535L3.18383 12.5233C4.34302 13.5202 5.8511 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34298 12.5233 3.1838L13.3536 2.35355C13.5488 2.15829 13.5488 1.8417 13.3536 1.64644C13.1583 1.45118 12.8417 1.45118 12.6465 1.64644L11.8162 2.47667C10.657 1.47966 9.14883 0.877045 7.49991 0.877045ZM11.1423 3.15065C10.1568 2.32449 8.88644 1.82704 7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 8.88641 2.32452 10.1568 3.15069 11.1422L11.1423 3.15065ZM3.85781 11.8493C4.84322 12.6753 6.11348 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11345 12.6754 4.84319 11.8493 3.85778L3.85781 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3U = [
    "color"
];
var $45e7c250d3003265$export$a3edb785270158f1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3U);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".05",
        d: "M12.1398 3.88617C13.8553 4.94159 15 6.83701 15 9.00001C15 12.3137 12.3137 15 9.00002 15C6.84351 15 4.95296 13.8621 3.89569 12.1552L4.32076 11.8919C5.29069 13.4578 7.02376 14.5 9.00002 14.5C12.0376 14.5 14.5 12.0375 14.5 9.00001C14.5 7.01781 13.4516 5.28027 11.8778 4.31203L12.1398 3.88617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".2",
        d: "M12.851 5.07321C13.8684 6.07106 14.5 7.46199 14.5 9C14.5 12.0375 12.0376 14.5 9.00004 14.5C7.46215 14.5 6.07132 13.8685 5.07349 12.8513L5.43043 12.5011C6.3381 13.4264 7.60186 14 9.00004 14C11.7614 14 14 11.7614 14 9C14 7.60171 13.4264 6.33786 12.5009 5.43017L12.851 5.07321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".35",
        d: "M13.3022 6.45071C13.7455 7.19737 14 8.06935 14 9.00001C14 11.7614 11.7614 14 9.00002 14C8.04868 14 7.15868 13.7341 6.40118 13.2724L6.66142 12.8454C7.34275 13.2607 8.14306 13.5 9.00002 13.5C11.4853 13.5 13.5 11.4853 13.5 9.00001C13.5 8.16165 13.271 7.37754 12.8722 6.70599L13.3022 6.45071Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".5",
        d: "M13.3745 7.94022C13.4566 8.28031 13.5 8.63525 13.5 9.00001C13.5 11.4853 11.4853 13.5 9.00003 13.5C8.61104 13.5 8.23323 13.4506 7.87268 13.3576L7.99759 12.8734C8.31768 12.956 8.65353 13 9.00003 13C11.2091 13 13 11.2091 13 9.00001C13 8.67509 12.9613 8.35953 12.8884 8.05757L13.3745 7.94022Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".65",
        d: "M12.9155 9.82133C12.5898 11.3813 11.3562 12.6072 9.79205 12.9215L9.69354 12.4313C11.0613 12.1565 12.1413 11.0834 12.4261 9.71915L12.9155 9.82133Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.2771 7.50253C1.2771 4.06456 4.06413 1.27753 7.5021 1.27753C10.94 1.27753 13.7271 4.06456 13.7271 7.50253C13.7271 10.9405 10.94 13.7275 7.5021 13.7275C4.06413 13.7275 1.2771 10.9405 1.2771 7.50253ZM7.5021 2.22753C4.5888 2.22753 2.2271 4.58923 2.2271 7.50253C2.2271 10.4158 4.5888 12.7775 7.5021 12.7775C10.4154 12.7775 12.7771 10.4158 12.7771 7.50253C12.7771 4.58923 10.4154 2.22753 7.5021 2.22753Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3V = [
    "color"
];
var $45e7c250d3003265$export$fe819ae1b3a84d32 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3V);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 7.50003C5 8.32845 4.32843 9.00003 3.5 9.00003C2.67157 9.00003 2 8.32845 2 7.50003C2 6.6716 2.67157 6.00003 3.5 6.00003C4.32843 6.00003 5 6.6716 5 7.50003ZM5.71313 8.66388C5.29445 9.45838 4.46048 10 3.5 10C2.11929 10 1 8.88074 1 7.50003C1 6.11931 2.11929 5.00003 3.5 5.00003C4.46048 5.00003 5.29445 5.54167 5.71313 6.33616L9.10424 4.21671C9.03643 3.98968 9 3.74911 9 3.50003C9 2.11932 10.1193 1.00003 11.5 1.00003C12.8807 1.00003 14 2.11932 14 3.50003C14 4.88074 12.8807 6.00003 11.5 6.00003C10.6915 6.00003 9.97264 5.61624 9.51566 5.0209L5.9853 7.22738C5.99502 7.31692 6 7.40789 6 7.50003C6 7.59216 5.99502 7.68312 5.9853 7.77267L9.51567 9.97915C9.97265 9.38382 10.6915 9.00003 11.5 9.00003C12.8807 9.00003 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 11.2509 9.03643 11.0104 9.10425 10.7833L5.71313 8.66388ZM11.5 5.00003C12.3284 5.00003 13 4.32846 13 3.50003C13 2.6716 12.3284 2.00003 11.5 2.00003C10.6716 2.00003 10 2.6716 10 3.50003C10 4.32846 10.6716 5.00003 11.5 5.00003ZM13 11.5C13 12.3285 12.3284 13 11.5 13C10.6716 13 10 12.3285 10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3W = [
    "color"
];
var $45e7c250d3003265$export$fd8d21248a547675 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3W);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3X = [
    "color"
];
var $45e7c250d3003265$export$f584b8d6931467fb = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3X);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M12.3536 1.14645C12.1583 0.951184 11.8417 0.951184 11.6464 1.14645C11.4512 1.34171 11.4512 1.65829 11.6464 1.85355L12.7929 3H12C10.7037 3 9.71111 3.58423 8.87248 4.38931C8.20065 5.03427 7.59349 5.85684 6.99461 6.6682C6.86287 6.84668 6.73154 7.02462 6.6 7.2C5.10874 9.18835 3.49037 11 0.5 11C0.223858 11 0 11.2239 0 11.5C0 11.7761 0.223858 12 0.5 12C4.00963 12 5.89126 9.81165 7.4 7.8C7.54367 7.60845 7.6832 7.41962 7.81996 7.23454L7.82005 7.23443L7.82006 7.23441C8.41674 6.42695 8.96069 5.69085 9.56502 5.11069C10.2889 4.41577 11.0463 4 12 4H12.7929L11.6464 5.14645C11.4512 5.34171 11.4512 5.65829 11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355L14.3536 3.85355C14.5488 3.65829 14.5488 3.34171 14.3536 3.14645L12.3536 1.14645ZM0.5 3C3.35278 3 5.12992 4.44588 6.50548 6.06746L6.3762 6.24266C6.2483 6.4161 6.12293 6.58609 6 6.75C5.96397 6.79804 5.92798 6.84581 5.892 6.89331C4.57348 5.29306 3.02637 4 0.5 4C0.223858 4 0 3.77614 0 3.5C0 3.22386 0.223858 3 0.5 3ZM8.87248 10.6107C8.37284 10.131 7.90897 9.55314 7.45767 8.95468C7.64688 8.71693 7.82704 8.48061 8 8.25L8.08987 8.12987C8.58412 8.79402 9.05288 9.39766 9.56502 9.88931C10.2889 10.5842 11.0463 11 12 11H12.7929L11.6464 9.85355C11.4512 9.65829 11.4512 9.34171 11.6464 9.14645C11.8417 8.95118 12.1583 8.95118 12.3536 9.14645L14.3536 11.1464C14.5488 11.3417 14.5488 11.6583 14.3536 11.8536L12.3536 13.8536C12.1583 14.0488 11.8417 14.0488 11.6464 13.8536C11.4512 13.6583 11.4512 13.3417 11.6464 13.1464L12.7929 12H12C10.7037 12 9.71111 11.4158 8.87248 10.6107Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3Y = [
    "color"
];
var $45e7c250d3003265$export$9b9cddf895f6c38e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3Y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3Z = [
    "color"
];
var $45e7c250d3003265$export$5881b38319b9ceb7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3Z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.53731 0.826873C7.5125 0.824392 7.4875 0.824392 7.46269 0.826873L3.96269 1.17687C3.85672 1.18747 3.76025 1.24262 3.69736 1.32857L0.699771 5.42528C0.654046 5.48627 0.62647 5.56165 0.625057 5.6434C0.625019 5.6456 0.625 5.64781 0.625 5.65001C0.625 5.65052 0.625001 5.65103 0.625003 5.65153C0.625363 5.74237 0.658021 5.82559 0.712087 5.8903L7.21042 13.7883C7.28165 13.8749 7.38789 13.925 7.5 13.925C7.61211 13.925 7.71835 13.8749 7.78958 13.7883L14.2879 5.89031C14.342 5.8256 14.3746 5.74237 14.375 5.65153C14.375 5.65103 14.375 5.65052 14.375 5.65001C14.375 5.64849 14.375 5.64697 14.375 5.64545C14.3749 5.63963 14.3747 5.63382 14.3744 5.62801C14.37 5.55219 14.3431 5.48242 14.3002 5.42527L11.3026 1.32857C11.2397 1.24262 11.1433 1.18747 11.0373 1.17687L7.53731 0.826873ZM10.925 5.27501V5.25236L10.9223 5.27501H10.925ZM10.9342 5.17498H13.1877L11.2495 2.5261L10.9342 5.17498ZM10.5707 1.88395L8.04432 1.63131L10.1747 5.21034L10.5707 1.88395ZM6.95568 1.63131L4.42931 1.88395L4.82531 5.21034L6.95568 1.63131ZM3.75046 2.5261L1.81226 5.17498H4.0658L3.75046 2.5261ZM1.79416 6.02501L6.75861 12.0587L4.22371 6.0669C4.21787 6.0531 4.21314 6.0391 4.20949 6.02501H1.79416ZM5.15055 6.02501L7.49999 12.1085L9.84943 6.02501H9.78681H5.21319H5.15055ZM10.7905 6.02501C10.7869 6.0391 10.7821 6.0531 10.7763 6.0669L8.24139 12.0587L13.2058 6.02501H10.7905ZM7.5 2.18317L9.34038 5.27501H5.65962L7.5 2.18317Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3_ = [
    "color"
];
var $45e7c250d3003265$export$fab36db504d71648 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3_);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$3$ = [
    "color"
];
var $45e7c250d3003265$export$c1a54868c36d9c70 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$3$);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10.3004 7.49991C10.3004 8.4943 9.49426 9.30041 8.49988 9.30041C7.50549 9.30041 6.69938 8.4943 6.69938 7.49991C6.69938 6.50553 7.50549 5.69942 8.49988 5.69942C9.49426 5.69942 10.3004 6.50553 10.3004 7.49991ZM11.205 8C10.9699 9.28029 9.84816 10.2504 8.49988 10.2504C7.1516 10.2504 6.0299 9.28029 5.79473 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H5.7947C6.0298 5.71962 7.15154 4.74942 8.49988 4.74942C9.84822 4.74942 10.97 5.71962 11.2051 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H11.205Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$40 = [
    "color"
];
var $45e7c250d3003265$export$389ac29f15551cc = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$40);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$41 = [
    "color"
];
var $45e7c250d3003265$export$d6c80469522241f6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$41);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1L9 1V5C9 5.55228 8.55228 6 8 6H7C6.44772 6 6 5.55228 6 5V1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 9C6.44772 9 6 9.44771 6 10V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9V10C9 9.44772 8.55228 9 8 9H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$42 = [
    "color"
];
var $45e7c250d3003265$export$d569b77eb092ec4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$42);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992ZM0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992ZM1.99998 6.99994C1.99998 6.44766 2.44769 5.99995 2.99998 5.99995L5.99995 5.99995C6.55223 5.99995 6.99994 6.44766 6.99994 6.99994L6.99994 7.99993C6.99994 8.55221 6.55223 8.99992 5.99995 8.99992L2.99998 8.99992C2.4477 8.99992 1.99998 8.55221 1.99998 7.99993L1.99998 6.99994ZM8.99993 5.99995C8.44765 5.99995 7.99993 6.44766 7.99993 6.99994L7.99993 7.99993C7.99993 8.55221 8.44765 8.99992 8.99993 8.99992L11.9999 8.99992C12.5522 8.99992 12.9999 8.55221 12.9999 7.99993L12.9999 6.99994C12.9999 6.44766 12.5522 5.99995 11.9999 5.99995L8.99993 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$43 = [
    "color"
];
var $45e7c250d3003265$export$7b2a11c2d6945102 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$43);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 2C6.44772 2 6 2.44772 6 3V6C6 6.55228 6.44772 7 7 7H8C8.55228 7 9 6.55228 9 6V3C9 2.44772 8.55228 2 8 2H7ZM7 8C6.44772 8 6 8.44771 6 9V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V9C9 8.44772 8.55228 8 8 8H7ZM1.49988 14C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H1.49988Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$44 = [
    "color"
];
var $45e7c250d3003265$export$7fee6559072912ad = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$44);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.46968 1.05085C7.64122 1.13475 7.75 1.30904 7.75 1.5V13.5C7.75 13.691 7.64122 13.8653 7.46968 13.9492C7.29813 14.0331 7.09377 14.0119 6.94303 13.8947L3.2213 11H1.5C0.671571 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.2213L6.94303 1.10533C7.09377 0.988085 7.29813 0.966945 7.46968 1.05085ZM6.75 2.52232L3.69983 4.89468C3.61206 4.96294 3.50405 5 3.39286 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77615 1.22386 10 1.5 10H3.39286C3.50405 10 3.61206 10.0371 3.69983 10.1053L6.75 12.4777V2.52232ZM10.2784 3.84804C10.4623 3.72567 10.7106 3.77557 10.833 3.95949C12.2558 6.09798 12.2558 8.90199 10.833 11.0405C10.7106 11.2244 10.4623 11.2743 10.2784 11.1519C10.0944 11.0296 10.0445 10.7813 10.1669 10.5973C11.4111 8.72728 11.4111 6.27269 10.1669 4.40264C10.0445 4.21871 10.0944 3.97041 10.2784 3.84804ZM12.6785 1.43044C12.5356 1.2619 12.2832 1.24104 12.1147 1.38386C11.9462 1.52667 11.9253 1.77908 12.0681 1.94762C14.7773 5.14488 14.7773 9.85513 12.0681 13.0524C11.9253 13.2209 11.9462 13.4733 12.1147 13.6161C12.2832 13.759 12.5356 13.7381 12.6785 13.5696C15.6406 10.0739 15.6406 4.92612 12.6785 1.43044Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$45 = [
    "color"
];
var $45e7c250d3003265$export$a45f43fe1bacf3af = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$45);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.833 3.95949C10.7106 3.77557 10.4623 3.72567 10.2784 3.84804C10.0944 3.97041 10.0445 4.21871 10.1669 4.40264C11.4111 6.27268 11.4111 8.72728 10.1669 10.5973C10.0445 10.7813 10.0944 11.0296 10.2784 11.1519C10.4623 11.2743 10.7106 11.2244 10.833 11.0405C12.2558 8.90199 12.2558 6.09798 10.833 3.95949Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$46 = [
    "color"
];
var $45e7c250d3003265$export$9ea4d02db3207a8b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$46);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.72361 1.05279C7.893 1.13749 8 1.31062 8 1.5V13.5C8 13.6894 7.893 13.8625 7.72361 13.9472C7.55421 14.0319 7.35151 14.0136 7.2 13.9L3.33333 11H1.5C0.671573 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.33333L7.2 1.1C7.35151 0.986371 7.55421 0.968093 7.72361 1.05279ZM7 2.5L3.8 4.9C3.71345 4.96491 3.60819 5 3.5 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77614 1.22386 10 1.5 10H3.5C3.60819 10 3.71345 10.0351 3.8 10.1L7 12.5V2.5ZM14.8536 5.14645C15.0488 5.34171 15.0488 5.65829 14.8536 5.85355L13.2071 7.5L14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.5 8.20711L10.8536 9.85355C10.6583 10.0488 10.3417 10.0488 10.1464 9.85355C9.95118 9.65829 9.95118 9.34171 10.1464 9.14645L11.7929 7.5L10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645L12.5 6.79289L14.1464 5.14645C14.3417 4.95118 14.6583 4.95118 14.8536 5.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$47 = [
    "color"
];
var $45e7c250d3003265$export$c28fae3b5b7c9a0b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$47);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.083 5.05577C9.96066 4.87185 9.71235 4.82195 9.52843 4.94432C9.3445 5.06669 9.2946 5.31499 9.41697 5.49892C10.2207 6.70693 10.2207 8.29303 9.41697 9.50104C9.2946 9.68496 9.3445 9.93326 9.52843 10.0556C9.71235 10.178 9.96066 10.1281 10.083 9.94418C11.0653 8.46773 11.0653 6.53222 10.083 5.05577Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$48 = [
    "color"
];
var $45e7c250d3003265$export$c19d0dc844f6640 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$48);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$49 = [
    "color"
];
var $45e7c250d3003265$export$f95b8a41f9121b54 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$49);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.75432 1.81954C7.59742 1.72682 7.4025 1.72682 7.24559 1.81954L1.74559 5.06954C1.59336 5.15949 1.49996 5.32317 1.49996 5.5C1.49996 5.67683 1.59336 5.84051 1.74559 5.93046L7.24559 9.18046C7.4025 9.27318 7.59742 9.27318 7.75432 9.18046L13.2543 5.93046C13.4066 5.84051 13.5 5.67683 13.5 5.5C13.5 5.32317 13.4066 5.15949 13.2543 5.06954L7.75432 1.81954ZM7.49996 8.16923L2.9828 5.5L7.49996 2.83077L12.0171 5.5L7.49996 8.16923ZM2.25432 8.31954C2.01658 8.17906 1.70998 8.2579 1.56949 8.49564C1.42901 8.73337 1.50785 9.03998 1.74559 9.18046L7.24559 12.4305C7.4025 12.5232 7.59742 12.5232 7.75432 12.4305L13.2543 9.18046C13.4921 9.03998 13.5709 8.73337 13.4304 8.49564C13.2899 8.2579 12.9833 8.17906 12.7456 8.31954L7.49996 11.4192L2.25432 8.31954Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4a = [
    "color"
];
var $45e7c250d3003265$export$2ee28caa7f1e962e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4a);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.97942 1.25171L6.9585 1.30199L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422L1.7727 5.0697L1.71841 5.07405L1.38687 5.10063L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L1.14406 5.84793L1.39666 6.06431L1.43802 6.09974L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.41882 12.196L3.40618 12.249L3.32901 12.5725L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L3.9647 13.0344L4.24854 12.861L4.29502 12.8326L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L10.705 12.8326L10.7515 12.861L11.0354 13.0344L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L11.671 12.5725L11.5939 12.249L11.5812 12.196L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L13.562 6.09974L13.6034 6.06431L13.856 5.84793L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L13.6132 5.10063L13.2816 5.07405L13.2274 5.0697L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L8.04155 1.30199L8.02064 1.25171L7.89291 0.944609L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L7.10715 0.944609L6.97942 1.25171ZM7.50003 2.60397L6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4b = [
    "color"
];
var $45e7c250d3003265$export$b9957ed2bd2cc18b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4b);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$4c = [
    "color"
];
var $45e7c250d3003265$export$fa3807a0e988146 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4c);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 7.21321 1.87134 6.93143 1.91256 6.65615L9.56374 2.23875C9.86311 2.35627 10.15 2.49861 10.4219 2.66322L3.77065 6.50332C3.73669 6.52183 3.70482 6.5449 3.67602 6.57238C3.5911 6.65308 3.54245 6.76286 3.53682 6.87658C3.53359 6.9418 3.54451 7.00831 3.57086 7.07137C3.58927 7.1157 3.6149 7.15742 3.64744 7.19458C3.67306 7.22396 3.702 7.24941 3.73337 7.27069L7.32533 9.83813L3.87232 11.8317C2.63604 10.7953 1.84998 9.23944 1.84998 7.49998ZM8.36843 10.2751C8.37682 10.2706 8.38509 10.2659 8.39322 10.2608L9.84091 9.42499C9.84706 9.42163 9.85314 9.41812 9.85915 9.41446L11.3101 8.57677C11.3655 8.54649 11.4154 8.504 11.4554 8.44995C11.6034 8.25031 11.5616 7.96848 11.362 7.82046L7.82779 5.20017L11.2161 3.24393C12.4013 4.27963 13.15 5.80237 13.15 7.49998C13.15 7.83546 13.1207 8.16411 13.0647 8.48353L5.56875 12.8113C5.26138 12.6995 4.96646 12.5618 4.68662 12.4008L8.36843 10.2751ZM8.18149 9.34383L4.81659 6.93868L5.50918 6.53881L8.80604 8.98324L8.18149 9.34383ZM6.35875 6.04832L6.97822 5.69067L10.2751 8.13506L9.6556 8.49275L6.35875 6.04832ZM8.3318 1.91078L2.24263 5.42636C3.06941 3.33188 5.11164 1.84998 7.49998 1.84998C7.78258 1.84998 8.06033 1.87072 8.3318 1.91078ZM6.84684 13.1126C7.06114 13.1373 7.27908 13.15 7.49998 13.15C9.8246 13.15 11.8213 11.7461 12.6886 9.7399L6.84684 13.1126ZM7.49998 0.849976C3.82728 0.849976 0.849976 3.82728 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4d = [
    "color"
];
var $45e7c250d3003265$export$dc6949a98411e916 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4d);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3ZM12 3H3V12H12V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4e = [
    "color"
];
var $45e7c250d3003265$export$93c9322cdb01abe0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4e);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4f = [
    "color"
];
var $45e7c250d3003265$export$672f8b757251d92b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4f);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99992L13.9999 8.99992L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4g = [
    "color"
];
var $45e7c250d3003265$export$dd3bd56329b5fe85 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4g);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H6H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM9 14V1L6 1V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4h = [
    "color"
];
var $45e7c250d3003265$export$25ec4ecc9c5701a5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4h);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4i = [
    "color"
];
var $45e7c250d3003265$export$cd27c497b93dbe8d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4i);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4j = [
    "color"
];
var $45e7c250d3003265$export$381bc0c1798a0082 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4j);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4ZM7.67133 11C6.65183 10.175 6 8.91363 6 7.5C6 6.08637 6.65183 4.82498 7.67133 4H4.5C2.567 4 1 5.567 1 7.5C1 9.433 2.567 11 4.5 11H7.67133ZM0 7.5C0 5.01472 2.01472 3 4.5 3H10.5C12.9853 3 15 5.01472 15 7.5C15 9.98528 12.9853 12 10.5 12H4.5C2.01472 12 0 9.98528 0 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4k = [
    "color"
];
var $45e7c250d3003265$export$b6fcc44f764b8899 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4k);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4l = [
    "color"
];
var $45e7c250d3003265$export$560b0277c649ed6b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4l);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4m = [
    "color"
];
var $45e7c250d3003265$export$aea5b1a1d88a7a75 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4m);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.900024 7.50002C0.900024 3.85495 3.85495 0.900024 7.50002 0.900024C11.1451 0.900024 14.1 3.85495 14.1 7.50002C14.1 11.1451 11.1451 14.1 7.50002 14.1C3.85495 14.1 0.900024 11.1451 0.900024 7.50002ZM7.50002 1.80002C4.35201 1.80002 1.80002 4.35201 1.80002 7.50002C1.80002 10.648 4.35201 13.2 7.50002 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.35201 10.648 1.80002 7.50002 1.80002ZM3.07504 7.50002C3.07504 5.05617 5.05618 3.07502 7.50004 3.07502C9.94388 3.07502 11.925 5.05617 11.925 7.50002C11.925 9.94386 9.94388 11.925 7.50004 11.925C5.05618 11.925 3.07504 9.94386 3.07504 7.50002ZM7.50004 3.92502C5.52562 3.92502 3.92504 5.52561 3.92504 7.50002C3.92504 9.47442 5.52563 11.075 7.50004 11.075C9.47444 11.075 11.075 9.47442 11.075 7.50002C11.075 5.52561 9.47444 3.92502 7.50004 3.92502ZM7.50004 5.25002C6.2574 5.25002 5.25004 6.25739 5.25004 7.50002C5.25004 8.74266 6.2574 9.75002 7.50004 9.75002C8.74267 9.75002 9.75004 8.74266 9.75004 7.50002C9.75004 6.25738 8.74267 5.25002 7.50004 5.25002ZM6.05004 7.50002C6.05004 6.69921 6.69923 6.05002 7.50004 6.05002C8.30084 6.05002 8.95004 6.69921 8.95004 7.50002C8.95004 8.30083 8.30084 8.95002 7.50004 8.95002C6.69923 8.95002 6.05004 8.30083 6.05004 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4n = [
    "color"
];
var $45e7c250d3003265$export$4a7d2a945910cc57 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4n);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4o = [
    "color"
];
var $45e7c250d3003265$export$934aaa521722e7a1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4o);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.89949 5.50002C3.89949 5.27911 3.7204 5.10003 3.49949 5.10003C3.27857 5.10003 3.09949 5.27911 3.09949 5.50002L3.09949 12.5343L1.78233 11.2172C1.62612 11.061 1.37285 11.061 1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829L3.21664 13.7829C3.29166 13.8579 3.3934 13.9 3.49949 13.9C3.60557 13.9 3.70732 13.8579 3.78233 13.7829L5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172C5.62612 11.061 5.37285 11.061 5.21664 11.2172L3.89949 12.5343L3.89949 5.50002ZM8.49998 13C8.22383 13 7.99998 12.7762 7.99998 12.5C7.99998 12.2239 8.22383 12 8.49998 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7762 14.7761 13 14.5 13H8.49998ZM8.49998 10C8.22383 10 7.99998 9.77617 7.99998 9.50002C7.99998 9.22388 8.22383 9.00002 8.49998 9.00002H14.5C14.7761 9.00002 15 9.22388 15 9.50002C15 9.77617 14.7761 10 14.5 10H8.49998ZM7.99998 6.50002C7.99998 6.77617 8.22383 7.00002 8.49998 7.00002H14.5C14.7761 7.00002 15 6.77617 15 6.50002C15 6.22388 14.7761 6.00002 14.5 6.00002H8.49998C8.22383 6.00002 7.99998 6.22388 7.99998 6.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4p = [
    "color"
];
var $45e7c250d3003265$export$c0990f168a0bad08 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4p);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4q = [
    "color"
];
var $45e7c250d3003265$export$8ea3580a4e458099 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4r = [
    "color"
];
var $45e7c250d3003265$export$e9337773b10190a1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4r);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4s = [
    "color"
];
var $45e7c250d3003265$export$79a9a721b029c6d9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4s);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.49949 14.9C3.7204 14.9 3.89949 14.7209 3.89949 14.5L3.89949 10.4657L5.21664 11.7829C5.37285 11.9391 5.62612 11.9391 5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172L3.78233 9.21718C3.70732 9.14217 3.60557 9.10002 3.49949 9.10002C3.3934 9.10002 3.29166 9.14217 3.21664 9.21718L1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829C1.37285 11.9391 1.62612 11.9391 1.78233 11.7829L3.09949 10.4657L3.09949 14.5C3.09949 14.7209 3.27857 14.9 3.49949 14.9ZM7.99998 10.5C7.99998 10.7762 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7762 15 10.5C15 10.2239 14.7761 10 14.5 10H8.49998C8.22383 10 7.99998 10.2239 7.99998 10.5ZM7.99998 7.50002C7.99998 7.77617 8.22383 8.00002 8.49998 8.00002H14.5C14.7761 8.00002 15 7.77617 15 7.50002C15 7.22388 14.7761 7.00002 14.5 7.00002H8.49998C8.22383 7.00002 7.99998 7.22388 7.99998 7.50002ZM8.49998 5.00002C8.22383 5.00002 7.99998 4.77617 7.99998 4.50002C7.99998 4.22388 8.22383 4.00002 8.49998 4.00002H14.5C14.7761 4.00002 15 4.22388 15 4.50002C15 4.77617 14.7761 5.00002 14.5 5.00002H8.49998ZM3.89949 0.500025C3.89949 0.279111 3.7204 0.100025 3.49949 0.100025C3.27857 0.100025 3.09949 0.279111 3.09949 0.500025L3.09949 4.53434L1.78233 3.21718C1.62612 3.06097 1.37285 3.06097 1.21664 3.21718C1.06043 3.37339 1.06043 3.62666 1.21664 3.78287L3.21664 5.78287C3.29166 5.85788 3.3934 5.90002 3.49949 5.90002C3.60557 5.90002 3.70732 5.85788 3.78233 5.78287L5.78233 3.78287C5.93854 3.62666 5.93854 3.37339 5.78233 3.21718C5.62612 3.06097 5.37285 3.06097 5.21664 3.21718L3.89949 4.53434L3.89949 0.500025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4t = [
    "color"
];
var $45e7c250d3003265$export$2b644951427679e4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4t);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H4.5C4.22386 11 4 10.7761 4 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4u = [
    "color"
];
var $45e7c250d3003265$export$65298c635b1d5567 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4u);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M3.89949 9.49998C3.89949 9.72089 3.7204 9.89997 3.49949 9.89997C3.27857 9.89997 3.09949 9.72089 3.09949 9.49998L3.09949 2.46566L1.78233 3.78282C1.62612 3.93903 1.37285 3.93903 1.21664 3.78282C1.06043 3.62661 1.06043 3.37334 1.21664 3.21713L3.21664 1.21713C3.29166 1.14212 3.3934 1.09998 3.49949 1.09998C3.60557 1.09998 3.70732 1.14212 3.78233 1.21713L5.78233 3.21713C5.93854 3.37334 5.93854 3.62661 5.78233 3.78282C5.62612 3.93903 5.37285 3.93903 5.21664 3.78282L3.89949 2.46566L3.89949 9.49998ZM8.49998 1.99998C8.22383 1.99998 7.99998 2.22383 7.99998 2.49998C7.99998 2.77612 8.22383 2.99998 8.49998 2.99998H14.5C14.7761 2.99998 15 2.77612 15 2.49998C15 2.22383 14.7761 1.99998 14.5 1.99998H8.49998ZM8.49998 4.99998C8.22383 4.99998 7.99998 5.22383 7.99998 5.49998C7.99998 5.77612 8.22383 5.99998 8.49998 5.99998H14.5C14.7761 5.99998 15 5.77612 15 5.49998C15 5.22383 14.7761 4.99998 14.5 4.99998H8.49998ZM7.99998 8.49998C7.99998 8.22383 8.22383 7.99998 8.49998 7.99998H14.5C14.7761 7.99998 15 8.22383 15 8.49998C15 8.77612 14.7761 8.99998 14.5 8.99998H8.49998C8.22383 8.99998 7.99998 8.77612 7.99998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4v = [
    "color"
];
var $45e7c250d3003265$export$2407db3e81e79ec8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4v);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4w = [
    "color"
];
var $45e7c250d3003265$export$d02861c1158d3b3d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4w);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V6H12.5C12.6873 6 12.8589 6.10467 12.9446 6.27121C13.0303 6.43774 13.0157 6.63821 12.9069 6.79062L7.90687 13.7906C7.81301 13.922 7.66148 14 7.5 14C7.33853 14 7.18699 13.922 7.09314 13.7906L2.09314 6.79062C1.98427 6.63821 1.96972 6.43774 2.05542 6.27121C2.14112 6.10467 2.31271 6 2.5 6H5V3.5ZM6 4V6.5C6 6.77614 5.77614 7 5.5 7H3.4716L7.5 12.6398L11.5284 7H9.5C9.22386 7 9 6.77614 9 6.5V4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4x = [
    "color"
];
var $45e7c250d3003265$export$90890f1931da847b = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4x);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4y = [
    "color"
];
var $45e7c250d3003265$export$72a6223ceb8df5ef = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4z = [
    "color"
];
var $45e7c250d3003265$export$edde007a504cdbfe = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.5 1C7.66148 1 7.81301 1.07798 7.90687 1.20938L12.9069 8.20938C13.0157 8.36179 13.0303 8.56226 12.9446 8.72879C12.8589 8.89533 12.6873 9 12.5 9H10V11.5C10 11.7761 9.77614 12 9.5 12H5.5C5.22386 12 5 11.7761 5 11.5V9H2.5C2.31271 9 2.14112 8.89533 2.05542 8.72879C1.96972 8.56226 1.98427 8.36179 2.09314 8.20938L7.09314 1.20938C7.18699 1.07798 7.33853 1 7.5 1ZM3.4716 8H5.5C5.77614 8 6 8.22386 6 8.5V11H9V8.5C9 8.22386 9.22386 8 9.5 8H11.5284L7.5 2.36023L3.4716 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4A = [
    "color"
];
var $45e7c250d3003265$export$579848c7cccecf3f = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4A);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4B = [
    "color"
];
var $45e7c250d3003265$export$872ef4fe88315cc3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4B);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4C = [
    "color"
];
var $45e7c250d3003265$export$df10b15f2353def5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4C);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M13.0502 2.74989C13.0502 2.44613 12.804 2.19989 12.5002 2.19989C12.1965 2.19989 11.9502 2.44613 11.9502 2.74989V7.2825C11.9046 7.18802 11.8295 7.10851 11.7334 7.05776L2.73338 2.30776C2.5784 2.22596 2.3919 2.23127 2.24182 2.32176C2.09175 2.41225 2 2.57471 2 2.74995V12.25C2 12.4252 2.09175 12.5877 2.24182 12.6781C2.3919 12.7686 2.5784 12.7739 2.73338 12.6921L11.7334 7.94214C11.8295 7.89139 11.9046 7.81188 11.9502 7.7174V12.2499C11.9502 12.5536 12.1965 12.7999 12.5002 12.7999C12.804 12.7999 13.0502 12.5536 13.0502 12.2499V2.74989ZM3 11.4207V3.5792L10.4288 7.49995L3 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4D = [
    "color"
];
var $45e7c250d3003265$export$6130ef86fd52e250 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4D);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.94976 2.74989C1.94976 2.44613 2.196 2.19989 2.49976 2.19989C2.80351 2.19989 3.04976 2.44613 3.04976 2.74989V7.2825C3.0954 7.18802 3.17046 7.10851 3.26662 7.05776L12.2666 2.30776C12.4216 2.22596 12.6081 2.23127 12.7582 2.32176C12.9083 2.41225 13 2.57471 13 2.74995V12.25C13 12.4252 12.9083 12.5877 12.7582 12.6781C12.6081 12.7686 12.4216 12.7739 12.2666 12.6921L3.26662 7.94214C3.17046 7.89139 3.0954 7.81188 3.04976 7.7174V12.2499C3.04976 12.5536 2.80351 12.7999 2.49976 12.7999C2.196 12.7999 1.94976 12.5536 1.94976 12.2499V2.74989ZM4.57122 7.49995L12 11.4207V3.5792L4.57122 7.49995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4E = [
    "color"
];
var $45e7c250d3003265$export$ee1fdf1996836514 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4E);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4F = [
    "color"
];
var $45e7c250d3003265$export$287e71cda35821ff = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4F);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        opacity: ".25",
        d: "M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4G = [
    "color"
];
var $45e7c250d3003265$export$d23329de703dffc4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4G);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4H = [
    "color"
];
var $45e7c250d3003265$export$b445c2dc6993f9f8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4H);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4 6H11L7.5 10.5L4 6Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$4I = [
    "color"
];
var $45e7c250d3003265$export$62f44957433ecfbf = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4I);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9 4L9 11L4.5 7.5L9 4Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$4J = [
    "color"
];
var $45e7c250d3003265$export$43e4d35e8a44b537 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4J);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6 11L6 4L10.5 7.5L6 11Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$4K = [
    "color"
];
var $45e7c250d3003265$export$9ff28f4659896371 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4K);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4 9H11L7.5 4.5L4 9Z",
        fill: color
    }));
});
var $45e7c250d3003265$var$_excluded$4L = [
    "color"
];
var $45e7c250d3003265$export$890946d7e35b6ab9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4L);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.23336 4.69629C7.23336 2.96884 8.63335 1.56857 10.36 1.56857C11.3736 1.56857 12.183 2.04804 12.7254 2.74385C13.3079 2.62467 13.8557 2.40913 14.3513 2.11508C14.1559 2.72598 13.7424 3.2396 13.2033 3.56463C13.2038 3.56568 13.2042 3.56674 13.2047 3.56779C13.7334 3.50361 14.2364 3.36302 14.7048 3.15546L14.7037 3.15715C14.3667 3.66183 13.9431 4.10736 13.4561 4.47034C13.4823 4.64672 13.4956 4.82427 13.4956 5.00079C13.4956 8.6871 10.6873 12.9746 5.52122 12.9746C3.93906 12.9746 2.46544 12.511 1.22505 11.7152C0.992632 11.5661 0.925108 11.2568 1.07423 11.0244C1.0874 11.0038 1.10183 10.9846 1.11734 10.9666C1.20582 10.8202 1.37438 10.7309 1.5554 10.7522C2.47066 10.8601 3.38568 10.7485 4.19219 10.3962C3.39226 10.0434 2.77129 9.35975 2.50204 8.51974C2.45359 8.3686 2.48835 8.20311 2.59351 8.08422C2.59716 8.0801 2.60087 8.07606 2.60464 8.0721C1.96391 7.50819 1.55973 6.68208 1.55973 5.76143V5.72759C1.55973 5.56814 1.64411 5.42059 1.78155 5.33974C1.82671 5.31317 1.87537 5.29511 1.92532 5.28558C1.70549 4.86154 1.58116 4.37984 1.58116 3.86958C1.58116 3.40165 1.58384 2.81192 1.91332 2.28081C1.98718 2.16175 2.10758 2.08915 2.2364 2.07195C2.42588 2.01237 2.64087 2.06969 2.77406 2.23302C3.86536 3.57126 5.44066 4.49583 7.23366 4.73961L7.23336 4.69629ZM5.52122 11.9746C4.73387 11.9746 3.97781 11.8435 3.27248 11.6023C4.13012 11.4538 4.95307 11.1159 5.66218 10.5602C5.81211 10.4427 5.87182 10.2435 5.81126 10.0629C5.7507 9.88234 5.583 9.75943 5.39255 9.75607C4.68968 9.74366 4.06712 9.39716 3.67793 8.86845C3.86828 8.85306 4.05428 8.82039 4.23445 8.77167C4.43603 8.71716 4.57363 8.53114 4.56674 8.32243C4.55985 8.11372 4.41029 7.93718 4.20555 7.89607C3.42694 7.73977 2.79883 7.16764 2.56169 6.42174C2.76255 6.47025 2.97102 6.4991 3.18482 6.5061C3.38563 6.51267 3.56646 6.38533 3.62795 6.19405C3.68943 6.00277 3.61666 5.79391 3.44963 5.68224C2.86523 5.29155 2.48116 4.62464 2.48116 3.86958C2.48116 3.70213 2.48352 3.55268 2.49355 3.41719C3.85115 4.79913 5.70873 5.68931 7.77588 5.79338C7.93225 5.80126 8.08328 5.73543 8.18395 5.61553C8.28463 5.49562 8.32332 5.33548 8.28851 5.18284C8.25255 5.02517 8.23336 4.86284 8.23336 4.69629C8.23336 3.52085 9.18591 2.56857 10.36 2.56857C11.5943 2.56857 12.4956 3.71208 12.4956 5.00079C12.4956 8.25709 10.0202 11.9746 5.52122 11.9746Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4M = [
    "color"
];
var $45e7c250d3003265$export$4ce1642bb7f15c79 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4M);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4N = [
    "color"
];
var $45e7c250d3003265$export$35f5c3e250802cd1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4N);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4O = [
    "color"
];
var $45e7c250d3003265$export$8df90684a752ef81 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4O);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.81825 1.18188C7.64251 1.00615 7.35759 1.00615 7.18185 1.18188L4.18185 4.18188C4.00611 4.35762 4.00611 4.64254 4.18185 4.81828C4.35759 4.99401 4.64251 4.99401 4.81825 4.81828L7.05005 2.58648V9.49996C7.05005 9.74849 7.25152 9.94996 7.50005 9.94996C7.74858 9.94996 7.95005 9.74849 7.95005 9.49996V2.58648L10.1819 4.81828C10.3576 4.99401 10.6425 4.99401 10.8182 4.81828C10.994 4.64254 10.994 4.35762 10.8182 4.18188L7.81825 1.18188ZM2.5 9.99997C2.77614 9.99997 3 10.2238 3 10.5V12C3 12.5538 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2238 12.2239 9.99997 12.5 9.99997C12.7761 9.99997 13 10.2238 13 10.5V12C13 13.104 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2238 2.22386 9.99997 2.5 9.99997Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4P = [
    "color"
];
var $45e7c250d3003265$export$6e6352268496f418 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4P);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4Q = [
    "color"
];
var $45e7c250d3003265$export$aff958e91ee0391a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4Q);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4R = [
    "color"
];
var $45e7c250d3003265$export$18bf59af111847c = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4R);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4S = [
    "color"
];
var $45e7c250d3003265$export$4ec8735ec23c8112 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4S);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4T = [
    "color"
];
var $45e7c250d3003265$export$6262053f5289408a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4T);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M7 2H1.5C1.22386 2 1 2.22386 1 2.5V7H7V2ZM8 2V7H14V2.5C14 2.22386 13.7761 2 13.5 2H8ZM7 8H1V12.5C1 12.7761 1.22386 13 1.5 13H7V8ZM8 13V8H14V12.5C14 12.7761 13.7761 13 13.5 13H8ZM1.5 1C0.671573 1 0 1.67157 0 2.5V12.5C0 13.3284 0.671573 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.67157 14.3284 1 13.5 1H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4U = [
    "color"
];
var $45e7c250d3003265$export$832ec864fd299632 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4U);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M1.5 2H13.5C13.7761 2 14 2.22386 14 2.5V7H1V2.5C1 2.22386 1.22386 2 1.5 2ZM1 8V12.5C1 12.7761 1.22386 13 1.5 13H13.5C13.7761 13 14 12.7761 14 12.5V8H1ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4V = [
    "color"
];
var $45e7c250d3003265$export$c65e16705969a7a8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4V);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M14 2.58711L1.85163 13H13.5C13.7761 13 14 12.7761 14 12.5V2.58711ZM0.762879 13.8067L0.825396 13.8796L0.854717 13.8545C1.05017 13.9478 1.26899 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.93949 14.6926 1.45078 14.2371 1.19331L14.1746 1.12037L14.1453 1.1455C13.9498 1.05222 13.731 1 13.5 1H1.5C0.671573 1 0 1.67157 0 2.5V12.5C0 13.0605 0.307435 13.5492 0.762879 13.8067ZM1 12.4129L13.1484 2H1.5C1.22386 2 1 2.22386 1 2.5V12.4129Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4W = [
    "color"
];
var $45e7c250d3003265$export$96186050b98a4434 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4W);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M8 2H13.5C13.7761 2 14 2.22386 14 2.5V12.5C14 12.7761 13.7761 13 13.5 13H8V2ZM7 2H1.5C1.22386 2 1 2.22386 1 2.5V12.5C1 12.7761 1.22386 13 1.5 13H7V2ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4X = [
    "color"
];
var $45e7c250d3003265$export$815859cc984b9edf = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4X);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4Y = [
    "color"
];
var $45e7c250d3003265$export$418cedbcfc990387 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4Y);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $45e7c250d3003265$var$_excluded$4Z = [
    "color"
];
var $45e7c250d3003265$export$fbd55a4c69e8e024 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $45e7c250d3003265$var$_objectWithoutPropertiesLoose(_ref, $45e7c250d3003265$var$_excluded$4Z);
    return (0, $bh6RR.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});





const $331b238b8b7c8b95$var$ConfirmDeleteQueryDialog = ({ matrixId: matrixId , deleteQuery: deleteQuery  })=>{
    const { setIsAuthModalOpen: setIsAuthModalOpen  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const [dialogOpen, setDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    function handleDelete(matrixId) {
        deleteQuery(matrixId);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    const garbageSVG24 = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($331b238b8b7c8b95$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-trash-2",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M3 6h18"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("line", {
                x1: "10",
                x2: "10",
                y1: "11",
                y2: "17"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("line", {
                x1: "14",
                x2: "14",
                y1: "11",
                y2: "17"
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$be92b6f5f03c0fe9, {
        onOpenChange: ()=>{
            setDialogOpen((oldValue)=>{
                setIsAuthModalOpen(!oldValue);
                return !oldValue;
            });
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "Button violet",
                    children: garbageSVG24
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$c6fdb837b070b4ff, {
                        className: "DialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$7c6e2c02157bb7d2, {
                        className: "ConfirmDialogContent",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f99233281efd08a0, {
                                className: "ConfirmDialogTitle",
                                children: "WARNING: Deletes are permanent."
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    marginTop: 25,
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "Button red",
                                        onClick: ()=>handleDelete(matrixId),
                                        children: "Delete"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f39c2d165cd861fe, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "ConfirmIconButton",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$b7fa469a3cb3cd4f), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $331b238b8b7c8b95$export$2e2bcd8739ae039 = $331b238b8b7c8b95$var$ConfirmDeleteQueryDialog;
const $331b238b8b7c8b95$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  cursor: pointer;
`;





parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $168a40e325c04e1b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $168a40e325c04e1b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $168a40e325c04e1b$export$803cd8101b6c182b = /*#__PURE__*/ $168a40e325c04e1b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[0], side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[1]), []);
const $168a40e325c04e1b$export$96ec731ed4dcb222 = Math.min;
const $168a40e325c04e1b$export$8960430cfd85939f = Math.max;
const $168a40e325c04e1b$export$2077e0241d6afd3c = Math.round;
const $168a40e325c04e1b$export$a3fe094919f356fd = Math.floor;
const $168a40e325c04e1b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $168a40e325c04e1b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $168a40e325c04e1b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $168a40e325c04e1b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $168a40e325c04e1b$export$8960430cfd85939f(start, $168a40e325c04e1b$export$96ec731ed4dcb222(value, end));
}
function $168a40e325c04e1b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $168a40e325c04e1b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $168a40e325c04e1b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $168a40e325c04e1b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $168a40e325c04e1b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $168a40e325c04e1b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($168a40e325c04e1b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement) {
    return $168a40e325c04e1b$export$8a000a963141ac32($168a40e325c04e1b$export$f28e8f882010718a(placement));
}
function $168a40e325c04e1b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement);
    const length = $168a40e325c04e1b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $168a40e325c04e1b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $168a40e325c04e1b$export$9c5e28bad23365fa(placement);
    return [
        $168a40e325c04e1b$export$2b182c584985588b(placement),
        oppositePlacement,
        $168a40e325c04e1b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $168a40e325c04e1b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$168a40e325c04e1b$var$oppositeAlignmentMap[alignment]);
}
function $168a40e325c04e1b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $168a40e325c04e1b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    let list = $168a40e325c04e1b$var$getSideList($168a40e325c04e1b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($168a40e325c04e1b$export$2b182c584985588b));
    }
    return list;
}
function $168a40e325c04e1b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$168a40e325c04e1b$var$oppositeSideMap[side]);
}
function $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $168a40e325c04e1b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $168a40e325c04e1b$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $c08575a6ddb212a3$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const sideAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c08575a6ddb212a3$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $c08575a6ddb212a3$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name , fn: fn  } = validMiddleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $c08575a6ddb212a3$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c08575a6ddb212a3$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = state;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c08575a6ddb212a3$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , platform: platform , elements: elements , middlewareData: middlewareData  } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element , padding: padding = 0  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c08575a6ddb212a3$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $168a40e325c04e1b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c08575a6ddb212a3$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = state;
            const { crossAxis: crossAxis = false , alignment: alignment , allowedPlacements: allowedPlacements = (0, $168a40e325c04e1b$export$803cd8101b6c182b) , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $168a40e325c04e1b$export$803cd8101b6c182b) ? $c08575a6ddb212a3$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c08575a6ddb212a3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $168a40e325c04e1b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c08575a6ddb212a3$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , fallbackAxisSideDirection: fallbackAxisSideDirection = "none" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $168a40e325c04e1b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $168a40e325c04e1b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $168a40e325c04e1b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c08575a6ddb212a3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $168a40e325c04e1b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c08575a6ddb212a3$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c08575a6ddb212a3$var$isAnySideFullyClipped(overflow) {
    return (0, $168a40e325c04e1b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c08575a6ddb212a3$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects  } = state;
            const { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $c08575a6ddb212a3$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $c08575a6ddb212a3$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c08575a6ddb212a3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $c08575a6ddb212a3$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c08575a6ddb212a3$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c08575a6ddb212a3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c08575a6ddb212a3$var$getBoundingRect(rects) {
    const minX = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c08575a6ddb212a3$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($c08575a6ddb212a3$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c08575a6ddb212a3$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c08575a6ddb212a3$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($c08575a6ddb212a3$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c08575a6ddb212a3$var$convertValueToCoords(state, options) {
    const { placement: placement , platform: platform , elements: elements  } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c08575a6ddb212a3$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x , y: y , placement: placement , middlewareData: middlewareData  } = state;
            const diffCoords = await $c08575a6ddb212a3$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c08575a6ddb212a3$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c08575a6ddb212a3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c08575a6ddb212a3$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = state;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c08575a6ddb212a3$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            const { apply: apply = ()=>{} , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $c08575a6ddb212a3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
            const { width: width , height: height  } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $8da4680c6d092b5b$export$651544f548703224(node) {
    if ($8da4680c6d092b5b$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $8da4680c6d092b5b$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $8da4680c6d092b5b$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($8da4680c6d092b5b$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $8da4680c6d092b5b$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).Node;
}
function $8da4680c6d092b5b$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).Element;
}
function $8da4680c6d092b5b$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).HTMLElement;
}
function $8da4680c6d092b5b$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $8da4680c6d092b5b$export$989e911fa9af580a(element) {
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY , display: display  } = $8da4680c6d092b5b$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $8da4680c6d092b5b$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($8da4680c6d092b5b$export$651544f548703224(element));
}
function $8da4680c6d092b5b$export$d6c4e8150c35fed1(element) {
    const webkit = $8da4680c6d092b5b$export$78551043582a6a98();
    const css = $8da4680c6d092b5b$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $8da4680c6d092b5b$export$940d8225183e1404(element) {
    let currentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(element);
    while($8da4680c6d092b5b$export$1b3bfaa9684536aa(currentNode) && !$8da4680c6d092b5b$export$d1162fb0b6d4cd51(currentNode)){
        if ($8da4680c6d092b5b$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $8da4680c6d092b5b$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $8da4680c6d092b5b$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($8da4680c6d092b5b$export$651544f548703224(node));
}
function $8da4680c6d092b5b$export$3735103072e4a80(element) {
    return $8da4680c6d092b5b$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $8da4680c6d092b5b$export$dc8fc79fa2800137(element) {
    if ($8da4680c6d092b5b$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $8da4680c6d092b5b$export$4e12058fc4d51d56(node) {
    if ($8da4680c6d092b5b$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $8da4680c6d092b5b$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $8da4680c6d092b5b$export$e495491855dc5418(node);
    return $8da4680c6d092b5b$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $8da4680c6d092b5b$export$7cd01a57c8ca906c(node) {
    const parentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(node);
    if ($8da4680c6d092b5b$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($8da4680c6d092b5b$export$1b3bfaa9684536aa(parentNode) && $8da4680c6d092b5b$export$989e911fa9af580a(parentNode)) return parentNode;
    return $8da4680c6d092b5b$export$7cd01a57c8ca906c(parentNode);
}
function $8da4680c6d092b5b$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $8da4680c6d092b5b$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $8da4680c6d092b5b$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $8da4680c6d092b5b$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $8da4680c6d092b5b$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $8da4680c6d092b5b$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $eb1d538a79f8020f$var$getCssDimensions(element) {
    const css = (0, $8da4680c6d092b5b$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $eb1d538a79f8020f$var$unwrapElement(element) {
    return !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $eb1d538a79f8020f$var$getScale(element) {
    const domElement = $eb1d538a79f8020f$var$unwrapElement(element);
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(domElement)) return (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width , height: height , $: $  } = $eb1d538a79f8020f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $eb1d538a79f8020f$var$noOffsets = /*#__PURE__*/ (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
function $eb1d538a79f8020f$var$getVisualOffsets(element) {
    const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    if (!(0, $8da4680c6d092b5b$export$78551043582a6a98)() || !win.visualViewport) return $eb1d538a79f8020f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $eb1d538a79f8020f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $eb1d538a79f8020f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $eb1d538a79f8020f$var$unwrapElement(element);
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(offsetParent)) scale = $eb1d538a79f8020f$var$getScale(offsetParent);
        } else scale = $eb1d538a79f8020f$var$getScale(element);
    }
    const visualOffsets = $eb1d538a79f8020f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $eb1d538a79f8020f$var$getVisualOffsets(domElement) : (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $eb1d538a79f8020f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $8da4680c6d092b5b$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $eb1d538a79f8020f$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $eb1d538a79f8020f$var$isTopLayer(floating) {
    return $eb1d538a79f8020f$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $eb1d538a79f8020f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements , rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $8da4680c6d092b5b$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $eb1d538a79f8020f$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) !== "body" || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(documentElement)) scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $eb1d538a79f8020f$var$getBoundingClientRect(offsetParent);
            scale = $eb1d538a79f8020f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $eb1d538a79f8020f$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $eb1d538a79f8020f$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $eb1d538a79f8020f$var$getBoundingClientRect((0, $8da4680c6d092b5b$export$e495491855dc5418)(element)).left + (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $eb1d538a79f8020f$var$getDocumentRect(element) {
    const html = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    const scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $eb1d538a79f8020f$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $8da4680c6d092b5b$export$3735103072e4a80)(body).direction === "rtl") x += (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $eb1d538a79f8020f$var$getViewportRect(element, strategy) {
    const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    const html = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $8da4680c6d092b5b$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $eb1d538a79f8020f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $eb1d538a79f8020f$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) ? $eb1d538a79f8020f$var$getScale(element) : (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $eb1d538a79f8020f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $eb1d538a79f8020f$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $eb1d538a79f8020f$var$getDocumentRect((0, $8da4680c6d092b5b$export$e495491855dc5418)(element));
    else if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $eb1d538a79f8020f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $eb1d538a79f8020f$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(rect);
}
function $eb1d538a79f8020f$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(parentNode) || (0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $8da4680c6d092b5b$export$3735103072e4a80)(parentNode).position === "fixed" || $eb1d538a79f8020f$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $eb1d538a79f8020f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $8da4680c6d092b5b$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(el) && (0, $8da4680c6d092b5b$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(currentNode) && !(0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $8da4680c6d092b5b$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $8da4680c6d092b5b$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $eb1d538a79f8020f$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $eb1d538a79f8020f$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $eb1d538a79f8020f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $eb1d538a79f8020f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $eb1d538a79f8020f$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $eb1d538a79f8020f$var$getDimensions(element) {
    const { width: width , height: height  } = $eb1d538a79f8020f$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $eb1d538a79f8020f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $8da4680c6d092b5b$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $eb1d538a79f8020f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) !== "body" || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(documentElement)) scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $eb1d538a79f8020f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $eb1d538a79f8020f$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $eb1d538a79f8020f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) || (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $eb1d538a79f8020f$var$getOffsetParent(element, polyfill) {
    const window = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) || $eb1d538a79f8020f$var$isTopLayer(element)) return window;
    let offsetParent = $eb1d538a79f8020f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $8da4680c6d092b5b$export$71535ffaa902797f)(offsetParent) && (0, $8da4680c6d092b5b$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $eb1d538a79f8020f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) === "html" || (0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) === "body" && (0, $8da4680c6d092b5b$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $8da4680c6d092b5b$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $8da4680c6d092b5b$export$940d8225183e1404)(element) || window;
}
const $eb1d538a79f8020f$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $eb1d538a79f8020f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $eb1d538a79f8020f$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function $eb1d538a79f8020f$var$isRTL(element) {
    return (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).direction === "rtl";
}
const $eb1d538a79f8020f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $eb1d538a79f8020f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $8da4680c6d092b5b$export$e495491855dc5418,
    getClippingRect: $eb1d538a79f8020f$var$getClippingRect,
    getOffsetParent: $eb1d538a79f8020f$var$getOffsetParent,
    getElementRects: $eb1d538a79f8020f$var$getElementRects,
    getClientRects: $eb1d538a79f8020f$var$getClientRects,
    getDimensions: $eb1d538a79f8020f$var$getDimensions,
    getScale: $eb1d538a79f8020f$var$getScale,
    isElement: $8da4680c6d092b5b$export$45a5e7f76e0caa8d,
    isRTL: $eb1d538a79f8020f$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $eb1d538a79f8020f$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left , top: top , width: width , height: height  } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $168a40e325c04e1b$export$8960430cfd85939f)(0, (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $eb1d538a79f8020f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true , ancestorResize: ancestorResize = true , elementResize: elementResize = typeof ResizeObserver === "function" , layoutShift: layoutShift = typeof IntersectionObserver === "function" , animationFrame: animationFrame = false  } = options;
    const referenceEl = $eb1d538a79f8020f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $8da4680c6d092b5b$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $8da4680c6d092b5b$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $eb1d538a79f8020f$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $eb1d538a79f8020f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $eb1d538a79f8020f$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $eb1d538a79f8020f$export$91fb6ecbd551914 = (0, $c08575a6ddb212a3$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $eb1d538a79f8020f$export$fba63a578e423eb = (0, $c08575a6ddb212a3$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $eb1d538a79f8020f$export$8a83211c878a3f1f = (0, $c08575a6ddb212a3$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $eb1d538a79f8020f$export$346677f925de839c = (0, $c08575a6ddb212a3$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $eb1d538a79f8020f$export$fe8985bb6374093c = (0, $c08575a6ddb212a3$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $eb1d538a79f8020f$export$f2120bbfa5450bd2 = (0, $c08575a6ddb212a3$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $eb1d538a79f8020f$export$18c8ad048e32c7d5 = (0, $c08575a6ddb212a3$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $eb1d538a79f8020f$export$7bf07e38f3dc4b69 = (0, $c08575a6ddb212a3$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $eb1d538a79f8020f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $eb1d538a79f8020f$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $c08575a6ddb212a3$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $bh6RR = parcelRequire("bh6RR");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $8a178805085a3571$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element , padding: padding  } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $eb1d538a79f8020f$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $eb1d538a79f8020f$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $8a178805085a3571$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $8a178805085a3571$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$8a178805085a3571$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$8a178805085a3571$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // biome-ignore lint/suspicious/noSelfCompare: in source
    return a !== a && b !== b;
}
function $8a178805085a3571$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $8a178805085a3571$var$roundByDPR(element, value) {
    const dpr = $8a178805085a3571$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $8a178805085a3571$var$useLatestRef(value) {
    const ref = $bh6RR.useRef(value);
    $8a178805085a3571$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $8a178805085a3571$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform , elements: { reference: externalReference , floating: externalFloating  } = {} , transform: transform = true , whileElementsMounted: whileElementsMounted , open: open  } = options;
    const [data, setData] = $bh6RR.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $bh6RR.useState(middleware);
    if (!$8a178805085a3571$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $bh6RR.useState(null);
    const [_floating, _setFloating] = $bh6RR.useState(null);
    const setReference = $bh6RR.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $bh6RR.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $bh6RR.useRef(null);
    const floatingRef = $bh6RR.useRef(null);
    const dataRef = $bh6RR.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $8a178805085a3571$var$useLatestRef(whileElementsMounted);
    const platformRef = $8a178805085a3571$var$useLatestRef(platform);
    const update = $bh6RR.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $eb1d538a79f8020f$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$8a178805085a3571$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $47cfd4084854a574$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $8a178805085a3571$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $bh6RR.useRef(false);
    $8a178805085a3571$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
    $8a178805085a3571$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $bh6RR.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $bh6RR.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $bh6RR.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $8a178805085a3571$var$roundByDPR(elements.floating, data.x);
        const y = $8a178805085a3571$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$8a178805085a3571$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $bh6RR.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $16be71d67e49e3d7$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $16be71d67e49e3d7$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $bh6RR.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($16be71d67e49e3d7$export$21b07c8f274aebd5, {
    displayName: $16be71d67e49e3d7$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $16be71d67e49e3d7$export$be92b6f5f03c0fe9 = $16be71d67e49e3d7$export$21b07c8f274aebd5;








var $bh6RR = parcelRequire("bh6RR");

function $56d498be3b1274ee$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $bh6RR.useState)(undefined);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $cef20fc375922749$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $cef20fc375922749$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$cef20fc375922749$var$$cf1ac5d9fe0e8206$var$createPopperContext, $cef20fc375922749$export$722aac194ae923] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cef20fc375922749$var$$cf1ac5d9fe0e8206$var$PopperProvider, $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$createPopperContext($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cef20fc375922749$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = (0, $bh6RR.useState)(null);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($cef20fc375922749$export$badac9ada3a0bdf9, {
    displayName: $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $cef20fc375922749$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$usePopperContext($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($cef20fc375922749$export$ecd4e1ccab6ed6d, {
    displayName: $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$cef20fc375922749$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$useContentContext] = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$createPopperContext($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $cef20fc375922749$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper , side: side = "bottom" , sideOffset: sideOffset = 0 , align: align = "center" , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , avoidCollisions: avoidCollisions = true , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = "partial" , hideWhenDetached: hideWhenDetached = false , updatePositionStrategy: updatePositionStrategy = "optimized" , onPlaced: onPlaced , ...contentProps } = props;
    const context = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$usePopperContext($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $bh6RR.useState)(null);
    const arrowSize = (0, $56d498be3b1274ee$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = (0, $8a178805085a3571$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $eb1d538a79f8020f$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $c08575a6ddb212a3$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $eb1d538a79f8020f$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $eb1d538a79f8020f$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $eb1d538a79f8020f$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $eb1d538a79f8020f$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $8a178805085a3571$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $eb1d538a79f8020f$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPlaced);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($cef20fc375922749$export$bc4ae5855d3c4fc, {
    displayName: $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $cef20fc375922749$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$useContentContext($cef20fc375922749$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $bh6RR.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $16be71d67e49e3d7$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($cef20fc375922749$export$79d62cd4e10a3fd0, {
    displayName: $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $cef20fc375922749$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $cef20fc375922749$export$be92b6f5f03c0fe9 = $cef20fc375922749$export$badac9ada3a0bdf9;
const $cef20fc375922749$export$b688253958b8dfe7 = $cef20fc375922749$export$ecd4e1ccab6ed6d;
const $cef20fc375922749$export$7c6e2c02157bb7d2 = $cef20fc375922749$export$bc4ae5855d3c4fc;
const $cef20fc375922749$export$21b07c8f274aebd5 = $cef20fc375922749$export$79d62cd4e10a3fd0;









var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $91436baa4104b247$export$439d29a4e110a164 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($91436baa4104b247$export$439d29a4e110a164, {
    displayName: $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$export$be92b6f5f03c0fe9 = $91436baa4104b247$export$439d29a4e110a164;


const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext, $07f3afa847a16c98$export$1c540a2224f0d865] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $cef20fc375922749$export$722aac194ae923)
]);
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope = (0, $cef20fc375922749$export$722aac194ae923)();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME);
const $07f3afa847a16c98$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , delayDuration: delayDuration = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION , skipDelayDuration: skipDelayDuration = 300 , disableHoverableContent: disableHoverableContent = false , children: children  } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0, $bh6RR.useState)(true);
    const isPointerInTransitRef = (0, $bh6RR.useRef)(false);
    const skipDelayTimerRef = (0, $bh6RR.useRef)(0);
    (0, $bh6RR.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0, $bh6RR.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0, $bh6RR.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0, $bh6RR.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$f78649fb9ca566b8, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME);
const $07f3afa847a16c98$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , open: openProp , defaultOpen: defaultOpen = false , onOpenChange: onOpenChange , disableHoverableContent: disableHoverableContentProp , delayDuration: delayDurationProp  } = props;
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0, $bh6RR.useState)(null);
    const contentId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const openTimerRef = (0, $bh6RR.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0, $bh6RR.useRef)(false);
    const [open1 = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0, $bh6RR.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open1
    ]);
    const handleOpen = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $cef20fc375922749$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0, $bh6RR.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0, $bh6RR.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$28c660c63b792dea, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $07f3afa847a16c98$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...triggerProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0, $bh6RR.useRef)(false);
    const hasPointerMoveOpenedRef = (0, $bh6RR.useRef)(false);
    const handlePointerUp = (0, $bh6RR.useCallback)(()=>isPointerDownRef.current = false, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $cef20fc375922749$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (event.pointerType === "touch") return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener("pointerup", handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$8c610744efcf8a1d, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$PortalProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePortalContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $07f3afa847a16c98$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , forceMount: forceMount , children: children , container: container  } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$7b36b8f925ab7497, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $07f3afa847a16c98$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePortalContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount , side: side = "top" , ...contentProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentHoverable, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0, $bh6RR.useState)(null);
    const { trigger: trigger , onClose: onClose  } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange  } = providerContext;
    const handleRemoveGraceArea = (0, $bh6RR.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0, $bh6RR.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$07f3afa847a16c98$var$$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , "aria-label": ariaLabel , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , ...contentProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose  } = context; // Close this tooltip if another one opens
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0, $bh6RR.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $cef20fc375922749$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
            "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
            "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $18fd289ffa468154$export$d9f1ccf0bdb05d45), null, children), /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91436baa4104b247$export$be92b6f5f03c0fe9), {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$e9003e2be37ec060, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $07f3afa847a16c98$export$c27ee0ad710f7559 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...arrowProps } = props;
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $cef20fc375922749$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$c27ee0ad710f7559, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top , right: right , bottom: bottom , left: left  } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $07f3afa847a16c98$export$2881499e37b75b9a = $07f3afa847a16c98$export$f78649fb9ca566b8;
const $07f3afa847a16c98$export$be92b6f5f03c0fe9 = $07f3afa847a16c98$export$28c660c63b792dea;
const $07f3afa847a16c98$export$41fb9f06171c75f4 = $07f3afa847a16c98$export$8c610744efcf8a1d;
const $07f3afa847a16c98$export$602eac185826482c = $07f3afa847a16c98$export$7b36b8f925ab7497;
const $07f3afa847a16c98$export$7c6e2c02157bb7d2 = $07f3afa847a16c98$export$e9003e2be37ec060;
const $07f3afa847a16c98$export$21b07c8f274aebd5 = $07f3afa847a16c98$export$c27ee0ad710f7559;




const $d2a91c365c46d765$var$TooltipWrapper = ({ children: children , message: message , side: side , sideOffset: sideOffset , alignOffset: alignOffset , arrowshiftY: arrowshiftY , arrowshiftX: arrowshiftX , omitInfo: omitInfo = false  })=>{
    const infoSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-info",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "7.5",
                cy: "7.5",
                r: "6.25"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M7.5 10v-2.5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M7.5 5h.01"
            })
        ]
    });
    const infoSVG2 = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($d2a91c365c46d765$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        className: "lucide lucide-info",
        viewBox: "0 0 15 15",
        width: "15",
        height: "15",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "7.5",
                cy: "7.5",
                r: "6.25"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M7.5 10v-2.5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M7.5 5h.01"
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($07f3afa847a16c98$export$2881499e37b75b9a, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($07f3afa847a16c98$export$be92b6f5f03c0fe9, {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($07f3afa847a16c98$export$41fb9f06171c75f4, {
                    asChild: true,
                    children: children
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($07f3afa847a16c98$export$602eac185826482c, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($07f3afa847a16c98$export$7c6e2c02157bb7d2, {
                        className: "TooltipContent",
                        sideOffset: sideOffset,
                        alignOffset: alignOffset,
                        side: side,
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none !important"
                        },
                        children: [
                            !omitInfo && infoSVG2,
                            !omitInfo && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d2a91c365c46d765$var$SpacerDiv, {}),
                            message,
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($07f3afa847a16c98$export$21b07c8f274aebd5, {
                                style: {
                                    transform: `translate(${arrowshiftX}, ${arrowshiftY})`,
                                    zIndex: 1
                                },
                                className: "TooltipArrow"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $d2a91c365c46d765$var$SpacerDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  min-width: 5px;
  z-index: -1px;
`;
const $d2a91c365c46d765$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  fill: none;
  stroke: currentColor;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  transform: translateY(-1px);
`;
var $d2a91c365c46d765$export$2e2bcd8739ae039 = $d2a91c365c46d765$var$TooltipWrapper;




const $6531107febf5e71a$export$3ae94a2503e890a1 = (dateString)=>{
    if (!dateString.endsWith("Z")) dateString += "Z";
    const date = new Date(Date.parse(dateString));
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userLocale = navigator.language || navigator.languages[0];
    if (isNaN(date)) return "Invalid date string";
    const dateOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: userTimeZone
    };
    const timeOptions = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: userTimeZone
    };
    const formattedDate = date.toLocaleString(userLocale, dateOptions);
    const formattedTime = date.toLocaleString(userLocale, timeOptions);
    return `${formattedDate}, ${formattedTime}`;
};
const $6531107febf5e71a$export$4812e460280c6ef2 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $6531107febf5e71a$export$d02631cccf789723 = (start, end, step = 1)=>{
    let output = [];
    if (typeof end === "undefined") {
        end = start;
        start = 0;
    }
    for(let i = start; i < end; i += step)output.push(i);
    return output;
};
const $6531107febf5e71a$export$4385e60b38654f68 = (min, max)=>Math.floor(Math.random() * (max - min)) + min;


function $e39b83e0b57a38fe$var$UserHistory() {
    const { userQueries: userQueries , deleteQuery: deleteQuery  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    if (userQueries.length < 1) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    function getSequenceDisplay(sequenceTerms) {
        return [
            ...sequenceTerms,
            "..."
        ].map((term, index)=>{
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$MiniNumberBoxWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$InnerContainer, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$InnerElement, {
                        children: term
                    })
                })
            }, `term-${index}`);
        });
    }
    const linkSVG24 = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($e39b83e0b57a38fe$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-link",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
            })
        ]
    });
    const SearchSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($e39b83e0b57a38fe$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-eye",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
    // const garbageSVG24 = (
    //   <StyledSVG
    //     xmlns='http://www.w3.org/2000/svg'
    //     width='24'
    //     height='24'
    //     viewBox='0 0 24 24'
    //     fill='none'
    //     stroke='currentColor'
    //     strokeWidth='2'
    //     strokeLinecap='round'
    //     strokeLinejoin='round'
    //     className='lucide lucide-trash-2'
    //   >
    //     <path d='M3 6h18' />
    //     <path d='M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6' />
    //     <path d='M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2' />
    //     <line x1='10' x2='10' y1='11' y2='17' />
    //     <line x1='14' x2='14' y1='11' y2='17' />
    //   </StyledSVG>
    // );
    // const garbageSVG15 = (
    //   <StyledSVG
    //     xmlns='http://www.w3.org/2000/svg'
    //     width='15'
    //     height='15'
    //     viewBox='0 0 15 15'
    //     fill='none'
    //     stroke='currentColor'
    //     strokeWidth='1.33333'
    //     strokeLinecap='round'
    //     strokeLinejoin='round'
    //     className='lucide lucide-trash-2'
    //   >
    //     <path d='M2 4h11' />
    //     <path d='M12.5 4v9.33333c0 .66667-.66667 1.33333-1.33333 1.33333H3.83333C3.16667 15 2.5 14.33333 2.5 13.33333V4' />
    //     <path d='M5.33333 4V3c0-.66667.66667-1.33333 1.33334-1.33333h2.66666c.66667 0 1.33333.66666 1.33333 1.33333v1' />
    //     <line x1='6.66667' y1='7.33333' x2='6.66667' y2='11.33333' />
    //     <line x1='9.33333' y1='7.33333' x2='9.33333' y2='11.33333' />
    //   </StyledSVG>
    // );
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($e39b83e0b57a38fe$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                            children: "Permalink"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                            children: "Title"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                            children: "Date"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                            children: "G"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                            children: "F"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                            children: "Preview"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                            children: "Delete"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                children: userQueries.map((query, index)=>{
                    const displayMatrix = JSON.parse(query["MATRIX_DATA"]["S"])["riordan group elem"];
                    const matrixElem = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$MatrixTable, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                            children: displayMatrix.map((row, rowIndex)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                    children: row.map((num, colIndex)=>{
                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$MatrixCell, {
                                            $row: rowIndex + 1,
                                            $col: colIndex + 1,
                                            children: num
                                        }, `${rowIndex},${colIndex + 1}`);
                                    })
                                }, `row${rowIndex}`);
                            })
                        }, "matrixbody")
                    });
                    const previewElem = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
                        message: matrixElem,
                        side: "top",
                        sideOffset: 5,
                        alignOffset: "-500px",
                        arrowshiftX: "0",
                        arrowshiftY: "0",
                        omitInfo: true,
                        children: SearchSVG
                    });
                    const matrixTitle = query.TITLE ? query.TITLE.S : "(none)";
                    const displayGTerms = getSequenceDisplay(JSON.parse(query.G_SEQUENCE.S).slice(0, 10));
                    const displayFTerms = getSequenceDisplay(JSON.parse(query.F_SEQUENCE.S).slice(0, 10));
                    const matrixId = query.MATRIX_SHAREID.S;
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$Permalink, {
                                    href: `/?${matrixId}`,
                                    children: linkSVG24
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                                children: matrixTitle
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                                children: (0, $6531107febf5e71a$export$3ae94a2503e890a1)(query.CREATED_AT.S)
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                                children: displayGTerms
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                                children: displayFTerms
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$Preview, {
                                    children: previewElem
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e39b83e0b57a38fe$var$TDWrapper, {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $331b238b8b7c8b95$export$2e2bcd8739ae039), {
                                    matrixId: matrixId,
                                    deleteQuery: deleteQuery
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}
var $e39b83e0b57a38fe$export$2e2bcd8739ae039 = $e39b83e0b57a38fe$var$UserHistory;
const $e39b83e0b57a38fe$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  cursor: pointer;
`;
const $e39b83e0b57a38fe$var$Preview = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-left: 15px;
`;
const $e39b83e0b57a38fe$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  background-color: var(--user-history-cell-background);
  border-collapse: collapse;
  border: 1.5px solid var(--mini-number-box-border-color);
  width: fit-content;
  margin-top: 200px;
  margin-right: 30px;
  margin-bottom: 300px;
`;
const $e39b83e0b57a38fe$var$TDWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  border: 1px solid var(--mini-number-box-border-color);
  padding: 8px;
`;
const $e39b83e0b57a38fe$var$Permalink = (0, $e484c752f3f06549$export$2e2bcd8739ae039).a`
  text-decoration: none;
  padding-left: 20px;

  &:visited {
    color: blue;
    text-decoration: none;
  }
`;
const $e39b83e0b57a38fe$var$MiniNumberBoxWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: ${(p)=>p.disabled ? "default" : "text"};
  background-color: var(--mini-number-box-background-color);
  border-radius: var(--mini-number-box-border-radius);
  min-width: var(--mini-number-box-width);
  height: var(--mini-number-box-height);
  margin: 1px;
  border: 1px solid var(--mini-number-box-border-color);
  z-index: 1;
  /* padding: 10%; */
`;
const $e39b83e0b57a38fe$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--mini-number-box-font-color);
  color: var(--mini-number-box-font-color);
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $e39b83e0b57a38fe$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
`;
const $e39b83e0b57a38fe$var$MatrixTable = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  border-spacing: 0px;
  border-collapse: collapse;
`;
const $e39b83e0b57a38fe$var$MatrixRow = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr``;
const $e39b83e0b57a38fe$var$MatrixCell = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  border: 1px solid var(--number-box-border-color);
  min-width: 60px;
  height: 50px;
  text-align: center;
  background-color: ${(p)=>p.$col === 0 || p.$row === 0 ? "var(--select-td-background)" : p.$row > 0 && p.$col > p.$row ? "var(--matrix-cell-background-color)" : "black"};

  background-image: ${(p)=>p.$col === 0 || p.$row === 0 ? "revert" : p.$col > p.$row ? "var(--box-gradient)" : "revert"};
  color: ${(p)=>p.$row > 0 && p.$col > p.$row ? "var(--number-box-font-color)" : "white"};
`;







var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");
function $57084659f555c894$var$_extends() {
    $57084659f555c894$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $57084659f555c894$var$_extends.apply(this, arguments);
}
function $57084659f555c894$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $57084659f555c894$var$useOnMount(callback) {
    (0, $bh6RR.useEffect)(callback, []);
}

function $57084659f555c894$export$a34349420ba3cec8(src, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$volume = _ref2.volume, volume = _ref2$volume === void 0 ? 1 : _ref2$volume, _ref2$playbackRate = _ref2.playbackRate, playbackRate = _ref2$playbackRate === void 0 ? 1 : _ref2$playbackRate, _ref2$soundEnabled = _ref2.soundEnabled, soundEnabled = _ref2$soundEnabled === void 0 ? true : _ref2$soundEnabled, _ref2$interrupt = _ref2.interrupt, interrupt = _ref2$interrupt === void 0 ? false : _ref2$interrupt, onload = _ref2.onload, delegated = $57084659f555c894$var$_objectWithoutPropertiesLoose(_ref2, [
        "id",
        "volume",
        "playbackRate",
        "soundEnabled",
        "interrupt",
        "onload"
    ]);
    var HowlConstructor = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null), duration = _React$useState[0], setDuration = _React$useState[1];
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null), sound = _React$useState2[0], setSound = _React$useState2[1];
    var handleLoad = function handleLoad() {
        if (typeof onload === "function") // @ts-ignore
        onload.call(this);
        if (isMounted.current) // @ts-ignore
        setDuration(this.duration() * 1000);
         // @ts-ignore
        setSound(this);
    }; // We want to lazy-load Howler, since sounds can't play on load anyway.
    $57084659f555c894$var$useOnMount(function() {
        (parcelRequire("3vQgY")).then(function(mod) {
            if (!isMounted.current) {
                var _mod$Howl;
                // Depending on the module system used, `mod` might hold
                // the export directly, or it might be under `default`.
                HowlConstructor.current = (_mod$Howl = mod.Howl) !== null && _mod$Howl !== void 0 ? _mod$Howl : mod["default"].Howl;
                isMounted.current = true;
                new HowlConstructor.current($57084659f555c894$var$_extends({
                    src: Array.isArray(src) ? src : [
                        src
                    ],
                    volume: volume,
                    rate: playbackRate,
                    onload: handleLoad
                }, delegated));
            }
        });
        return function() {
            isMounted.current = false;
        };
    }); // When the `src` changes, we have to do a whole thing where we recreate
    // the Howl instance. This is because Howler doesn't expose a way to
    // tweak the sound
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        if (HowlConstructor.current && sound) setSound(new HowlConstructor.current($57084659f555c894$var$_extends({
            src: Array.isArray(src) ? src : [
                src
            ],
            volume: volume,
            onload: handleLoad
        }, delegated)));
         // The linter wants to run this effect whenever ANYTHING changes,
    // but very specifically I only want to recreate the Howl instance
    // when the `src` changes. Other changes should have no effect.
    // Passing array to the useEffect dependencies list will result in
    // ifinite loop so we need to stringify it, for more details check
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(src)
    ]); // Whenever volume/playbackRate are changed, change those properties
    // on the sound instance.
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        if (sound) {
            sound.volume(volume);
            sound.rate(playbackRate);
        } // A weird bug means that including the `sound` here can trigger an
    // error on unmount, where the state loses track of the sprites??
    // No idea, but anyway I don't need to re-run this if only the `sound`
    // changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        volume,
        playbackRate
    ]);
    var play = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(options) {
        if (typeof options === "undefined") options = {};
        if (!sound || !soundEnabled && !options.forceSoundEnabled) return;
        if (interrupt) sound.stop();
        if (options.playbackRate) sound.rate(options.playbackRate);
        sound.play(options.id);
    }, [
        sound,
        soundEnabled,
        interrupt
    ]);
    var stop = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(id) {
        if (!sound) return;
        sound.stop(id);
    }, [
        sound
    ]);
    var pause = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(id) {
        if (!sound) return;
        sound.pause(id);
    }, [
        sound
    ]);
    var returnedValue = [
        play,
        {
            sound: sound,
            stop: stop,
            pause: pause,
            duration: duration
        }
    ];
    return returnedValue;
}
var $57084659f555c894$export$2e2bcd8739ae039 = $57084659f555c894$export$a34349420ba3cec8;




var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $751885f374b03b87$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}









var $bh6RR = parcelRequire("bh6RR");
const $24c5db9b917dc8b0$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $24c5db9b917dc8b0$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($24c5db9b917dc8b0$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $24c5db9b917dc8b0$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $bh6RR.useContext)($24c5db9b917dc8b0$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $24c5db9b917dc8b0$export$2881499e37b75b9a = $24c5db9b917dc8b0$export$c760c09fdd558351;


const $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$Collection, $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$useCollection, $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $751885f374b03b87$export$c74125a8e3af6bb2)($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $0c1db1251143a899$export$c7109489551a4f4] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $0c1db1251143a899$export$8699f7c8af148338 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($0c1db1251143a899$export$8699f7c8af148338, {
    displayName: $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $24c5db9b917dc8b0$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $bh6RR.useState)(false);
    const handleEntryFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $bh6RR.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $bh6RR.useState)(0);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $bh6RR.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $bh6RR.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $bh6RR.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $bh6RR.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $0c1db1251143a899$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    (0, $bh6RR.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($0c1db1251143a899$export$ab9df7c53fe8454, {
    displayName: $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $0c1db1251143a899$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $0c1db1251143a899$export$be92b6f5f03c0fe9 = $0c1db1251143a899$export$8699f7c8af148338;
const $0c1db1251143a899$export$6d08773d2e66f8f2 = $0c1db1251143a899$export$ab9df7c53fe8454;







/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$cddb0ca76cb01c25$var$$69cb30bb0017df05$var$createTabsContext, $cddb0ca76cb01c25$export$355f5bd209d7b13a] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TABS_NAME, [
    (0, $0c1db1251143a899$export$c7109489551a4f4)
]);
const $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$useRovingFocusGroupScope = (0, $0c1db1251143a899$export$c7109489551a4f4)();
const [$cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TabsProvider, $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$useTabsContext] = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$createTabsContext($cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TABS_NAME);
const $cddb0ca76cb01c25$export$b2539bed5023c21c = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = "horizontal" , dir: dir , activationMode: activationMode = "automatic" , ...tabsProps } = props;
    const direction = (0, $24c5db9b917dc8b0$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($cddb0ca76cb01c25$export$b2539bed5023c21c, {
    displayName: $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $cddb0ca76cb01c25$export$9712d22edc0d78c1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$useTabsContext($cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0c1db1251143a899$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($cddb0ca76cb01c25$export$9712d22edc0d78c1, {
    displayName: $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $cddb0ca76cb01c25$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$useTabsContext($cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0c1db1251143a899$export$6d08773d2e66f8f2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? "active" : "inactive",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else event.preventDefault();
        }),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if ([
                " ",
                "Enter"
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== "manual";
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($cddb0ca76cb01c25$export$8114b9fdfdf9f3ba, {
    displayName: $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $cddb0ca76cb01c25$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$useTabsContext($cddb0ca76cb01c25$var$$69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0, $bh6RR.useRef)(isSelected);
    (0, $bh6RR.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected
    }, ({ present: present  })=>/*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
            "data-state": isSelected ? "active" : "inactive",
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? "0s" : undefined
            }
        }), present && children));
});
/*#__PURE__*/ Object.assign($cddb0ca76cb01c25$export$bd905d70e8fd2ebb, {
    displayName: $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $cddb0ca76cb01c25$var$$69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $cddb0ca76cb01c25$export$be92b6f5f03c0fe9 = $cddb0ca76cb01c25$export$b2539bed5023c21c;
const $cddb0ca76cb01c25$export$54c2e3dc7acea9f5 = $cddb0ca76cb01c25$export$9712d22edc0d78c1;
const $cddb0ca76cb01c25$export$41fb9f06171c75f4 = $cddb0ca76cb01c25$export$8114b9fdfdf9f3ba;
const $cddb0ca76cb01c25$export$7c6e2c02157bb7d2 = $cddb0ca76cb01c25$export$bd905d70e8fd2ebb;


const $bfafc62980e59835$var$AuthDialog = ()=>{
    const [email, setEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [firstname, setFirstname] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [lastname, setLastname] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [password, setPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [confirmPassword, setConfirmPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const { handleLogin: handleLogin , handleSignUp: handleSignUp , handleConfirmSignUp: handleConfirmSignUp , setIsAuthModalOpen: setIsAuthModalOpen  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const [dialogOpen, setDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [awaitingConfirmation, setAwaitingConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const passwordIsLongEnough = password.length >= 8;
    const passwordContainsNumber = /\d/.test(password);
    const passwordContainsSpecialCharacter = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
    const passwordContainsUppercase = /[A-Z]/.test(password);
    const passwordContainsLowercase = /[a-z]/.test(password);
    const passwordMatchesConfirm = password === confirmPassword && password.length > 0;
    const passwordIsValid = passwordIsLongEnough && passwordContainsNumber && passwordContainsSpecialCharacter && passwordContainsUppercase && passwordContainsLowercase && passwordMatchesConfirm;
    function handleLoginAttempt() {
        handleLogin(email, password);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    function handleSignUpAttempt() {
        if (!passwordIsValid) {
            window.alert("Password is not valid! Review the requirements!");
            return;
        }
        if (email === "") {
            window.alert("Email not valid!");
            return;
        }
        if (firstname === "" || lastname === "") {
            window.alert("Must provide a first and last name!");
            return;
        }
        handleSignUp(email, password, firstname, lastname);
        setAwaitingConfirmation(true);
    }
    function handleConfirmSignUpAttempt() {
        handleConfirmSignUp(email, code);
        setAwaitingConfirmation(false);
        setTimeout(()=>{
            handleLogin(email, password);
        }, 1000);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    const signUpForm = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "Text",
                children: "Create an account!"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "email",
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: email,
                        onChange: (e)=>setEmail(e.target.value),
                        className: "Input",
                        id: "email",
                        type: "email"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "firstname",
                        children: "First Name"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: firstname,
                        onChange: (e)=>setFirstname(e.target.value),
                        className: "Input",
                        id: "firstname",
                        type: "text"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "lastname",
                        children: "Last Name"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: lastname,
                        onChange: (e)=>setLastname(e.target.value),
                        className: "Input",
                        id: "lastname",
                        type: "text"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "password",
                        children: "Password"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: password,
                        onChange: (e)=>setPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "confirmpassword",
                        children: "Confirm Password"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: confirmPassword,
                        onChange: (e)=>setConfirmPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            passwordIsLongEnough ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">= 8 characters long"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "< 8 characters long!"
            }),
            passwordContainsNumber ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 number"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 number!"
            }),
            passwordContainsSpecialCharacter ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 special character"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 special character"
            }),
            passwordContainsUppercase ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 uppercase letter"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 uppercase letter"
            }),
            passwordContainsLowercase ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 lowercase letter"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 lowercase letter"
            }),
            passwordMatchesConfirm ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: "Password matches confirm"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "Password & confirm don't match"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: handleSignUpAttempt,
                    className: "Button green",
                    children: "Sign Up"
                })
            })
        ]
    });
    const confirmForm = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "Text",
                children: `Enter Confirmation Code Sent to ${email}`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "code",
                        children: "Confirmation Code"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        value: code,
                        onChange: (e)=>setCode(e.target.value),
                        className: "Input",
                        id: "code",
                        type: "text"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: handleConfirmSignUpAttempt,
                    className: "Button green",
                    children: "Confirm"
                })
            })
        ]
    });
    const signUpTabContent = awaitingConfirmation ? confirmForm : signUpForm;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$be92b6f5f03c0fe9, {
        open: dialogOpen,
        onOpenChange: ()=>{
            setDialogOpen((oldValue)=>{
                setIsAuthModalOpen(!oldValue);
                return !oldValue;
            });
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "Button violet",
                    children: "Login"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$c6fdb837b070b4ff, {
                        className: "AuthDialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$7c6e2c02157bb7d2, {
                        className: "AuthDialogContent",
                        asChild: true,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($cddb0ca76cb01c25$export$be92b6f5f03c0fe9, {
                            className: "TabsRoot",
                            defaultValue: "tab1",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($cddb0ca76cb01c25$export$54c2e3dc7acea9f5, {
                                    className: "TabsList",
                                    "aria-label": "Manage your account",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($cddb0ca76cb01c25$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab1",
                                            children: "Log In"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($cddb0ca76cb01c25$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab2",
                                            children: "Sign Up"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($cddb0ca76cb01c25$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab1",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                            className: "Text",
                                            children: "Your username is your email."
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "email",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    value: email,
                                                    onChange: (e)=>setEmail(e.target.value),
                                                    className: "Input",
                                                    id: "email",
                                                    type: "email"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "password",
                                                    children: "Password"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    className: "Input",
                                                    id: "password",
                                                    type: "password"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                marginTop: 20,
                                                justifyContent: "flex-end"
                                            },
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: handleLoginAttempt,
                                                className: "Button green",
                                                children: "Log In"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($cddb0ca76cb01c25$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab2",
                                    children: signUpTabContent
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $bfafc62980e59835$export$2e2bcd8739ae039 = $bfafc62980e59835$var$AuthDialog;




var $9451fc84508b70b9$exports = {};

$9451fc84508b70b9$exports = new URL((parcelRequire("kyEFX")).resolve("hjTt7"), import.meta.url).toString();


var $342ac1c5191b15fb$exports = {};

$342ac1c5191b15fb$exports = new URL((parcelRequire("kyEFX")).resolve("dI7BD"), import.meta.url).toString();


function $37b5ded325cf8cdb$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}


var $a343d757d782559e$exports = {};
"use strict";

$a343d757d782559e$exports = (parcelRequire("kIFeU"));


var $1e26d3f39a4684b5$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1e26d3f39a4684b5$var$ReactIs, $1e26d3f39a4684b5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1e26d3f39a4684b5$exports = (parcelRequire("7N52U"))();


function $bad2ae7414cae43d$export$2e2bcd8739ae039() {
    $bad2ae7414cae43d$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bad2ae7414cae43d$export$2e2bcd8739ae039.apply(this, arguments);
}


function $e20cbad4211dd813$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $e20cbad4211dd813$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $e20cbad4211dd813$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $e20cbad4211dd813$var$isAbsolute(to);
    var isFromAbs = from && $e20cbad4211dd813$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $e20cbad4211dd813$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $e20cbad4211dd813$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $e20cbad4211dd813$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $e20cbad4211dd813$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$e20cbad4211dd813$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $e20cbad4211dd813$export$2e2bcd8739ae039 = $e20cbad4211dd813$var$resolvePathname;


function $458fa546ee299b6d$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $458fa546ee299b6d$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $458fa546ee299b6d$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $458fa546ee299b6d$var$valueOf(a);
        var bValue = $458fa546ee299b6d$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $458fa546ee299b6d$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $458fa546ee299b6d$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $458fa546ee299b6d$export$2e2bcd8739ae039 = $458fa546ee299b6d$var$valueEqual;



var $60b7ec5b6c13fef1$var$isProduction = true;
var $60b7ec5b6c13fef1$var$prefix = "Invariant failed";
function $60b7ec5b6c13fef1$var$invariant(condition, message) {
    if (condition) return;
    if ($60b7ec5b6c13fef1$var$isProduction) throw new Error($60b7ec5b6c13fef1$var$prefix);
    throw new Error($60b7ec5b6c13fef1$var$prefix + ": " + (message || ""));
}
var $60b7ec5b6c13fef1$export$2e2bcd8739ae039 = $60b7ec5b6c13fef1$var$invariant;


function $f464b1698530ce4d$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $f464b1698530ce4d$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $f464b1698530ce4d$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $f464b1698530ce4d$var$stripBasename(path, prefix) {
    return $f464b1698530ce4d$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $f464b1698530ce4d$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $f464b1698530ce4d$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $f464b1698530ce4d$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $f464b1698530ce4d$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $f464b1698530ce4d$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $e20cbad4211dd813$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $f464b1698530ce4d$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $458fa546ee299b6d$export$2e2bcd8739ae039)(a.state, b.state);
}
function $f464b1698530ce4d$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $f464b1698530ce4d$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $f464b1698530ce4d$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $f464b1698530ce4d$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $f464b1698530ce4d$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $f464b1698530ce4d$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $f464b1698530ce4d$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $f464b1698530ce4d$var$PopStateEvent = "popstate";
var $f464b1698530ce4d$var$HashChangeEvent = "hashchange";
function $f464b1698530ce4d$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $f464b1698530ce4d$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$f464b1698530ce4d$var$canUseDOM && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $f464b1698530ce4d$var$supportsHistory();
    var needsHashChangeListener = !$f464b1698530ce4d$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $f464b1698530ce4d$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $f464b1698530ce4d$var$stripTrailingSlash($f464b1698530ce4d$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $f464b1698530ce4d$var$stripBasename(path, basename);
        return $f464b1698530ce4d$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $f464b1698530ce4d$var$createTransitionManager();
    function setState(nextState) {
        (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($f464b1698530ce4d$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($f464b1698530ce4d$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($f464b1698530ce4d$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $f464b1698530ce4d$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $f464b1698530ce4d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $f464b1698530ce4d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($f464b1698530ce4d$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($f464b1698530ce4d$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($f464b1698530ce4d$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($f464b1698530ce4d$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $f464b1698530ce4d$var$HashChangeEvent$1 = "hashchange";
var $f464b1698530ce4d$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $f464b1698530ce4d$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $f464b1698530ce4d$var$stripLeadingSlash,
        decodePath: $f464b1698530ce4d$var$addLeadingSlash
    },
    slash: {
        encodePath: $f464b1698530ce4d$var$addLeadingSlash,
        decodePath: $f464b1698530ce4d$var$addLeadingSlash
    }
};
function $f464b1698530ce4d$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $f464b1698530ce4d$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $f464b1698530ce4d$var$pushHashPath(path) {
    window.location.hash = path;
}
function $f464b1698530ce4d$var$replaceHashPath(path) {
    window.location.replace($f464b1698530ce4d$var$stripHash(window.location.href) + "#" + path);
}
function $f464b1698530ce4d$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$f464b1698530ce4d$var$canUseDOM && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $f464b1698530ce4d$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $f464b1698530ce4d$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $f464b1698530ce4d$var$stripTrailingSlash($f464b1698530ce4d$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $f464b1698530ce4d$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($f464b1698530ce4d$var$getHashPath());
        if (basename) path = $f464b1698530ce4d$var$stripBasename(path, basename);
        return $f464b1698530ce4d$export$90c043f1c57770b8(path);
    }
    var transitionManager = $f464b1698530ce4d$var$createTransitionManager();
    function setState(nextState) {
        (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $f464b1698530ce4d$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $f464b1698530ce4d$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $f464b1698530ce4d$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($f464b1698530ce4d$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($f464b1698530ce4d$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $f464b1698530ce4d$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $f464b1698530ce4d$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $f464b1698530ce4d$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $f464b1698530ce4d$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $f464b1698530ce4d$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $f464b1698530ce4d$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $f464b1698530ce4d$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $f464b1698530ce4d$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $f464b1698530ce4d$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($f464b1698530ce4d$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $f464b1698530ce4d$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $f464b1698530ce4d$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $f464b1698530ce4d$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $f464b1698530ce4d$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($f464b1698530ce4d$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($f464b1698530ce4d$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($f464b1698530ce4d$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $f464b1698530ce4d$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $f464b1698530ce4d$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $f464b1698530ce4d$var$createTransitionManager();
    function setState(nextState) {
        (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $f464b1698530ce4d$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $f464b1698530ce4d$export$90c043f1c57770b8(entry, undefined, createKey()) : $f464b1698530ce4d$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $f464b1698530ce4d$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $f464b1698530ce4d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $f464b1698530ce4d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $f464b1698530ce4d$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




function $dd1d85cbc6006405$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}




var $2823be4352df424d$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $2823be4352df424d$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
function $2823be4352df424d$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $2823be4352df424d$var$commonjsGlobal[key] = ($2823be4352df424d$var$commonjsGlobal[key] || 0) + 1;
}
function $2823be4352df424d$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $2823be4352df424d$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $2823be4352df424d$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $2823be4352df424d$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $2823be4352df424d$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $dd1d85cbc6006405$export$2e2bcd8739ae039)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $2823be4352df424d$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($2823be4352df424d$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $2823be4352df424d$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $a343d757d782559e$exports.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($1e26d3f39a4684b5$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $dd1d85cbc6006405$export$2e2bcd8739ae039)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $2823be4352df424d$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $2823be4352df424d$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $2823be4352df424d$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $a343d757d782559e$exports.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($1e26d3f39a4684b5$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $2823be4352df424d$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createContext || $2823be4352df424d$var$createReactContext;
var $2823be4352df424d$export$2e2bcd8739ae039 = $2823be4352df424d$var$index;




var $2f9e8fd0ae91f4ee$exports = {};
var $56fcbe267ad2a082$exports = {};
$56fcbe267ad2a082$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $2f9e8fd0ae91f4ee$exports = $2f9e8fd0ae91f4ee$var$pathToRegexp;
$2f9e8fd0ae91f4ee$exports.parse = $2f9e8fd0ae91f4ee$var$parse;
$2f9e8fd0ae91f4ee$exports.compile = $2f9e8fd0ae91f4ee$var$compile;
$2f9e8fd0ae91f4ee$exports.tokensToFunction = $2f9e8fd0ae91f4ee$var$tokensToFunction;
$2f9e8fd0ae91f4ee$exports.tokensToRegExp = $2f9e8fd0ae91f4ee$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $2f9e8fd0ae91f4ee$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $2f9e8fd0ae91f4ee$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $2f9e8fd0ae91f4ee$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $2f9e8fd0ae91f4ee$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $2f9e8fd0ae91f4ee$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $2f9e8fd0ae91f4ee$var$compile(str, options) {
    return $2f9e8fd0ae91f4ee$var$tokensToFunction($2f9e8fd0ae91f4ee$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $2f9e8fd0ae91f4ee$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $2f9e8fd0ae91f4ee$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $2f9e8fd0ae91f4ee$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $2f9e8fd0ae91f4ee$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $2f9e8fd0ae91f4ee$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($56fcbe267ad2a082$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $2f9e8fd0ae91f4ee$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $2f9e8fd0ae91f4ee$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $2f9e8fd0ae91f4ee$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $2f9e8fd0ae91f4ee$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $2f9e8fd0ae91f4ee$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $2f9e8fd0ae91f4ee$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $2f9e8fd0ae91f4ee$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2f9e8fd0ae91f4ee$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($2f9e8fd0ae91f4ee$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $2f9e8fd0ae91f4ee$var$flags(options));
    return $2f9e8fd0ae91f4ee$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2f9e8fd0ae91f4ee$var$stringToRegexp(path, keys, options) {
    return $2f9e8fd0ae91f4ee$var$tokensToRegExp($2f9e8fd0ae91f4ee$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $2f9e8fd0ae91f4ee$var$tokensToRegExp(tokens, keys, options) {
    if (!$56fcbe267ad2a082$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $2f9e8fd0ae91f4ee$var$escapeString(token);
        else {
            var prefix = $2f9e8fd0ae91f4ee$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $2f9e8fd0ae91f4ee$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $2f9e8fd0ae91f4ee$var$attachKeys(new RegExp("^" + route, $2f9e8fd0ae91f4ee$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $2f9e8fd0ae91f4ee$var$pathToRegexp(path, keys, options) {
    if (!$56fcbe267ad2a082$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $2f9e8fd0ae91f4ee$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($56fcbe267ad2a082$exports(path)) return $2f9e8fd0ae91f4ee$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $2f9e8fd0ae91f4ee$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $2df64f243bf03de1$exports = {};
"use strict";

$2df64f243bf03de1$exports = (parcelRequire("55YFC"));


function $40832161664b4b7d$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $bf2b0338e4d45cfd$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $bf2b0338e4d45cfd$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $bf2b0338e4d45cfd$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $bf2b0338e4d45cfd$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $bf2b0338e4d45cfd$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $bf2b0338e4d45cfd$var$TYPE_STATICS = {};
$bf2b0338e4d45cfd$var$TYPE_STATICS[$2df64f243bf03de1$exports.ForwardRef] = $bf2b0338e4d45cfd$var$FORWARD_REF_STATICS;
$bf2b0338e4d45cfd$var$TYPE_STATICS[$2df64f243bf03de1$exports.Memo] = $bf2b0338e4d45cfd$var$MEMO_STATICS;
function $bf2b0338e4d45cfd$var$getStatics(component) {
    // React v16.11 and below
    if ($2df64f243bf03de1$exports.isMemo(component)) return $bf2b0338e4d45cfd$var$MEMO_STATICS;
     // React v16.12 and above
    return $bf2b0338e4d45cfd$var$TYPE_STATICS[component["$$typeof"]] || $bf2b0338e4d45cfd$var$REACT_STATICS;
}
var $bf2b0338e4d45cfd$var$defineProperty = Object.defineProperty;
var $bf2b0338e4d45cfd$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $bf2b0338e4d45cfd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $bf2b0338e4d45cfd$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $bf2b0338e4d45cfd$var$getPrototypeOf = Object.getPrototypeOf;
var $bf2b0338e4d45cfd$var$objectPrototype = Object.prototype;
function $bf2b0338e4d45cfd$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($bf2b0338e4d45cfd$var$objectPrototype) {
            var inheritedComponent = $bf2b0338e4d45cfd$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $bf2b0338e4d45cfd$var$objectPrototype) $bf2b0338e4d45cfd$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $bf2b0338e4d45cfd$var$getOwnPropertyNames(sourceComponent);
        if ($bf2b0338e4d45cfd$var$getOwnPropertySymbols) keys = keys.concat($bf2b0338e4d45cfd$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $bf2b0338e4d45cfd$var$getStatics(targetComponent);
        var sourceStatics = $bf2b0338e4d45cfd$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$bf2b0338e4d45cfd$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $bf2b0338e4d45cfd$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $bf2b0338e4d45cfd$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$bf2b0338e4d45cfd$exports = $bf2b0338e4d45cfd$var$hoistNonReactStatics;


// TODO: Replace with React.createContext once we can assume React 16+
var $425ef4756eb915c9$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $2823be4352df424d$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $425ef4756eb915c9$export$c213558b66925821 = /*#__PURE__*/ $425ef4756eb915c9$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $425ef4756eb915c9$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $2823be4352df424d$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $425ef4756eb915c9$export$63baa8ccbe60bb07 = /*#__PURE__*/ $425ef4756eb915c9$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $425ef4756eb915c9$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $425ef4756eb915c9$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $f464b1698530ce4d$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
var $425ef4756eb915c9$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $425ef4756eb915c9$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $425ef4756eb915c9$var$messageType;
var $425ef4756eb915c9$var$cache = {};
var $425ef4756eb915c9$var$cacheLimit = 10000;
var $425ef4756eb915c9$var$cacheCount = 0;
function $425ef4756eb915c9$var$compilePath(path) {
    if ($425ef4756eb915c9$var$cache[path]) return $425ef4756eb915c9$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($2f9e8fd0ae91f4ee$exports))).compile(path);
    if ($425ef4756eb915c9$var$cacheCount < $425ef4756eb915c9$var$cacheLimit) {
        $425ef4756eb915c9$var$cache[path] = generator;
        $425ef4756eb915c9$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $425ef4756eb915c9$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $425ef4756eb915c9$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $425ef4756eb915c9$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $f464b1698530ce4d$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $425ef4756eb915c9$export$82476f982757e71e(to, computedMatch.params) : (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, to, {
            pathname: $425ef4756eb915c9$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $f464b1698530ce4d$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $f464b1698530ce4d$export$c3e8bb440bd55b18)(prevLocation, (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $425ef4756eb915c9$var$cache$1 = {};
var $425ef4756eb915c9$var$cacheLimit$1 = 10000;
var $425ef4756eb915c9$var$cacheCount$1 = 0;
function $425ef4756eb915c9$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $425ef4756eb915c9$var$cache$1[cacheKey] || ($425ef4756eb915c9$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($2f9e8fd0ae91f4ee$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($425ef4756eb915c9$var$cacheCount$1 < $425ef4756eb915c9$var$cacheLimit$1) {
        pathCache[path] = result;
        $425ef4756eb915c9$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $425ef4756eb915c9$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $425ef4756eb915c9$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $425ef4756eb915c9$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Children.count(children) === 0;
}
function $425ef4756eb915c9$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $425ef4756eb915c9$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $425ef4756eb915c9$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
function $425ef4756eb915c9$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $425ef4756eb915c9$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, location, {
        pathname: $425ef4756eb915c9$var$addLeadingSlash(basename) + location.pathname
    });
}
function $425ef4756eb915c9$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $425ef4756eb915c9$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $425ef4756eb915c9$var$createURL(location) {
    return typeof location === "string" ? location : (0, $f464b1698530ce4d$export$fe53371bee54353d)(location);
}
function $425ef4756eb915c9$var$staticHandler(methodName) {
    return function() {
        (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
    };
}
function $425ef4756eb915c9$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $425ef4756eb915c9$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $425ef4756eb915c9$var$noop;
        };
        _this.handleBlock = function() {
            return $425ef4756eb915c9$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $425ef4756eb915c9$var$addBasename(basename, (0, $f464b1698530ce4d$export$90c043f1c57770b8)(location));
        context.url = $425ef4756eb915c9$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $40832161664b4b7d$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $425ef4756eb915c9$var$addLeadingSlash(basename + $425ef4756eb915c9$var$createURL(path));
            },
            action: "POP",
            location: $425ef4756eb915c9$var$stripBasename(basename, (0, $f464b1698530ce4d$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $425ef4756eb915c9$var$staticHandler("go"),
            goBack: $425ef4756eb915c9$var$staticHandler("goBack"),
            goForward: $425ef4756eb915c9$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$55185c17a0fcbe46, (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $425ef4756eb915c9$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $425ef4756eb915c9$export$81336c211d5ff295(location.pathname, (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $425ef4756eb915c9$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $40832161664b4b7d$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($425ef4756eb915c9$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement(Component, (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bf2b0338e4d45cfd$exports)))(C, Component);
}
var $425ef4756eb915c9$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).useContext;
function $425ef4756eb915c9$export$3420e1dc2c4a518c() {
    return $425ef4756eb915c9$var$useContext($425ef4756eb915c9$export$c213558b66925821);
}
function $425ef4756eb915c9$export$45d76561a5302f2b() {
    return $425ef4756eb915c9$var$useContext($425ef4756eb915c9$export$63baa8ccbe60bb07).location;
}
function $425ef4756eb915c9$export$99eaa27ddbbb95ef() {
    var match = $425ef4756eb915c9$var$useContext($425ef4756eb915c9$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $425ef4756eb915c9$export$632be4bb944c1bc7(path) {
    var location = $425ef4756eb915c9$export$45d76561a5302f2b();
    var match = $425ef4756eb915c9$var$useContext($425ef4756eb915c9$export$63baa8ccbe60bb07).match;
    return path ? $425ef4756eb915c9$export$81336c211d5ff295(location.pathname, path) : match;
}
var $425ef4756eb915c9$var$global, $425ef4756eb915c9$var$key, $425ef4756eb915c9$var$buildNames, $425ef4756eb915c9$var$initialBuildName, $425ef4756eb915c9$var$secondaryBuildName;










/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $92e1a497b2510420$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $f464b1698530ce4d$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement((0, $425ef4756eb915c9$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $92e1a497b2510420$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $37b5ded325cf8cdb$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $f464b1698530ce4d$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement((0, $425ef4756eb915c9$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).Component);
var $92e1a497b2510420$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $92e1a497b2510420$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $f464b1698530ce4d$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $92e1a497b2510420$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $92e1a497b2510420$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).forwardRef;
if (typeof $92e1a497b2510420$var$forwardRef === "undefined") $92e1a497b2510420$var$forwardRef = $92e1a497b2510420$var$forwardRefShim;
function $92e1a497b2510420$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $92e1a497b2510420$var$LinkAnchor = $92e1a497b2510420$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $40832161664b4b7d$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$92e1a497b2510420$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($92e1a497b2510420$var$forwardRefShim !== $92e1a497b2510420$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $92e1a497b2510420$export$a6c7ac8248d6e38a = $92e1a497b2510420$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $92e1a497b2510420$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $40832161664b4b7d$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement((0, $425ef4756eb915c9$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $92e1a497b2510420$var$normalizeToLocation($92e1a497b2510420$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $92e1a497b2510420$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($92e1a497b2510420$var$forwardRefShim !== $92e1a497b2510420$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement(component, props);
    });
});
var $92e1a497b2510420$var$toType, $92e1a497b2510420$var$refType;
var $92e1a497b2510420$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $92e1a497b2510420$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).forwardRef;
if (typeof $92e1a497b2510420$var$forwardRef$1 === "undefined") $92e1a497b2510420$var$forwardRef$1 = $92e1a497b2510420$var$forwardRefShim$1;
function $92e1a497b2510420$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $92e1a497b2510420$export$b0d92dbee9b5b60d = $92e1a497b2510420$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $40832161664b4b7d$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement((0, $425ef4756eb915c9$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $60b7ec5b6c13fef1$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $92e1a497b2510420$var$normalizeToLocation($92e1a497b2510420$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $425ef4756eb915c9$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $92e1a497b2510420$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $bad2ae7414cae43d$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($92e1a497b2510420$var$forwardRefShim$1 !== $92e1a497b2510420$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a343d757d782559e$exports))).createElement($92e1a497b2510420$export$a6c7ac8248d6e38a, props);
    });
});
var $92e1a497b2510420$var$ariaCurrentType;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
function $ad536c13151ecfb5$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $48f750d71278f534$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $48f750d71278f534$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$48f750d71278f534$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $48f750d71278f534$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($48f750d71278f534$export$43e446d32b3d21af(...refs), refs);
}



var $bh6RR = parcelRequire("bh6RR");
function $b1676b1d27d1eee3$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $b1676b1d27d1eee3$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $b1676b1d27d1eee3$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $b1676b1d27d1eee3$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $7d3e2cbefcbe8b52$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $bh6RR.useRef)(callback);
    (0, $bh6RR.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $bh6RR.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $2ce63df780ef0595$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $2ce63df780ef0595$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $7d3e2cbefcbe8b52$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $bh6RR.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $2ce63df780ef0595$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0, $bh6RR.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $bh6RR.useRef)(value);
    const handleChange = (0, $7d3e2cbefcbe8b52$export$25bec8c6f54ee79a)(onChange);
    (0, $bh6RR.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $9f62ef58bf8892bf$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$9f62ef58bf8892bf$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $48f750d71278f534$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $9f62ef58bf8892bf$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $9f62ef58bf8892bf$export$d9f1ccf0bdb05d45;
}
function $9f62ef58bf8892bf$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $9f62ef58bf8892bf$export$be92b6f5f03c0fe9 = $9f62ef58bf8892bf$export$8c6ed5c666ac1360;


const $f69aca1675017c41$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $f69aca1675017c41$export$250ffa63cdc0d034 = $f69aca1675017c41$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $9f62ef58bf8892bf$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $f69aca1675017c41$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $f69aca1675017c41$export$be92b6f5f03c0fe9 = $f69aca1675017c41$export$250ffa63cdc0d034;




var $bh6RR = parcelRequire("bh6RR");
function $74eb8dfddc90e1e7$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $2a262ee5ae909699$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $2a262ee5ae909699$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $2a262ee5ae909699$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $2a262ee5ae909699$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $5fe5b498f51ddd8a$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $5fe5b498f51ddd8a$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$5fe5b498f51ddd8a$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $5fe5b498f51ddd8a$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($5fe5b498f51ddd8a$export$43e446d32b3d21af(...refs), refs);
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $3a95a2a2d2ca8dd5$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$3a95a2a2d2ca8dd5$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $5fe5b498f51ddd8a$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $3a95a2a2d2ca8dd5$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $3a95a2a2d2ca8dd5$export$d9f1ccf0bdb05d45;
}
function $3a95a2a2d2ca8dd5$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $3a95a2a2d2ca8dd5$export$be92b6f5f03c0fe9 = $3a95a2a2d2ca8dd5$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $0928e9a030d7dbc9$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $2a262ee5ae909699$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $5fe5b498f51ddd8a$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3a95a2a2d2ca8dd5$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const composedRefs = (0, $5fe5b498f51ddd8a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3a95a2a2d2ca8dd5$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $74397e510ea9ebe4$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $74397e510ea9ebe4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$74397e510ea9ebe4$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $74397e510ea9ebe4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($74397e510ea9ebe4$export$43e446d32b3d21af(...refs), refs);
}



var $bh6RR = parcelRequire("bh6RR");
function $ff62918149a22b5f$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $ff62918149a22b5f$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $ff62918149a22b5f$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $ff62918149a22b5f$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $bh6RR = parcelRequire("bh6RR");
const $87990fa25f891e42$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $87990fa25f891e42$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($87990fa25f891e42$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $87990fa25f891e42$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $bh6RR.useContext)($87990fa25f891e42$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $87990fa25f891e42$export$2881499e37b75b9a = $87990fa25f891e42$export$c760c09fdd558351;




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $ce8e1a73f7e1edbf$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$ce8e1a73f7e1edbf$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $74397e510ea9ebe4$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $ce8e1a73f7e1edbf$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $ce8e1a73f7e1edbf$export$d9f1ccf0bdb05d45;
}
function $ce8e1a73f7e1edbf$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $ce8e1a73f7e1edbf$export$be92b6f5f03c0fe9 = $ce8e1a73f7e1edbf$export$8c6ed5c666ac1360;


const $8b55fa05a208ecee$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8b55fa05a208ecee$export$250ffa63cdc0d034 = $8b55fa05a208ecee$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $ce8e1a73f7e1edbf$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8b55fa05a208ecee$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $8b55fa05a208ecee$export$be92b6f5f03c0fe9 = $8b55fa05a208ecee$export$250ffa63cdc0d034;




var $bh6RR = parcelRequire("bh6RR");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $6e0683946f0e154c$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $bh6RR.useRef)(callback);
    (0, $bh6RR.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $bh6RR.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $bh6RR = parcelRequire("bh6RR");

/**
 * Listens for when the escape key is down
 */ function $0eb4747d8e3a7f8e$export$3a72a57244d6e765(onEscapeKeyDownProp) {
    const onEscapeKeyDown = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $bh6RR.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $dbfdf744c6d639a4$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0, $bh6RR.useContext)($dbfdf744c6d639a4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $bh6RR.useState)(null);
    const [, force] = (0, $bh6RR.useState)({});
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    const focusOutside = $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    (0, $0eb4747d8e3a7f8e$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$originalBodyPointerEvents = document.body.style.pointerEvents;
                document.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) document.body.style.pointerEvents = $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($dbfdf744c6d639a4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($dbfdf744c6d639a4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($dbfdf744c6d639a4$export$177fb62ff3ec1f22, {
    displayName: $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $dbfdf744c6d639a4$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = (0, $bh6RR.useContext)($dbfdf744c6d639a4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($dbfdf744c6d639a4$export$4d5eb2109db14228, {
    displayName: $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
    const handlePointerDownOutside = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    const handleClickRef = (0, $bh6RR.useRef)(()=>{});
    (0, $bh6RR.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($dbfdf744c6d639a4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    document.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    document.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            document.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            document.removeEventListener("pointerdown", handlePointerDown);
            document.removeEventListener("click", handleClickRef.current);
        };
    }, [
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
    const handleFocusOutside = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($dbfdf744c6d639a4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        document.addEventListener("focusin", handleFocus);
        return ()=>document.removeEventListener("focusin", handleFocus);
    }, [
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($dbfdf744c6d639a4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $dbfdf744c6d639a4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $8b55fa05a208ecee$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $dbfdf744c6d639a4$export$be92b6f5f03c0fe9 = $dbfdf744c6d639a4$export$177fb62ff3ec1f22;
const $dbfdf744c6d639a4$export$aecb2ddcb55c95be = $dbfdf744c6d639a4$export$4d5eb2109db14228;



var $bh6RR = parcelRequire("bh6RR");
/** Number of components which have requested interest to have focus guards */ let $6b87294b606edc3e$var$$3db38b7d1fb3fe6a$var$count = 0;
function $6b87294b606edc3e$export$ac5b58043b79449b(props) {
    $6b87294b606edc3e$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $6b87294b606edc3e$export$b7ece24a22aeda8c() {
    (0, $bh6RR.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $6b87294b606edc3e$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $6b87294b606edc3e$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $6b87294b606edc3e$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($6b87294b606edc3e$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $6b87294b606edc3e$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $6b87294b606edc3e$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $6b87294b606edc3e$export$be92b6f5f03c0fe9 = $6b87294b606edc3e$export$ac5b58043b79449b;




var $bh6RR = parcelRequire("bh6RR");



const $4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $4b213624ced1593f$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $4b213624ced1593f$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $4b213624ced1593f$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0, $bh6RR.useState)(null);
    const onMountAutoFocus = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $bh6RR.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $bh6RR.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                if (!container1.contains(event.relatedTarget)) $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (container1) {
            $4b213624ced1593f$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $4b213624ced1593f$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $4b213624ced1593f$var$$d3863c46a17e8a28$var$focusFirst($4b213624ced1593f$var$$d3863c46a17e8a28$var$removeLinks($4b213624ced1593f$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $4b213624ced1593f$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($4b213624ced1593f$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $4b213624ced1593f$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $bh6RR.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $4b213624ced1593f$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($4b213624ced1593f$export$20e40289641fbbb6, {
    displayName: $4b213624ced1593f$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $4b213624ced1593f$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $4b213624ced1593f$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $4b213624ced1593f$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $4b213624ced1593f$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $4b213624ced1593f$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $4b213624ced1593f$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $4b213624ced1593f$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$4b213624ced1593f$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $4b213624ced1593f$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $4b213624ced1593f$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $4b213624ced1593f$var$$d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $4b213624ced1593f$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $4b213624ced1593f$var$$d3863c46a17e8a28$var$focusScopesStack = $4b213624ced1593f$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $4b213624ced1593f$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $4b213624ced1593f$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $4b213624ced1593f$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $4b213624ced1593f$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $4b213624ced1593f$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $4b213624ced1593f$export$be92b6f5f03c0fe9 = $4b213624ced1593f$export$20e40289641fbbb6;



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $bfc439fb5a9be4e2$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};


const $657600ce222ab206$var$$1746a345f3d73bb7$var$useReactId = $bh6RR["useId".toString()] || (()=>undefined);
let $657600ce222ab206$var$$1746a345f3d73bb7$var$count = 0;
function $657600ce222ab206$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($657600ce222ab206$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $bfc439fb5a9be4e2$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($657600ce222ab206$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}




var $bh6RR = parcelRequire("bh6RR");
function $926256944d3cd62f$var$getSide(placement) {
    return placement.split("-")[0];
}
function $926256944d3cd62f$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $926256944d3cd62f$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].includes($926256944d3cd62f$var$getSide(placement)) ? "x" : "y";
}
function $926256944d3cd62f$var$getLengthFromAxis(axis) {
    return axis === "y" ? "height" : "width";
}
function $926256944d3cd62f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $926256944d3cd62f$var$getMainAxisFromPlacement(placement);
    const length = $926256944d3cd62f$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $926256944d3cd62f$var$getSide(placement);
    const isVertical = mainAxis === "x";
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($926256944d3cd62f$var$getAlignment(placement)){
        case "start":
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $926256944d3cd62f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    var _ref;
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < middleware.length; i++){
        const { name: name , fn: fn  } = middleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $926256944d3cd62f$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $926256944d3cd62f$var$getSideObjectFromPadding(padding) {
    return typeof padding !== "number" ? $926256944d3cd62f$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $926256944d3cd62f$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $926256944d3cd62f$export$37b6bde19b108ecc(middlewareArguments, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = middlewareArguments;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = options;
    const paddingObject = $926256944d3cd62f$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $926256944d3cd62f$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const elementClientRect = $926256944d3cd62f$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: elementContext === "floating" ? {
            ...rects.floating,
            x: x,
            y: y
        } : rects.reference,
        offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
        strategy: strategy
    }) : rects[elementContext]);
    return {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
}
const $926256944d3cd62f$var$min = Math.min;
const $926256944d3cd62f$var$max = Math.max;
function $926256944d3cd62f$var$within(min$1, value, max$1) {
    return $926256944d3cd62f$var$max(min$1, $926256944d3cd62f$var$min(value, max$1));
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $926256944d3cd62f$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (middlewareArguments) {
            // Since `element` is required, we don't Partial<> the type
            const { element: element , padding: padding = 0  } = options != null ? options : {};
            const { x: x , y: y , placement: placement , rects: rects , platform: platform  } = middlewareArguments;
            if (element == null) return {};
            const paddingObject = $926256944d3cd62f$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $926256944d3cd62f$var$getMainAxisFromPlacement(placement);
            const alignment = $926256944d3cd62f$var$getAlignment(placement);
            const length = $926256944d3cd62f$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const minProp = axis === "y" ? "top" : "left";
            const maxProp = axis === "y" ? "bottom" : "right";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
            if (clientSize === 0) clientSize = rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $926256944d3cd62f$var$within(min, center, max); // Make sure that arrow points at the reference
            const alignmentPadding = alignment === "start" ? paddingObject[minProp] : paddingObject[maxProp];
            const shouldAddOffset = alignmentPadding > 0 && center !== offset && rects.reference[length] <= rects.floating[length];
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $926256944d3cd62f$var$hash$1 = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $926256944d3cd62f$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (matched)=>$926256944d3cd62f$var$hash$1[matched]);
}
function $926256944d3cd62f$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $926256944d3cd62f$var$getAlignment(placement);
    const mainAxis = $926256944d3cd62f$var$getMainAxisFromPlacement(placement);
    const length = $926256944d3cd62f$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $926256944d3cd62f$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $926256944d3cd62f$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $926256944d3cd62f$var$hash = {
    start: "end",
    end: "start"
};
function $926256944d3cd62f$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (matched)=>$926256944d3cd62f$var$hash[matched]);
}
const $926256944d3cd62f$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $926256944d3cd62f$var$allPlacements = /*#__PURE__*/ $926256944d3cd62f$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
function $926256944d3cd62f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$926256944d3cd62f$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$926256944d3cd62f$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$926256944d3cd62f$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $926256944d3cd62f$var$getAlignment(placement) === alignment || (autoAlignment ? $926256944d3cd62f$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Automatically chooses the `placement` which has the most space available.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $926256944d3cd62f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$autoP, _middlewareData$autoP2, _middlewareData$autoP3, _middlewareData$autoP4, _placementsSortedByLe;
            const { x: x , y: y , rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = middlewareArguments;
            const { alignment: alignment = null , allowedPlacements: allowedPlacements = $926256944d3cd62f$var$allPlacements , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = options;
            const placements = $926256944d3cd62f$var$getPlacementList(alignment, autoAlignment, allowedPlacements);
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const currentIndex = (_middlewareData$autoP = (_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.index) != null ? _middlewareData$autoP : 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main , cross: cross  } = $926256944d3cd62f$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))); // Make `computeCoords` start from the right place
            if (placement !== currentPlacement) return {
                x: x,
                y: y,
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$926256944d3cd62f$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...(_middlewareData$autoP3 = (_middlewareData$autoP4 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP4.overflows) != null ? _middlewareData$autoP3 : [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1]; // There are more placements to check
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByLeastOverflow = allOverflows.slice().sort((a, b)=>a.overflows[0] - b.overflows[0]);
            const placementThatFitsOnAllSides = (_placementsSortedByLe = placementsSortedByLeastOverflow.find((_ref)=>{
                let { overflows: overflows  } = _ref;
                return overflows.every((overflow)=>overflow <= 0);
            })) == null ? void 0 : _placementsSortedByLe.placement;
            const resetPlacement = placementThatFitsOnAllSides != null ? placementThatFitsOnAllSides : placementsSortedByLeastOverflow[0].placement;
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $926256944d3cd62f$var$getExpandedPlacements(placement) {
    const oppositePlacement = $926256944d3cd62f$var$getOppositePlacement(placement);
    return [
        $926256944d3cd62f$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $926256944d3cd62f$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
/**
 * Changes the placement of the floating element to one that will fit if the
 * initially specified `placement` does not.
 * @see https://floating-ui.com/docs/flip
 */ const $926256944d3cd62f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = middlewareArguments;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = options;
            const side = $926256944d3cd62f$var$getSide(placement);
            const isBasePlacement = side === initialPlacement;
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $926256944d3cd62f$var$getOppositePlacement(initialPlacement)
            ] : $926256944d3cd62f$var$getExpandedPlacements(initialPlacement));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main , cross: cross  } = $926256944d3cd62f$var$getAlignmentSides(placement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ]; // One or more sides is overflowing
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip$, _middlewareData$flip2;
                const nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) != null ? _middlewareData$flip$ : 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = "bottom";
                switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $926256944d3cd62f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $926256944d3cd62f$var$isAnySideFullyClipped(overflow) {
    return $926256944d3cd62f$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $926256944d3cd62f$export$fe8985bb6374093c = function(_temp) {
    let { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = _temp === void 0 ? {} : _temp;
    return {
        name: "hide",
        async fn (middlewareArguments) {
            const { rects: rects  } = middlewareArguments;
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
async function $926256944d3cd62f$var$convertValueToCoords(middlewareArguments, value) {
    const { placement: placement , platform: platform , elements: elements  } = middlewareArguments;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $926256944d3cd62f$var$getSide(placement);
    const alignment = $926256944d3cd62f$var$getAlignment(placement);
    const isVertical = $926256944d3cd62f$var$getMainAxisFromPlacement(placement) === "x";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === "function" ? value(middlewareArguments) : value; // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Displaces the floating element from its reference element.
 * @see https://floating-ui.com/docs/offset
 */ const $926256944d3cd62f$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: "offset",
        options: value,
        async fn (middlewareArguments) {
            const { x: x , y: y  } = middlewareArguments;
            const diffCoords = await $926256944d3cd62f$var$convertValueToCoords(middlewareArguments, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $926256944d3cd62f$var$getCrossAxis(axis) {
    return axis === "x" ? "y" : "x";
}
/**
 * Shifts the floating element in order to keep it in view when it will overflow
 * a clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $926256944d3cd62f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (middlewareArguments) {
            const { x: x , y: y , placement: placement  } = middlewareArguments;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const mainAxis = $926256944d3cd62f$var$getMainAxisFromPlacement($926256944d3cd62f$var$getSide(placement));
            const crossAxis = $926256944d3cd62f$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $926256944d3cd62f$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $926256944d3cd62f$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...middlewareArguments,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $926256944d3cd62f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (middlewareArguments) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = middlewareArguments;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $926256944d3cd62f$var$getMainAxisFromPlacement(placement);
            const crossAxis = $926256944d3cd62f$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === "function" ? offset({
                ...rects,
                placement: placement
            }) : offset;
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2, _middlewareData$offse3, _middlewareData$offse4;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($926256944d3cd62f$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? (_middlewareData$offse = (_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) != null ? _middlewareData$offse : 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : (_middlewareData$offse3 = (_middlewareData$offse4 = middlewareData.offset) == null ? void 0 : _middlewareData$offse4[crossAxis]) != null ? _middlewareData$offse3 : 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data to change the size of the floating element. For instance,
 * prevent it from overflowing its clipping boundary or match the width of the
 * reference element.
 * @see https://floating-ui.com/docs/size
 */ const $926256944d3cd62f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (middlewareArguments) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = middlewareArguments;
            const { apply: apply , ...detectOverflowOptions } = options;
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const side = $926256944d3cd62f$var$getSide(placement);
            const alignment = $926256944d3cd62f$var$getAlignment(placement);
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const xMin = $926256944d3cd62f$var$max(overflow.left, 0);
            const xMax = $926256944d3cd62f$var$max(overflow.right, 0);
            const yMin = $926256944d3cd62f$var$max(overflow.top, 0);
            const yMax = $926256944d3cd62f$var$max(overflow.bottom, 0);
            const dimensions = {
                availableHeight: rects.floating.height - ([
                    "left",
                    "right"
                ].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $926256944d3cd62f$var$max(overflow.top, overflow.bottom)) : overflow[heightSide]),
                availableWidth: rects.floating.width - ([
                    "top",
                    "bottom"
                ].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $926256944d3cd62f$var$max(overflow.left, overflow.right)) : overflow[widthSide])
            };
            const prevDimensions = await platform.getDimensions(elements.floating);
            apply == null || apply({
                ...middlewareArguments,
                ...dimensions
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (prevDimensions.width !== nextDimensions.width || prevDimensions.height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $926256944d3cd62f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (middlewareArguments) {
            var _await$platform$getCl;
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = middlewareArguments; // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = options;
            const fallback = $926256944d3cd62f$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                rect: rects.reference,
                offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
                strategy: strategy
            }) : rects.reference);
            const clientRects = (_await$platform$getCl = await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) != null ? _await$platform$getCl : [];
            const paddingObject = $926256944d3cd62f$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
                    var _clientRects$find;
                    // Find the first rect in which the point is fully inside
                    return (_clientRects$find = clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom)) != null ? _clientRects$find : fallback;
                } // There are 2 or more connected rects
                if (clientRects.length >= 2) {
                    if ($926256944d3cd62f$var$getMainAxisFromPlacement(placement) === "x") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $926256944d3cd62f$var$getSide(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $926256944d3cd62f$var$getSide(placement) === "left";
                    const maxRight = $926256944d3cd62f$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $926256944d3cd62f$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};


function $985fd6054d85832a$var$isWindow(value) {
    return value && value.document && value.location && value.alert && value.setInterval;
}
function $985fd6054d85832a$var$getWindow(node) {
    if (node == null) return window;
    if (!$985fd6054d85832a$var$isWindow(node)) {
        const ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}
function $985fd6054d85832a$var$getComputedStyle$1(element) {
    return $985fd6054d85832a$var$getWindow(element).getComputedStyle(element);
}
function $985fd6054d85832a$var$getNodeName(node) {
    return $985fd6054d85832a$var$isWindow(node) ? "" : node ? (node.nodeName || "").toLowerCase() : "";
}
function $985fd6054d85832a$var$getUAString() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map((item)=>item.brand + "/" + item.version).join(" ");
    return navigator.userAgent;
}
function $985fd6054d85832a$var$isHTMLElement(value) {
    return value instanceof $985fd6054d85832a$var$getWindow(value).HTMLElement;
}
function $985fd6054d85832a$var$isElement(value) {
    return value instanceof $985fd6054d85832a$var$getWindow(value).Element;
}
function $985fd6054d85832a$var$isNode(value) {
    return value instanceof $985fd6054d85832a$var$getWindow(value).Node;
}
function $985fd6054d85832a$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $985fd6054d85832a$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $985fd6054d85832a$var$isOverflowElement(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY  } = $985fd6054d85832a$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $985fd6054d85832a$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($985fd6054d85832a$var$getNodeName(element));
}
function $985fd6054d85832a$var$isContainingBlock(element) {
    // TODO: Try and use feature detection here instead
    const isFirefox = /firefox/i.test($985fd6054d85832a$var$getUAString());
    const css = $985fd6054d85832a$var$getComputedStyle$1(element); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || // @ts-ignore (TS 4.1 compat)
    css.contain === "paint" || [
        "transform",
        "perspective"
    ].includes(css.willChange) || isFirefox && css.willChange === "filter" || isFirefox && (css.filter ? css.filter !== "none" : false);
}
function $985fd6054d85832a$var$isLayoutViewport() {
    // Not Safari
    return !/^((?!chrome|android).)*safari/i.test($985fd6054d85832a$var$getUAString()); // Feature detection for this fails in various ways
// • Always-visible scrollbar or not
// • Width of <html>, etc.
// const vV = win.visualViewport;
// return vV ? Math.abs(win.innerWidth / vV.scale - vV.width) < 0.5 : true;
}
const $985fd6054d85832a$var$min = Math.min;
const $985fd6054d85832a$var$max = Math.max;
const $985fd6054d85832a$var$round = Math.round;
function $985fd6054d85832a$var$getBoundingClientRect(element, includeScale, isFixedStrategy) {
    var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    let scaleX = 1;
    let scaleY = 1;
    if (includeScale && $985fd6054d85832a$var$isHTMLElement(element)) {
        scaleX = element.offsetWidth > 0 ? $985fd6054d85832a$var$round(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? $985fd6054d85832a$var$round(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    const win = $985fd6054d85832a$var$isElement(element) ? $985fd6054d85832a$var$getWindow(element) : window;
    const addVisualOffsets = !$985fd6054d85832a$var$isLayoutViewport() && isFixedStrategy;
    const x = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scaleX;
    const y = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scaleY;
    const width = clientRect.width / scaleX;
    const height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getDocumentElement(node) {
    return (($985fd6054d85832a$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $985fd6054d85832a$var$getNodeScroll(element) {
    if ($985fd6054d85832a$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $985fd6054d85832a$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $985fd6054d85832a$var$getBoundingClientRect($985fd6054d85832a$var$getDocumentElement(element)).left + $985fd6054d85832a$var$getNodeScroll(element).scrollLeft;
}
function $985fd6054d85832a$var$isScaled(element) {
    const rect = $985fd6054d85832a$var$getBoundingClientRect(element);
    return $985fd6054d85832a$var$round(rect.width) !== element.offsetWidth || $985fd6054d85832a$var$round(rect.height) !== element.offsetHeight;
}
function $985fd6054d85832a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $985fd6054d85832a$var$isHTMLElement(offsetParent);
    const documentElement = $985fd6054d85832a$var$getDocumentElement(offsetParent);
    const rect = $985fd6054d85832a$var$getBoundingClientRect(element, isOffsetParentAnElement && $985fd6054d85832a$var$isScaled(offsetParent), strategy === "fixed");
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($985fd6054d85832a$var$getNodeName(offsetParent) !== "body" || $985fd6054d85832a$var$isOverflowElement(documentElement)) scroll = $985fd6054d85832a$var$getNodeScroll(offsetParent);
        if ($985fd6054d85832a$var$isHTMLElement(offsetParent)) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $985fd6054d85832a$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $985fd6054d85832a$var$getParentNode(node) {
    if ($985fd6054d85832a$var$getNodeName(node) === "html") return node;
    return(// @ts-ignore
    node.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    node.parentNode || ($985fd6054d85832a$var$isShadowRoot(node) ? node.host : null) || // ShadowRoot detected
    $985fd6054d85832a$var$getDocumentElement(node) // fallback
    );
}
function $985fd6054d85832a$var$getTrueOffsetParent(element) {
    if (!$985fd6054d85832a$var$isHTMLElement(element) || getComputedStyle(element).position === "fixed") return null;
    return element.offsetParent;
}
function $985fd6054d85832a$var$getContainingBlock(element) {
    let currentNode = $985fd6054d85832a$var$getParentNode(element);
    if ($985fd6054d85832a$var$isShadowRoot(currentNode)) currentNode = currentNode.host;
    while($985fd6054d85832a$var$isHTMLElement(currentNode) && ![
        "html",
        "body"
    ].includes($985fd6054d85832a$var$getNodeName(currentNode))){
        if ($985fd6054d85832a$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $985fd6054d85832a$var$getOffsetParent(element) {
    const window1 = $985fd6054d85832a$var$getWindow(element);
    let offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(element);
    while(offsetParent && $985fd6054d85832a$var$isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static")offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ($985fd6054d85832a$var$getNodeName(offsetParent) === "html" || $985fd6054d85832a$var$getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static" && !$985fd6054d85832a$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $985fd6054d85832a$var$getContainingBlock(element) || window1;
}
function $985fd6054d85832a$var$getDimensions(element) {
    if ($985fd6054d85832a$var$isHTMLElement(element)) return {
        width: element.offsetWidth,
        height: element.offsetHeight
    };
    const rect = $985fd6054d85832a$var$getBoundingClientRect(element);
    return {
        width: rect.width,
        height: rect.height
    };
}
function $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isOffsetParentAnElement = $985fd6054d85832a$var$isHTMLElement(offsetParent);
    const documentElement = $985fd6054d85832a$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($985fd6054d85832a$var$getNodeName(offsetParent) !== "body" || $985fd6054d85832a$var$isOverflowElement(documentElement)) scroll = $985fd6054d85832a$var$getNodeScroll(offsetParent);
        if ($985fd6054d85832a$var$isHTMLElement(offsetParent)) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } // This doesn't appear to be need to be negated.
    // else if (documentElement) {
    //   offsets.x = getWindowScrollBarX(documentElement);
    // }
    }
    return {
        ...rect,
        x: rect.x - scroll.scrollLeft + offsets.x,
        y: rect.y - scroll.scrollTop + offsets.y
    };
}
function $985fd6054d85832a$var$getViewportRect(element, strategy) {
    const win = $985fd6054d85832a$var$getWindow(element);
    const html = $985fd6054d85832a$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const layoutViewport = $985fd6054d85832a$var$isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function $985fd6054d85832a$var$getDocumentRect(element) {
    var _element$ownerDocumen;
    const html = $985fd6054d85832a$var$getDocumentElement(element);
    const scroll = $985fd6054d85832a$var$getNodeScroll(element);
    const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    const width = $985fd6054d85832a$var$max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    const height = $985fd6054d85832a$var$max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    let x = -scroll.scrollLeft + $985fd6054d85832a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($985fd6054d85832a$var$getComputedStyle$1(body || html).direction === "rtl") x += $985fd6054d85832a$var$max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getNearestOverflowAncestor(node) {
    const parentNode = $985fd6054d85832a$var$getParentNode(node);
    if ([
        "html",
        "body",
        "#document"
    ].includes($985fd6054d85832a$var$getNodeName(parentNode))) // @ts-ignore assume body is always available
    return node.ownerDocument.body;
    if ($985fd6054d85832a$var$isHTMLElement(parentNode) && $985fd6054d85832a$var$isOverflowElement(parentNode)) return parentNode;
    return $985fd6054d85832a$var$getNearestOverflowAncestor(parentNode);
}
function $985fd6054d85832a$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $985fd6054d85832a$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $985fd6054d85832a$var$getWindow(scrollableAncestor);
    const target = isBody ? [
        win
    ].concat(win.visualViewport || [], $985fd6054d85832a$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []) : scrollableAncestor;
    const updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($985fd6054d85832a$export$3b57c1601291186b(target));
}
function $985fd6054d85832a$var$contains(parent, child) {
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && $985fd6054d85832a$var$isShadowRoot(rootNode)) {
        let next = child;
        do {
            // use `===` replace node.isSameNode()
            if (next && parent === next) return true;
             // @ts-ignore: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    }
    return false;
}
function $985fd6054d85832a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $985fd6054d85832a$var$getBoundingClientRect(element, false, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    return {
        top: top,
        left: left,
        x: left,
        y: top,
        right: left + element.clientWidth,
        bottom: top + element.clientHeight,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingParent, strategy) {
    if (clippingParent === "viewport") return (0, $926256944d3cd62f$export$ee05aea0aeecbad4)($985fd6054d85832a$var$getViewportRect(element, strategy));
    if ($985fd6054d85832a$var$isElement(clippingParent)) return $985fd6054d85832a$var$getInnerBoundingClientRect(clippingParent, strategy);
    return (0, $926256944d3cd62f$export$ee05aea0aeecbad4)($985fd6054d85832a$var$getDocumentRect($985fd6054d85832a$var$getDocumentElement(element)));
} // A "clipping ancestor" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $985fd6054d85832a$var$getClippingAncestors(element) {
    const clippingAncestors = $985fd6054d85832a$export$3b57c1601291186b(element);
    const canEscapeClipping = [
        "absolute",
        "fixed"
    ].includes($985fd6054d85832a$var$getComputedStyle$1(element).position);
    const clipperElement = canEscapeClipping && $985fd6054d85832a$var$isHTMLElement(element) ? $985fd6054d85832a$var$getOffsetParent(element) : element;
    if (!$985fd6054d85832a$var$isElement(clipperElement)) return [];
     // @ts-ignore isElement check ensures we return Array<Element>
    return clippingAncestors.filter((clippingAncestors)=>$985fd6054d85832a$var$isElement(clippingAncestors) && $985fd6054d85832a$var$contains(clippingAncestors, clipperElement) && $985fd6054d85832a$var$getNodeName(clippingAncestors) !== "body");
} // Gets the maximum area that the element is visible in due to any number of
// clipping ancestors
function $985fd6054d85832a$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const mainClippingAncestors = boundary === "clippingAncestors" ? $985fd6054d85832a$var$getClippingAncestors(element) : [].concat(boundary);
    const clippingAncestors = [
        ...mainClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $985fd6054d85832a$var$max(rect.top, accRect.top);
        accRect.right = $985fd6054d85832a$var$min(rect.right, accRect.right);
        accRect.bottom = $985fd6054d85832a$var$min(rect.bottom, accRect.bottom);
        accRect.left = $985fd6054d85832a$var$max(rect.left, accRect.left);
        return accRect;
    }, $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
const $985fd6054d85832a$var$platform = {
    getClippingRect: $985fd6054d85832a$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $985fd6054d85832a$var$isElement,
    getDimensions: $985fd6054d85832a$var$getDimensions,
    getOffsetParent: $985fd6054d85832a$var$getOffsetParent,
    getDocumentElement: $985fd6054d85832a$var$getDocumentElement,
    getElementRects: (_ref)=>{
        let { reference: reference , floating: floating , strategy: strategy  } = _ref;
        return {
            reference: $985fd6054d85832a$var$getRectRelativeToOffsetParent(reference, $985fd6054d85832a$var$getOffsetParent(floating), strategy),
            floating: {
                ...$985fd6054d85832a$var$getDimensions(floating),
                x: 0,
                y: 0
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$985fd6054d85832a$var$getComputedStyle$1(element).direction === "rtl"
};
/**
 * Automatically updates the position of the floating element when necessary.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $985fd6054d85832a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: _ancestorScroll = true , ancestorResize: _ancestorResize = true , elementResize: elementResize = true , animationFrame: animationFrame = false  } = options;
    const ancestorScroll = _ancestorScroll && !animationFrame;
    const ancestorResize = _ancestorResize && !animationFrame;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$985fd6054d85832a$var$isElement(reference) ? $985fd6054d85832a$export$3b57c1601291186b(reference) : [],
        ...$985fd6054d85832a$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    let observer = null;
    if (elementResize) {
        let initialUpdate = true;
        observer = new ResizeObserver(()=>{
            if (!initialUpdate) update();
            initialUpdate = false;
        });
        $985fd6054d85832a$var$isElement(reference) && !animationFrame && observer.observe(reference);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $985fd6054d85832a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $985fd6054d85832a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $985fd6054d85832a$export$48a53dcb22e581d0 = (reference, floating, options)=>(0, $926256944d3cd62f$export$48a53dcb22e581d0)(reference, floating, {
        platform: $985fd6054d85832a$var$platform,
        ...options
    });



var $bh6RR = parcelRequire("bh6RR");

var $f0eb2bc09271deae$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f0eb2bc09271deae$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f0eb2bc09271deae$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$f0eb2bc09271deae$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $f0eb2bc09271deae$var$useLatestRef(value) {
    const ref = $bh6RR.useRef(value);
    $f0eb2bc09271deae$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
function $f0eb2bc09271deae$export$4e02a5c1d08bac65(_temp) {
    let { middleware: middleware , placement: placement = "bottom" , strategy: strategy = "absolute" , whileElementsMounted: whileElementsMounted  } = _temp === void 0 ? {} : _temp;
    const reference = $bh6RR.useRef(null);
    const floating = $bh6RR.useRef(null);
    const whileElementsMountedRef = $f0eb2bc09271deae$var$useLatestRef(whileElementsMounted);
    const cleanupRef = $bh6RR.useRef(null);
    const [data, setData] = $bh6RR.useState({
        // Setting these to `null` will allow the consumer to determine if
        // `computePosition()` has run yet
        x: null,
        y: null,
        strategy: strategy,
        placement: placement,
        middlewareData: {}
    });
    const [latestMiddleware, setLatestMiddleware] = $bh6RR.useState(middleware);
    if (!$f0eb2bc09271deae$var$deepEqual(latestMiddleware == null ? void 0 : latestMiddleware.map((_ref)=>{
        let { options: options  } = _ref;
        return options;
    }), middleware == null ? void 0 : middleware.map((_ref2)=>{
        let { options: options  } = _ref2;
        return options;
    }))) setLatestMiddleware(middleware);
    const update = $bh6RR.useCallback(()=>{
        if (!reference.current || !floating.current) return;
        (0, $985fd6054d85832a$export$48a53dcb22e581d0)(reference.current, floating.current, {
            middleware: latestMiddleware,
            placement: placement,
            strategy: strategy
        }).then((data)=>{
            if (isMountedRef.current) $47cfd4084854a574$exports.flushSync(()=>{
                setData(data);
            });
        });
    }, [
        latestMiddleware,
        placement,
        strategy
    ]);
    $f0eb2bc09271deae$var$index(()=>{
        // Skip first update
        if (isMountedRef.current) update();
    }, [
        update
    ]);
    const isMountedRef = $bh6RR.useRef(false);
    $f0eb2bc09271deae$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const runElementMountCallback = $bh6RR.useCallback(()=>{
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (reference.current && floating.current) {
            if (whileElementsMountedRef.current) {
                const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
                cleanupRef.current = cleanupFn;
            } else update();
        }
    }, [
        update,
        whileElementsMountedRef
    ]);
    const setReference = $bh6RR.useCallback((node)=>{
        reference.current = node;
        runElementMountCallback();
    }, [
        runElementMountCallback
    ]);
    const setFloating = $bh6RR.useCallback((node)=>{
        floating.current = node;
        runElementMountCallback();
    }, [
        runElementMountCallback
    ]);
    const refs = $bh6RR.useMemo(()=>({
            reference: reference,
            floating: floating
        }), []);
    return $bh6RR.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            reference: setReference,
            floating: setFloating
        }), [
        data,
        update,
        refs,
        setReference,
        setFloating
    ]);
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f0eb2bc09271deae$export$f2120bbfa5450bd2 = (options)=>{
    const { element: element , padding: padding  } = options;
    function isRef(value) {
        return Object.prototype.hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (args) {
            if (isRef(element)) {
                if (element.current != null) return (0, $926256944d3cd62f$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(args);
                return {};
            } else if (element) return (0, $926256944d3cd62f$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(args);
            return {};
        }
    };
};




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $021d6c7c11562959$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $021d6c7c11562959$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$021d6c7c11562959$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $021d6c7c11562959$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($021d6c7c11562959$export$43e446d32b3d21af(...refs), refs);
}


/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $ab9bffbf11310fb6$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$ab9bffbf11310fb6$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $021d6c7c11562959$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $ab9bffbf11310fb6$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $ab9bffbf11310fb6$export$d9f1ccf0bdb05d45;
}
function $ab9bffbf11310fb6$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $ab9bffbf11310fb6$export$be92b6f5f03c0fe9 = $ab9bffbf11310fb6$export$8c6ed5c666ac1360;


const $acb18173593dba42$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $acb18173593dba42$export$250ffa63cdc0d034 = $acb18173593dba42$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $ab9bffbf11310fb6$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $acb18173593dba42$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $acb18173593dba42$export$be92b6f5f03c0fe9 = $acb18173593dba42$export$250ffa63cdc0d034;


/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $68b994871f059ff0$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $68b994871f059ff0$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $acb18173593dba42$export$250ffa63cdc0d034).svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $bh6RR.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($68b994871f059ff0$export$21b07c8f274aebd5, {
    displayName: $68b994871f059ff0$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $68b994871f059ff0$export$be92b6f5f03c0fe9 = $68b994871f059ff0$export$21b07c8f274aebd5;



var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $769b2d6ebaf818a2$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $769b2d6ebaf818a2$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$769b2d6ebaf818a2$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $769b2d6ebaf818a2$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($769b2d6ebaf818a2$export$43e446d32b3d21af(...refs), refs);
}



var $bh6RR = parcelRequire("bh6RR");
function $8962238c4fadb382$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $8962238c4fadb382$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $8962238c4fadb382$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $8962238c4fadb382$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $d8620ec6d570e2df$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($d8620ec6d570e2df$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($d8620ec6d570e2df$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($d8620ec6d570e2df$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$d8620ec6d570e2df$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $d8620ec6d570e2df$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$d8620ec6d570e2df$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $769b2d6ebaf818a2$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$d8620ec6d570e2df$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $d8620ec6d570e2df$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $d8620ec6d570e2df$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $d8620ec6d570e2df$export$d9f1ccf0bdb05d45;
}
function $d8620ec6d570e2df$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $d8620ec6d570e2df$export$be92b6f5f03c0fe9 = $d8620ec6d570e2df$export$8c6ed5c666ac1360;


const $44ab0615d163a944$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $44ab0615d163a944$export$250ffa63cdc0d034 = $44ab0615d163a944$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $d8620ec6d570e2df$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $44ab0615d163a944$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $44ab0615d163a944$export$be92b6f5f03c0fe9 = $44ab0615d163a944$export$250ffa63cdc0d034;



var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $557f5179540f701f$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $d8e502cc42f2509a$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};


function $d15f70cceda28db4$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $bh6RR.useState)(undefined);
    (0, $d8e502cc42f2509a$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $e360c8d229d9b2b7$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $e360c8d229d9b2b7$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$createPopperContext, $e360c8d229d9b2b7$export$722aac194ae923] = (0, $8962238c4fadb382$export$50c7b4e9d9f19c1)($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$PopperProvider, $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$createPopperContext($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $e360c8d229d9b2b7$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = (0, $bh6RR.useState)(null);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($e360c8d229d9b2b7$export$badac9ada3a0bdf9, {
    displayName: $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $e360c8d229d9b2b7$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$usePopperContext($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $769b2d6ebaf818a2$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $44ab0615d163a944$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($e360c8d229d9b2b7$export$ecd4e1ccab6ed6d, {
    displayName: $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$useContentContext] = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$createPopperContext($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const [$e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$PositionContextProvider, $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$usePositionContext] = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$createPopperContext($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, {
    hasParent: false,
    positionUpdateFns: new Set()
});
const $e360c8d229d9b2b7$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
    const { __scopePopper: __scopePopper , side: side = "bottom" , sideOffset: sideOffset = 0 , align: align = "center" , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = "partial" , hideWhenDetached: hideWhenDetached = false , avoidCollisions: avoidCollisions = true , ...contentProps } = props;
    const context = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$usePopperContext($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $769b2d6ebaf818a2$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $bh6RR.useState)(null);
    const arrowSize = (0, $d15f70cceda28db4$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { reference: reference , floating: floating , strategy: strategy , x: x , y: y , placement: placement , middlewareData: middlewareData , update: update  } = (0, $f0eb2bc09271deae$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (0, $985fd6054d85832a$export$deee3a793edee05f),
        middleware: [
            (0, $926256944d3cd62f$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions ? (0, $926256944d3cd62f$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $926256944d3cd62f$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }) : undefined,
            arrow ? (0, $f0eb2bc09271deae$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }) : undefined,
            avoidCollisions ? (0, $926256944d3cd62f$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }) : undefined,
            $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached ? (0, $926256944d3cd62f$export$fe8985bb6374093c)({
                strategy: "referenceHidden"
            }) : undefined
        ].filter($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$isDefined)
    }); // assign the reference dynamically once `Content` has mounted so we can collocate the logic
    (0, $557f5179540f701f$export$e5c5a5f917a5871c)(()=>{
        reference(context.anchor);
    }, [
        reference,
        context.anchor
    ]);
    const isPlaced = x !== null && y !== null;
    const [placedSide, placedAlign] = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $557f5179540f701f$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const { hasParent: hasParent , positionUpdateFns: positionUpdateFns  } = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$usePositionContext($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const isRoot = !hasParent;
    (0, $bh6RR.useLayoutEffect)(()=>{
        if (!isRoot) {
            positionUpdateFns.add(update);
            return ()=>{
                positionUpdateFns.delete(update);
            };
        }
    }, [
        isRoot,
        positionUpdateFns,
        update
    ]); // when nested contents are rendered in portals, they are appended out of order causing
    // children to be positioned incorrectly if initially open.
    // we need to re-compute the positioning once the parent has finally been placed.
    // https://github.com/floating-ui/floating-ui/issues/1531
    (0, $bh6RR.useLayoutEffect)(()=>{
        if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach((fn)=>requestAnimationFrame(fn));
    }, [
        isRoot,
        isPlaced,
        positionUpdateFns
    ]);
    const commonProps = {
        "data-side": placedSide,
        "data-align": placedAlign,
        ...contentProps,
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPlaced ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    };
    return /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: floating,
        "data-radix-popper-content-wrapper": "",
        style: {
            position: strategy,
            left: 0,
            top: 0,
            transform: isPlaced ? `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)` : "translate3d(0, -200%, 0)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, isRoot ? /*#__PURE__*/ (0, $bh6RR.createElement)($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$PositionContextProvider, {
        scope: __scopePopper,
        hasParent: true,
        positionUpdateFns: positionUpdateFns
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $44ab0615d163a944$export$250ffa63cdc0d034).div, commonProps)) : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $44ab0615d163a944$export$250ffa63cdc0d034).div, commonProps)));
});
/*#__PURE__*/ Object.assign($e360c8d229d9b2b7$export$bc4ae5855d3c4fc, {
    displayName: $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $e360c8d229d9b2b7$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$useContentContext($e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $bh6RR.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $68b994871f059ff0$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($e360c8d229d9b2b7$export$79d62cd4e10a3fd0, {
    displayName: $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$isDefined(value) {
    return value !== undefined;
}
function $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $e360c8d229d9b2b7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $e360c8d229d9b2b7$export$be92b6f5f03c0fe9 = $e360c8d229d9b2b7$export$badac9ada3a0bdf9;
const $e360c8d229d9b2b7$export$b688253958b8dfe7 = $e360c8d229d9b2b7$export$ecd4e1ccab6ed6d;
const $e360c8d229d9b2b7$export$7c6e2c02157bb7d2 = $e360c8d229d9b2b7$export$bc4ae5855d3c4fc;
const $e360c8d229d9b2b7$export$21b07c8f274aebd5 = $e360c8d229d9b2b7$export$79d62cd4e10a3fd0;




var $bh6RR = parcelRequire("bh6RR");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $25eb9a6695888273$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $25eb9a6695888273$export$602eac185826482c = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).createPortal(/*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($25eb9a6695888273$export$602eac185826482c, {
    displayName: $25eb9a6695888273$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $25eb9a6695888273$export$be92b6f5f03c0fe9 = $25eb9a6695888273$export$602eac185826482c;



var $bh6RR = parcelRequire("bh6RR");



function $e3b59b8c3589b16a$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $bh6RR.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $e3b59b8c3589b16a$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $e3b59b8c3589b16a$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $bh6RR.Children).only(children);
    const ref = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(child, {
        ref: ref
    }) : null;
};
$e3b59b8c3589b16a$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $e3b59b8c3589b16a$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $bh6RR.useState)();
    const stylesRef = (0, $bh6RR.useRef)({});
    const prevPresentRef = (0, $bh6RR.useRef)(present);
    const prevAnimationNameRef = (0, $bh6RR.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e3b59b8c3589b16a$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        const currentAnimationName = $e3b59b8c3589b16a$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $bfc439fb5a9be4e2$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e3b59b8c3589b16a$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $bfc439fb5a9be4e2$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e3b59b8c3589b16a$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $47cfd4084854a574$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $e3b59b8c3589b16a$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $bh6RR.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $e3b59b8c3589b16a$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $bh6RR = parcelRequire("bh6RR");
function $6598d72b98a0b6be$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}




var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $cd7f2691f539d713$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $cd7f2691f539d713$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$cd7f2691f539d713$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $cd7f2691f539d713$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($cd7f2691f539d713$export$43e446d32b3d21af(...refs), refs);
}



var $bh6RR = parcelRequire("bh6RR");
function $2a253819f5dee164$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $2a253819f5dee164$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $2a253819f5dee164$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $2a253819f5dee164$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $ef2657a90bae9c8a$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};


const $1089b8f17bd4d7f6$var$$1746a345f3d73bb7$var$useReactId = $bh6RR["useId".toString()] || (()=>undefined);
let $1089b8f17bd4d7f6$var$$1746a345f3d73bb7$var$count = 0;
function $1089b8f17bd4d7f6$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($1089b8f17bd4d7f6$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $ef2657a90bae9c8a$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($1089b8f17bd4d7f6$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $e9b3baea3d5be75c$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$e9b3baea3d5be75c$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $cd7f2691f539d713$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $e9b3baea3d5be75c$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $e9b3baea3d5be75c$export$d9f1ccf0bdb05d45;
}
function $e9b3baea3d5be75c$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $e9b3baea3d5be75c$export$be92b6f5f03c0fe9 = $e9b3baea3d5be75c$export$8c6ed5c666ac1360;


const $9f33ccbe7667c828$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $9f33ccbe7667c828$export$250ffa63cdc0d034 = $9f33ccbe7667c828$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $e9b3baea3d5be75c$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $9f33ccbe7667c828$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $9f33ccbe7667c828$export$be92b6f5f03c0fe9 = $9f33ccbe7667c828$export$250ffa63cdc0d034;



var $bh6RR = parcelRequire("bh6RR");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $65d7e367d49702b1$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $bh6RR.useRef)(callback);
    (0, $bh6RR.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $bh6RR.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $bh6RR = parcelRequire("bh6RR");

function $3a92bcbef1051fe8$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $3a92bcbef1051fe8$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $65d7e367d49702b1$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $bh6RR.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $3a92bcbef1051fe8$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0, $bh6RR.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $bh6RR.useRef)(value);
    const handleChange = (0, $65d7e367d49702b1$export$25bec8c6f54ee79a)(onChange);
    (0, $bh6RR.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



const $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$Collection, $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$useCollection, $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $0928e9a030d7dbc9$export$c74125a8e3af6bb2)($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $1a8d4496b8378cba$export$c7109489551a4f4] = (0, $2a253819f5dee164$export$50c7b4e9d9f19c1)($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $1a8d4496b8378cba$export$8699f7c8af148338 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($1a8d4496b8378cba$export$8699f7c8af148338, {
    displayName: $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $cd7f2691f539d713$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $87990fa25f891e42$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $3a92bcbef1051fe8$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $bh6RR.useState)(false);
    const handleEntryFocus = (0, $65d7e367d49702b1$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $bh6RR.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $bh6RR.useCallback)(()=>setIsTabbingBackOut(true), [])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $9f33ccbe7667c828$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $6598d72b98a0b6be$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $6598d72b98a0b6be$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $6598d72b98a0b6be$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $1a8d4496b8378cba$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , ...itemProps } = props;
    const id = (0, $1089b8f17bd4d7f6$export$f680877a34711e37)();
    const context = $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $9f33ccbe7667c828$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $6598d72b98a0b6be$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $6598d72b98a0b6be$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $6598d72b98a0b6be$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($1a8d4496b8378cba$export$ab9df7c53fe8454, {
    displayName: $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $1a8d4496b8378cba$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $1a8d4496b8378cba$export$be92b6f5f03c0fe9 = $1a8d4496b8378cba$export$8699f7c8af148338;
const $1a8d4496b8378cba$export$6d08773d2e66f8f2 = $1a8d4496b8378cba$export$ab9df7c53fe8454;







var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



var $29f01441dc53d988$export$e27363444bedfeac = (0, $0647093a1b1c5afc$export$e13ec7dd7a14088d)();


var $bd9f283a4124b02e$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $bd9f283a4124b02e$export$22940b497e769dee = $bh6RR.forwardRef(function(props, parentRef) {
    var ref = $bh6RR.useRef(null);
    var _a = $bh6RR.useState({
        onScrollCapture: $bd9f283a4124b02e$var$nothing,
        onWheelCapture: $bd9f283a4124b02e$var$nothing,
        onTouchMoveCapture: $bd9f283a4124b02e$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $59e9bf7262dc1a6d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest), callbacks);
    return $bh6RR.createElement($bh6RR.Fragment, null, enabled && $bh6RR.createElement(SideCar, {
        sideCar: (0, $29f01441dc53d988$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $bh6RR.cloneElement($bh6RR.Children.only(children), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $bh6RR.createElement(Container, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$bd9f283a4124b02e$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$bd9f283a4124b02e$export$22940b497e769dee.classNames = {
    fullWidth: (0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e),
    zeroRight: (0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3)
};





var $bh6RR = parcelRequire("bh6RR");


var $153cce866684b258$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $153cce866684b258$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $153cce866684b258$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $153cce866684b258$var$options, $153cce866684b258$var$options);
    // @ts-ignore
    window.removeEventListener("test", $153cce866684b258$var$options, $153cce866684b258$var$options);
} catch (err) {
    $153cce866684b258$var$passiveSupported = false;
}
var $153cce866684b258$export$10a6e88623fa9454 = $153cce866684b258$var$passiveSupported ? {
    passive: false
} : false;


var $885f1f3a946d08c2$var$elementCouldBeVScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowY !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowY === "visible" // scrollable
    );
};
var $885f1f3a946d08c2$var$elementCouldBeHScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowX !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowX === "visible" // scrollable
    );
};
var $885f1f3a946d08c2$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $885f1f3a946d08c2$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $885f1f3a946d08c2$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $885f1f3a946d08c2$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $885f1f3a946d08c2$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $885f1f3a946d08c2$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $885f1f3a946d08c2$var$elementCouldBeVScrolled(node) : $885f1f3a946d08c2$var$elementCouldBeHScrolled(node);
};
var $885f1f3a946d08c2$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $885f1f3a946d08c2$var$getVScrollVariables(node) : $885f1f3a946d08c2$var$getHScrollVariables(node);
};
var $885f1f3a946d08c2$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $885f1f3a946d08c2$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $885f1f3a946d08c2$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $885f1f3a946d08c2$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($885f1f3a946d08c2$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $eddb39fb09ff5040$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $eddb39fb09ff5040$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $eddb39fb09ff5040$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $eddb39fb09ff5040$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $eddb39fb09ff5040$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $eddb39fb09ff5040$var$idCounter = 0;
var $eddb39fb09ff5040$var$lockStack = [];
function $eddb39fb09ff5040$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $bh6RR.useRef([]);
    var touchStartRef = $bh6RR.useRef([
        0,
        0
    ]);
    var activeAxis = $bh6RR.useRef();
    var id = $bh6RR.useState($eddb39fb09ff5040$var$idCounter++)[0];
    var Style = $bh6RR.useState(function() {
        return (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $bh6RR.useRef(props);
    $bh6RR.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $bh6RR.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($eddb39fb09ff5040$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $bh6RR.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $eddb39fb09ff5040$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $885f1f3a946d08c2$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $885f1f3a946d08c2$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $885f1f3a946d08c2$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $bh6RR.useCallback(function(_event) {
        var event = _event;
        if (!$eddb39fb09ff5040$var$lockStack.length || $eddb39fb09ff5040$var$lockStack[$eddb39fb09ff5040$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $eddb39fb09ff5040$export$39efaa2ca254a28d(event) : $eddb39fb09ff5040$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $eddb39fb09ff5040$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($eddb39fb09ff5040$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) event.preventDefault();
        }
    }, []);
    var shouldCancel = $bh6RR.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $bh6RR.useCallback(function(event) {
        touchStartRef.current = $eddb39fb09ff5040$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $eddb39fb09ff5040$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $eddb39fb09ff5040$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $bh6RR.useEffect(function() {
        $eddb39fb09ff5040$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $153cce866684b258$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $153cce866684b258$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $153cce866684b258$export$10a6e88623fa9454));
        return function() {
            $eddb39fb09ff5040$var$lockStack = $eddb39fb09ff5040$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $153cce866684b258$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $153cce866684b258$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $153cce866684b258$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $bh6RR.createElement($bh6RR.Fragment, null, inert ? $bh6RR.createElement(Style, {
        styles: $eddb39fb09ff5040$var$generateStyle(id)
    }) : null, removeScrollBar ? $bh6RR.createElement((0, $a1bca04d3c994e31$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $0767db29e2640e60$export$2e2bcd8739ae039 = (0, $db1654befbc8d676$export$6cacc8fb0a9b94ce)((0, $29f01441dc53d988$export$e27363444bedfeac), (0, $eddb39fb09ff5040$export$a09dbff87b5da2d));


var $09a0ed93b63c496d$var$ReactRemoveScroll = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement((0, $bd9f283a4124b02e$export$22940b497e769dee), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0767db29e2640e60$export$2e2bcd8739ae039)
    }));
});
$09a0ed93b63c496d$var$ReactRemoveScroll.classNames = (0, $bd9f283a4124b02e$export$22940b497e769dee).classNames;
var $09a0ed93b63c496d$export$2e2bcd8739ae039 = $09a0ed93b63c496d$var$ReactRemoveScroll;


const $f49f73514807b007$var$$6cc32821e9371a1c$var$SELECTION_KEYS = [
    "Enter",
    " "
];
const $f49f73514807b007$var$$6cc32821e9371a1c$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
const $f49f73514807b007$var$$6cc32821e9371a1c$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
const $f49f73514807b007$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
    ...$f49f73514807b007$var$$6cc32821e9371a1c$var$FIRST_KEYS,
    ...$f49f73514807b007$var$$6cc32821e9371a1c$var$LAST_KEYS
];
const $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$f49f73514807b007$var$$6cc32821e9371a1c$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$f49f73514807b007$var$$6cc32821e9371a1c$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
const $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
/* -------------------------------------------------------------------------------------------------
 * Menu
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$MENU_NAME = "Menu";
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$Collection, $f49f73514807b007$var$$6cc32821e9371a1c$var$useCollection, $f49f73514807b007$var$$6cc32821e9371a1c$var$createCollectionScope] = (0, $0928e9a030d7dbc9$export$c74125a8e3af6bb2)($f49f73514807b007$var$$6cc32821e9371a1c$var$MENU_NAME);
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext, $f49f73514807b007$export$4027731b685e72eb] = (0, $ff62918149a22b5f$export$50c7b4e9d9f19c1)($f49f73514807b007$var$$6cc32821e9371a1c$var$MENU_NAME, [
    $f49f73514807b007$var$$6cc32821e9371a1c$var$createCollectionScope,
    (0, $e360c8d229d9b2b7$export$722aac194ae923),
    (0, $1a8d4496b8378cba$export$c7109489551a4f4)
]);
const $f49f73514807b007$var$$6cc32821e9371a1c$var$usePopperScope = (0, $e360c8d229d9b2b7$export$722aac194ae923)();
const $f49f73514807b007$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope = (0, $1a8d4496b8378cba$export$c7109489551a4f4)();
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$MenuProvider, $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext] = $f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$MENU_NAME);
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$MenuRootProvider, $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuRootContext] = $f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$MENU_NAME);
const $f49f73514807b007$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu , open: open = false , children: children , dir: dir , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const popperScope = $f49f73514807b007$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const isUsingKeyboardRef = (0, $bh6RR.useRef)(false);
    const handleOpenChange = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onOpenChange);
    const direction = (0, $87990fa25f891e42$export$b39126d51d94e6f3)(dir);
    (0, $bh6RR.useEffect)(()=>{
        // Capture phase ensures we set the boolean before any side effects execute
        // in response to the key or pointer event as they might depend on this value.
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e360c8d229d9b2b7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuRootProvider, {
        scope: __scopeMenu,
        onClose: (0, $bh6RR.useCallback)(()=>handleOpenChange(false), [
            handleOpenChange
        ]),
        isUsingKeyboardRef: isUsingKeyboardRef,
        dir: direction,
        modal: modal
    }, children)));
};
/*#__PURE__*/ Object.assign($f49f73514807b007$export$d9b273488cd8ce6f, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuAnchor
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$ANCHOR_NAME = "MenuAnchor";
const $f49f73514807b007$export$9fa5ebd18bee4d43 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...anchorProps } = props;
    const popperScope = $f49f73514807b007$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e360c8d229d9b2b7$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$9fa5ebd18bee4d43, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$PORTAL_NAME = "MenuPortal";
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$PortalProvider, $f49f73514807b007$var$$6cc32821e9371a1c$var$usePortalContext] = $f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$PORTAL_NAME, {
    forceMount: undefined
});
const $f49f73514807b007$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu , forceMount: forceMount , children: children , container: container  } = props;
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e3b59b8c3589b16a$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $25eb9a6695888273$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($f49f73514807b007$export$793392f970497feb, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuContent
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME = "MenuContent";
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$MenuContentProvider, $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContentContext] = $f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME);
const $f49f73514807b007$export$479f0f2f71193efe = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$usePortalContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuRootContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e3b59b8c3589b16a$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, rootContext.modal ? /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuRootContentModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuRootContentNonModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })))));
});
/* ---------------------------------------------------------------------------------------------- */ const $f49f73514807b007$var$$6cc32821e9371a1c$var$MenuRootContentModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, ref); // Hide everything from ARIA except the `MenuContent`
    (0, $bh6RR.useEffect)(()=>{
        const content = ref.current;
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open // make sure to only disable pointer events when open
        ,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
const $f49f73514807b007$var$$6cc32821e9371a1c$var$MenuRootContentNonModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $f49f73514807b007$var$$6cc32821e9371a1c$var$MenuContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , loop: loop = false , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , disableOutsideScroll: disableOutsideScroll , ...contentProps } = props;
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuRootContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $f49f73514807b007$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $f49f73514807b007$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $f49f73514807b007$var$$6cc32821e9371a1c$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = (0, $bh6RR.useState)(null);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = (0, $bh6RR.useRef)(0);
    const searchRef = (0, $bh6RR.useRef)("");
    const pointerGraceTimerRef = (0, $bh6RR.useRef)(0);
    const pointerGraceIntentRef = (0, $bh6RR.useRef)(null);
    const pointerDirRef = (0, $bh6RR.useRef)("right");
    const lastPointerXRef = (0, $bh6RR.useRef)(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $09a0ed93b63c496d$export$2e2bcd8739ae039) : (0, $bh6RR.Fragment);
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: (0, $ce8e1a73f7e1edbf$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    } : undefined;
    const handleTypeaheadSearch = (key)=>{
        var _items$find, _items$find2;
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = (_items$find = items.find((item)=>item.ref.current === currentItem)) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $f49f73514807b007$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
        const newItem = (_items$find2 = items.find((item)=>item.textValue === nextMatch)) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current; // Reset `searchRef` 1 second after it was last updated
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1000);
        })(search);
        if (newItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>newItem.focus());
    };
    (0, $bh6RR.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []); // Make sure the whole tree has focus guards as our `MenuContent` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $6b87294b606edc3e$export$b7ece24a22aeda8c)();
    const isPointerMovingToSubmenu = (0, $bh6RR.useCallback)((event)=>{
        var _pointerGraceIntentRe, _pointerGraceIntentRe2;
        const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
        return isMovingTowards && $f49f73514807b007$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: (0, $bh6RR.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: (0, $bh6RR.useCallback)((event)=>{
            var _contentRef$current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: (0, $bh6RR.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: (0, $bh6RR.useCallback)((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, [])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)(ScrollLockWrapper, scrollLockWrapperProps, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $4b213624ced1593f$export$20e40289641fbbb6), {
        asChild: true,
        trapped: trapFocus,
        onMountAutoFocus: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(onOpenAutoFocus, (event)=>{
            var _contentRef$current2;
            // when opening, explicitly focus the content area only and leave
            // `onEntryFocus` in  control of focusing first item
            event.preventDefault();
            (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
        }),
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $dbfdf744c6d639a4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onInteractOutside: onInteractOutside,
        onDismiss: onDismiss
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $1a8d4496b8378cba$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        dir: rootContext.dir,
        orientation: "vertical",
        loop: loop,
        currentTabStopId: currentItemId,
        onCurrentTabStopIdChange: setCurrentItemId,
        onEntryFocus: (event)=>{
            // only focus first item when using keyboard
            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
        }
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e360c8d229d9b2b7$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "menu",
        "aria-orientation": "vertical",
        "data-state": $f49f73514807b007$var$$6cc32821e9371a1c$var$getOpenState(context.open),
        dir: rootContext.dir
    }, popperScope, contentProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...contentProps.style
        },
        onKeyDown: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
            // submenu key events bubble through portals. We only care about keys in this menu.
            const target = event.target;
            const isKeyDownInside = target.closest('[role="menu"]') === event.currentTarget;
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            const isCharacterKey = event.key.length === 1;
            if (isKeyDownInside) {
                // menus should not be navigated using tab key so we prevent it
                if (event.key === "Tab") event.preventDefault();
                if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
            } // focus first/last item based on key pressed
            const content = contentRef.current;
            if (event.target !== content) return;
            if (!$f49f73514807b007$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
            event.preventDefault();
            const items = getItems().filter((item)=>!item.disabled);
            const candidateNodes = items.map((item)=>item.ref.current);
            if ($f49f73514807b007$var$$6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
            $f49f73514807b007$var$$6cc32821e9371a1c$var$focusFirst(candidateNodes);
        }),
        onBlur: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onBlur, (event)=>{
            // clear search buffer when leaving the menu
            if (!event.currentTarget.contains(event.target)) {
                window.clearTimeout(timerRef.current);
                searchRef.current = "";
            }
        }),
        onPointerMove: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onPointerMove, $f49f73514807b007$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            const target = event.target;
            const pointerXHasChanged = lastPointerXRef.current !== event.clientX; // We don't use `event.movementX` for this check because Safari will
            // always return `0` on a pointer event.
            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                pointerDirRef.current = newDir;
                lastPointerXRef.current = event.clientX;
            }
        }))
    })))))));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$479f0f2f71193efe, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$GROUP_NAME = "MenuGroup";
const $f49f73514807b007$export$22a631d1f72787bb = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...groupProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "group"
    }, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$22a631d1f72787bb, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$LABEL_NAME = "MenuLabel";
const $f49f73514807b007$export$dd37bec0e8a99143 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...labelProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$dd37bec0e8a99143, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItem
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_NAME = "MenuItem";
const $f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_SELECT = "menu.itemSelect";
const $f49f73514807b007$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { disabled: disabled = false , onSelect: onSelect , ...itemProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const rootContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuRootContext($f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContentContext($f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const isPointerDownRef = (0, $bh6RR.useRef)(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event), {
                once: true
            });
            (0, $8b55fa05a208ecee$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, itemProps, {
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            var _props$onPointerDown;
            (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            var _event$currentTarget;
            // Pointer down can move to a different menu item which should activate it on pointer up.
            // We dispatch a click for selection to allow composition with click based triggers and to
            // prevent Firefox from getting stuck in text selection mode when the menu closes.
            if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
        }),
        onKeyDown: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($f49f73514807b007$var$$6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                /**
         * We prevent default browser behaviour for selection keys as they should trigger
         * a selection only:
         * - prevents space from scrolling the page.
         * - if keydown causes focus to move, prevents keydown from firing on the new target.
         */ event.preventDefault();
            }
        })
    }));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$2ce376c2cc3355c8, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $f49f73514807b007$var$$6cc32821e9371a1c$var$MenuItemImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , disabled: disabled = false , textValue: textValue , ...itemProps } = props;
    const contentContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContentContext($f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $f49f73514807b007$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [isFocused, setIsFocused] = (0, $bh6RR.useState)(false); // get the item's `.textContent` as default strategy for typeahead `textValue`
    const [textContent, setTextContent] = (0, $bh6RR.useState)("");
    (0, $bh6RR.useEffect)(()=>{
        const menuItem = ref.current;
        if (menuItem) {
            var _menuItem$textContent;
            setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : "").trim());
        }
    }, [
        itemProps.children
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $1a8d4496b8378cba$export$6d08773d2e66f8f2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "menuitem",
        "data-highlighted": isFocused ? "" : undefined,
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined
    }, itemProps, {
        ref: composedRefs,
        onPointerMove: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onPointerMove, $f49f73514807b007$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            if (disabled) contentContext.onItemLeave(event);
            else {
                contentContext.onItemEnter(event);
                if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus();
                }
            }
        })),
        onPointerLeave: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onPointerLeave, $f49f73514807b007$var$$6cc32821e9371a1c$var$whenMouse((event)=>contentContext.onItemLeave(event))),
        onFocus: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsFocused(false))
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
const $f49f73514807b007$export$f6f243521332502d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { checked: checked = false , onCheckedChange: onCheckedChange , ...checkboxItemProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$export$2ce376c2cc3355c8, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "menuitemcheckbox",
        "aria-checked": checked
    }, checkboxItemProps, {
        ref: forwardedRef,
        "data-state": $f49f73514807b007$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, ()=>onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange(!checked), {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$f6f243521332502d, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$RadioGroupProvider, $f49f73514807b007$var$$6cc32821e9371a1c$var$useRadioGroupContext] = $f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
    value: undefined,
    onValueChange: ()=>{}
});
const $f49f73514807b007$export$ea2200c9eee416b3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { value: value , onValueChange: onValueChange , ...groupProps } = props;
    const handleValueChange = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onValueChange);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$export$22a631d1f72787bb, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$ea2200c9eee416b3, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME = "MenuRadioItem";
const $f49f73514807b007$export$69bd225e9817f6d0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { value: value , ...radioItemProps } = props;
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useRadioGroupContext($f49f73514807b007$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$export$2ce376c2cc3355c8, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "menuitemradio",
        "aria-checked": checked
    }, radioItemProps, {
        ref: forwardedRef,
        "data-state": $f49f73514807b007$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(radioItemProps.onSelect, ()=>{
            var _context$onValueChang;
            return (_context$onValueChang = context.onValueChange) === null || _context$onValueChang === void 0 ? void 0 : _context$onValueChang.call(context, value);
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$69bd225e9817f6d0, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, $f49f73514807b007$var$$6cc32821e9371a1c$var$useItemIndicatorContext] = $f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
    checked: false
});
const $f49f73514807b007$export$a2593e23056970a3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , forceMount: forceMount , ...itemIndicatorProps } = props;
    const indicatorContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useItemIndicatorContext($f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e3b59b8c3589b16a$export$99c2b779aa4e8b8b), {
        present: forceMount || indicatorContext.checked
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, itemIndicatorProps, {
        ref: forwardedRef,
        "data-state": $f49f73514807b007$var$$6cc32821e9371a1c$var$getCheckedState(indicatorContext.checked)
    })));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$a2593e23056970a3, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$SEPARATOR_NAME = "MenuSeparator";
const $f49f73514807b007$export$1cec7dcdd713e220 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...separatorProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8b55fa05a208ecee$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "separator",
        "aria-orientation": "horizontal"
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$1cec7dcdd713e220, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$ARROW_NAME = "MenuArrow";
const $f49f73514807b007$export$bcdda4773debf5fa = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...arrowProps } = props;
    const popperScope = $f49f73514807b007$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e360c8d229d9b2b7$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$bcdda4773debf5fa, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSub
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_NAME = "MenuSub";
const [$f49f73514807b007$var$$6cc32821e9371a1c$var$MenuSubProvider, $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuSubContext] = $f49f73514807b007$var$$6cc32821e9371a1c$var$createMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_NAME);
const $f49f73514807b007$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu , children: children , open: open = false , onOpenChange: onOpenChange  } = props;
    const parentMenuContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_NAME, __scopeMenu);
    const popperScope = $f49f73514807b007$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = (0, $bh6RR.useState)(null);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const handleOpenChange = (0, $6e0683946f0e154c$export$25bec8c6f54ee79a)(onOpenChange); // Prevent the parent menu from reopening with open submenus.
    (0, $bh6RR.useEffect)(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e360c8d229d9b2b7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuSubProvider, {
        scope: __scopeMenu,
        contentId: (0, $657600ce222ab206$export$f680877a34711e37)(),
        triggerId: (0, $657600ce222ab206$export$f680877a34711e37)(),
        trigger: trigger,
        onTriggerChange: setTrigger
    }, children)));
};
/*#__PURE__*/ Object.assign($f49f73514807b007$export$71bdb9d1e2909932, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
const $f49f73514807b007$export$5fbbb3ba7297405f = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuRootContext($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuSubContext($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContentContext($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = (0, $bh6RR.useRef)(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef , onPointerGraceIntentChange: onPointerGraceIntentChange  } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = (0, $bh6RR.useCallback)(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    (0, $bh6RR.useEffect)(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$export$9fa5ebd18bee4d43, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, scope), /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": subContext.contentId,
        "data-state": $f49f73514807b007$var$$6cc32821e9371a1c$var$getOpenState(context.open)
    }, props, {
        ref: (0, $74397e510ea9ebe4$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange) // This is redundant for mouse users but we cannot determine pointer type from
        ,
        onClick: (event)=>{
            var _props$onClick;
            (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
            if (props.disabled || event.defaultPrevented) return;
            /**
       * We manually focus because iOS Safari doesn't always focus on click (e.g. buttons)
       * and we rely heavily on `onFocusOutside` for submenus to close when switching
       * between separate submenus.
       */ event.currentTarget.focus();
            if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onPointerMove, $f49f73514807b007$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
                contentContext.onPointerGraceIntentChange(null);
                openTimerRef.current = window.setTimeout(()=>{
                    context.onOpenChange(true);
                    clearOpenTimer();
                }, 100);
            }
        })),
        onPointerLeave: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onPointerLeave, $f49f73514807b007$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            var _context$content;
            clearOpenTimer();
            const contentRect = (_context$content = context.content) === null || _context$content === void 0 ? void 0 : _context$content.getBoundingClientRect();
            if (contentRect) {
                var _context$content2;
                // TODO: make sure to update this when we change positioning logic
                const side = (_context$content2 = context.content) === null || _context$content2 === void 0 ? void 0 : _context$content2.dataset.side;
                const rightSide = side === "right";
                const bleed = rightSide ? -5 : 5;
                const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                contentContext.onPointerGraceIntentChange({
                    area: [
                        // consistently within polygon bounds
                        {
                            x: event.clientX + bleed,
                            y: event.clientY
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.bottom
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.bottom
                        }
                    ],
                    side: side
                });
                window.clearTimeout(pointerGraceTimerRef.current);
                pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
            } else {
                contentContext.onTriggerLeave(event);
                if (event.defaultPrevented) return; // There's 100ms where the user may leave an item before the submenu was opened.
                contentContext.onPointerGraceIntentChange(null);
            }
        })),
        onKeyDown: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (props.disabled || isTypingAhead && event.key === " ") return;
            if ($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                var _context$content3;
                context.onOpenChange(true); // The trigger may hold focus if opened via pointer interaction
                // so we ensure content is given focus again when switching to keyboard.
                (_context$content3 = context.content) === null || _context$content3 === void 0 || _context$content3.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$5fbbb3ba7297405f, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME = "MenuSubContent";
const $f49f73514807b007$export$e7142ab31822bde6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$usePortalContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount , ...subContentProps } = props;
    const context = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuRootContext($f49f73514807b007$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $f49f73514807b007$var$$6cc32821e9371a1c$var$useMenuSubContext($f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $74397e510ea9ebe4$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e3b59b8c3589b16a$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($f49f73514807b007$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId
    }, subContentProps, {
        ref: composedRefs,
        align: "start",
        side: rootContext.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: (event)=>{
            var _ref$current;
            // when opening a submenu, focus content for keyboard users only
            if (rootContext.isUsingKeyboardRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
            event.preventDefault();
        } // The menu might close because of focusing another menu item in the parent menu. We
        ,
        onCloseAutoFocus: (event)=>event.preventDefault(),
        onFocusOutside: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
            // We prevent closing when the trigger is focused to avoid triggering a re-open animation
            // on pointer interaction.
            if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onEscapeKeyDown, rootContext.onClose),
        onKeyDown: (0, $74eb8dfddc90e1e7$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            // Submenu key events bubble through portals. We only care about keys in this menu.
            const isKeyDownInside = event.currentTarget.contains(event.target);
            const isCloseKey = $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
            if (isKeyDownInside && isCloseKey) {
                var _subContext$trigger;
                context.onOpenChange(false); // We focus manually because we prevented it in `onCloseAutoFocus`
                (_subContext$trigger = subContext.trigger) === null || _subContext$trigger === void 0 || _subContext$trigger.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })))));
});
/*#__PURE__*/ Object.assign($f49f73514807b007$export$e7142ab31822bde6, {
    displayName: $f49f73514807b007$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $f49f73514807b007$var$$6cc32821e9371a1c$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $f49f73514807b007$var$$6cc32821e9371a1c$var$getCheckedState(checked) {
    return checked ? "checked" : "unchecked";
}
function $f49f73514807b007$var$$6cc32821e9371a1c$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $f49f73514807b007$var$$6cc32821e9371a1c$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in all the values,
 * the search and the current match, and returns the next match (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through options starting with that character)
 *
 * We also reorder the values by wrapping the array around the current match.
 * This is so we always look forward from the current match, and picking the first
 * match will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current match from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current match still matches.
 */ function $f49f73514807b007$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $f49f73514807b007$var$$6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : undefined;
}
// Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $f49f73514807b007$var$$6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $f49f73514807b007$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $f49f73514807b007$var$$6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $f49f73514807b007$var$$6cc32821e9371a1c$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : undefined;
}
const $f49f73514807b007$export$be92b6f5f03c0fe9 = $f49f73514807b007$export$d9b273488cd8ce6f;
const $f49f73514807b007$export$b688253958b8dfe7 = $f49f73514807b007$export$9fa5ebd18bee4d43;
const $f49f73514807b007$export$602eac185826482c = $f49f73514807b007$export$793392f970497feb;
const $f49f73514807b007$export$7c6e2c02157bb7d2 = $f49f73514807b007$export$479f0f2f71193efe;
const $f49f73514807b007$export$eb2fcfdbd7ba97d4 = $f49f73514807b007$export$22a631d1f72787bb;
const $f49f73514807b007$export$b04be29aa201d4f5 = $f49f73514807b007$export$dd37bec0e8a99143;
const $f49f73514807b007$export$6d08773d2e66f8f2 = $f49f73514807b007$export$2ce376c2cc3355c8;
const $f49f73514807b007$export$16ce288f89fa631c = $f49f73514807b007$export$f6f243521332502d;
const $f49f73514807b007$export$a98f0dcb43a68a25 = $f49f73514807b007$export$ea2200c9eee416b3;
const $f49f73514807b007$export$371ab307eab489c0 = $f49f73514807b007$export$69bd225e9817f6d0;
const $f49f73514807b007$export$c3468e2714d175fa = $f49f73514807b007$export$a2593e23056970a3;
const $f49f73514807b007$export$1ff3c3f08ae963c0 = $f49f73514807b007$export$1cec7dcdd713e220;
const $f49f73514807b007$export$21b07c8f274aebd5 = $f49f73514807b007$export$bcdda4773debf5fa;
const $f49f73514807b007$export$d7a01e11500dfb6f = $f49f73514807b007$export$71bdb9d1e2909932;
const $f49f73514807b007$export$2ea8a7a591ac5eac = $f49f73514807b007$export$5fbbb3ba7297405f;
const $f49f73514807b007$export$6d4de93b380beddf = $f49f73514807b007$export$e7142ab31822bde6;



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $5c11e0fa53c1aa88$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};


const $b86629450e47cd63$var$$1746a345f3d73bb7$var$useReactId = $bh6RR["useId".toString()] || (()=>undefined);
let $b86629450e47cd63$var$$1746a345f3d73bb7$var$count = 0;
function $b86629450e47cd63$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($b86629450e47cd63$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $5c11e0fa53c1aa88$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($b86629450e47cd63$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


/* -------------------------------------------------------------------------------------------------
 * DropdownMenu
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME = "DropdownMenu";
const [$005e45cd2e84c207$var$$d08ef79370b62062$var$createDropdownMenuContext, $005e45cd2e84c207$export$c0623cd925aeb687] = (0, $b1676b1d27d1eee3$export$50c7b4e9d9f19c1)($005e45cd2e84c207$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
    (0, $f49f73514807b007$export$4027731b685e72eb)
]);
const $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope = (0, $f49f73514807b007$export$4027731b685e72eb)();
const [$005e45cd2e84c207$var$$d08ef79370b62062$var$DropdownMenuProvider, $005e45cd2e84c207$var$$d08ef79370b62062$var$useDropdownMenuContext] = $005e45cd2e84c207$var$$d08ef79370b62062$var$createDropdownMenuContext($005e45cd2e84c207$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $005e45cd2e84c207$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , children: children , dir: dir , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = (0, $bh6RR.useRef)(null);
    const [open = false, setOpen] = (0, $2ce63df780ef0595$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($005e45cd2e84c207$var$$d08ef79370b62062$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $b86629450e47cd63$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $b86629450e47cd63$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $bh6RR.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, {
        open: open,
        onOpenChange: setOpen,
        dir: dir,
        modal: modal
    }), children));
};
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$e44a253a59704894, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$TRIGGER_NAME = "DropdownMenuTrigger";
const $005e45cd2e84c207$export$d2469213b3befba9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , disabled: disabled = false , ...triggerProps } = props;
    const context = $005e45cd2e84c207$var$$d08ef79370b62062$var$useDropdownMenuContext($005e45cd2e84c207$var$$d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, menuScope), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f69aca1675017c41$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open ? true : undefined,
        "aria-controls": context.open ? context.contentId : undefined,
        "data-state": context.open ? "open" : "closed",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled
    }, triggerProps, {
        ref: (0, $48f750d71278f534$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
        onPointerDown: (0, $ad536c13151ecfb5$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onOpenToggle(); // prevent trigger focusing when opening
                // this allows the content to be given focus without competition
                if (!context.open) event.preventDefault();
            }
        }),
        onKeyDown: (0, $ad536c13151ecfb5$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (disabled) return;
            if ([
                "Enter",
                " "
            ].includes(event.key)) context.onOpenToggle();
            if (event.key === "ArrowDown") context.onOpenChange(true); // prevent keypresses from scrolling window
            if ([
                " ",
                "ArrowDown"
            ].includes(event.key)) event.preventDefault();
        })
    })));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$d2469213b3befba9, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$PORTAL_NAME = "DropdownMenuPortal";
const $005e45cd2e84c207$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...portalProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$602eac185826482c), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, portalProps));
};
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$cd369b4d4d54efc9, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuContent
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$CONTENT_NAME = "DropdownMenuContent";
const $005e45cd2e84c207$export$6e76d93a37c01248 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...contentProps } = props;
    const context = $005e45cd2e84c207$var$$d08ef79370b62062$var$useDropdownMenuContext($005e45cd2e84c207$var$$d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = (0, $bh6RR.useRef)(false);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: context.contentId,
        "aria-labelledby": context.triggerId
    }, menuScope, contentProps, {
        ref: forwardedRef,
        onCloseAutoFocus: (0, $ad536c13151ecfb5$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
            hasInteractedOutsideRef.current = false; // Always prevent auto focus because we either focus manually or want user agent focus
            event.preventDefault();
        }),
        onInteractOutside: (0, $ad536c13151ecfb5$export$b9ecd428b558ff10)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            // re-namespace exposed content custom property
            ["--radix-dropdown-menu-content-transform-origin"]: "var(--radix-popper-transform-origin)"
        }
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$6e76d93a37c01248, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$GROUP_NAME = "DropdownMenuGroup";
const $005e45cd2e84c207$export$246bebaba3a2f70e = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...groupProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$eb2fcfdbd7ba97d4), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$246bebaba3a2f70e, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$LABEL_NAME = "DropdownMenuLabel";
const $005e45cd2e84c207$export$76e48c5b57f24495 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...labelProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$b04be29aa201d4f5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$76e48c5b57f24495, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItem
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$ITEM_NAME = "DropdownMenuItem";
const $005e45cd2e84c207$export$ed97964d1871885d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...itemProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$6d08773d2e66f8f2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, itemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$ed97964d1871885d, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
const $005e45cd2e84c207$export$53a69729da201fa9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...checkboxItemProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$16ce288f89fa631c), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, checkboxItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$53a69729da201fa9, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
const $005e45cd2e84c207$export$3323ad73d55f587e = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...radioGroupProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$a98f0dcb43a68a25), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, radioGroupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$3323ad73d55f587e, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
const $005e45cd2e84c207$export$e4f69b41b1637536 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...radioItemProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$371ab307eab489c0), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, radioItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$e4f69b41b1637536, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
const $005e45cd2e84c207$export$42355ae145153fb6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...itemIndicatorProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$c3468e2714d175fa), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, itemIndicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$42355ae145153fb6, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$SEPARATOR_NAME = "DropdownMenuSeparator";
const $005e45cd2e84c207$export$da160178fd3bc7e9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...separatorProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$1ff3c3f08ae963c0), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$da160178fd3bc7e9, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$ARROW_NAME = "DropdownMenuArrow";
const $005e45cd2e84c207$export$34b8980744021ec5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...arrowProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$34b8980744021ec5, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSub
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , children: children , open: openProp , onOpenChange: onOpenChange , defaultOpen: defaultOpen  } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = (0, $2ce63df780ef0595$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$d7a01e11500dfb6f), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, {
        open: open,
        onOpenChange: setOpen
    }), children);
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
const $005e45cd2e84c207$export$21dcb7ec56f874cf = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...subTriggerProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$2ea8a7a591ac5eac), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, subTriggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$21dcb7ec56f874cf, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$var$$d08ef79370b62062$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
const $005e45cd2e84c207$export$f34ec8bc2482cc5f = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...subContentProps } = props;
    const menuScope = $005e45cd2e84c207$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $f49f73514807b007$export$6d4de93b380beddf), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, menuScope, subContentProps, {
        ref: forwardedRef,
        style: {
            ...props.style,
            // re-namespace exposed content custom property
            ["--radix-dropdown-menu-content-transform-origin"]: "var(--radix-popper-transform-origin)"
        }
    }));
});
/*#__PURE__*/ Object.assign($005e45cd2e84c207$export$f34ec8bc2482cc5f, {
    displayName: $005e45cd2e84c207$var$$d08ef79370b62062$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $005e45cd2e84c207$export$be92b6f5f03c0fe9 = $005e45cd2e84c207$export$e44a253a59704894;
const $005e45cd2e84c207$export$41fb9f06171c75f4 = $005e45cd2e84c207$export$d2469213b3befba9;
const $005e45cd2e84c207$export$602eac185826482c = $005e45cd2e84c207$export$cd369b4d4d54efc9;
const $005e45cd2e84c207$export$7c6e2c02157bb7d2 = $005e45cd2e84c207$export$6e76d93a37c01248;
const $005e45cd2e84c207$export$eb2fcfdbd7ba97d4 = $005e45cd2e84c207$export$246bebaba3a2f70e;
const $005e45cd2e84c207$export$b04be29aa201d4f5 = $005e45cd2e84c207$export$76e48c5b57f24495;
const $005e45cd2e84c207$export$6d08773d2e66f8f2 = $005e45cd2e84c207$export$ed97964d1871885d;
const $005e45cd2e84c207$export$16ce288f89fa631c = $005e45cd2e84c207$export$53a69729da201fa9;
const $005e45cd2e84c207$export$a98f0dcb43a68a25 = $005e45cd2e84c207$export$3323ad73d55f587e;
const $005e45cd2e84c207$export$371ab307eab489c0 = $005e45cd2e84c207$export$e4f69b41b1637536;
const $005e45cd2e84c207$export$c3468e2714d175fa = $005e45cd2e84c207$export$42355ae145153fb6;
const $005e45cd2e84c207$export$1ff3c3f08ae963c0 = $005e45cd2e84c207$export$da160178fd3bc7e9;
const $005e45cd2e84c207$export$21b07c8f274aebd5 = $005e45cd2e84c207$export$34b8980744021ec5;
const $005e45cd2e84c207$export$d7a01e11500dfb6f = $005e45cd2e84c207$export$2f307d81a64f5442;
const $005e45cd2e84c207$export$2ea8a7a591ac5eac = $005e45cd2e84c207$export$21dcb7ec56f874cf;
const $005e45cd2e84c207$export$6d4de93b380beddf = $005e45cd2e84c207$export$f34ec8bc2482cc5f;





const $b2eb5b442752711a$var$UserDropdown = ({ user: user , children: children  })=>{
    const [bookmarksChecked, setBookmarksChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(true);
    const [urlsChecked, setUrlsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [person, setPerson] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("pedro");
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($005e45cd2e84c207$export$be92b6f5f03c0fe9, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($005e45cd2e84c207$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "DropdownIconButton",
                    "aria-label": "Customise options",
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($005e45cd2e84c207$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($005e45cd2e84c207$export$7c6e2c02157bb7d2, {
                    className: "DropdownMenuContent",
                    sideOffset: 5,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $92e1a497b2510420$export$a6c7ac8248d6e38a), {
                            to: "/sequences",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($005e45cd2e84c207$export$6d08773d2e66f8f2, {
                                className: "DropdownMenuItem",
                                children: "Sequences"
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $92e1a497b2510420$export$a6c7ac8248d6e38a), {
                            to: "/history",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($005e45cd2e84c207$export$6d08773d2e66f8f2, {
                                className: "DropdownMenuItem",
                                children: "History"
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($005e45cd2e84c207$export$21b07c8f274aebd5, {
                            className: "DropdownMenuArrow"
                        })
                    ]
                })
            })
        ]
    });
};
var $b2eb5b442752711a$export$2e2bcd8739ae039 = $b2eb5b442752711a$var$UserDropdown;




function $ddb89bb066eb98c1$var$NavBar() {
    const { isAuthenticated: isAuthenticated , user: user , name: name , handleLogout: handleLogout  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const { volume: volume , toggleMute: toggleMute  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playVolumeOnSound] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($9451fc84508b70b9$exports))));
    const [playVolumeOffSound] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($342ac1c5191b15fb$exports))));
    function handleVolumeClick() {
        const playSound = volume === 1 ? playVolumeOffSound : playVolumeOnSound;
        playSound();
        toggleMute();
    }
    const LoginLogout = isAuthenticated ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
        onClick: handleLogout,
        children: "Logout"
    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bfafc62980e59835$export$2e2bcd8739ae039), {})
    });
    const settingsSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-settings",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
    const volumeMutedSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
            points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
        })
    });
    const volumeOnSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume-2",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M15.54 8.46a5 5 0 0 1 0 7.07"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M19.07 4.93a10 10 0 0 1 0 14.14"
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($ddb89bb066eb98c1$var$FlexWrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                onClick: handleVolumeClick,
                children: volume === 1 ? volumeOnSVG : volumeMutedSVG
            }),
            LoginLogout,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $92e1a497b2510420$export$a6c7ac8248d6e38a), {
                    to: "/about",
                    children: "About"
                })
            }),
            isAuthenticated && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $b2eb5b442752711a$export$2e2bcd8739ae039), {
                    children: [
                        name,
                        " ",
                        settingsSVG
                    ]
                })
            })
        ]
    });
}
var $ddb89bb066eb98c1$export$2e2bcd8739ae039 = $ddb89bb066eb98c1$var$NavBar;
const $ddb89bb066eb98c1$var$FlexWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  gap: 10px;
`;
const $ddb89bb066eb98c1$var$NavItem = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  background-color: var(--number-box-background-color);
  color: var(--number-box-font-color);
  border-left: 1px solid var(--number-box-border-color);
  border-bottom: 1px solid var(--number-box-border-color);
  border-right: 1px solid var(--number-box-border-color);
  &:hover {
    background-color: var(--number-box-border-color);
    color: white;
  }
  /* width: 100px; */
  display: flex;
  padding: 2px 6px;
  /* height: 50px; */
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;

  a {
    text-decoration: none;
    color: inherit;
  }
`; // --number-box-hover-background-color: hsl(240, 10%, 85%);
 // --matrix-cell-background-color: hsl(240, 50%, 93%);
 // --action-box-background-color: hsl(240 10% 95% / 50%);
 // --action-box-hover-background-color: hsl(240 10% 85% / 50%);
 // --action-box-hover-font-color: hsl(240 90% 50% / 50%);
 // --action-box-font-color: hsl(240 65% 40% / 50%);
 // --action-box-border-color: hsl(240 65% 65% / 50%);
 // --bubble-hover-background-color: hsl(240, 100%, 50%);
 // --number-box-hover-font-color: hsl(240, 100%, 50%);
 // --bubble-hover-border-color: hsl(240, 100%, 90%);
 // --number-box-border-radius: 8px;
 // --header-color: hsl(240, 85%, 35%);
 // --active-button-color: hsl(240, 85%, 35%);
 // --hover-button-color: hsl(240, 60%, 55%);
 // --mode-button-selected: hsl(240, 85%, 35%);






var $bh6RR = parcelRequire("bh6RR");




var $de3a9ab63f6c20c4$exports = {};

$de3a9ab63f6c20c4$exports = new URL((parcelRequire("kyEFX")).resolve("bCgZM"), import.meta.url).toString();


function $02ce57c81a0104d3$var$Header({ isHome: isHome  }) {
    const { metaMode: metaMode , setMetaMode: setMetaMode  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const isClassicSelected = metaMode === "classic";
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playClick] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($de3a9ab63f6c20c4$exports))), {
        volume: volume
    });
    function handleMetaModeClick(metaMode) {
        setMetaMode((oldValue)=>{
            if (oldValue !== metaMode) playClick();
            return metaMode;
        });
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$HeaderWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$StyledHeader, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$StyledLink, {
                        href: "/",
                        children: "Riordan Calculator"
                    })
                })
            }),
            isHome && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$StyledButton, {
                isSelected: isClassicSelected,
                onClick: ()=>handleMetaModeClick("classic"),
                children: "Classic"
            }),
            isHome && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$StyledButton, {
                isSelected: !isClassicSelected,
                onClick: ()=>handleMetaModeClick("exponential"),
                children: "Exponential"
            })
        ]
    });
}
const $02ce57c81a0104d3$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  /* flex-direction: column; */
`;
const $02ce57c81a0104d3$var$HeaderWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).header`
  width: 300px;
  display: inline;

  /* margin-bottom: 1px; */
  border: 1px solid var(--number-box-border-color);
  /* border-radius: 4px; */
  padding: 20px;
  padding-top: 25px;
  border-radius: 3px;
  background-color: var(--number-box-background-color);
  /* box-shadow: var(--box-shadow-distance) var(--box-shadow-distance)
    hsl(0, 0%, 50%); */
`;
const $02ce57c81a0104d3$var$StyledHeader = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h1`
  display: inline;
  font-size: 24px;
  font-weight: 500;
  color: var(--header-color);
`;
const $02ce57c81a0104d3$var$StyledLink = (0, $e484c752f3f06549$export$2e2bcd8739ae039).a`
  display: inline;
  font-size: 24px;
  font-weight: 500;
  color: var(--header-color);
  text-decoration: none;
  &:visited {
    color: var(--header-color);
  }
`;
const $02ce57c81a0104d3$var$StyledButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039)(({ isSelected: isSelected , ...props })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        ...props
    }))`
  font-size: 16px;
  background-color: ${(p)=>p.isSelected ? "var(--mode-button-selected)" : "white"};
  border: 1px solid var(--mode-button-selected);
  color: ${(p)=>p.isSelected ? "white" : "var(--mode-button-selected)"};
  padding: 10px;
  border-radius: 12px;
  cursor: ${(p)=>!p.isSelected ? "pointer" : "default"};
  margin: 3px;
  &:first-of-type {
    margin-left: 30px;
  }
  &:hover {
    background-color: ${(p)=>!p.isSelected ? "var(--hover-button-color)" : "var(--active-button-color)"};
    color: white;
  }
`;
var $02ce57c81a0104d3$export$2e2bcd8739ae039 = $02ce57c81a0104d3$var$Header;




function $bee2c5aab3b83228$var$History() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($bee2c5aab3b83228$var$FlexColumnWrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddb89bb066eb98c1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bee2c5aab3b83228$var$HeaderDiv, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e39b83e0b57a38fe$export$2e2bcd8739ae039), {}),
            ";"
        ]
    });
}
var $bee2c5aab3b83228$export$2e2bcd8739ae039 = $bee2c5aab3b83228$var$History;
const $bee2c5aab3b83228$var$HeaderDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  align-self: flex-start;
  padding-left: 300px;
`;
const $bee2c5aab3b83228$var$FlexColumnWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding-left: 35px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  /* background-color: hsl(240, 40%, 90%); */
  margin-left: 0px;
`;





parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");




var $10d37f55d23cc19a$exports = {};

$10d37f55d23cc19a$exports = new URL((parcelRequire("kyEFX")).resolve("30o4I"), import.meta.url).toString();



function $3b1c2110bf1e6ac8$var$NumberBox({ value: value , index: index , onSubmit: onSubmit , sequenceId: sequenceId , sequenceValue: sequenceValue , isFirst: isFirst , zIndex: zIndex , disabled: disabled = false  }) {
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [digits, setDigits] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(value);
    const [isSelected, setIsSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const divRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const [playWhoosh] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($10d37f55d23cc19a$exports))), {
        volume: volume
    });
    // const [playClick] = useSound(clickSound, { volume });
    const { targetBoxIndex: targetBoxIndex , setTargetBoxIndex: setTargetBoxIndex , handleSelectSequence: handleSelectSequence , tabWasPressed: tabWasPressed , setTabWasPressed: setTabWasPressed , handleTruncateSequence: handleTruncateSequence , handleSequenceChange: handleSequenceChange  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    function handleCloseOption() {
        if (isFirst) {
            handleSequenceChange(sequenceId, sequenceValue.slice(1));
            // handleLeftShift(sequenceId);
            playWhoosh();
        } else handleTruncateSequence();
        handleSelectSequence(sequenceId, "custom");
    }
    const [notMounting, setNotMounting] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setNotMounting(true);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (targetBoxIndex === index && buttonRef.current && notMounting && tabWasPressed) {
            buttonRef.current.click();
            setTabWasPressed(false);
        }
    }, [
        targetBoxIndex,
        index,
        notMounting,
        tabWasPressed
    ]);
    // setNumberBoxRefs((oldValue) => {
    //   return {
    //     index: buttonRef,
    //     ...oldValue,
    //   };
    // });
    const bodyStyles = getComputedStyle(document.body);
    const boxLength = bodyStyles.getPropertyValue("--number-box-width").replace("px", "");
    const minfontsize = "0.8rem";
    const maxfontsize = "1.1rem";
    const containerWidthPx = parseInt(boxLength);
    const maxWidthPerCharacter = containerWidthPx * 1.4 / digits.toString().length;
    const rootFontSizePx = 16;
    const maxfontsizeRem = `${maxWidthPerCharacter / rootFontSizePx}rem`;
    function handleClick(event) {
        if (!divRef.current) return;
        if (disabled) return;
        // Set some of the click area off-limits for the close bubble
        const { offsetWidth: width , offsetHeight: height  } = divRef.current;
        const rect = divRef.current.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        if (x > width / 8 && y < height / 8) return; // Ignore the click
        setIsSelected(true);
        setTargetBoxIndex(index);
        setNotMounting(true);
    }
    function handleBlur() {
        setIsSelected(false);
        onSubmit(index, digits);
        handleSelectSequence(sequenceId, "custom");
    }
    function handleKeyPress(value) {
        let cleaned = value.replace(/[^0-9]/g, "");
        if (value.startsWith("0") && value.length > 1) cleaned = value.slice(1);
        setDigits(cleaned);
    }
    const handleFocus = (event)=>{
        event.target.select();
    };
    const inputNumberBox = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            setIsSelected(false);
            onSubmit(index, digits);
            handleSelectSequence(sequenceId, "custom");
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3b1c2110bf1e6ac8$var$StyledInput, {
            value: digits,
            $minfontsize: minfontsize,
            fontSize: maxfontsizeRem,
            $maxfontsize: maxfontsize,
            onChange: (event)=>handleKeyPress(event.target.value),
            onBlur: handleBlur,
            onFocus: handleFocus,
            autoFocus: true
        })
    });
    const boxContents = isSelected ? inputNumberBox : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3b1c2110bf1e6ac8$var$InnerElement, {
        $minfontsize: minfontsize,
        fontSize: maxfontsizeRem,
        $maxfontsize: maxfontsize,
        ref: buttonRef,
        children: digits
    });
    const closeBubble = isFirst && !disabled ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
        message: "Delete First Term",
        side: "top",
        sideOffset: 5,
        arrowshiftX: "0",
        arrowshiftY: "0",
        zidx: zIndex,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3b1c2110bf1e6ac8$var$CloseBubble, {
            onClick: handleCloseOption,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 15 15",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                className: "lucide lucide-x",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M11.25 3.75 L3.75 11.25"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "m3.75 3.75 7.5 7.5"
                    })
                ]
            })
        })
    }) : null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3b1c2110bf1e6ac8$var$Wrapper, {
        ref: divRef,
        onClick: (event)=>handleClick(event),
        disabled: disabled,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($3b1c2110bf1e6ac8$var$InnerContainer, {
            disabled: disabled,
            children: [
                closeBubble,
                boxContents
            ]
        })
    });
}
var $3b1c2110bf1e6ac8$export$2e2bcd8739ae039 = $3b1c2110bf1e6ac8$var$NumberBox;
const $3b1c2110bf1e6ac8$var$CloseBubble = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: absolute;
  background-color: var(--number-box-background-color);
  border: 2px dashed var(--action-box-border-color);
  &:hover {
    background-color: var(--bubble-hover-background-color);
    color: white;
    border: 2px dashed var(--bubble-hover-border-color);
  }
  border-radius: 15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  top: -20px;
  left: 37px;
  z-index: ${(p)=>p.zidx};

  display: flex;
  justify-content: center;
  align-items: center;
`;
const $3b1c2110bf1e6ac8$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: ${(p)=>p.disabled ? "default" : "text"};
  background-color: ${(p)=>p.disabled ? "var(--number-box-disabled-background-color)" : "var(--number-box-background-color)"};
  &:hover {
    background-color: ${(p)=>p.disabled ? "var(--number-box-disabled-background-color)" : "var(--number-box-hover-background-color)"};
  }
  border-radius: var(--number-box-border-radius);
  width: fit-content;
  min-width: var(--number-box-width);
  width: 100%;
  height: var(--number-box-height);
  margin: 1px;
  border: 1px solid var(--number-box-border-color);
  z-index: 1;
  /* padding: 10%; */
`;
const $3b1c2110bf1e6ac8$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--number-box-font-color);
  color: ${(p)=>p.disabled ? "var(--number-box-disabled-font-color)" : "var(--number-box-font-color)"};
  &:hover {
    color: ${(p)=>p.disabled ? "var(--number-box-disabled-font-color)" : "var(--number-box-hover-font-color)"};
  }
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $3b1c2110bf1e6ac8$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
`;
const $3b1c2110bf1e6ac8$var$StyledInput = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input`
  font-family: 'Lato', sans-serif;
  color: hsl(243, 85%, 40%);
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
  height: 100%;
  width: max(var(--number-box-width), var(--number-box-width));
  margin-left: 2px;
  text-align: center;

  line-height: normal;
  border: 1px solid var(--number-box-hover-font-color);
  background-color: white;
  box-sizing: border-box;
`;






var $bh6RR = parcelRequire("bh6RR");




var $7e0db40af334407c$exports = {};

$7e0db40af334407c$exports = new URL((parcelRequire("kyEFX")).resolve("k2DNh"), import.meta.url).toString();



function $174b10774f00d89c$var$ActionBox({ actionType: actionType , sequenceId: sequenceId , sequenceValue: sequenceValue , enabled: enabled  }) {
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playClick] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($7e0db40af334407c$exports))), {
        volume: volume
    });
    const { handleSelectSequence: handleSelectSequence , handleSequenceChange: handleSequenceChange  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const symbol = actionType === "prependZero" ? ">>" : "?";
    function handleClick() {
        if (actionType === "prependZero") // handleAddZero(sequenceId);
        handleSequenceChange(sequenceId, [
            0,
            ...sequenceValue
        ]);
        handleSelectSequence(sequenceId, "custom");
        playClick();
    }
    const onClickAction = enabled ? handleClick : null;
    let result = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($174b10774f00d89c$var$Wrapper, {
        $enabled: enabled,
        onClick: onClickAction,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($174b10774f00d89c$var$InnerContainer, {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($174b10774f00d89c$var$InnerContainer, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($174b10774f00d89c$var$InnerElement, {
                    children: symbol
                })
            })
        })
    });
    if (actionType === "prependZero") result = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
        message: "Prepend a Zero",
        side: "top",
        sideOffset: 5,
        arrowshiftX: "0",
        arrowshiftY: "0",
        children: result
    });
    if (!enabled && actionType === "prependZero") result = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    return result;
}
var $174b10774f00d89c$export$2e2bcd8739ae039 = $174b10774f00d89c$var$ActionBox;
const $174b10774f00d89c$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: ${(p)=>p.$enabled ? "pointer" : "default"};
  background-color: var(--number-box-background-color);
  &:hover {
    background-color: ${(p)=>p.$enabled ? "var(--number-box-hover-background-color)" : "var(--number-box-background-color)"};
    color: ${(p)=>p.$enabled ? "var(--number-box-hover-font-color)" : "var(--number-box-font-color)"};
  }
  border-radius: var(--number-box-border-radius);
  width: fit-content;
  min-width: var(--number-box-width);
  width: 100%;
  height: var(--number-box-height);
  margin: 1px;
  border: 2px dashed var(--number-box-border-color);
  z-index: 0;
  /* padding: 10%; */
`;
const $174b10774f00d89c$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--number-box-font-color);
  &:hover {
    color: var(--number-box-hover-font-color);
  }
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $174b10774f00d89c$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: 1rem;
`;






var $bh6RR = parcelRequire("bh6RR");

function $47c18933f59b2062$var$Spacer() {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useId();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($47c18933f59b2062$var$Wrapper, {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($47c18933f59b2062$var$InnerContainer, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($47c18933f59b2062$var$InnerContainer, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($47c18933f59b2062$var$InnerElement, {})
                })
            })
        })
    }, id);
}
var $47c18933f59b2062$export$2e2bcd8739ae039 = $47c18933f59b2062$var$Spacer;
const $47c18933f59b2062$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: inline-block;
  cursor: none;
  background-color: transparent;
  min-width: var(--spacer-width);
  width: 100%;
  height: var(--number-box-height);
`;
const $47c18933f59b2062$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $47c18933f59b2062$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: 1rem;
`;






var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * @public
 */ const $f69ceb430ae9345a$export$22a697fb29aac98d = (0, $bh6RR.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $bh6RR = parcelRequire("bh6RR");
const $38e1c7c15d587098$export$2285bbca2c666415 = (0, $bh6RR.createContext)({});



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * @public
 */ const $12e60920c2394b39$export$f224e4635b6f8ce2 = (0, $bh6RR.createContext)(null);




var $bh6RR = parcelRequire("bh6RR");
const $0ec11121663cc82b$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $56377e0c81527360$export$700979bc83e7db82 = (0, $0ec11121663cc82b$export$4e09c449d6c407f7) ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);



var $bh6RR = parcelRequire("bh6RR");
const $6a5cdc65c5393968$export$40f10139ecf1f171 = (0, $bh6RR.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $002b84d235cc9e7f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $6b140fcbcf20767d$export$ed7b8fa9dbf0105d = "framerAppearId";
const $6b140fcbcf20767d$export$8592e1c077c890a6 = "data-" + (0, $002b84d235cc9e7f$export$9fd24a634729c672)($6b140fcbcf20767d$export$ed7b8fa9dbf0105d);


const $6c4fc775126b27b6$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


class $1b7b86ec18a0a90a$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $1b7b86ec18a0a90a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $1b7b86ec18a0a90a$var$Queue();
    let nextFrame = new $1b7b86ec18a0a90a$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
                callback(frameData);
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3c9d516863748892$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3c9d516863748892$var$maxElapsed = 40;
function $3c9d516863748892$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $1b7b86ec18a0a90a$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>{
        steps[stepId].process(state);
    };
    const processBatch = ()=>{
        const timestamp = (0, $6c4fc775126b27b6$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3c9d516863748892$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $3c9d516863748892$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$3c9d516863748892$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $3858c82cd1ca695a$export$bb76eed83315504c , cancel: $3858c82cd1ca695a$export$3252729004b8456e  } = (0, $3c9d516863748892$export$510b0596a933801a)(queueMicrotask, false);


function $05aa2ab8e054331c$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent  } = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
    const lazyContext = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171));
    const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $bh6RR.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $bh6RR.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $bh6RR.useRef)(Boolean(props[0, $6b140fcbcf20767d$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $56377e0c81527360$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        (0, $3858c82cd1ca695a$export$bb76eed83315504c).postRender(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}



var $bh6RR = parcelRequire("bh6RR");
function $0dc8dc297bc3aa83$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $29bcaad27b8bb245$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $bh6RR.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $bh6RR = parcelRequire("bh6RR");

/**
 * Decides if the supplied variable is variant label
 */ function $e4ec7857057a08b6$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $6c424f3bd35daf15$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $eb6a0a2a824114cd$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $eb6a0a2a824114cd$export$1405a65085f40b9 = [
    "initial",
    ...$eb6a0a2a824114cd$export$16e45afcc206d3a8
];


function $a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) {
    return (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(props.animate) || (0, $eb6a0a2a824114cd$export$1405a65085f40b9).some((name)=>(0, $e4ec7857057a08b6$export$720b90e312cea233)(props[name]));
}
function $a01dc07902ba23d1$export$ce46fa4165cdec40(props) {
    return Boolean($a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $be811e3f75d8f6fc$export$12fc32fc096a04a3(props, context) {
    if ((0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial , animate: animate  } = props;
        return {
            initial: initial === false || (0, $e4ec7857057a08b6$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $e4ec7857057a08b6$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $a6e92297d8c984af$export$c5638d843b37a176(props) {
    const { initial: initial , animate: animate  } = (0, $be811e3f75d8f6fc$export$12fc32fc096a04a3)(props, (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415)));
    return (0, $bh6RR.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a6e92297d8c984af$var$variantLabelsAsDependency(initial),
        $a6e92297d8c984af$var$variantLabelsAsDependency(animate)
    ]);
}
function $a6e92297d8c984af$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $145d8d26c6dc52b8$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $145d8d26c6dc52b8$export$65570e08d843624d = {};
for(const key in $145d8d26c6dc52b8$var$featureProps)$145d8d26c6dc52b8$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$145d8d26c6dc52b8$var$featureProps[key].some((name)=>!!props[name])
};


function $8223c64d87d3460d$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key] = {
        ...(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $bh6RR = parcelRequire("bh6RR");
const $364741b44296b530$export$a3579ca508007a95 = (0, $bh6RR.createContext)({});




var $bh6RR = parcelRequire("bh6RR");
/**
 * Internal, exported only for usage in Framer
 */ const $b8a0e6b50203ba18$export$da5f7b802957459a = (0, $bh6RR.createContext)({});


const $92847778545e8ed0$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $0c5a031ea8dd3973$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures , createVisualElement: createVisualElement , useRender: useRender , useVisualState: useVisualState , Component: Component  }) {
    preloadedFeatures && (0, $8223c64d87d3460d$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)),
            ...props,
            layoutId: $0c5a031ea8dd3973$var$useLayoutId(props)
        };
        const { isStatic: isStatic  } = configAndProps;
        const context = (0, $a6e92297d8c984af$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $0ec11121663cc82b$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $05aa2ab8e054331c$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a));
            const isStrict = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $d4dab640dcbe486c$exports.jsxs)((0, $38e1c7c15d587098$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $d4dab640dcbe486c$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $29bcaad27b8bb245$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $bh6RR.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $92847778545e8ed0$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $0c5a031ea8dd3973$var$useLayoutId({ layoutId: layoutId  }) {
    const layoutGroupId = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $5b22e6221ec72104$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $0c5a031ea8dd3973$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c47a60ce42aa9a7c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $f9a5862a9160f78d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $c47a60ce42aa9a7c$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $93233d74f0d10a65$export$91ddd985b97788d1 = {};
function $93233d74f0d10a65$export$de9e7791c71225fd(correctors) {
    Object.assign($93233d74f0d10a65$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $05d385f303970557$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $05d385f303970557$export$7b42a0094fb00b6e = new Set($05d385f303970557$export$280dc01950909d86);


function $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf(key, { layout: layout , layoutId: layoutId  }) {
    return (0, $05d385f303970557$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $93233d74f0d10a65$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $d449570363f09a53$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $6330a89fb7e6648e$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $6330a89fb7e6648e$var$numTransforms = (0, $05d385f303970557$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $6330a89fb7e6648e$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true , allowTransformNone: allowTransformNone = true  }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $6330a89fb7e6648e$var$numTransforms; i++){
        const key = (0, $05d385f303970557$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $6330a89fb7e6648e$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $9223341d00255d67$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $9223341d00255d67$export$9de1236619d9e756 = $9223341d00255d67$var$checkStringStartsWith("--");
const $9223341d00255d67$var$startsAsVariableToken = $9223341d00255d67$var$checkStringStartsWith("var(--");
const $9223341d00255d67$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $9223341d00255d67$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $9223341d00255d67$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $9223341d00255d67$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $40c56554da907737$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $84044ef4463ca44e$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $84044ef4463ca44e$export$58f0f39f63f3cf42 = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    transform: (v)=>(0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $84044ef4463ca44e$export$dcdf75081b88279d = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $633590f9df316f77$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $633590f9df316f77$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $633590f9df316f77$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $633590f9df316f77$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $633590f9df316f77$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $ee89500f7aaa2f56$var$createUnitType = (unit)=>({
        test: (v)=>(0, $633590f9df316f77$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ee89500f7aaa2f56$export$41fc368e1a942b97 = $ee89500f7aaa2f56$var$createUnitType("deg");
const $ee89500f7aaa2f56$export$626336c2cd4b14de = $ee89500f7aaa2f56$var$createUnitType("%");
const $ee89500f7aaa2f56$export$91c0eda1d06bf008 = $ee89500f7aaa2f56$var$createUnitType("px");
const $ee89500f7aaa2f56$export$f91e8c45a95a32f2 = $ee89500f7aaa2f56$var$createUnitType("vh");
const $ee89500f7aaa2f56$export$aed3d7b7d206c196 = $ee89500f7aaa2f56$var$createUnitType("vw");
const $ee89500f7aaa2f56$export$44e2e1705876d7ed = {
    ...$ee89500f7aaa2f56$export$626336c2cd4b14de,
    parse: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.transform(v * 100)
};



const $1500fa361742b746$export$7d260a2a5f8bc19e = {
    ...(0, $84044ef4463ca44e$export$98e628dec113755e),
    transform: Math.round
};


const $e26e0ac69c88d1e3$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderRightWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    radius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    maxWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    height: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    maxHeight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    size: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    top: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    right: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    bottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    left: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingTop: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingRight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingBottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingLeft: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    margin: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginTop: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginRight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginBottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginLeft: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateX: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateY: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateZ: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    scale: $84044ef4463ca44e$export$dcdf75081b88279d,
    scaleX: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    scaleY: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    scaleZ: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    skew: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    skewX: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    skewY: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    distance: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateX: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateY: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateZ: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    x: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    y: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    z: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    perspective: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    transformPerspective: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    opacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    originX: (0, $ee89500f7aaa2f56$export$44e2e1705876d7ed),
    originY: (0, $ee89500f7aaa2f56$export$44e2e1705876d7ed),
    originZ: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $1500fa361742b746$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    numOctaves: (0, $1500fa361742b746$export$7d260a2a5f8bc19e)
};


function $5a314cc097974a58$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style , vars: vars , transform: transform , transformOrigin: transformOrigin  } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $9223341d00255d67$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $40c56554da907737$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $6330a89fb7e6648e$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%" , originY: originY = "50%" , originZ: originZ = 0  } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $44dd7fb05ec6c3e6$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $1988bd02b7e1d29b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $d449570363f09a53$export$605d60a2578142d3)(source[key]) && !(0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $1988bd02b7e1d29b$var$useInitialMotionValues({ transformTemplate: transformTemplate  }, visualState, isStatic) {
    return (0, $bh6RR.useMemo)(()=>{
        const state = (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)();
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $1988bd02b7e1d29b$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $1988bd02b7e1d29b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $1988bd02b7e1d29b$var$useInitialMotionValues(props, visualState, isStatic));
    return style;
}
function $1988bd02b7e1d29b$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $1988bd02b7e1d29b$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a022688aad5e3d50$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a022688aad5e3d50$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a022688aad5e3d50$var$validMotionProps.has(key);
}


let $2d7757648940a601$var$shouldForward = (key)=>!(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key);
function $2d7757648940a601$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $2d7757648940a601$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $2d7757648940a601$export$59d6962c470509a5((parcelRequire("e94ba")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $2d7757648940a601$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($2d7757648940a601$var$shouldForward(key) || forwardMotionProps === true && (0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || !isDom && !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $bh6RR = parcelRequire("bh6RR");



function $72f78baea8d3959f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $72f78baea8d3959f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $72f78baea8d3959f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $72f78baea8d3959f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $3fd910e6a82125ad$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $3fd910e6a82125ad$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $3fd910e6a82125ad$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $3fd910e6a82125ad$var$dashKeys : $3fd910e6a82125ad$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $6f8e2d5207755192$export$5475d24f125d7053(state, { attrX: attrX , attrY: attrY , attrScale: attrScale , originX: originX , originY: originY , pathLength: pathLength , pathSpacing: pathSpacing = 1 , pathOffset: pathOffset = 0 , // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs , style: style , dimensions: dimensions  } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $72f78baea8d3959f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $3fd910e6a82125ad$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $a6f7f4461a184c55$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $5c8095c47c03f29b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $f708387b704893ba$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $bh6RR.useMemo)(()=>{
        const state = (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9)();
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $1988bd02b7e1d29b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $890426a95a69aae0$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues  }, isStatic)=>{
        const useVisualProps = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $f708387b704893ba$export$84309c4f53cb1bd5) : (0, $1988bd02b7e1d29b$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $2d7757648940a601$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $bh6RR.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children  } = props;
        const renderedChildren = (0, $bh6RR.useMemo)(()=>(0, $d449570363f09a53$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $bh6RR.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $46b26a876b49a8ee$export$1a32bf6229c258c0(element, { style: style , vars: vars  }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $896574d8c8ac028d$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $50c74351dd8901bc$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $46b26a876b49a8ee$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $c0a33d9fc770b07f$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style  } = props;
    const newValues = {};
    for(const key in style)if ((0, $d449570363f09a53$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $d449570363f09a53$export$605d60a2578142d3)(prevProps.style[key]) || (0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



function $4c234d289d8baf9a$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $d449570363f09a53$export$605d60a2578142d3)(props[key]) || (0, $d449570363f09a53$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $05d385f303970557$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $bh6RR = parcelRequire("bh6RR");


function $960c679efe64d12b$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $9237e2773f81c3d0$export$fe4300aa8eebea86(init) {
    const ref = (0, $bh6RR.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $96ae1bfc697c0155$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $b9d94c0c185391a2$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $b9d94c0c185391a2$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $9e7923b7600c25b9$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $b9d94c0c185391a2$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $e82a2bc47b563e2e$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps , createRenderState: createRenderState , onMount: onMount  }, props, context, presenceContext) {
    const state = {
        latestValues: $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $e82a2bc47b563e2e$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
        const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
        const make = ()=>$e82a2bc47b563e2e$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(make);
    };
function $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial , animate: animate  } = props;
    const isControllingVariants$1 = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd , transition: transition , ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $890b2290aa50a5ad$export$8793edee2d425525 = (any)=>any;



const { schedule: $6491bdd13544fdda$export$2cef06c20297c17d , cancel: $6491bdd13544fdda$export$ec99c0ef4978dccb , state: $6491bdd13544fdda$export$fff89137e9e818ce , steps: $6491bdd13544fdda$export$be3f796aed065412  } = (0, $3c9d516863748892$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $890b2290aa50a5ad$export$8793edee2d425525), true);


const $ecbb32c06e7c035d$export$44dabd3fae512e85 = {
    useVisualState: (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $4c234d289d8baf9a$export$16da615486abaa45),
        createRenderState: (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState , latestValues: latestValues  })=>{
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).render(()=>{
                (0, $6f8e2d5207755192$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $50c74351dd8901bc$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $cb524d462e20deb3$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $c0a33d9fc770b07f$export$16da615486abaa45,
        createRenderState: (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)
    })
};


function $a6b6deed5b4ac5c0$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false  }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $ecbb32c06e7c035d$export$44dabd3fae512e85) : (0, $cb524d462e20deb3$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $890426a95a69aae0$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $5727f053dc302d4d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $d4a10dbc24cee995$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $c20245f8d567b28b$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $c20245f8d567b28b$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $d4a10dbc24cee995$export$a4cf9c8a4b063a6e)(event) && handler(event, $c20245f8d567b28b$export$12f84bb882d06e1a(event));
};


function $149813d40ccb6fe7$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(target, eventName, (0, $c20245f8d567b28b$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $6cc9e4dbba39be5c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $6cc9e4dbba39be5c$export$a4627e546088548d = (...transformers)=>transformers.reduce($6cc9e4dbba39be5c$var$combineFunctions);


function $ab472a7ccdd5989f$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $ab472a7ccdd5989f$var$globalHorizontalLock = $ab472a7ccdd5989f$export$518c5fc2dcb7974b("dragHorizontal");
const $ab472a7ccdd5989f$var$globalVerticalLock = $ab472a7ccdd5989f$export$518c5fc2dcb7974b("dragVertical");
function $ab472a7ccdd5989f$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $ab472a7ccdd5989f$var$globalVerticalLock();
    else if (drag === "x") lock = $ab472a7ccdd5989f$var$globalHorizontalLock();
    else {
        const openHorizontal = $ab472a7ccdd5989f$var$globalHorizontalLock();
        const openVertical = $ab472a7ccdd5989f$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $ab472a7ccdd5989f$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $ab472a7ccdd5989f$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $8c269db61902fb68$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


function $d74f51ccafbc2725$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $ab472a7ccdd5989f$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) callback(event, info);
    };
    return (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $d74f51ccafbc2725$export$93a81ea037eac456 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)($d74f51ccafbc2725$var$addHoverEvent(this.node, true), $d74f51ccafbc2725$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $194e5f2fba7dd91c$export$d4826db40d47595b extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)((0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $53e08f6fdf34dfce$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $53e08f6fdf34dfce$export$e841ada32ff745b(parent, child.parentElement);
};



function $7978956cdecaf1df$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $7978956cdecaf1df$export$f026abdbba7f0c9e extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $890b2290aa50a5ad$export$8793edee2d425525);
        this.removeEndListeners = (0, $890b2290aa50a5ad$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $890b2290aa50a5ad$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap , onTapCancel: onTapCancel , globalTapTarget: globalTapTarget  } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ !globalTapTarget && !(0, $53e08f6fdf34dfce$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
            };
            const removePointerUpListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $7978956cdecaf1df$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap  } = this.node.getProps();
                        if (onTap) onTap(event, info);
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $7978956cdecaf1df$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $7978956cdecaf1df$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart , whileTap: whileTap  } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) onTapStart(event, info);
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $ab472a7ccdd5989f$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel  } = this.node.getProps();
        if (onTapCancel) onTapCancel(event, info);
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $a7da81711d7ddff5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $a7da81711d7ddff5$var$observers = new WeakMap();
const $a7da81711d7ddff5$var$fireObserverCallback = (entry)=>{
    const callback = $a7da81711d7ddff5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $a7da81711d7ddff5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($a7da81711d7ddff5$var$fireObserverCallback);
};
function $a7da81711d7ddff5$var$initIntersectionObserver({ root: root , ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$a7da81711d7ddff5$var$observers.has(lookupRoot)) $a7da81711d7ddff5$var$observers.set(lookupRoot, {});
    const rootObservers = $a7da81711d7ddff5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($a7da81711d7ddff5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $a7da81711d7ddff5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $a7da81711d7ddff5$var$initIntersectionObserver(options);
    $a7da81711d7ddff5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $a7da81711d7ddff5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $62d26f27ee79826d$var$thresholdNames = {
    some: 0,
    all: 1
};
class $62d26f27ee79826d$export$150851c8cc2f0c72 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {}  } = this.node.getProps();
        const { root: root , margin: rootMargin , amount: amount = "some" , once: once  } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $62d26f27ee79826d$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting  } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter , onViewportLeave: onViewportLeave  } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $a7da81711d7ddff5$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props , prevProps: prevProps  } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($62d26f27ee79826d$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $62d26f27ee79826d$var$hasViewportOptionChanged({ viewport: viewport = {}  }, { viewport: prevViewport = {}  } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $aadd72d7ca06bd3a$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $62d26f27ee79826d$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $7978956cdecaf1df$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $194e5f2fba7dd91c$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $d74f51ccafbc2725$export$93a81ea037eac456)
    }
};





function $b3131a4296a9915c$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $dfe6a10b7b91d234$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $dfe6a10b7b91d234$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $dfe6a10b7b91d234$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $dfe6a10b7b91d234$var$getCurrent(visualElement), $dfe6a10b7b91d234$var$getVelocity(visualElement));
}






/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $631bdbca8ed9a472$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $631bdbca8ed9a472$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $943a3f0a32f59f42$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $943a3f0a32f59f42$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $943a3f0a32f59f42$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $943a3f0a32f59f42$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $943a3f0a32f59f42$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes  })=>{
    if (keyframes.length > 2) return $943a3f0a32f59f42$var$keyframesTransition;
    else if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $943a3f0a32f59f42$var$criticallyDampedSpring(keyframes[1]) : $943a3f0a32f59f42$var$underDampedSpring;
    return $943a3f0a32f59f42$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $cba3eab4a749f231$export$ca8e47dc8ed5a9d7({ when: when , delay: _delay , delayChildren: delayChildren , staggerChildren: staggerChildren , staggerDirection: staggerDirection , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , from: from , elapsed: elapsed , ...transition }) {
    return !!Object.keys(transition).length;
}
function $cba3eab4a749f231$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $636ef95c23a1ebef$export$888a3d84909f9e3d = {
    current: false
};


const $cb21c6c57eea1e02$var$isNotNull = (value)=>value !== null;
function $cb21c6c57eea1e02$export$14de59408fad90b(keyframes, { repeat: repeat , repeatType: repeatType = "loop"  }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($cb21c6c57eea1e02$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





let $05b982fb85a2786e$var$now;
function $05b982fb85a2786e$var$clearTime() {
    $05b982fb85a2786e$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $05b982fb85a2786e$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($05b982fb85a2786e$var$now === undefined) $05b982fb85a2786e$export$2da9be4cfdb689b1.set((0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing || (0, $6c4fc775126b27b6$export$dd826089e3c5e502).useManualTiming ? (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp : performance.now());
        return $05b982fb85a2786e$var$now;
    },
    set: (newTime)=>{
        $05b982fb85a2786e$var$now = newTime;
        queueMicrotask($05b982fb85a2786e$var$clearTime);
    }
};


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $e46637106d3b5fd8$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $cfbb3fdee2e93a54$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $e46637106d3b5fd8$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $9ef77cb0818a2387$export$491112666e282270 = (0, $890b2290aa50a5ad$export$8793edee2d425525);
let $9ef77cb0818a2387$export$f5708dca728d7177 = (0, $890b2290aa50a5ad$export$8793edee2d425525);
var $9ef77cb0818a2387$var$check, $9ef77cb0818a2387$var$message, $9ef77cb0818a2387$var$check1, $9ef77cb0818a2387$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $307e1e0a636b2ddb$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ff42741a21ccb940$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $ff42741a21ccb940$export$b9f0c1f373aee2b0(current) {
    const match = $ff42741a21ccb940$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $ff42741a21ccb940$var$maxDepth = 4;
function $ff42741a21ccb940$export$289398774300c991(current, element, depth = 1) {
    (0, $9ef77cb0818a2387$export$f5708dca728d7177)(depth <= $ff42741a21ccb940$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ff42741a21ccb940$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $307e1e0a636b2ddb$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $9223341d00255d67$export$31f9caa2600b5723)(fallback) ? $ff42741a21ccb940$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






const $2b1f30070063653f$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $2b1f30070063653f$export$8e5250d1aa9bf370 = (v)=>v === (0, $84044ef4463ca44e$export$98e628dec113755e) || v === (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008);
const $2b1f30070063653f$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $2b1f30070063653f$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform  })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $2b1f30070063653f$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $2b1f30070063653f$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $2b1f30070063653f$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $2b1f30070063653f$var$nonTranslationalTransformKeys = (0, $05d385f303970557$export$280dc01950909d86).filter((key)=>!$2b1f30070063653f$var$transformKeys.has(key));
function $2b1f30070063653f$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $2b1f30070063653f$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $2b1f30070063653f$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x  }, { paddingLeft: paddingLeft = "0" , paddingRight: paddingRight = "0"  })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y  }, { paddingTop: paddingTop = "0" , paddingBottom: paddingBottom = "0"  })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top  })=>parseFloat(top),
    left: (_bbox, { left: left  })=>parseFloat(left),
    bottom: ({ y: y  }, { top: top  })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x  }, { left: left  })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $2b1f30070063653f$var$getTranslateFromMatrix(4, 13),
    y: $2b1f30070063653f$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$2b1f30070063653f$export$781d46a8aa670d52.translateX = $2b1f30070063653f$export$781d46a8aa670d52.x;
$2b1f30070063653f$export$781d46a8aa670d52.translateY = $2b1f30070063653f$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $bce78752b9f7f913$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $6e9d07411e0549ee$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $d03d4f627f09ffbd$export$d176691c1998a1f5 = [
    (0, $84044ef4463ca44e$export$98e628dec113755e),
    (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    (0, $ee89500f7aaa2f56$export$626336c2cd4b14de),
    (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    (0, $ee89500f7aaa2f56$export$aed3d7b7d206c196),
    (0, $ee89500f7aaa2f56$export$f91e8c45a95a32f2),
    (0, $6e9d07411e0549ee$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $d03d4f627f09ffbd$export$eefdd52e3ccae428 = (v)=>$d03d4f627f09ffbd$export$d176691c1998a1f5.find((0, $bce78752b9f7f913$export$6eae4d0a6a7ca7cd)(v));




const $8a643b2da1c7bc40$var$toResolve = new Set();
let $8a643b2da1c7bc40$var$isScheduled = false;
let $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
function $8a643b2da1c7bc40$var$measureAllKeyframes() {
    if ($8a643b2da1c7bc40$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($8a643b2da1c7bc40$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $2b1f30070063653f$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
    $8a643b2da1c7bc40$var$isScheduled = false;
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>resolver.complete());
    $8a643b2da1c7bc40$var$toResolve.clear();
}
function $8a643b2da1c7bc40$var$readAllKeyframes() {
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $8a643b2da1c7bc40$var$anyNeedsMeasurement = true;
    });
}
function $8a643b2da1c7bc40$export$78b96d2a12593b05() {
    $8a643b2da1c7bc40$var$readAllKeyframes();
    $8a643b2da1c7bc40$var$measureAllKeyframes();
}
class $8a643b2da1c7bc40$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $8a643b2da1c7bc40$var$toResolve.add(this);
            if (!$8a643b2da1c7bc40$var$isScheduled) {
                $8a643b2da1c7bc40$var$isScheduled = true;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).read($8a643b2da1c7bc40$var$readAllKeyframes);
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).resolveKeyframes($8a643b2da1c7bc40$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name , element: element , motionValue: motionValue  } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $8a643b2da1c7bc40$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $8a643b2da1c7bc40$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $5722faa01ec1ec2e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $633590f9df316f77$export$844ec244b1367d54)(v) && (0, $633590f9df316f77$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $5722faa01ec1ec2e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $633590f9df316f77$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $633590f9df316f77$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $73de4a1e9f0dd80c$var$clampRgbUnit = (v)=>(0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e = {
    ...(0, $84044ef4463ca44e$export$98e628dec113755e),
    transform: (v)=>Math.round($73de4a1e9f0dd80c$var$clampRgbUnit(v))
};
const $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b = {
    test: (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $5722faa01ec1ec2e$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red , green: green , blue: blue , alpha: alpha$1 = 1  })=>"rgba(" + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(red) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(green) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $633590f9df316f77$export$83d2e9e3e4ee39ed)((0, $84044ef4463ca44e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $30a5a0b739818b6d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $30a5a0b739818b6d$export$834dfc94dde4b3d8 = {
    test: (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("#"),
    parse: $30a5a0b739818b6d$var$parseHex,
    transform: (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform
};






const $0843b7e1fb4696f0$export$810b04175080204c = {
    test: (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $5722faa01ec1ec2e$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha$1 = 1  })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).transform((0, $633590f9df316f77$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).transform((0, $633590f9df316f77$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $633590f9df316f77$export$83d2e9e3e4ee39ed)((0, $84044ef4463ca44e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $7a26ed3125820d32$export$35e9368ef982300f = {
    test: (v)=>(0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).test(v) || (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8).test(v) || (0, $0843b7e1fb4696f0$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).test(v)) return (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $0843b7e1fb4696f0$export$810b04175080204c).test(v)) return (0, $0843b7e1fb4696f0$export$810b04175080204c).parse(v);
        else return (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $633590f9df316f77$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform(v) : (0, $0843b7e1fb4696f0$export$810b04175080204c).transform(v);
    }
};



function $a554c66132092e1c$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $633590f9df316f77$export$844ec244b1367d54)(v) && (((_a = v.match((0, $633590f9df316f77$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $633590f9df316f77$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $a554c66132092e1c$var$NUMBER_TOKEN = "number";
const $a554c66132092e1c$var$COLOR_TOKEN = "color";
const $a554c66132092e1c$var$VAR_TOKEN = "var";
const $a554c66132092e1c$var$VAR_FUNCTION_TOKEN = "var(";
const $a554c66132092e1c$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $a554c66132092e1c$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $a554c66132092e1c$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($a554c66132092e1c$var$complexRegex, (parsedValue)=>{
        if ((0, $7a26ed3125820d32$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($a554c66132092e1c$var$COLOR_TOKEN);
            values.push((0, $7a26ed3125820d32$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($a554c66132092e1c$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($a554c66132092e1c$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($a554c66132092e1c$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $a554c66132092e1c$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($a554c66132092e1c$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $a554c66132092e1c$var$parseComplexValue(v) {
    return $a554c66132092e1c$export$b61fc7c44bf646d5(v).values;
}
function $a554c66132092e1c$var$createTransformer(source) {
    const { split: split , types: types  } = $a554c66132092e1c$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $a554c66132092e1c$var$NUMBER_TOKEN) output += (0, $633590f9df316f77$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $a554c66132092e1c$var$COLOR_TOKEN) output += (0, $7a26ed3125820d32$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $a554c66132092e1c$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $a554c66132092e1c$var$getAnimatableNone(v) {
    const parsed = $a554c66132092e1c$var$parseComplexValue(v);
    const transformer = $a554c66132092e1c$var$createTransformer(v);
    return transformer(parsed.map($a554c66132092e1c$var$convertNumbersToZero));
}
const $a554c66132092e1c$export$83a0e34f1302825b = {
    test: $a554c66132092e1c$var$test,
    parse: $a554c66132092e1c$var$parseComplexValue,
    createTransformer: $a554c66132092e1c$var$createTransformer,
    getAnimatableNone: $a554c66132092e1c$var$getAnimatableNone
};




/**
 * Properties that should default to 1 or 100%
 */ const $9326f348bb1b920e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $9326f348bb1b920e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $633590f9df316f77$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $9326f348bb1b920e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $9326f348bb1b920e$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $9326f348bb1b920e$export$3dea766d36a8935f = {
    ...(0, $a554c66132092e1c$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($9326f348bb1b920e$var$functionRegex);
        return functions ? functions.map($9326f348bb1b920e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $5244b39289cc5c6d$export$98cd7c72c5a731fb = {
    ...(0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b),
    color: // Color props
    $7a26ed3125820d32$export$35e9368ef982300f,
    backgroundColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    outlineColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    fill: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    stroke: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderTopColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderRightColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderBottomColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderLeftColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    filter: $9326f348bb1b920e$export$3dea766d36a8935f,
    WebkitFilter: (0, $9326f348bb1b920e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $5244b39289cc5c6d$export$67d1babe0338d23b = (key)=>$5244b39289cc5c6d$export$98cd7c72c5a731fb[key];


function $1838583c06c42261$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $9326f348bb1b920e$export$3dea766d36a8935f)) defaultValueType = (0, $a554c66132092e1c$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ function $7a2127a321ebfc42$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        if (typeof unresolvedKeyframes[i] === "string" && unresolvedKeyframes[i] !== "none" && unresolvedKeyframes[i] !== "0") animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $1838583c06c42261$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $c8b2f05e40a653fe$export$4983792d11b61017 extends (0, $8a643b2da1c7bc40$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , element: element , name: name  } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            const keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string" && (0, $9223341d00255d67$export$31f9caa2600b5723)(keyframe)) {
                const resolved = (0, $ff42741a21ccb940$export$289398774300c991)(keyframe, element.current);
                if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
            }
        }
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $2b1f30070063653f$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return this.resolveNoneKeyframes();
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $d03d4f627f09ffbd$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $d03d4f627f09ffbd$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $2b1f30070063653f$export$8e5250d1aa9bf370)(originType) && (0, $2b1f30070063653f$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $cfbb3fdee2e93a54$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $7a2127a321ebfc42$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element , unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $2b1f30070063653f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element , name: name , unresolvedKeyframes: unresolvedKeyframes  } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $2b1f30070063653f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $b4f9da87da1ca830$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}








/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $9af063a91152801b$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $a554c66132092e1c$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $dd719f2577620065$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $dd719f2577620065$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $9af063a91152801b$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $9af063a91152801b$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $9ef77cb0818a2387$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $dd719f2577620065$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



class $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true , delay: delay = 0 , type: type = "keyframes" , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType = "loop" , ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $8a643b2da1c7bc40$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.hasAttemptedResolve = true;
        const { name: name , type: type , velocity: velocity , delay: delay , onComplete: onComplete , onUpdate: onUpdate , isGenerator: isGenerator  } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $dd719f2577620065$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $636ef95c23a1ebef$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $8d9716de34c4d522$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $53c11e9376dd0d8e$var$velocitySampleDuration = 5; // ms
function $53c11e9376dd0d8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $53c11e9376dd0d8e$var$velocitySampleDuration, 0);
    return (0, $8d9716de34c4d522$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $e053e23acb72da0f$var$safeMin = 0.001;
const $e053e23acb72da0f$export$a3cdb76e84ee608e = 0.01;
const $e053e23acb72da0f$export$1824b851fad8862b = 10.0;
const $e053e23acb72da0f$export$ff08f2d53484465 = 0.05;
const $e053e23acb72da0f$export$201ca48e54038115 = 1;
function $e053e23acb72da0f$export$b15f158dc6d6f458({ duration: duration = 800 , bounce: bounce = 0.25 , velocity: velocity = 0 , mass: mass = 1  }) {
    let envelope;
    let derivative;
    (0, $9ef77cb0818a2387$export$491112666e282270)(duration <= (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)($e053e23acb72da0f$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)($e053e23acb72da0f$export$ff08f2d53484465, $e053e23acb72da0f$export$201ca48e54038115, dampingRatio);
    duration = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)($e053e23acb72da0f$export$a3cdb76e84ee608e, $e053e23acb72da0f$export$1824b851fad8862b, (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $e053e23acb72da0f$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $e053e23acb72da0f$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $e053e23acb72da0f$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$e053e23acb72da0f$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $e053e23acb72da0f$var$rootIterations = 12;
function $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $e053e23acb72da0f$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $883a7f57df047776$var$durationKeys = [
    "duration",
    "bounce"
];
const $883a7f57df047776$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $883a7f57df047776$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $883a7f57df047776$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$physicsKeys) && $883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$durationKeys)) {
        const derived = (0, $e053e23acb72da0f$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $883a7f57df047776$export$b36281d89752ae66({ keyframes: keyframes , restDelta: restDelta , restSpeed: restSpeed , ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness , damping: damping , mass: mass , duration: duration , velocity: velocity , isResolvedFromDuration: isResolvedFromDuration  } = $883a7f57df047776$var$getSpringOptions({
        ...options,
        velocity: -(0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $e053e23acb72da0f$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $53c11e9376dd0d8e$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $45d5055f4c56892a$export$ee3ff3a17106998({ keyframes: keyframes , velocity: velocity = 0.0 , power: power = 0.8 , timeConstant: timeConstant = 325 , bounceDamping: bounceDamping = 10 , bounceStiffness: bounceStiffness = 500 , modifyTarget: modifyTarget , min: min , max: max , restDelta: restDelta = 0.5 , restSpeed: restSpeed  }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $883a7f57df047776$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $53c11e9376dd0d8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $704adaa4b6058bb3$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $704adaa4b6058bb3$var$subdivisionPrecision = 0.0000001;
const $704adaa4b6058bb3$var$subdivisionMaxIterations = 12;
function $704adaa4b6058bb3$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $704adaa4b6058bb3$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $704adaa4b6058bb3$var$subdivisionPrecision && ++i < $704adaa4b6058bb3$var$subdivisionMaxIterations);
    return currentT;
}
function $704adaa4b6058bb3$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $890b2290aa50a5ad$export$8793edee2d425525;
    const getTForX = (aX)=>$704adaa4b6058bb3$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $704adaa4b6058bb3$var$calcBezier(getTForX(t), mY1, mY2);
}


const $d8968a9bf4ef9569$export$929e5a82286172a6 = (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $d8968a9bf4ef9569$export$57636bb43b1ccbb0 = (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $d8968a9bf4ef9569$export$c07234257a03d5e9 = (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $77de1aec9c0d8bc3$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $89b4bec8fd3fdad1$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $0437738b097fa26f$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $f0e499eff44e3cea$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $f0e499eff44e3cea$export$c8d67a19199d1a50 = (0, $0437738b097fa26f$export$2c07eeff45156d4d)($f0e499eff44e3cea$export$e444123e42d03385);
const $f0e499eff44e3cea$export$30d3455eee55bed5 = (0, $89b4bec8fd3fdad1$export$f946554fb8aeaf0d)($f0e499eff44e3cea$export$e444123e42d03385);





const $d3c4eaabf34a945a$export$77edfce482316a60 = (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $d3c4eaabf34a945a$export$b01116c84cdfe1a2 = (0, $0437738b097fa26f$export$2c07eeff45156d4d)($d3c4eaabf34a945a$export$77edfce482316a60);
const $d3c4eaabf34a945a$export$ddc5fd596f6c71b2 = (0, $89b4bec8fd3fdad1$export$f946554fb8aeaf0d)($d3c4eaabf34a945a$export$b01116c84cdfe1a2);



const $1a7a42634de0d0af$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $d3c4eaabf34a945a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $d606f3c6c8f4d23c$var$easingLookup = {
    linear: (0, $890b2290aa50a5ad$export$8793edee2d425525),
    easeIn: $d8968a9bf4ef9569$export$929e5a82286172a6,
    easeInOut: $d8968a9bf4ef9569$export$c07234257a03d5e9,
    easeOut: $d8968a9bf4ef9569$export$57636bb43b1ccbb0,
    circIn: $f0e499eff44e3cea$export$e444123e42d03385,
    circInOut: $f0e499eff44e3cea$export$30d3455eee55bed5,
    circOut: $f0e499eff44e3cea$export$c8d67a19199d1a50,
    backIn: $d3c4eaabf34a945a$export$b01116c84cdfe1a2,
    backInOut: $d3c4eaabf34a945a$export$ddc5fd596f6c71b2,
    backOut: $d3c4eaabf34a945a$export$77edfce482316a60,
    anticipate: $1a7a42634de0d0af$export$6b0af63b873d419e
};
const $d606f3c6c8f4d23c$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $9ef77cb0818a2387$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $9ef77cb0818a2387$export$f5708dca728d7177)($d606f3c6c8f4d23c$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $d606f3c6c8f4d23c$var$easingLookup[definition];
    }
    return definition;
};





/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $e6e94e48128648b0$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $87248eb8ba080f28$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $5429745468e3b812$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5429745468e3b812$export$6ae64dbcd6bfc33e({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha  }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $5429745468e3b812$var$hueToRgb(p, q, hue + 1 / 3);
        green = $5429745468e3b812$var$hueToRgb(p, q, hue);
        blue = $5429745468e3b812$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $3587923dc2cfe4e2$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $3587923dc2cfe4e2$var$colorTypes = [
    (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8),
    (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b),
    (0, $0843b7e1fb4696f0$export$810b04175080204c)
];
const $3587923dc2cfe4e2$var$getColorType = (v)=>$3587923dc2cfe4e2$var$colorTypes.find((type)=>type.test(v));
function $3587923dc2cfe4e2$var$asRGBA(color) {
    const type = $3587923dc2cfe4e2$var$getColorType(color);
    (0, $9ef77cb0818a2387$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $0843b7e1fb4696f0$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $5429745468e3b812$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $3587923dc2cfe4e2$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $3587923dc2cfe4e2$var$asRGBA(from);
    const toRGBA = $3587923dc2cfe4e2$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform(blended);
    };
};







function $bbad6d399b1675c4$var$mixImmediate(a, b) {
    return (p)=>p > 0 ? b : a;
}
function $bbad6d399b1675c4$var$mixNumber(a, b) {
    return (p)=>(0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $bbad6d399b1675c4$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $bbad6d399b1675c4$var$mixNumber;
    else if (typeof a === "string") return (0, $9223341d00255d67$export$31f9caa2600b5723)(a) ? $bbad6d399b1675c4$var$mixImmediate : (0, $7a26ed3125820d32$export$35e9368ef982300f).test(a) ? (0, $3587923dc2cfe4e2$export$51e568cf5c039bac) : $bbad6d399b1675c4$export$65516310a87d8205;
    else if (Array.isArray(a)) return $bbad6d399b1675c4$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $7a26ed3125820d32$export$35e9368ef982300f).test(a) ? (0, $3587923dc2cfe4e2$export$51e568cf5c039bac) : $bbad6d399b1675c4$export$ebc23b6840c51ba1;
    return $bbad6d399b1675c4$var$mixImmediate;
}
function $bbad6d399b1675c4$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$bbad6d399b1675c4$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $bbad6d399b1675c4$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $bbad6d399b1675c4$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $bbad6d399b1675c4$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $bbad6d399b1675c4$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $a554c66132092e1c$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) return (0, $6cc9e4dbba39be5c$export$a4627e546088548d)($bbad6d399b1675c4$export$3bbefa2f402845c4($bbad6d399b1675c4$var$matchOrder(originStats, targetStats), targetStats.values), template);
    else {
        (0, $9ef77cb0818a2387$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $bbad6d399b1675c4$var$mixImmediate(origin, target);
    }
};



function $ffbcc7e5194b07fa$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $bbad6d399b1675c4$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $db1b2cb99cb3914e$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $ffbcc7e5194b07fa$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $890b2290aa50a5ad$export$8793edee2d425525) : ease;
            mixer = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $db1b2cb99cb3914e$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true , ease: ease , mixer: mixer  } = {}) {
    const inputLength = input.length;
    (0, $9ef77cb0818a2387$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $db1b2cb99cb3914e$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $3d0a1060fe6b890b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $3d0a1060fe6b890b$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $56a5cdb9e012c5ee$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $a441228218aac9d3$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $d8968a9bf4ef9569$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $a441228218aac9d3$export$d25ddfdf17c3ad3e({ duration: duration = 300 , keyframes: keyframeValues , times: times , ease: ease = "easeInOut"  }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $77de1aec9c0d8bc3$export$216948827bbdc797)(ease) ? ease.map((0, $d606f3c6c8f4d23c$export$ef97fe084f156ca4)) : (0, $d606f3c6c8f4d23c$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $56a5cdb9e012c5ee$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $db1b2cb99cb3914e$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $a441228218aac9d3$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9e09771207b3385c$export$f4ff70a5b4808fd8 = 20000;
function $9e09771207b3385c$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $9e09771207b3385c$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $9e09771207b3385c$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $eb7f9ad0d187e388$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp  })=>update(timestamp);
    return {
        start: ()=>(0, $6491bdd13544fdda$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing ? (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp : (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now()
    };
};



const $38d8d0fc14215eff$var$generators = {
    decay: (0, $45d5055f4c56892a$export$ee3ff3a17106998),
    inertia: $45d5055f4c56892a$export$ee3ff3a17106998,
    tween: (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e),
    keyframes: (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e),
    spring: $883a7f57df047776$export$b36281d89752ae66
};
const $38d8d0fc14215eff$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $38d8d0fc14215eff$export$fd98d9cca67a58bc extends (0, $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $8a643b2da1c7bc40$export$74d34ca3182f1750) , ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop  } = this.options;
            onStop && onStop();
        };
        const { name: name , motionValue: motionValue , keyframes: keyframes  } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes" , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType , velocity: velocity = 0  } = this.options;
        const generatorFactory = $38d8d0fc14215eff$var$generators[type] || (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)($38d8d0fc14215eff$var$percentToProgress, (0, $ffbcc7e5194b07fa$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $9e09771207b3385c$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration  } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true  } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved  } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes  } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe , generator: generator , mirroredGenerator: mirroredGenerator , mapPercentToKeyframes: mapPercentToKeyframes , keyframes: keyframes , calculatedDuration: calculatedDuration , totalDuration: totalDuration , resolvedDuration: resolvedDuration  } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , onUpdate: onUpdate  } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done  } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved  } = this;
        return resolved ? (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $eb7f9ad0d187e388$export$c1033964b5ad7fef) , onPlay: onPlay  } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete  } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $38d8d0fc14215eff$export$ee9b76de7353d815(options) {
    return new $38d8d0fc14215eff$export$fd98d9cca67a58bc(options);
}


const $3a622b680f893ceb$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $9b4b0944f487b7c3$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $9b4b0944f487b7c3$export$2cf569f5e2221176 || (0, $3a622b680f893ceb$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($9b4b0944f487b7c3$export$fcdd8f3f2160beda));
}
const $9b4b0944f487b7c3$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $9b4b0944f487b7c3$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $9b4b0944f487b7c3$var$mapEasingToNativeEasingWithDefault(easing) {
    return $9b4b0944f487b7c3$export$916ea73bcd3a6030(easing) || $9b4b0944f487b7c3$export$2cf569f5e2221176.easeOut;
}
function $9b4b0944f487b7c3$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $3a622b680f893ceb$export$ff43f99925d7366b)(easing)) return $9b4b0944f487b7c3$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($9b4b0944f487b7c3$var$mapEasingToNativeEasingWithDefault);
    else return $9b4b0944f487b7c3$export$2cf569f5e2221176[easing];
}


function $2b04773fa5493e28$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0 , duration: duration = 300 , repeat: repeat = 0 , repeatType: repeatType = "loop" , ease: ease , times: times  } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $9b4b0944f487b7c3$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $264f965dbb30cd85$var$supportsWaapi = (0, $b4f9da87da1ca830$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $264f965dbb30cd85$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $264f965dbb30cd85$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $264f965dbb30cd85$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $264f965dbb30cd85$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || options.name === "backgroundColor" || !(0, $9b4b0944f487b7c3$export$fcdd8f3f2160beda)(options.ease);
}
function $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $264f965dbb30cd85$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $264f965dbb30cd85$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $264f965dbb30cd85$var$sampleDelta,
        ease: "linear"
    };
}
class $264f965dbb30cd85$export$2a45abb4e6513325 extends (0, $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name , motionValue: motionValue , keyframes: keyframes  } = this.options;
        this.resolver = new (0, $c8b2f05e40a653fe$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300 , times: times , ease: ease , type: type , motionValue: motionValue , name: name  } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($264f965dbb30cd85$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete , onUpdate: onUpdate , motionValue: motionValue , ...options } = this.options;
            const pregeneratedAnimation = $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $2b04773fa5493e28$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete  } = this.options;
            motionValue.set((0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved  } = this;
        if (!resolved) return 0;
        const { duration: duration  } = resolved;
        return (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved  } = this;
        if (!resolved) return 0;
        const { animation: animation  } = resolved;
        return (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.currentTime = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved  } = this;
        if (!resolved) return 1;
        const { animation: animation  } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved  } = this;
        if (!resolved) return "idle";
        const { animation: animation  } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved  } = this;
            if (!resolved) return 0, $890b2290aa50a5ad$export$8793edee2d425525;
            const { animation: animation  } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $890b2290aa50a5ad$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation , keyframes: keyframes , duration: duration , type: type , ease: ease , times: times  } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue , onUpdate: onUpdate , onComplete: onComplete , ...options } = this.options;
            const sampleAnimation = new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $264f965dbb30cd85$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $264f965dbb30cd85$var$sampleDelta);
        }
        this.cancel();
    }
    complete() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue , name: name , repeatDelay: repeatDelay , repeatType: repeatType , damping: damping , type: type  } = options;
        return $264f965dbb30cd85$var$supportsWaapi() && name && $264f965dbb30cd85$var$acceleratedValues.has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}



const $3431270835958863$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $cba3eab4a749f231$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0  } = transition;
        elapsed = elapsed - (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $cba3eab4a749f231$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $943a3f0a32f59f42$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $636ef95c23a1ebef$export$888a3d84909f9e3d).current || (0, $6c4fc775126b27b6$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $cb21c6c57eea1e02$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $264f965dbb30cd85$export$2a45abb4e6513325).supports(options)) return new (0, $264f965dbb30cd85$export$2a45abb4e6513325)(options);
        else return new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)(options);
    };



function $7b21dab475728d1e$export$98397f3adbf6259f(value) {
    return Boolean((0, $d449570363f09a53$export$605d60a2578142d3)(value) && value.add);
}



function $13ad1cfa8b4681b0$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $13ad1cfa8b4681b0$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $925342fde4532b85$var$MAX_VELOCITY_DELTA = 30;
const $925342fde4532b85$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $925342fde4532b85$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $925342fde4532b85$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.1.7";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.canTrackVelocity = $925342fde4532b85$var$isFloat(this.current);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($925342fde4532b85$export$67fcd818a264039d.current) $925342fde4532b85$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $925342fde4532b85$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $925342fde4532b85$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $8d9716de34c4d522$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $925342fde4532b85$export$ce8bdc721e76545f(init, options) {
    return new $925342fde4532b85$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(value));
}
function $4ddbbe2518feafa3$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {} , transition: transition = {} , ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $b9d94c0c185391a2$export$5485128c47bd48bb)(target[key]);
        $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value);
    }
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cbfc21822c188a13$var$shouldBlockAnimation({ protectedKeys: protectedKeys , needsAnimating: needsAnimating  }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cbfc21822c188a13$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0 , transitionOverride: transitionOverride , type: type  } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition() , transitionEnd: transitionEnd , ...target } = targetAndTransition;
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $cbfc21822c188a13$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $cba3eab4a749f231$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const props = visualElement.getProps();
            const appearId = props[0, $6b140fcbcf20767d$export$8592e1c077c890a6];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key);
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $3431270835958863$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $05d385f303970557$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) {
            if ((0, $7b21dab475728d1e$export$98397f3adbf6259f)(willChange)) {
                willChange.add(key);
                animation.then(()=>willChange.remove(key));
            }
            animations.push(animation);
        }
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $4ddbbe2518feafa3$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $8c445c76717d72c0$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {}  } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0 , staggerChildren: staggerChildren , staggerDirection: staggerDirection  } = transition;
        return $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when  } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($8c445c76717d72c0$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($8c445c76717d72c0$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $8c445c76717d72c0$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}



function $ca7433f5e9b78911$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>{
            visualElement.notify("AnimationComplete", definition);
        });
    });
}


const $e4063d3013cf053c$var$reversePriorityOrder = [
    ...(0, $eb6a0a2a824114cd$export$16e45afcc206d3a8)
].reverse();
const $e4063d3013cf053c$var$numAnimationTypes = (0, $eb6a0a2a824114cd$export$16e45afcc206d3a8).length;
function $e4063d3013cf053c$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation , options: options  })=>(0, $ca7433f5e9b78911$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $e4063d3013cf053c$export$bb53502b7a672aa8(visualElement) {
    let animate = $e4063d3013cf053c$var$animateList(visualElement);
    const state = $e4063d3013cf053c$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition , transitionEnd: transitionEnd , ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $e4063d3013cf053c$var$numAnimationTypes; i++){
            const type = $e4063d3013cf053c$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $e4ec7857057a08b6$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $e4063d3013cf053c$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {}  } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(next) && (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $e4063d3013cf053c$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $e4063d3013cf053c$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $e4063d3013cf053c$var$createState() {
    return {
        animate: $e4063d3013cf053c$var$createTypeState(true),
        whileInView: $e4063d3013cf053c$var$createTypeState(),
        whileHover: $e4063d3013cf053c$var$createTypeState(),
        whileTap: $e4063d3013cf053c$var$createTypeState(),
        whileDrag: $e4063d3013cf053c$var$createTypeState(),
        whileFocus: $e4063d3013cf053c$var$createTypeState(),
        exit: $e4063d3013cf053c$var$createTypeState()
    };
}



class $f32e32aeb432bca6$export$b45b3fe5caabdca extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $e4063d3013cf053c$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate  } = this.node.getProps();
        this.unmount();
        if ((0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate  } = this.node.getProps();
        const { animate: prevAnimate  } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $a4f717d2e1520e94$var$id = 0;
class $a4f717d2e1520e94$export$4989d1eb6104cc6c extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $a4f717d2e1520e94$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent , onExitComplete: onExitComplete  } = this.node.presenceContext;
        const { isPresent: prevIsPresent  } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register  } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $61912b83da9ce72c$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f32e32aeb432bca6$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $a4f717d2e1520e94$export$4989d1eb6104cc6c)
    }
};









const $d4f8ff7f023adf4a$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $d4f8ff7f023adf4a$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.x, b.x);
    const yDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $f05cb07b67532e20$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint , contextWindow: contextWindow , dragSnapToOrigin: dragSnapToOrigin = false  } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $f05cb07b67532e20$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $d4f8ff7f023adf4a$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point  } = info;
            const { timestamp: timestamp  } = (0, $6491bdd13544fdda$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart , onMove: onMove  } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd , onSessionEnd: onSessionEnd , resumeAnimation: resumeAnimation  } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $f05cb07b67532e20$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $d4a10dbc24cee995$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event);
        const initialInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
        const { point: point  } = initialInfo;
        const { timestamp: timestamp  } = (0, $6491bdd13544fdda$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart  } = handlers;
        onSessionStart && onSessionStart(event, $f05cb07b67532e20$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)((0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $f05cb07b67532e20$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $f05cb07b67532e20$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $f05cb07b67532e20$var$getPanInfo({ point: point  }, history) {
    return {
        point: point,
        delta: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$lastDevicePoint(history)),
        offset: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$startDevicePoint(history)),
        velocity: $f05cb07b67532e20$var$getVelocity(history, 0.1)
    };
}
function $f05cb07b67532e20$var$startDevicePoint(history) {
    return history[0];
}
function $f05cb07b67532e20$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $f05cb07b67532e20$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $f05cb07b67532e20$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $631bdbca8ed9a472$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $631bdbca8ed9a472$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $d9901b0e7f584a90$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $d9901b0e7f584a90$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $d9901b0e7f584a90$export$c1c127004b72a37(target) / $d9901b0e7f584a90$export$c1c127004b72a37(source);
    if ($d9901b0e7f584a90$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($d9901b0e7f584a90$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $d9901b0e7f584a90$export$c0d25e96fc67d310(delta, source, target, origin) {
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $d9901b0e7f584a90$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(relative);
}
function $d9901b0e7f584a90$export$426154f9d100f99(target, relative, parent) {
    $d9901b0e7f584a90$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $d9901b0e7f584a90$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $d9901b0e7f584a90$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(layout);
}
function $d9901b0e7f584a90$export$2785bfcc929c5650(target, layout, parent) {
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3(point, { min: min , max: max  }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $e4bc4f9b398dfeb3$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $e4bc4f9b398dfeb3$export$4e9195bf7793bc78(layoutBox, { top: top , left: left , bottom: bottom , right: right  }) {
    return {
        x: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.x, left, right),
        y: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $e4bc4f9b398dfeb3$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $e4bc4f9b398dfeb3$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(source);
    const targetLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $e6e94e48128648b0$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $e4bc4f9b398dfeb3$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22(dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742;
    return {
        x: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $93b39ae61dedc877$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $93b39ae61dedc877$export$3d227df54007d73a = ()=>({
        x: $93b39ae61dedc877$export$ff25708b37f72782(),
        y: $93b39ae61dedc877$export$ff25708b37f72782()
    });
const $93b39ae61dedc877$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $93b39ae61dedc877$export$6459fc9e86be362e = ()=>({
        x: $93b39ae61dedc877$export$6db76765312617ac(),
        y: $93b39ae61dedc877$export$6db76765312617ac()
    });


function $c68037220032f1d8$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $040c3e7ac51c9eb3$export$d3955c6a8f65a36b({ top: top , left: left , right: right , bottom: bottom  }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $040c3e7ac51c9eb3$export$b6b9cd4198191a47({ x: x , y: y  }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $040c3e7ac51c9eb3$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fed21f2a9fad1fb9$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fed21f2a9fad1fb9$export$bdf30dca883ea463({ scale: scale , scaleX: scaleX , scaleY: scaleY  }) {
    return !$fed21f2a9fad1fb9$var$isIdentityScale(scale) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleX) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleY);
}
function $fed21f2a9fad1fb9$export$a545127cf1fbb600(values) {
    return $fed21f2a9fad1fb9$export$bdf30dca883ea463(values) || $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) {
    return $fed21f2a9fad1fb9$var$is2DTranslate(values.x) || $fed21f2a9fad1fb9$var$is2DTranslate(values.y);
}
function $fed21f2a9fad1fb9$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $4c951bbfa32a6f81$export$d80074982803af5c(box, { x: x , y: y  }) {
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $4c951bbfa32a6f81$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $4c951bbfa32a6f81$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $4c951bbfa32a6f81$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) $4c951bbfa32a6f81$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $4c951bbfa32a6f81$var$snapToDefault(treeScale.x);
    treeScale.y = $4c951bbfa32a6f81$var$snapToDefault(treeScale.y);
}
function $4c951bbfa32a6f81$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $4c951bbfa32a6f81$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $4c951bbfa32a6f81$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $4c951bbfa32a6f81$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $4c951bbfa32a6f81$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $4c951bbfa32a6f81$export$58b16271041fbfb(box, transform) {
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.x, transform, $4c951bbfa32a6f81$var$xKeys);
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.y, transform, $4c951bbfa32a6f81$var$yKeys);
}


function $0b2600dd2e3d7275$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)((0, $040c3e7ac51c9eb3$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $0b2600dd2e3d7275$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $0b2600dd2e3d7275$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll  } = rootProjectionNode;
    if (scroll) {
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $1a5cc9ddc6d87d3a$export$d533d84f9871c879 = ({ current: current  })=>{
    return current ? current.ownerDocument.defaultView : null;
};


const $0ba13f75c89670e3$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $0ba13f75c89670e3$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false  } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext  } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag , dragPropagation: dragPropagation , onDragStart: onDragStart  } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $ab472a7ccdd5989f$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection  } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) onDragStart(event, info);
            const { animationState: animationState  } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation , dragDirectionLock: dragDirectionLock , onDirectionLock: onDirectionLock , onDrag: onDrag  } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset  } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $0ba13f75c89670e3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
        this.panSession = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity  } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd  } = this.getProps();
        if (onDragEnd) onDragEnd(event, info);
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection , animationState: animationState  } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation  } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag  } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints , dragElastic: dragElastic  } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $e4bc4f9b398dfeb3$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints , onMeasureDragConstraints: onMeasureDragConstraints  } = this.getProps();
        if (!constraints || !(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $9ef77cb0818a2387$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection  } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $0b2600dd2e3d7275$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $e4bc4f9b398dfeb3$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $040c3e7ac51c9eb3$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag , dragMomentum: dragMomentum , dragElastic: dragElastic , dragTransition: dragTransition , dragSnapToOrigin: dragSnapToOrigin , onDragTransitionEnd: onDragTransitionEnd  } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $3431270835958863$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement));
    }
    stopAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const { drag: drag  } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection  } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min , max: max  } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag , dragConstraints: dragConstraints  } = this.getProps();
        const { projection: projection  } = this.visualElement;
        if (!(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $e4bc4f9b398dfeb3$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate  } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min , max: max  } = this.constraints[axis];
            axisValue.set((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $0ba13f75c89670e3$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag , dragListener: dragListener = true  } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints  } = this.getProps();
            if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection  } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged  })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false , dragDirectionLock: dragDirectionLock = false , dragPropagation: dragPropagation = false , dragConstraints: dragConstraints = false , dragElastic: dragElastic = (0, $e4bc4f9b398dfeb3$export$a3366d3bac43a742) , dragMomentum: dragMomentum = true  } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $0ba13f75c89670e3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $0ba13f75c89670e3$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $012c82f716440bf2$export$5d97dc2872682820 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $890b2290aa50a5ad$export$8793edee2d425525);
        this.removeListeners = (0, $890b2290aa50a5ad$export$8793edee2d425525);
        this.controls = new (0, $0ba13f75c89670e3$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls  } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $890b2290aa50a5ad$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $a23e02b288283422$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) handler(event, info);
    };
class $a23e02b288283422$export$b4f8f1ee75ce5859 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $890b2290aa50a5ad$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart , onPanStart: onPanStart , onPan: onPan , onPanEnd: onPanEnd  } = this.node.getProps();
        return {
            onSessionStart: $a23e02b288283422$var$asyncHandler(onPanSessionStart),
            onStart: $a23e02b288283422$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) onPanEnd(event, info);
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $11db8f3094dfc6f1$export$2a8c16d82a0a0e26() {
    const context = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent , onExitComplete: onExitComplete , register: register  } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $bh6RR.useId)();
    (0, $bh6RR.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $11db8f3094dfc6f1$export$8249053f690ea39a() {
    return $11db8f3094dfc6f1$export$ee27c052bca048fb((0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2)));
}
function $11db8f3094dfc6f1$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $fb51e1392d812b31$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $e543877808356f59$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $e543877808356f59$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $e543877808356f59$export$fafff692be55225d(latest, node.target.x);
        const y = $e543877808356f59$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $2e837016dedbf14e$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale , projectionDelta: projectionDelta  })=>{
        const original = latest;
        const shadow = (0, $a554c66132092e1c$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $a554c66132092e1c$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};





class $b6e93d5d187b3d6c$var$MeasureLayoutWithContext extends (0, $bh6RR.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: switchLayoutGroup , layoutId: layoutId  } = this.props;
        const { projection: projection  } = visualElement;
        (0, $93233d74f0d10a65$export$de9e7791c71225fd)($b6e93d5d187b3d6c$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency , visualElement: visualElement , drag: drag , isPresent: isPresent  } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection  } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $3858c82cd1ca695a$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: promoteContext  } = this.props;
        const { projection: projection  } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove  } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $b6e93d5d187b3d6c$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $11db8f3094dfc6f1$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95));
    return (0, $d4dab640dcbe486c$exports.jsx)($b6e93d5d187b3d6c$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $b6e93d5d187b3d6c$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $e543877808356f59$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    boxShadow: (0, $2e837016dedbf14e$export$eb0bc629e74dcf8)
};








const $210c6abc2ab907de$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $210c6abc2ab907de$var$numBorders = $210c6abc2ab907de$var$borders.length;
const $210c6abc2ab907de$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $210c6abc2ab907de$var$isPx = (value)=>typeof value === "number" || (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).test(value);
function $210c6abc2ab907de$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $210c6abc2ab907de$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $210c6abc2ab907de$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $210c6abc2ab907de$var$numBorders; i++){
        const borderLabel = `border${$210c6abc2ab907de$var$borders[i]}Radius`;
        let followRadius = $210c6abc2ab907de$var$getRadius(follow, borderLabel);
        let leadRadius = $210c6abc2ab907de$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $210c6abc2ab907de$var$isPx(followRadius) === $210c6abc2ab907de$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)($210c6abc2ab907de$var$asNumber(followRadius), $210c6abc2ab907de$var$asNumber(leadRadius), progress), 0);
            if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(leadRadius) || (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $210c6abc2ab907de$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $210c6abc2ab907de$var$easeCrossfadeIn = $210c6abc2ab907de$var$compress(0, 0.5, (0, $f0e499eff44e3cea$export$c8d67a19199d1a50));
const $210c6abc2ab907de$var$easeCrossfadeOut = $210c6abc2ab907de$var$compress(0.5, 0.95, (0, $890b2290aa50a5ad$export$8793edee2d425525));
function $210c6abc2ab907de$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $e6e94e48128648b0$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$c53fd88f45d77e4b(box, originBox) {
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.x, originBox.x);
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $749794150c53d8b2$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $749794150c53d8b2$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $749794150c53d8b2$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $749794150c53d8b2$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $749794150c53d8b2$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $749794150c53d8b2$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $749794150c53d8b2$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.x, transforms, $749794150c53d8b2$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.y, transforms, $749794150c53d8b2$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $360ce5c67f749464$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $360ce5c67f749464$export$a7ec7642fe550fb6(delta) {
    return $360ce5c67f749464$var$isAxisDeltaZero(delta.x) && $360ce5c67f749464$var$isAxisDeltaZero(delta.y);
}
function $360ce5c67f749464$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $360ce5c67f749464$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $360ce5c67f749464$export$c5706146bc63213(box) {
    return (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.x) / (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.y);
}



class $183043a6fc74a7d6$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade  } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options , resumingFrom: resumingFrom  } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $bec23b122ca5d293$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective , rotate: rotate , rotateX: rotateX , rotateY: rotateY , skewX: skewX , skewY: skewY  } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $b2b47619cf5d2c84$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $1f12cfa00e0c731b$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $b2b47619cf5d2c84$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $d62baf960e3e1cd2$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp  })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(checkElapsed);
}



function $c9982a9dccc413c3$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $7982a746f864c4a2$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $f126955027450c75$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value : (0, $925342fde4532b85$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $3431270835958863$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}







const $281d58aebf127403$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $281d58aebf127403$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $281d58aebf127403$var$animationTarget = 1000;
let $281d58aebf127403$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $281d58aebf127403$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $281d58aebf127403$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues  } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $281d58aebf127403$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener , defaultParent: defaultParent , measureScroll: measureScroll , checkIsScrollRoot: checkIsScrollRoot , resetTransform: resetTransform  }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $281d58aebf127403$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $281d58aebf127403$var$projectionFrameData.totalNodes = $281d58aebf127403$var$projectionFrameData.resolvedTargetDeltas = $281d58aebf127403$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($281d58aebf127403$export$131f2f0cc5fe9609);
                this.nodes.forEach($281d58aebf127403$var$resolveTargetDelta);
                this.nodes.forEach($281d58aebf127403$var$calcProjection);
                this.nodes.forEach($281d58aebf127403$export$c2664f37bc951031);
                (0, $c9982a9dccc413c3$export$e5185e241753e543)($281d58aebf127403$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $1f12cfa00e0c731b$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $7982a746f864c4a2$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId , layout: layout , visualElement: visualElement  } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $d62baf960e3e1cd2$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($281d58aebf127403$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged , hasRelativeTargetChanged: hasRelativeTargetChanged , layout: newLayout  })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $281d58aebf127403$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart , onLayoutAnimationComplete: onLayoutAnimationComplete  } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $360ce5c67f749464$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $cba3eab4a749f231$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $281d58aebf127403$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($281d58aebf127403$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement  } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId , layout: layout  } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($281d58aebf127403$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($281d58aebf127403$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ if (window.HandoffCancelAllAnimations) window.HandoffCancelAllAnimations();
            this.nodes.forEach($281d58aebf127403$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($281d58aebf127403$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($281d58aebf127403$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).delta = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp);
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp = now;
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing = true;
            (0, $6491bdd13544fdda$export$be3f796aed065412).update.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$be3f796aed065412).preRender.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$be3f796aed065412).render.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $3858c82cd1ca695a$export$bb76eed83315504c).read(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($281d58aebf127403$var$clearSnapshot);
            this.sharedNodes.forEach($281d58aebf127403$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement  } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $281d58aebf127403$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll  } = this.root;
            if (scroll) {
                (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll , options: options  } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll  } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $d9901b0e7f584a90$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $4c951bbfa32a6f81$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $281d58aebf127403$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $4c951bbfa32a6f81$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            const { target: target  } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $bec23b122ca5d293$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $281d58aebf127403$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($281d58aebf127403$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $281d58aebf127403$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $360ce5c67f749464$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $210c6abc2ab907de$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
                (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $f126955027450c75$export$335a17c977067b99)(0, $281d58aebf127403$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($281d58aebf127403$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms , target: target , layout: layout , latestValues: latestValues  } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $281d58aebf127403$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const xLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $183043a6fc74a7d6$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId  } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId  } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId  } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset , transition: transition , preserveFollowOpacity: preserveFollowOpacity  } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues  } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $281d58aebf127403$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $281d58aebf127403$var$transformAxes.length; i++){
                $281d58aebf127403$var$resetDistortingTransform(`rotate${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $281d58aebf127403$var$resetDistortingTransform(`skew${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $281d58aebf127403$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $bec23b122ca5d293$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x , y: y  } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $93233d74f0d10a65$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct , applyTo: applyTo  } = (0, $93233d74f0d10a65$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($281d58aebf127403$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $281d58aebf127403$var$updateLayout(node) {
    node.updateLayout();
}
function $281d58aebf127403$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout , measuredBox: measuredLayout  } = node.layout;
        const { animationType: animationType  } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        if (isShared) (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot , layout: parentLayout  } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $360ce5c67f749464$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete  } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $281d58aebf127403$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $281d58aebf127403$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $281d58aebf127403$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $281d58aebf127403$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $281d58aebf127403$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $281d58aebf127403$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $281d58aebf127403$var$resetTransformStyle(node) {
    const { visualElement: visualElement  } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $281d58aebf127403$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $281d58aebf127403$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $281d58aebf127403$var$calcProjection(node) {
    node.calcProjection();
}
function $281d58aebf127403$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $281d58aebf127403$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $281d58aebf127403$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $281d58aebf127403$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $281d58aebf127403$export$6ffd3e6ae339a132(output, from, to, p) {
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $281d58aebf127403$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $281d58aebf127403$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $281d58aebf127403$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $281d58aebf127403$var$roundPoint = $281d58aebf127403$var$userAgentContains("applewebkit/") && !$281d58aebf127403$var$userAgentContains("chrome/") ? Math.round : (0, $890b2290aa50a5ad$export$8793edee2d425525);
function $281d58aebf127403$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $281d58aebf127403$var$roundPoint(axis.min);
    axis.max = $281d58aebf127403$var$roundPoint(axis.max);
}
function $281d58aebf127403$var$roundBox(box) {
    $281d58aebf127403$var$roundAxis(box.x);
    $281d58aebf127403$var$roundAxis(box.y);
}
function $281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $d9901b0e7f584a90$export$28d0384c4b79bde2)((0, $360ce5c67f749464$export$c5706146bc63213)(snapshot), (0, $360ce5c67f749464$export$c5706146bc63213)(layout), 0.2);
}




const $b2724fa5a1f79278$export$2d029a49a09b6177 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $5727f053dc302d4d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $e8dff807472b9243$export$b91509fcf893b648 = {
    current: undefined
};
const $e8dff807472b9243$export$b61a9eb3dbde8858 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$e8dff807472b9243$export$b91509fcf893b648.current) {
            const documentNode = new (0, $b2724fa5a1f79278$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $e8dff807472b9243$export$b91509fcf893b648.current = documentNode;
        }
        return $e8dff807472b9243$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $5e0aeefdd70dc82e$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $a23e02b288283422$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $012c82f716440bf2$export$5d97dc2872682820),
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};



var $bh6RR = parcelRequire("bh6RR");











// Does this device prefer reduced motion? Returns `null` server-side.
const $16faa30fcf534207$export$ff7706047246b98b = {
    current: null
};
const $16faa30fcf534207$export$6476d16e2fd2d0db = {
    current: false
};


function $8c52f85ab085b323$export$ca9f41fb23dded3d() {
    (0, $16faa30fcf534207$export$6476d16e2fd2d0db).current = true;
    if (!(0, $0ec11121663cc82b$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $16faa30fcf534207$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $16faa30fcf534207$export$ff7706047246b98b).current = false;
}














function $c1ce9b34358097f3$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange  } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $d449570363f09a53$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $7b21dab475728d1e$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $d449570363f09a53$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $7b21dab475728d1e$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $7680e86648d809f1$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $3f77fa41782f639b$var$valueTypes = [
    ...(0, $d03d4f627f09ffbd$export$d176691c1998a1f5),
    (0, $7a26ed3125820d32$export$35e9368ef982300f),
    (0, $a554c66132092e1c$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $3f77fa41782f639b$export$950e7e59ea1ffed7 = (v)=>$3f77fa41782f639b$var$valueTypes.find((0, $bce78752b9f7f913$export$6eae4d0a6a7ca7cd)(v));





const $59dc28bcfaa62e03$var$featureNames = Object.keys((0, $145d8d26c6dc52b8$export$65570e08d843624d));
const $59dc28bcfaa62e03$var$numFeatures = $59dc28bcfaa62e03$var$featureNames.length;
const $59dc28bcfaa62e03$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $59dc28bcfaa62e03$var$numVariantProps = (0, $eb6a0a2a824114cd$export$1405a65085f40b9).length;
function $59dc28bcfaa62e03$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $59dc28bcfaa62e03$var$getClosestProjectingNode(visualElement.parent);
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $59dc28bcfaa62e03$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent , props: props , presenceContext: presenceContext , reducedMotionConfig: reducedMotionConfig , blockInitialAnimation: blockInitialAnimation , visualState: visualState  }, options = {}){
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $8a643b2da1c7bc40$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $6491bdd13544fdda$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues , renderState: renderState  } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange , ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $d449570363f09a53$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $7b21dab475728d1e$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $7680e86648d809f1$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $16faa30fcf534207$export$6476d16e2fd2d0db).current) (0, $8c52f85ab085b323$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $16faa30fcf534207$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        var _a;
        (0, $7680e86648d809f1$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)(_a = this.features[key]) === null || _a === void 0 || _a.unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $05d385f303970557$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $6491bdd13544fdda$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children , ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $59dc28bcfaa62e03$var$numFeatures; i++){
            const name = $59dc28bcfaa62e03$var$featureNames[i];
            const { isEnabled: isEnabled , Feature: FeatureConstructor , ProjectionNode: ProjectionNode , MeasureLayout: MeasureLayoutComponent  } = (0, $145d8d26c6dc52b8$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, $59dc28bcfaa62e03$var$getClosestProjectingNode(this.parent));
            const { layoutId: layoutId , layout: layout , drag: drag , dragConstraints: dragConstraints , layoutScroll: layoutScroll , layoutRoot: layoutRoot  } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $59dc28bcfaa62e03$var$propEventHandlers.length; i++){
            const key = $59dc28bcfaa62e03$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $c1ce9b34358097f3$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $59dc28bcfaa62e03$var$numVariantProps; i++){
            const name = (0, $eb6a0a2a824114cd$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $e4ec7857057a08b6$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $925342fde4532b85$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $307e1e0a636b2ddb$export$65583ed5a868f2d9)(value) || (0, $e46637106d3b5fd8$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $3f77fa41782f639b$export$950e7e59ea1ffed7)(value) && (0, $a554c66132092e1c$export$83a0e34f1302825b).test(target)) value = (0, $1838583c06c42261$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial  } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $d449570363f09a53$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $f82c67e8782ea4e3$export$e49735c2a366bdc7 extends (0, $59dc28bcfaa62e03$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $c8b2f05e40a653fe$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars , style: style  }) {
        delete vars[key];
        delete style[key];
    }
}



function $c22d56f4f698c1a8$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $c22d56f4f698c1a8$export$23fea75b03ac16b3 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $c22d56f4f698c1a8$export$3735103072e4a80(instance);
            const value = ((0, $9223341d00255d67$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint  }) {
        return (0, $0b2600dd2e3d7275$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children  } = this.props;
        if ((0, $d449570363f09a53$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $46b26a876b49a8ee$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $86a41d187babab09$export$86bcdffbaf733d84 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $05d385f303970557$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $4c234d289d8baf9a$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, options, props) {
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $50c74351dd8901bc$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $584c8429f63c1575$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? new (0, $86a41d187babab09$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $c22d56f4f698c1a8$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $bh6RR.Fragment),
        enableHardwareAcceleration: true
    });
};




const $17a320fc4896a503$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};


const $ecb603c03d63940a$var$preloadedFeatures = {
    ...(0, $61912b83da9ce72c$export$7f9953c70dacfd7f),
    ...(0, $aadd72d7ca06bd3a$export$e5b72898e5a201f1),
    ...(0, $5e0aeefdd70dc82e$export$d7d5d435647ed5a0),
    ...(0, $17a320fc4896a503$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $ecb603c03d63940a$export$e25e478948902b8b = /*@__PURE__*/ (0, $5b22e6221ec72104$export$a28d6df673050e18)((Component, config)=>(0, $a6b6deed5b4ac5c0$export$732916c0e88175fb)(Component, config, $ecb603c03d63940a$var$preloadedFeatures, (0, $584c8429f63c1575$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $ecb603c03d63940a$export$546614c4a05701f9(key) {
    return (0, $0c5a031ea8dd3973$export$46b7e4b9dc6110c3)((0, $a6b6deed5b4ac5c0$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $ecb603c03d63940a$var$preloadedFeatures, (0, $584c8429f63c1575$export$56ba0183203348f5)));
}




function $6204eef74ceda398$var$Sequence({ sequenceId: sequenceId  }) {
    const { sequenceLength: sequenceLength , gSequence: gSequence , fSequence: fSequence , handleSequenceChange: handleSequenceChange , fJustIncreased: fJustIncreased , gJustIncreased: gJustIncreased , mode: mode  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const sequence = sequenceId === "g" ? gSequence : fSequence;
    function handleNumberChange(index, newValue) {
        const newSequence = [
            ...sequence
        ];
        const targetIndex = index % sequenceLength;
        newSequence[targetIndex] = parseInt(newValue);
        handleSequenceChange(sequenceId, newSequence);
    }
    const sequenceValue = sequenceId === "g" ? gSequence : fSequence;
    const didJustIncrease = sequenceId === "g" ? gJustIncreased : fJustIncreased;
    const delta = sequenceId === "f" ? sequenceLength : 0;
    const elements = sequence.slice(0, Math.min(sequenceLength, fSequence.length, gSequence.length)).map((num, index)=>{
        const isLast = index === sequenceLength - 1;
        const isFirst = index === 0;
        const distanceToSequenceEnd = sequence.length - 1 - index;
        const firstInitial = didJustIncrease && isFirst ? {
            scale: 0
        } : null;
        const firstAnimate = didJustIncrease && isFirst ? {
            scale: 1
        } : null;
        // const firstTiming =
        //   didJustIncrease && isFirst
        //     ? {
        //         scale: {
        //           delay: 10,
        //           duration: 0.1,
        //         },
        //       }
        //     : null;
        const damping = isFirst ? 50 : Math.max(100 - 10 * index, 30);
        const seqZIndex = sequenceId === "f" ? {
            zIndex: 10 + distanceToSequenceEnd - index,
            position: "relative"
        } : {};
        const disableNumberBox = [
            "bell",
            "appell",
            "twobell"
        ].includes(mode) && sequenceId === "f" || [
            "derivative",
            "associated"
        ].includes(mode) && sequenceId === "g";
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ecb603c03d63940a$export$e25e478948902b8b).div, {
                layoutId: `${sequenceId}-${distanceToSequenceEnd}-to-last`,
                initial: firstInitial,
                animate: firstAnimate,
                style: seqZIndex,
                // exit={{ opacity: 0, x: '300%' }}
                transition: {
                    type: "spring",
                    stiffness: 300,
                    // damping: 30 + 3 * index,
                    damping: damping
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b1c2110bf1e6ac8$export$2e2bcd8739ae039), {
                    value: num,
                    index: index + delta,
                    sequenceId: sequenceId,
                    sequenceValue: sequenceValue,
                    isFirst: isFirst,
                    isLast: isLast,
                    onSubmit: handleNumberChange,
                    disabled: disableNumberBox
                }, `${index + delta}-${num}`)
            }, `${sequenceId}-${distanceToSequenceEnd}-to-last`)
        }, `${index + delta}-${num}`);
    });
    const disablePrepend = [
        "bell",
        "appell",
        "twobell"
    ].includes(mode) && sequenceId === "f" || [
        "derivative",
        "associated"
    ].includes(mode) && sequenceId === "g";
    const prependZeroElement = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        style: {
            zIndex: 0
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ecb603c03d63940a$export$e25e478948902b8b).div, {
            layoutId: `${sequenceId}-prepend-box`,
            style: {
                zIndex: 0
            },
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 30
            },
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174b10774f00d89c$export$2e2bcd8739ae039), {
                actionType: "prependZero",
                sequenceId: sequenceId,
                sequenceValue: sequenceValue,
                onSubmit: handleNumberChange,
                enabled: !disablePrepend
            }, `prependzero-${delta}`)
        }, `${sequenceId}-prepend-box`)
    }, `prependzero-${delta}`);
    const shorterSequenceLength = Math.min(fSequence.length, gSequence.length);
    const numAugmentBoxes = shorterSequenceLength - sequenceLength;
    const mysteryBoxes = (0, $6531107febf5e71a$export$d02631cccf789723)(numAugmentBoxes).map((index)=>{
        const distanceToSequenceEnd = sequence.length - sequenceLength - 1 - index;
        // const opacity = Math.max(1 - index * 0.25, 0.05);
        const opacity = Math.max(1.5 / (index + 1), 0.15);
        // const initOpacity = { opacity: Math.max(1 - (index - 1) * 0.25, 0.05) };
        // const endOpacity = { opacity: Math.max(1 - index * 0.25, 0.05) };
        const initOpacity = {
            opacity: Math.max(1.5 / (index + 1), 0.15)
        };
        const endOpacity = {
            opacity: Math.max(1.5 / (index + 1), 0.15)
        };
        const opacityTiming = {
            opacity: {
                duration: 0.7
            }
        };
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            style: {
                zIndex: 0,
                opacity: opacity
            },
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ecb603c03d63940a$export$e25e478948902b8b).div, {
                layoutId: `${sequenceId}-${distanceToSequenceEnd}-to-last`,
                style: {
                    zIndex: 0
                },
                initial: initOpacity,
                animate: endOpacity,
                transition: {
                    type: "spring",
                    stiffness: 600,
                    // damping: 15 + 5 * (sequenceLength + index),
                    damping: 45,
                    opacityTiming: opacityTiming
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174b10774f00d89c$export$2e2bcd8739ae039), {
                    actionType: "augment",
                    sequenceId: sequenceId,
                    sequenceValue: sequenceValue,
                    enabled: false
                }, `augment-${delta}`)
            }, `${sequenceId}-${distanceToSequenceEnd}-to-last`)
        }, `augment-${index}`);
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($6204eef74ceda398$var$Wrapper, {
        children: [
            prependZeroElement,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47c18933f59b2062$export$2e2bcd8739ae039), {}),
            elements,
            mysteryBoxes
        ]
    });
}
var $6204eef74ceda398$export$2e2bcd8739ae039 = $6204eef74ceda398$var$Sequence;
const $6204eef74ceda398$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  color: var(--number-box-font-color);
`;





parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");



var $3774fe84ff338282$export$c973a4b3cb86a03d;
var $3774fe84ff338282$export$99b400cabb58c515;
var $3774fe84ff338282$export$13ef48a934230896;
var $3774fe84ff338282$export$6b9198de19accfe6;
var $3774fe84ff338282$export$f67338d29bd972f8;
var $3774fe84ff338282$export$536bd91ba45f6b0a;
var $3774fe84ff338282$export$eba4b1df07cb1d3;
var $3774fe84ff338282$export$3ac1e88a1c0b9f1;
var $3774fe84ff338282$export$9ed6e7b40248d36d;
var $3774fe84ff338282$export$496307dcaa6031c4;
$3774fe84ff338282$export$c973a4b3cb86a03d = `I4HnWa_SelectContent`;
$3774fe84ff338282$export$99b400cabb58c515 = `I4HnWa_SelectIcon`;
$3774fe84ff338282$export$13ef48a934230896 = `I4HnWa_SelectItem`;
$3774fe84ff338282$export$6b9198de19accfe6 = `I4HnWa_SelectItemIndicator`;
$3774fe84ff338282$export$f67338d29bd972f8 = `I4HnWa_SelectLabel`;
$3774fe84ff338282$export$536bd91ba45f6b0a = `I4HnWa_SelectScrollButton`;
$3774fe84ff338282$export$eba4b1df07cb1d3 = `I4HnWa_SelectSeparator`;
$3774fe84ff338282$export$3ac1e88a1c0b9f1 = `I4HnWa_SelectTrigger`;
$3774fe84ff338282$export$9ed6e7b40248d36d = `I4HnWa_SelectViewport`;
$3774fe84ff338282$export$496307dcaa6031c4 = `I4HnWa_selectRoot`;





var $bh6RR = parcelRequire("bh6RR");

function $7b5993acd6454a5e$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}




var $bh6RR = parcelRequire("bh6RR");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $f40cb27330ac95c0$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





var $bh6RR = parcelRequire("bh6RR");
const $861a16ed03937ac2$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $861a16ed03937ac2$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($861a16ed03937ac2$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $861a16ed03937ac2$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $bh6RR.useContext)($861a16ed03937ac2$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $861a16ed03937ac2$export$2881499e37b75b9a = $861a16ed03937ac2$export$c760c09fdd558351;








var $bh6RR = parcelRequire("bh6RR");

function $3261e7eea2c2a215$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const sideAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $3261e7eea2c2a215$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $3261e7eea2c2a215$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name , fn: fn  } = validMiddleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $3261e7eea2c2a215$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $3261e7eea2c2a215$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = state;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3261e7eea2c2a215$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , platform: platform , elements: elements , middlewareData: middlewareData  } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element , padding: padding = 0  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $3261e7eea2c2a215$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $168a40e325c04e1b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3261e7eea2c2a215$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = state;
            const { crossAxis: crossAxis = false , alignment: alignment , allowedPlacements: allowedPlacements = (0, $168a40e325c04e1b$export$803cd8101b6c182b) , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $168a40e325c04e1b$export$803cd8101b6c182b) ? $3261e7eea2c2a215$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $3261e7eea2c2a215$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $168a40e325c04e1b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3261e7eea2c2a215$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , fallbackAxisSideDirection: fallbackAxisSideDirection = "none" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $168a40e325c04e1b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $168a40e325c04e1b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $168a40e325c04e1b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $3261e7eea2c2a215$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $168a40e325c04e1b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $3261e7eea2c2a215$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $3261e7eea2c2a215$var$isAnySideFullyClipped(overflow) {
    return (0, $168a40e325c04e1b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3261e7eea2c2a215$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects  } = state;
            const { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $3261e7eea2c2a215$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $3261e7eea2c2a215$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $3261e7eea2c2a215$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $3261e7eea2c2a215$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $3261e7eea2c2a215$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $3261e7eea2c2a215$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $3261e7eea2c2a215$var$getBoundingRect(rects) {
    const minX = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $3261e7eea2c2a215$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($3261e7eea2c2a215$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3261e7eea2c2a215$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $3261e7eea2c2a215$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($3261e7eea2c2a215$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $3261e7eea2c2a215$var$convertValueToCoords(state, options) {
    const { placement: placement , platform: platform , elements: elements  } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3261e7eea2c2a215$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x , y: y , placement: placement , middlewareData: middlewareData  } = state;
            const diffCoords = await $3261e7eea2c2a215$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3261e7eea2c2a215$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $3261e7eea2c2a215$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3261e7eea2c2a215$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = state;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3261e7eea2c2a215$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            const { apply: apply = ()=>{} , ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $3261e7eea2c2a215$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
            const { width: width , height: height  } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};




function $a743a54bae508f36$var$getCssDimensions(element) {
    const css = (0, $8da4680c6d092b5b$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $a743a54bae508f36$var$unwrapElement(element) {
    return !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $a743a54bae508f36$var$getScale(element) {
    const domElement = $a743a54bae508f36$var$unwrapElement(element);
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(domElement)) return (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width , height: height , $: $  } = $a743a54bae508f36$var$getCssDimensions(domElement);
    let x = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $a743a54bae508f36$var$noOffsets = /*#__PURE__*/ (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
function $a743a54bae508f36$var$getVisualOffsets(element) {
    const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    if (!(0, $8da4680c6d092b5b$export$78551043582a6a98)() || !win.visualViewport) return $a743a54bae508f36$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $a743a54bae508f36$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $a743a54bae508f36$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $a743a54bae508f36$var$unwrapElement(element);
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(offsetParent)) scale = $a743a54bae508f36$var$getScale(offsetParent);
        } else scale = $a743a54bae508f36$var$getScale(element);
    }
    const visualOffsets = $a743a54bae508f36$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $a743a54bae508f36$var$getVisualOffsets(domElement) : (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $a743a54bae508f36$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $8da4680c6d092b5b$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $a743a54bae508f36$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $a743a54bae508f36$var$isTopLayer(floating) {
    return $a743a54bae508f36$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $a743a54bae508f36$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements , rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $8da4680c6d092b5b$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $a743a54bae508f36$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) !== "body" || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(documentElement)) scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $a743a54bae508f36$var$getBoundingClientRect(offsetParent);
            scale = $a743a54bae508f36$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $a743a54bae508f36$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $a743a54bae508f36$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $a743a54bae508f36$var$getBoundingClientRect((0, $8da4680c6d092b5b$export$e495491855dc5418)(element)).left + (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $a743a54bae508f36$var$getDocumentRect(element) {
    const html = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    const scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $a743a54bae508f36$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $8da4680c6d092b5b$export$3735103072e4a80)(body).direction === "rtl") x += (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $a743a54bae508f36$var$getViewportRect(element, strategy) {
    const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    const html = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $8da4680c6d092b5b$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $a743a54bae508f36$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $a743a54bae508f36$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) ? $a743a54bae508f36$var$getScale(element) : (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $a743a54bae508f36$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $a743a54bae508f36$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $a743a54bae508f36$var$getDocumentRect((0, $8da4680c6d092b5b$export$e495491855dc5418)(element));
    else if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $a743a54bae508f36$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $a743a54bae508f36$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(rect);
}
function $a743a54bae508f36$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(parentNode) || (0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $8da4680c6d092b5b$export$3735103072e4a80)(parentNode).position === "fixed" || $a743a54bae508f36$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $a743a54bae508f36$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $8da4680c6d092b5b$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(el) && (0, $8da4680c6d092b5b$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(currentNode) && !(0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $8da4680c6d092b5b$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $8da4680c6d092b5b$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $a743a54bae508f36$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $a743a54bae508f36$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $a743a54bae508f36$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $a743a54bae508f36$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $a743a54bae508f36$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $a743a54bae508f36$var$getDimensions(element) {
    const { width: width , height: height  } = $a743a54bae508f36$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $a743a54bae508f36$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $8da4680c6d092b5b$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $a743a54bae508f36$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) !== "body" || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(documentElement)) scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $a743a54bae508f36$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $a743a54bae508f36$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $a743a54bae508f36$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) || (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $a743a54bae508f36$var$getOffsetParent(element, polyfill) {
    const window = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) || $a743a54bae508f36$var$isTopLayer(element)) return window;
    let offsetParent = $a743a54bae508f36$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $8da4680c6d092b5b$export$71535ffaa902797f)(offsetParent) && (0, $8da4680c6d092b5b$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $a743a54bae508f36$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) === "html" || (0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) === "body" && (0, $8da4680c6d092b5b$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $8da4680c6d092b5b$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $8da4680c6d092b5b$export$940d8225183e1404)(element) || window;
}
const $a743a54bae508f36$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $a743a54bae508f36$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $a743a54bae508f36$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function $a743a54bae508f36$var$isRTL(element) {
    return (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).direction === "rtl";
}
const $a743a54bae508f36$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $a743a54bae508f36$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $8da4680c6d092b5b$export$e495491855dc5418,
    getClippingRect: $a743a54bae508f36$var$getClippingRect,
    getOffsetParent: $a743a54bae508f36$var$getOffsetParent,
    getElementRects: $a743a54bae508f36$var$getElementRects,
    getClientRects: $a743a54bae508f36$var$getClientRects,
    getDimensions: $a743a54bae508f36$var$getDimensions,
    getScale: $a743a54bae508f36$var$getScale,
    isElement: $8da4680c6d092b5b$export$45a5e7f76e0caa8d,
    isRTL: $a743a54bae508f36$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $a743a54bae508f36$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left , top: top , width: width , height: height  } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $168a40e325c04e1b$export$8960430cfd85939f)(0, (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $a743a54bae508f36$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true , ancestorResize: ancestorResize = true , elementResize: elementResize = typeof ResizeObserver === "function" , layoutShift: layoutShift = typeof IntersectionObserver === "function" , animationFrame: animationFrame = false  } = options;
    const referenceEl = $a743a54bae508f36$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $8da4680c6d092b5b$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $8da4680c6d092b5b$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $a743a54bae508f36$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $a743a54bae508f36$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $a743a54bae508f36$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $a743a54bae508f36$export$91fb6ecbd551914 = (0, $3261e7eea2c2a215$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $a743a54bae508f36$export$fba63a578e423eb = (0, $3261e7eea2c2a215$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $a743a54bae508f36$export$8a83211c878a3f1f = (0, $3261e7eea2c2a215$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $a743a54bae508f36$export$346677f925de839c = (0, $3261e7eea2c2a215$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $a743a54bae508f36$export$fe8985bb6374093c = (0, $3261e7eea2c2a215$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a743a54bae508f36$export$f2120bbfa5450bd2 = (0, $3261e7eea2c2a215$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $a743a54bae508f36$export$18c8ad048e32c7d5 = (0, $3261e7eea2c2a215$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $a743a54bae508f36$export$7bf07e38f3dc4b69 = (0, $3261e7eea2c2a215$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $a743a54bae508f36$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $a743a54bae508f36$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $3261e7eea2c2a215$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $bh6RR = parcelRequire("bh6RR");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f5cc9f295c20d98f$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element , padding: padding  } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $a743a54bae508f36$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $a743a54bae508f36$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $f5cc9f295c20d98f$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f5cc9f295c20d98f$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f5cc9f295c20d98f$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$f5cc9f295c20d98f$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // biome-ignore lint/suspicious/noSelfCompare: in source
    return a !== a && b !== b;
}
function $f5cc9f295c20d98f$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $f5cc9f295c20d98f$var$roundByDPR(element, value) {
    const dpr = $f5cc9f295c20d98f$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $f5cc9f295c20d98f$var$useLatestRef(value) {
    const ref = $bh6RR.useRef(value);
    $f5cc9f295c20d98f$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $f5cc9f295c20d98f$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform , elements: { reference: externalReference , floating: externalFloating  } = {} , transform: transform = true , whileElementsMounted: whileElementsMounted , open: open  } = options;
    const [data, setData] = $bh6RR.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $bh6RR.useState(middleware);
    if (!$f5cc9f295c20d98f$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $bh6RR.useState(null);
    const [_floating, _setFloating] = $bh6RR.useState(null);
    const setReference = $bh6RR.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $bh6RR.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $bh6RR.useRef(null);
    const floatingRef = $bh6RR.useRef(null);
    const dataRef = $bh6RR.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $f5cc9f295c20d98f$var$useLatestRef(whileElementsMounted);
    const platformRef = $f5cc9f295c20d98f$var$useLatestRef(platform);
    const update = $bh6RR.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $a743a54bae508f36$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$f5cc9f295c20d98f$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $47cfd4084854a574$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $f5cc9f295c20d98f$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $bh6RR.useRef(false);
    $f5cc9f295c20d98f$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
    $f5cc9f295c20d98f$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $bh6RR.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $bh6RR.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $bh6RR.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $f5cc9f295c20d98f$var$roundByDPR(elements.floating, data.x);
        const y = $f5cc9f295c20d98f$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$f5cc9f295c20d98f$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $bh6RR.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $cf31848c29c0e34a$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $cf31848c29c0e34a$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $bh6RR.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($cf31848c29c0e34a$export$21b07c8f274aebd5, {
    displayName: $cf31848c29c0e34a$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $cf31848c29c0e34a$export$be92b6f5f03c0fe9 = $cf31848c29c0e34a$export$21b07c8f274aebd5;








var $bh6RR = parcelRequire("bh6RR");

function $a4c035a635c3c71b$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $bh6RR.useState)(undefined);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $8c25544344d35f6c$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $8c25544344d35f6c$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$createPopperContext, $8c25544344d35f6c$export$722aac194ae923] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$PopperProvider, $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$createPopperContext($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $8c25544344d35f6c$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = (0, $bh6RR.useState)(null);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($8c25544344d35f6c$export$badac9ada3a0bdf9, {
    displayName: $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $8c25544344d35f6c$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$usePopperContext($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($8c25544344d35f6c$export$ecd4e1ccab6ed6d, {
    displayName: $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$useContentContext] = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$createPopperContext($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $8c25544344d35f6c$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper , side: side = "bottom" , sideOffset: sideOffset = 0 , align: align = "center" , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , avoidCollisions: avoidCollisions = true , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = "partial" , hideWhenDetached: hideWhenDetached = false , updatePositionStrategy: updatePositionStrategy = "optimized" , onPlaced: onPlaced , ...contentProps } = props;
    const context = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$usePopperContext($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $bh6RR.useState)(null);
    const arrowSize = (0, $a4c035a635c3c71b$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = (0, $f5cc9f295c20d98f$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $a743a54bae508f36$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $3261e7eea2c2a215$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $a743a54bae508f36$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $a743a54bae508f36$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $a743a54bae508f36$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $a743a54bae508f36$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $f5cc9f295c20d98f$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $a743a54bae508f36$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPlaced);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($8c25544344d35f6c$export$bc4ae5855d3c4fc, {
    displayName: $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $8c25544344d35f6c$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$useContentContext($8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $bh6RR.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $cf31848c29c0e34a$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($8c25544344d35f6c$export$79d62cd4e10a3fd0, {
    displayName: $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $8c25544344d35f6c$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $8c25544344d35f6c$export$be92b6f5f03c0fe9 = $8c25544344d35f6c$export$badac9ada3a0bdf9;
const $8c25544344d35f6c$export$b688253958b8dfe7 = $8c25544344d35f6c$export$ecd4e1ccab6ed6d;
const $8c25544344d35f6c$export$7c6e2c02157bb7d2 = $8c25544344d35f6c$export$bc4ae5855d3c4fc;
const $8c25544344d35f6c$export$21b07c8f274aebd5 = $8c25544344d35f6c$export$79d62cd4e10a3fd0;









var $bh6RR = parcelRequire("bh6RR");
function $50865d54cfb9b593$export$5cae361ad82dce8b(value) {
    const ref = (0, $bh6RR.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0, $bh6RR.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
/* -------------------------------------------------------------------------------------------------
 * Select
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME = "Select";
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createCollectionScope] = (0, $f40cb27330ac95c0$export$c74125a8e3af6bb2)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext, $b68f655bc0cea6a8$export$286727a75dc039bd] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME, [
    $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createCollectionScope,
    (0, $8c25544344d35f6c$export$722aac194ae923)
]);
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope = (0, $8c25544344d35f6c$export$722aac194ae923)();
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME);
const $b68f655bc0cea6a8$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange , dir: dir , name: name , autoComplete: autoComplete , disabled: disabled , required: required  } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = (0, $bh6RR.useState)(null);
    const [valueNode, setValueNode] = (0, $bh6RR.useState)(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = (0, $bh6RR.useState)(false);
    const direction = (0, $861a16ed03937ac2$export$b39126d51d94e6f3)(dir);
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = (0, $bh6RR.useRef)(null); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = (0, $bh6RR.useState)(new Set()); // The native `select` only associates the correct default value if the corresponding
    // `option` is rendered as a child **at the same time** as itself.
    // Because it might take a few renders for our items to gather the information to build
    // the native `option`(s), we generate a key on the `select` to make sure React re-builds it
    // each time the options change.
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8c25544344d35f6c$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectProvider, {
        required: required,
        scope: __scopeSelect,
        trigger: trigger,
        onTriggerChange: setTrigger,
        valueNode: valueNode,
        onValueNodeChange: setValueNode,
        valueNodeHasChildren: valueNodeHasChildren,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        open: open,
        onOpenChange: setOpen,
        dir: direction,
        triggerPointerDownPosRef: triggerPointerDownPosRef,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.Provider, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
        scope: props.__scopeSelect,
        onNativeOptionAdd: (0, $bh6RR.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>new Set(prev).add(option));
        }, []),
        onNativeOptionRemove: (0, $bh6RR.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>{
                const optionsSet = new Set(prev);
                optionsSet.delete(option);
                return optionsSet;
            });
        }, [])
    }, children)), isFormControl ? /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$BubbleSelect, {
        key: nativeSelectKey,
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        value: value // enable form autofill
        ,
        onChange: (event)=>setValue(event.target.value),
        disabled: disabled
    }, value === undefined ? /*#__PURE__*/ (0, $bh6RR.createElement)("option", {
        value: ""
    }) : null, Array.from(nativeOptionsSet)) : null));
};
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$ef9b1a59e592288f, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectTrigger
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$TRIGGER_NAME = "SelectTrigger";
const $b68f655bc0cea6a8$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , disabled: disabled = false , ...triggerProps } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== undefined) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true); // reset typeahead when we open
            resetTypeahead();
        }
    };
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8c25544344d35f6c$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "combobox",
        "aria-controls": context.contentId,
        "aria-expanded": context.open,
        "aria-required": context.required,
        "aria-autocomplete": "none",
        dir: context.dir,
        "data-state": context.open ? "open" : "closed",
        disabled: isDisabled,
        "data-disabled": isDisabled ? "" : undefined,
        "data-placeholder": $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? "" : undefined
    }, triggerProps, {
        ref: composedRefs // Enable compatibility with native label or custom `Label` "click" for Safari:
        ,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
            // Whilst browsers generally have no issue focusing the trigger when clicking
            // on a label, Safari seems to struggle with the fact that there's no `onClick`.
            // We force `focus` in this case. Note: this doesn't create any other side-effect
            // because we are preventing default in `onPointerDown` so effectively
            // this only runs for a label "click"
            event.currentTarget.focus();
        }),
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
            // prevent implicit pointer capture
            // https://www.w3.org/TR/pointerevents3/#implicit-pointer-capture
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (event.button === 0 && event.ctrlKey === false) {
                handleOpen();
                context.triggerPointerDownPosRef.current = {
                    x: Math.round(event.pageX),
                    y: Math.round(event.pageY)
                }; // prevent trigger from stealing focus from the active item after opening.
                event.preventDefault();
            }
        }),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
            const isTypingAhead = searchRef.current !== "";
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if (isTypingAhead && event.key === " ") return;
            if ($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
                handleOpen();
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$3ac1e88a1c0b9f1, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectValue
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VALUE_NAME = "SelectValue";
const $b68f655bc0cea6a8$export$e288731fd71264f0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect , className: className , style: style , children: children , placeholder: placeholder = "" , ...valueProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange  } = context;
    const hasChildren = children !== undefined;
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, valueProps, {
        ref: composedRefs // we don't want events from the portalled `SelectValue` children to bubble
        ,
        style: {
            pointerEvents: "none"
        }
    }), $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, placeholder) : children);
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$e288731fd71264f0, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VALUE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectIcon
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ICON_NAME = "SelectIcon";
const $b68f655bc0cea6a8$export$99b400cabb58c515 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , children: children , ...iconProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, iconProps, {
        ref: forwardedRef
    }), children || "▼");
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$99b400cabb58c515, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ICON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPortal
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$PORTAL_NAME = "SelectPortal";
const $b68f655bc0cea6a8$export$b2af6c9944296213 = (props)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, props));
};
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$b2af6c9944296213, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContent
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME = "SelectContent";
const $b68f655bc0cea6a8$export$c973a4b3cb86a03d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = (0, $bh6RR.useState)(); // setting the fragment in `useLayoutEffect` as `DocumentFragment` doesn't exist on the server
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? /*#__PURE__*/ (0, $47cfd4084854a574$exports.createPortal)(/*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentProvider, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.Slot, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $bh6RR.createElement)("div", null, props.children))), frag) : null;
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$c973a4b3cb86a03d, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContentImpl
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME);
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME = "SelectContentImpl";
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , position: position = "item-aligned" , onCloseAutoFocus: onCloseAutoFocus , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , side: // PopperContent props
    side , sideOffset: sideOffset , align: align , alignOffset: alignOffset , arrowPadding: arrowPadding , collisionBoundary: collisionBoundary , collisionPadding: collisionPadding , sticky: sticky , hideWhenDetached: hideWhenDetached , avoidCollisions: avoidCollisions , ...contentProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const [viewport, setViewport] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = (0, $bh6RR.useState)(null);
    const [selectedItemText, setSelectedItemText] = (0, $bh6RR.useState)(null);
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = (0, $bh6RR.useState)(false);
    const firstValidItemFoundRef = (0, $bh6RR.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $bh6RR.useEffect)(()=>{
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, [
        content
    ]); // Make sure the whole tree has focus guards as our `Select` may be
    // the last element in the DOM (because of the `Portal`)
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    const focusFirst = (0, $bh6RR.useCallback)((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 || candidate.scrollIntoView({
                block: "nearest"
            }); // viewport might have padding so scroll to its edges when focusing first/last items.
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 || candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = (0, $bh6RR.useCallback)(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]); // Since this is not dependent on layout, we want to ensure this runs at the same time as
    // other effects across components. Hence why we don't call `focusSelectedItem` inside `position`.
    (0, $bh6RR.useEffect)(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]); // prevent selecting items on `pointerup` in some cases after opening from `pointerdown`
    // and close on `pointerup` outside.
    const { onOpenChange: onOpenChange , triggerPointerDownPosRef: triggerPointerDownPosRef  } = context;
    (0, $bh6RR.useEffect)(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
                };
            };
            const handlePointerUp = (event)=>{
                // If the pointer hasn't moved by a certain threshold then we prevent selecting item on `pointerup`.
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = (0, $bh6RR.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = (0, $bh6RR.useCallback)(()=>content === null || content === void 0 ? void 0 : content.focus(), [
        content
    ]);
    const itemTextRefCallback = (0, $bh6RR.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition : $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition; // Silently ignore props that are not supported by `SelectItemAlignedPosition`
    const popperContentProps = SelectPosition === $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: (0, $18fd289ffa468154$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
        asChild: true // we make sure we're not trapping once it's been closed
        ,
        trapped: context.open,
        onMountAutoFocus: (event)=>{
            // we prevent open autofocus because we manually focus the selected item
            event.preventDefault();
        },
        onUnmountAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
            var _context$trigger;
            (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
                preventScroll: true
            });
            event.preventDefault();
        })
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: true,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside // When focus is trapped, a focusout event may still happen.
        ,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $bh6RR.createElement)(SelectPosition, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "listbox",
        id: context.contentId,
        "data-state": context.open ? "open" : "closed",
        dir: context.dir,
        onContextMenu: (event)=>event.preventDefault()
    }, contentProps, popperContentProps, {
        onPlaced: ()=>setIsPositioned(true),
        ref: composedRefs,
        style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...contentProps.style
        },
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey; // select should not be navigated using tab key so we prevent it
            if (event.key === "Tab") event.preventDefault();
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if ([
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
            ].includes(event.key)) {
                const items = getItems().filter((item)=>!item.disabled);
                let candidateNodes = items.map((item)=>item.ref.current);
                if ([
                    "ArrowUp",
                    "End"
                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                if ([
                    "ArrowUp",
                    "ArrowDown"
                ].includes(event.key)) {
                    const currentElement = event.target;
                    const currentIndex = candidateNodes.indexOf(currentElement);
                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>focusFirst(candidateNodes));
                event.preventDefault();
            }
        })
    }))))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentImpl, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemAlignedPosition
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , onPlaced: onPlaced , ...popperProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = (0, $bh6RR.useState)(null);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = (0, $bh6RR.useRef)(false);
    const shouldRepositionRef = (0, $bh6RR.useRef)(true);
    const { viewport: viewport , selectedItem: selectedItem , selectedItemText: selectedItemText , focusSelectedItem: focusSelectedItem  } = contentContext;
    const position = (0, $bh6RR.useCallback)(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect(); // -----------------------------------------------------------------------------------------
            //  Horizontal positioning
            // -----------------------------------------------------------------------------------------
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedLeft = (0, $7b5993acd6454a5e$export$7d15b64cf5a3a4c4)(left, [
                    $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedRight = (0, $7b5993acd6454a5e$export$7d15b64cf5a3a4c4)(right, [
                    $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            } // -----------------------------------------------------------------------------------------
            // Vertical positioning
            // -----------------------------------------------------------------------------------------
            const items = getItems();
            const availableHeight = window.innerHeight - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth; // prettier-ignore
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px"; // -----------------------------------------------------------------------------------------
            onPlaced === null || onPlaced === void 0 || onPlaced(); // we don't want the initial scroll position adjustment to trigger "expand on scroll"
            // so we explicitly turn it on only after they've registered.
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]); // copy z-index from content to wrapper
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]); // When the viewport becomes scrollable at the top, the scroll up button will mount.
    // Because it is part of the normal flow, it will push down the viewport, thus throwing our
    // trigger => selectedItem alignment off by the amount the viewport was pushed down.
    // We wait for this to happen and then re-run the positining logic one more time to account for it.
    const handleScrollButtonChange = (0, $bh6RR.useCallback)((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange
    }, /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: setContentWrapper,
        style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: contentZIndex
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperProps, {
        ref: composedRefs,
        style: {
            // When we get the height of the content, it includes borders. If we were to set
            // the height without having `boxSizing: 'border-box'` it would be too big.
            boxSizing: "border-box",
            // We need to ensure the content doesn't get taller than the wrapper
            maxHeight: "100%",
            ...popperProps.style
        }
    }))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPopperPosition
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME = "SelectPopperPosition";
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , align: align = "start" , collisionPadding: collisionPadding = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN , ...popperProps } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8c25544344d35f6c$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, popperProps, {
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectViewport
 * -----------------------------------------------------------------------------------------------*/ const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectViewportProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, {});
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME = "SelectViewport";
const $b68f655bc0cea6a8$export$9ed6e7b40248d36d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...viewportProps } = props;
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = (0, $bh6RR.useRef)(0);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, /*#__PURE__*/ (0, $bh6RR.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.Slot, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-radix-select-viewport": "",
        role: "presentation"
    }, viewportProps, {
        ref: composedRefs,
        style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...viewportProps.style
        },
        onScroll: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
            const viewport = event.currentTarget;
            const { contentWrapper: contentWrapper , shouldExpandOnScrollRef: shouldExpandOnScrollRef  } = viewportContext;
            if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
                const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                if (scrolledBy > 0) {
                    const availableHeight = window.innerHeight - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
                    const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                    const cssHeight = parseFloat(contentWrapper.style.height);
                    const prevHeight = Math.max(cssMinHeight, cssHeight);
                    if (prevHeight < availableHeight) {
                        const nextHeight = prevHeight + scrolledBy;
                        const clampedNextHeight = Math.min(availableHeight, nextHeight);
                        const heightDiff = nextHeight - clampedNextHeight;
                        contentWrapper.style.height = clampedNextHeight + "px";
                        if (contentWrapper.style.bottom === "0px") {
                            viewport.scrollTop = heightDiff > 0 ? heightDiff : 0; // ensure the content stays pinned to the bottom
                            contentWrapper.style.justifyContent = "flex-end";
                        }
                    }
                }
            }
            prevScrollTopRef.current = viewport.scrollTop;
        })
    }))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$9ed6e7b40248d36d, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectGroup
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$GROUP_NAME = "SelectGroup";
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectGroupContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$GROUP_NAME);
const $b68f655bc0cea6a8$export$ee25a334c55de1f4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...groupProps } = props;
    const groupId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "group",
        "aria-labelledby": groupId
    }, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$ee25a334c55de1f4, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectLabel
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$LABEL_NAME = "SelectLabel";
const $b68f655bc0cea6a8$export$f67338d29bd972f8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...labelProps } = props;
    const groupContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectGroupContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$LABEL_NAME, __scopeSelect);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: groupContext.id
    }, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$f67338d29bd972f8, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItem
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME = "SelectItem";
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemContextProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectItemContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME);
const $b68f655bc0cea6a8$export$13ef48a934230896 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , value: value , disabled: disabled = false , textValue: textValueProp , ...itemProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = (0, $bh6RR.useState)(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
    const [isFocused, setIsFocused] = (0, $bh6RR.useState)(false);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>{
        var _contentContext$itemR;
        return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled);
    });
    const textId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: (0, $bh6RR.useCallback)((node)=>{
            setTextValue((prevTextValue)=>{
                var _node$textContent;
                return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : "").trim();
            });
        }, [])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.ItemSlot, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textValue: textValue
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "option",
        "aria-labelledby": textId,
        "data-highlighted": isFocused ? "" : undefined // `isFocused` caveat fixes stuttering in VoiceOver
        ,
        "aria-selected": isSelected && isFocused,
        "data-state": isSelected ? "checked" : "unchecked",
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined,
        tabIndex: disabled ? undefined : -1
    }, itemProps, {
        ref: composedRefs,
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
        onPointerUp: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onPointerUp, handleSelect),
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
            if (disabled) {
                var _contentContext$onIte;
                (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
            } else // as it only means it might scroll a few pixels when using the pointer.
            event.currentTarget.focus({
                preventScroll: true
            });
        }),
        onPointerLeave: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
            if (event.currentTarget === document.activeElement) {
                var _contentContext$onIte2;
                (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
            }
        }),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
            var _contentContext$searc;
            const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== "";
            if (isTypingAhead && event.key === " ") return;
            if ($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect(); // prevent page scroll if using the space key to select an item
            if (event.key === " ") event.preventDefault();
        })
    }))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$13ef48a934230896, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemText
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME = "SelectItemText";
const $b68f655bc0cea6a8$export$3572fb0fb821ff49 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect , className: className , style: style , ...itemTextProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectItemContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>{
        var _contentContext$itemT;
        return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = (0, $bh6RR.useMemo)(()=>/*#__PURE__*/ (0, $bh6RR.createElement)("option", {
            key: itemContext.value,
            value: itemContext.value,
            disabled: itemContext.disabled
        }, textContent), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd , onNativeOptionRemove: onNativeOptionRemove  } = nativeOptionsContext;
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: itemContext.textId
    }, itemTextProps, {
        ref: composedRefs
    })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /*#__PURE__*/ (0, $47cfd4084854a574$exports.createPortal)(itemTextProps.children, context.valueNode) : null);
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$3572fb0fb821ff49, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
const $b68f655bc0cea6a8$export$6b9198de19accfe6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...itemIndicatorProps } = props;
    const itemContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectItemContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, itemIndicatorProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$6b9198de19accfe6, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollUpButton
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
const $b68f655bc0cea6a8$export$d8117927658af6d7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp1, setCanScrollUp] = (0, $bh6RR.useState)(false);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const canScrollUp = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp1 ? /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport , selectedItem: selectedItem  } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$d8117927658af6d7, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollDownButton
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
const $b68f655bc0cea6a8$export$ff951e476c12189 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown1, setCanScrollDown] = (0, $bh6RR.useState)(false);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight; // we use Math.ceil here because if the UI is zoomed-in
                // `scrollTop` is not always reported as an integer
                const canScrollDown = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown1 ? /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport , selectedItem: selectedItem  } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$ff951e476c12189, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME
});
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , onAutoScroll: onAutoScroll , ...scrollIndicatorProps } = props;
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = (0, $bh6RR.useRef)(null);
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = (0, $bh6RR.useCallback)(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]); // When the viewport becomes scrollable on either side, the relevant scroll button will mount.
    // Because it is part of the normal flow, it will push down (top button) or shrink (bottom button)
    // the viewport, potentially causing the active item to now be partially out of view.
    // We re-run the `scrollIntoView` logic to make sure it stays within the viewport.
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        var _activeItem$ref$curre;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, scrollIndicatorProps, {
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext$onIte3;
            (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SelectSeparator
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SEPARATOR_NAME = "SelectSeparator";
const $b68f655bc0cea6a8$export$eba4b1df07cb1d3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...separatorProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$eba4b1df07cb1d3, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectArrow
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME = "SelectArrow";
const $b68f655bc0cea6a8$export$314f4cb8f8099628 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...arrowProps } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8c25544344d35f6c$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$314f4cb8f8099628, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(value) {
    return value === "" || value === undefined;
}
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$BubbleSelect = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { value: value , ...selectProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(value); // Bubble value change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    /**
   * We purposefully use a `select` here to support form autofill as much
   * as possible.
   *
   * We purposefully do not add the `value` attribute here to allow the value
   * to be set programatically and bubble to any parent form `onChange` event.
   * Adding the `value` will cause React to consider the programatic
   * dispatch a duplicate and it will get swallowed.
   *
   * We use `VisuallyHidden` rather than `display: "none"` because Safari autofill
   * won't work otherwise.
   */ return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91436baa4104b247$export$439d29a4e110a164), {
        asChild: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)("select", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, selectProps, {
        ref: composedRefs,
        defaultValue: value
    })));
});
$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$BubbleSelect.displayName = "BubbleSelect";
function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = (0, $bh6RR.useRef)("");
    const timerRef = (0, $bh6RR.useRef)(0);
    const handleTypeaheadSearch = (0, $bh6RR.useCallback)((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current); // Reset `searchRef` 1 second after it was last updated
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1000);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = (0, $bh6RR.useCallback)(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in a list of items,
 * the search and the current item, and returns the next item (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through items starting with that character)
 *
 * We also reorder the items by wrapping the array around the current item.
 * This is so we always look forward from the current item, and picking the first
 * item will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current item from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current item still matches.
 */ function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : undefined;
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $b68f655bc0cea6a8$export$be92b6f5f03c0fe9 = $b68f655bc0cea6a8$export$ef9b1a59e592288f;
const $b68f655bc0cea6a8$export$41fb9f06171c75f4 = $b68f655bc0cea6a8$export$3ac1e88a1c0b9f1;
const $b68f655bc0cea6a8$export$4c8d1a57a761ef94 = $b68f655bc0cea6a8$export$e288731fd71264f0;
const $b68f655bc0cea6a8$export$f04a61298a47a40f = $b68f655bc0cea6a8$export$99b400cabb58c515;
const $b68f655bc0cea6a8$export$602eac185826482c = $b68f655bc0cea6a8$export$b2af6c9944296213;
const $b68f655bc0cea6a8$export$7c6e2c02157bb7d2 = $b68f655bc0cea6a8$export$c973a4b3cb86a03d;
const $b68f655bc0cea6a8$export$d5c6c08dc2d3ca7 = $b68f655bc0cea6a8$export$9ed6e7b40248d36d;
const $b68f655bc0cea6a8$export$eb2fcfdbd7ba97d4 = $b68f655bc0cea6a8$export$ee25a334c55de1f4;
const $b68f655bc0cea6a8$export$b04be29aa201d4f5 = $b68f655bc0cea6a8$export$f67338d29bd972f8;
const $b68f655bc0cea6a8$export$6d08773d2e66f8f2 = $b68f655bc0cea6a8$export$13ef48a934230896;
const $b68f655bc0cea6a8$export$d6e5bf9c43ea9319 = $b68f655bc0cea6a8$export$3572fb0fb821ff49;
const $b68f655bc0cea6a8$export$c3468e2714d175fa = $b68f655bc0cea6a8$export$6b9198de19accfe6;
const $b68f655bc0cea6a8$export$2f60d3ec9ad468f2 = $b68f655bc0cea6a8$export$d8117927658af6d7;
const $b68f655bc0cea6a8$export$bf1aedc3039c8d63 = $b68f655bc0cea6a8$export$ff951e476c12189;
const $b68f655bc0cea6a8$export$1ff3c3f08ae963c0 = $b68f655bc0cea6a8$export$eba4b1df07cb1d3;
const $b68f655bc0cea6a8$export$21b07c8f274aebd5 = $b68f655bc0cea6a8$export$314f4cb8f8099628;



const $6caf637fe83ce3f2$var$SequenceComboBox = ({ sequenceId: sequenceId  })=>{
    const { handleSelectSequence: handleSelectSequence , currentGSelection: currentGSelection , currentFSelection: currentFSelection  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const { userSequences: userSequences , userDefaultHiddenSequences: userDefaultHiddenSequences  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const currentSelection = sequenceId === "g" ? currentGSelection : currentFSelection;
    // const [value, setValue] = React.useState(initialValue);
    function handleSelectValue(selection) {
        // setValue(selection);
        console.log(`selection=${selection}`);
        handleSelectSequence(sequenceId, selection);
    }
    const userSequencesExist = userSequences.length > 0;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$be92b6f5f03c0fe9, {
        value: currentSelection,
        onValueChange: (selection)=>handleSelectValue(selection),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$41fb9f06171c75f4, {
                className: $3774fe84ff338282$export$3ac1e88a1c0b9f1,
                "aria-label": "Sequences",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$4c8d1a57a761ef94, {
                        placeholder: "Sequence…",
                        "aria-label": currentSelection,
                        children: (0, $fd5756bdc716f509$export$98a7a12ae94b641)[currentSelection]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$f04a61298a47a40f, {
                        className: $3774fe84ff338282$export$99b400cabb58c515,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$4857d3f3f5f8319b), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$7c6e2c02157bb7d2, {
                    className: $3774fe84ff338282$export$c973a4b3cb86a03d,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$2f60d3ec9ad468f2, {
                            className: $3774fe84ff338282$export$536bd91ba45f6b0a,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$7f01a6cbee61a0f2), {})
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$d5c6c08dc2d3ca7, {
                            className: $3774fe84ff338282$export$9ed6e7b40248d36d,
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$eb2fcfdbd7ba97d4, {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$b04be29aa201d4f5, {
                                            className: $3774fe84ff338282$export$f67338d29bd972f8,
                                            children: "Default Sequences"
                                        }, "grouplabel"),
                                        (0, $fd5756bdc716f509$export$98a7a12ae94b641).map((item)=>{
                                            if (userDefaultHiddenSequences && Array.isArray(userDefaultHiddenSequences) && userDefaultHiddenSequences.includes(item.id)) return null;
                                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6caf637fe83ce3f2$var$SelectItem, {
                                                value: item.id,
                                                children: item.name
                                            }, item.id);
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6caf637fe83ce3f2$var$SelectItem, {
                                            value: "custom",
                                            children: "Custom"
                                        })
                                    ]
                                }),
                                userSequencesExist && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$1ff3c3f08ae963c0, {
                                    className: "SelectSeparator"
                                }),
                                userSequencesExist && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$eb2fcfdbd7ba97d4, {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$b04be29aa201d4f5, {
                                            className: $3774fe84ff338282$export$f67338d29bd972f8,
                                            children: "Custom Sequences"
                                        }, "customlabel"),
                                        userSequences.map((item)=>{
                                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6caf637fe83ce3f2$var$SelectItem, {
                                                value: item.id,
                                                children: item.name
                                            }, item.id);
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$bf1aedc3039c8d63, {
                            className: $3774fe84ff338282$export$536bd91ba45f6b0a,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$4857d3f3f5f8319b), {})
                        })
                    ]
                })
            })
        ]
    });
};
const $6caf637fe83ce3f2$var$SelectItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ children: children , className: className , ...props }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$6d08773d2e66f8f2, {
        className: "SelectItem",
        ...props,
        ref: forwardedRef,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$d6e5bf9c43ea9319, {
                children: children
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$c3468e2714d175fa, {
                className: $3774fe84ff338282$export$6b9198de19accfe6,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$7dd004358974b05d), {})
            })
        ]
    });
});
var $6caf637fe83ce3f2$export$2e2bcd8739ae039 = $6caf637fe83ce3f2$var$SequenceComboBox;




function $e55a0891ad7a381f$var$SequenceControl({ sequenceId: sequenceId  }) {
    const { mode: mode  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($e55a0891ad7a381f$var$Wrapper, {
        $sequenceid: sequenceId,
        mode: mode,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                children: [
                    sequenceId,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e55a0891ad7a381f$var$SelectWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6caf637fe83ce3f2$export$2e2bcd8739ae039), {
                    sequenceId: sequenceId
                })
            })
        ]
    });
}
var $e55a0891ad7a381f$export$2e2bcd8739ae039 = $e55a0891ad7a381f$var$SequenceControl;
const $e55a0891ad7a381f$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  visibility: ${(p)=>p.$sequenceid === "f" && [
        "bell",
        "appell",
        "twobell"
    ].includes(p.mode) || p.$sequenceid === "g" && [
        "derivative",
        "associated"
    ].includes(p.mode) ? "hidden" : "revert"};
`;
const $e55a0891ad7a381f$var$SelectWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  min-width: 210px;
  display: relative;
  flex-direction: column;
  /* background-color: var(--select-td-background); */
  height: var(--number-box-height);
`;




function $f5c926b02c7d71dd$var$SequenceControlPanel() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($f5c926b02c7d71dd$var$Wrapper, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("table", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e55a0891ad7a381f$export$2e2bcd8739ae039), {
                        sequenceId: "g"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e55a0891ad7a381f$export$2e2bcd8739ae039), {
                        sequenceId: "f"
                    })
                ]
            })
        })
    });
}
var $f5c926b02c7d71dd$export$2e2bcd8739ae039 = $f5c926b02c7d71dd$var$SequenceControlPanel;
const $f5c926b02c7d71dd$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  color: var(--number-box-font-color);
  z-index: 1;
  transform: translateY(56px);
  /* margin-top: 0px; */
  font-family: 'Lato', sans-serif;
  border-right: var(--audio-player-border);
  width: var(--playlists-width);

  text-align: left;
  padding: none;
  padding-top: 5px;
`;







var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */ const $01b6592cc49933c5$export$f3b8df5418bf8d44 = (0, $bh6RR.createContext)(null);



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

function $44fe9b5a67d08fd8$export$80c2a3957bcb42ea() {
    const isMounted = (0, $bh6RR.useRef)(false);
    (0, $56377e0c81527360$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



function $9fa8237cfa1feaa5$export$91db9bc4f8ac944a() {
    const isMounted = (0, $44fe9b5a67d08fd8$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $bh6RR.useState)(0);
    const forceRender = (0, $bh6RR.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $bh6RR.useCallback)(()=>(0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}


const $ee05b06512be977f$var$notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function $ee05b06512be977f$export$df39f9da6f278ce7() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach($ee05b06512be977f$var$notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}


const $820ec76912211d3a$var$shouldInheritGroup = (inherit)=>inherit === true;
const $820ec76912211d3a$var$shouldInheritId = (inherit)=>$820ec76912211d3a$var$shouldInheritGroup(inherit === true) || inherit === "id";
const $820ec76912211d3a$export$7fe0cbe305f29bb4 = ({ children: children , id: id , inherit: inherit = true  })=>{
    const layoutGroupContext = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95));
    const deprecatedLayoutGroupContext = (0, $bh6RR.useContext)((0, $01b6592cc49933c5$export$f3b8df5418bf8d44));
    const [forceRender, key] = (0, $9fa8237cfa1feaa5$export$91db9bc4f8ac944a)();
    const context = (0, $bh6RR.useRef)(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if ($820ec76912211d3a$var$shouldInheritId(inherit) && upstreamId) id = id ? upstreamId + "-" + id : upstreamId;
        context.current = {
            id: id,
            group: $820ec76912211d3a$var$shouldInheritGroup(inherit) ? layoutGroupContext.group || (0, $ee05b06512be977f$export$df39f9da6f278ce7)() : (0, $ee05b06512be977f$export$df39f9da6f278ce7)()
        };
    }
    const memoizedContext = (0, $bh6RR.useMemo)(()=>({
            ...context.current,
            forceRender: forceRender
        }), [
        key
    ]);
    return (0, $d4dab640dcbe486c$exports.jsx)((0, $364741b44296b530$export$a3579ca508007a95).Provider, {
        value: memoizedContext,
        children: children
    });
};





var $bh6RR = parcelRequire("bh6RR");
const $41f8a5367d186866$export$240b20df485e8ed6 = [
    {
        id: "normal",
        name: "Normal"
    },
    {
        id: "bell",
        name: "Bell Subgroup"
    },
    {
        id: "derivative",
        name: "Derivative Subgroup"
    },
    {
        id: "appell",
        name: "Appell Subgroup"
    },
    {
        id: "associated",
        name: "Associated (Lagrange) Subgroup"
    },
    {
        id: "twobell",
        name: "2-Bell Subgroup"
    }
];



var $fa063c55d48575d7$export$c973a4b3cb86a03d;
var $fa063c55d48575d7$export$99b400cabb58c515;
var $fa063c55d48575d7$export$13ef48a934230896;
var $fa063c55d48575d7$export$6b9198de19accfe6;
var $fa063c55d48575d7$export$f67338d29bd972f8;
var $fa063c55d48575d7$export$536bd91ba45f6b0a;
var $fa063c55d48575d7$export$eba4b1df07cb1d3;
var $fa063c55d48575d7$export$3ac1e88a1c0b9f1;
var $fa063c55d48575d7$export$9ed6e7b40248d36d;
var $fa063c55d48575d7$export$c797be94f89059d8;
var $fa063c55d48575d7$export$496307dcaa6031c4;
$fa063c55d48575d7$export$c973a4b3cb86a03d = `IagbGq_SelectContent`;
$fa063c55d48575d7$export$99b400cabb58c515 = `IagbGq_SelectIcon`;
$fa063c55d48575d7$export$13ef48a934230896 = `IagbGq_SelectItem`;
$fa063c55d48575d7$export$6b9198de19accfe6 = `IagbGq_SelectItemIndicator`;
$fa063c55d48575d7$export$f67338d29bd972f8 = `IagbGq_SelectLabel`;
$fa063c55d48575d7$export$536bd91ba45f6b0a = `IagbGq_SelectScrollButton`;
$fa063c55d48575d7$export$eba4b1df07cb1d3 = `IagbGq_SelectSeparator`;
$fa063c55d48575d7$export$3ac1e88a1c0b9f1 = `IagbGq_SelectTrigger`;
$fa063c55d48575d7$export$9ed6e7b40248d36d = `IagbGq_SelectViewport`;
$fa063c55d48575d7$export$c797be94f89059d8 = `IagbGq_modeComboBox`;
$fa063c55d48575d7$export$496307dcaa6031c4 = `IagbGq_selectRoot`;




const $9d2eb9ae6fa932ec$var$ModeComboBox = ({ sequenceId: sequenceId  })=>{
    const { mode: mode , handleSelectMode: handleSelectMode , matrixId: matrixId  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(mode);
    function handleSelectValue(selection) {
        setValue(selection);
        handleSelectMode(selection);
    }
    if (matrixId && value !== mode) setValue(mode);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: $fa063c55d48575d7$export$c797be94f89059d8,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$be92b6f5f03c0fe9, {
            value: value,
            onValueChange: (selection)=>handleSelectValue(selection),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$41fb9f06171c75f4, {
                    className: $fa063c55d48575d7$export$3ac1e88a1c0b9f1,
                    "aria-label": "Modes",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$4c8d1a57a761ef94, {
                            placeholder: "Mode…",
                            "aria-label": value,
                            children: (0, $41f8a5367d186866$export$240b20df485e8ed6)[value]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$f04a61298a47a40f, {
                            className: $fa063c55d48575d7$export$99b400cabb58c515,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$4857d3f3f5f8319b), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$602eac185826482c, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$7c6e2c02157bb7d2, {
                        className: $fa063c55d48575d7$export$c973a4b3cb86a03d,
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$2f60d3ec9ad468f2, {
                                className: $fa063c55d48575d7$export$536bd91ba45f6b0a,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$7f01a6cbee61a0f2), {})
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$d5c6c08dc2d3ca7, {
                                className: $fa063c55d48575d7$export$9ed6e7b40248d36d,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$eb2fcfdbd7ba97d4, {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$b04be29aa201d4f5, {
                                            className: $fa063c55d48575d7$export$f67338d29bd972f8,
                                            children: "Modes"
                                        }, "grouplabel"),
                                        (0, $41f8a5367d186866$export$240b20df485e8ed6).map((item)=>{
                                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9d2eb9ae6fa932ec$var$SelectItem, {
                                                value: item.id,
                                                children: item.name
                                            }, item.id);
                                        })
                                    ]
                                }, "modes")
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$bf1aedc3039c8d63, {
                                className: $fa063c55d48575d7$export$536bd91ba45f6b0a,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$4857d3f3f5f8319b), {})
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $9d2eb9ae6fa932ec$var$SelectItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ children: children , className: className , ...props }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$6d08773d2e66f8f2, {
        className: "SelectItem",
        ...props,
        ref: forwardedRef,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$d6e5bf9c43ea9319, {
                children: children
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$c3468e2714d175fa, {
                className: $fa063c55d48575d7$export$6b9198de19accfe6,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$7dd004358974b05d), {})
            })
        ]
    });
});
var $9d2eb9ae6fa932ec$export$2e2bcd8739ae039 = $9d2eb9ae6fa932ec$var$ModeComboBox;






var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $d186aca7082ed863$export$407448d2b89b1813 = function() {
    $d186aca7082ed863$export$407448d2b89b1813 = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d186aca7082ed863$export$407448d2b89b1813.apply(this, arguments);
};
function $d186aca7082ed863$export$71511d61b312f219(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $d186aca7082ed863$var$defaultProps = {
    color: "#38ad48",
    enabled: true,
    size: 50,
    style: {}
};
var $d186aca7082ed863$var$normalizeSize = function(size) {
    return parseFloat(size.toString()).toString() === size.toString() ? size + "px" : size.toString();
};
var $d186aca7082ed863$export$efccba1c4a2ef57b = function(Component) {
    var Wrapper = function(props) {
        var color = props.color, enabled = props.enabled, size = props.size, style = props.style, otherProps = $d186aca7082ed863$export$71511d61b312f219(props, [
            "color",
            "enabled",
            "size",
            "style"
        ]);
        var componentProps = $d186aca7082ed863$export$407448d2b89b1813($d186aca7082ed863$export$407448d2b89b1813({}, otherProps), {
            style: $d186aca7082ed863$export$407448d2b89b1813({
                color: color,
                overflow: "visible",
                width: $d186aca7082ed863$var$normalizeSize(size)
            }, style)
        });
        if (!enabled) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, $d186aca7082ed863$export$407448d2b89b1813({}, componentProps));
    };
    Wrapper.defaultProps = $d186aca7082ed863$var$defaultProps;
    return Wrapper;
};



var $bh6RR = parcelRequire("bh6RR");

var $211f0656e3112e1d$export$4368d992c4eafac0 = {
    speed: 100,
    still: false,
    thickness: 100
};
var $211f0656e3112e1d$export$407448d2b89b1813 = (0, $d186aca7082ed863$export$407448d2b89b1813)((0, $d186aca7082ed863$export$407448d2b89b1813)({}, $211f0656e3112e1d$export$4368d992c4eafac0), {
    secondaryColor: "rgba(0,0,0,0.44)"
});
function $211f0656e3112e1d$export$2408f22a0fab9ae5(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}


var $91bb32e82d504c85$var$css_248z = "@keyframes spinners-react-infinity{0%{stroke-dasharray:1,347;stroke-dashoffset:75}25%,75%{stroke-dasharray:17,330}50%{stroke-dasharray:1,347}to{stroke-dasharray:1,347;stroke-dashoffset:423}}";
(0, $211f0656e3112e1d$export$2408f22a0fab9ae5)($91bb32e82d504c85$var$css_248z);
var $91bb32e82d504c85$var$Component = function(_a) {
    var secondaryColor = _a.secondaryColor, speed = _a.speed, still = _a.still, thickness = _a.thickness, svgProps = (0, $d186aca7082ed863$export$71511d61b312f219)(_a, [
        "secondaryColor",
        "speed",
        "still",
        "thickness"
    ]);
    var strokeWidth = 7 * (thickness / 100);
    var dashStyle = !still ? {
        animation: "spinners-react-infinity " + 140 / speed + "s linear infinite"
    } : {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", (0, $d186aca7082ed863$export$407448d2b89b1813)({
        fill: "none",
        viewBox: "0 0 131 55"
    }, svgProps), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M46.57 45.5138C36.346 55.4954 19.8919 55.4954 9.66794 45.5138C-0.55598 35.5321 -0.55598 19.4678 9.66794 9.48624C19.8919 -0.495412 36.346 -0.495412 46.57 9.48624L84.4303 45.5138C94.6543 55.4954 111.108 55.4954 121.332 45.5138C131.556 35.5321 131.556 19.4678 121.332 9.48624C111.108 -0.495412 94.6543 -0.495412 84.4303 9.48624L46.57 45.5138Z",
        id: "spinners-react-infinity-path"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("use", {
        stroke: secondaryColor,
        strokeWidth: strokeWidth,
        xlinkHref: "#spinners-react-infinity-path"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("use", {
        fill: "none",
        stroke: "currentColor",
        strokeDasharray: "1, 347",
        strokeDashoffset: "75",
        strokeLinecap: "round",
        strokeWidth: strokeWidth,
        style: dashStyle,
        xlinkHref: "#spinners-react-infinity-path"
    }));
};
$91bb32e82d504c85$var$Component.defaultProps = (0, $211f0656e3112e1d$export$407448d2b89b1813);
var $91bb32e82d504c85$export$ca4c88ee8928471 = (0, $d186aca7082ed863$export$efccba1c4a2ef57b)($91bb32e82d504c85$var$Component);



var $b4f6584b377a4cce$exports = {};

$b4f6584b377a4cce$exports = new URL((parcelRequire("kyEFX")).resolve("6w0FO"), import.meta.url).toString();



function $101b5d80c0473474$var$SubmitButton() {
    const { handleCompute: handleCompute , computeWasRequested: computeWasRequested , matrixWasFetched: matrixWasFetched  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playSubmit] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($b4f6584b377a4cce$exports))), {
        volume: volume
    });
    const buttonContents = computeWasRequested && !matrixWasFetched ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91bb32e82d504c85$export$ca4c88ee8928471), {
        size: 40,
        thickness: 100,
        speed: 100,
        color: "var(--submit-button-border)",
        secondaryColor: "white"
    }) : "Compute";
    return(// <StyledSubmitButton onClick={handleCompute}>Compute</StyledSubmitButton>
    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($101b5d80c0473474$var$StyledSubmitButton, {
        onClick: ()=>{
            handleCompute();
            playSubmit();
        },
        children: buttonContents
    }));
}
var $101b5d80c0473474$export$2e2bcd8739ae039 = $101b5d80c0473474$var$SubmitButton;
const $101b5d80c0473474$var$StyledSubmitButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  z-index: 10000;
  margin-top: 55px;
  margin-left: 10px;
  width: 65px;
  /* width: fit-content; */
  height: 19px;
  border: 1px solid var(--submit-button-border);
  padding: 10px;
  border-radius: var(--number-box-border-radius);
  color: white;
  background-color: var(--submit-button-background);
  &:hover {
    background-image: revert;
    background-color: var(--hover-button-color);
    color: white;
  }
  &:active {
    background-color: var(--active-button-color);
    color: white;
  }
`;






var $bh6RR = parcelRequire("bh6RR");





const $9ae5a5ad10dcbca1$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  &:visited {
    --link-color: : var(--number-box-font-color);
  }
  display: block;
  max-width: 100%;
`;
const $9ae5a5ad10dcbca1$var$SearchSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9ae5a5ad10dcbca1$var$StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "var(--number-box-font-color)",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-search",
    children: [
        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
            cx: "11",
            cy: "11",
            r: "8"
        }),
        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "m21 21-4.3-4.3"
        })
    ]
});
function $9ae5a5ad10dcbca1$var$Matrix({ variant: variant  }) {
    const { matrix: matrix , matrixCreator: matrixCreator , metaMode: metaMode  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const { isAuthenticated: isAuthenticated , user: user , token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    if (!matrix) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    const parsedMatrix = JSON.parse(matrix);
    const matrices = {
        classic: {
            default: {
                id: "riordan group elem",
                title: "Riordan Group Element",
                leftMargin: "0"
            },
            inverse: {
                id: "riordan group inverse",
                title: "Riordan Group Inverse",
                leftMargin: "96px"
            },
            stieltjes: {
                id: "stieltjes",
                title: "Stieltjes/Projection Matrix",
                leftMargin: "96px"
            }
        },
        exponential: {
            default: {
                id: "exponential",
                title: "Exponential Riordan Group Element",
                leftMargin: "0"
            },
            inverse: {
                id: "riordan group inverse",
                title: "Riordan Group Inverse",
                leftMargin: "96px"
            },
            stieltjes: {
                id: "exponentialstieltjes",
                title: "Stieltjes/Projection Matrix",
                leftMargin: "96px"
            }
        }
    };
    let displayMatrix = parsedMatrix[matrices[metaMode][variant]["id"]];
    if (!displayMatrix) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    let matrixTitle = matrices[metaMode][variant]["title"];
    const leftMargin = matrices[metaMode][variant]["leftMargin"];
    const rowSums = displayMatrix.map((row)=>{
        return row.reduce(function(a, b) {
            return a + b;
        }, 0);
    });
    const alternatingRowSums = displayMatrix.map((row)=>{
        const newVector = new Array(row.length).fill(1);
        for(let idx in newVector)if (idx % 2 === 1) newVector[idx] = -1;
        const unreducedProduct = row.map((elem, idx)=>{
            return elem * newVector[idx];
        });
        return unreducedProduct.reduce(function(a, b) {
            return a + b;
        }, 0);
    });
    const rowSumsOEISQuery = rowSums.join("%2C");
    const alternatingRowSumsOEISQuery = alternatingRowSums.join("%2C");
    const userIsMatrixCreator = user === matrixCreator;
    let shareButton = userIsMatrixCreator ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$StyledShareButton, {
        children: "Share"
    }) : null;
    shareButton = null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9ae5a5ad10dcbca1$var$Wrapper, {
        $leftmargin: leftMargin,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: matrixTitle
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$MatrixTable, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                (0, $6531107febf5e71a$export$d02631cccf789723)(0, displayMatrix[0].length + 1).map((item, colIndex)=>{
                                    const searchEntries = displayMatrix.map((row)=>row[colIndex - 1]).slice(colIndex - 1);
                                    const searchQueryParam = searchEntries.join("%2C");
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$MatrixCell, {
                                        style: {
                                            paddingLeft: "15px"
                                        },
                                        $row: 0,
                                        $col: colIndex,
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
                                            message: "OEIS Column Lookup",
                                            side: "top",
                                            sideOffset: 5,
                                            arrowshiftX: "-10px",
                                            arrowshiftY: "0",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: `https://oeis.org/search?q=${searchQueryParam}&language=english&go=Search`,
                                                children: colIndex > 0 ? $9ae5a5ad10dcbca1$var$SearchSVG : ""
                                            })
                                        })
                                    }, `0,${colIndex}`);
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$MatrixCell, {
                                    style: {
                                        paddingLeft: "15px"
                                    },
                                    $row: 0,
                                    $col: displayMatrix[0].length,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
                                        message: "OEIS Row Sums Lookup",
                                        side: "top",
                                        sideOffset: 5,
                                        arrowshiftX: "-10px",
                                        arrowshiftY: "0",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                            target: "_blank",
                                            rel: "noreferrer",
                                            href: `https://oeis.org/search?q=${rowSumsOEISQuery}&language=english&go=Search`,
                                            children: $9ae5a5ad10dcbca1$var$SearchSVG
                                        })
                                    })
                                }, `0,${displayMatrix[0].length}`),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$MatrixCell, {
                                    style: {
                                        paddingLeft: "15px"
                                    },
                                    $row: 0,
                                    $col: displayMatrix[0].length + 1,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
                                        message: "OEIS Alternating Row Sums Lookup",
                                        side: "top",
                                        sideOffset: 5,
                                        arrowshiftX: "-10px",
                                        arrowshiftY: "0",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                            target: "_blank",
                                            rel: "noreferrer",
                                            href: `https://oeis.org/search?q=${alternatingRowSumsOEISQuery}&language=english&go=Search`,
                                            children: $9ae5a5ad10dcbca1$var$SearchSVG
                                        })
                                    })
                                }, `0,${displayMatrix[0].length + 1}`)
                            ]
                        }, "oeisrow"),
                        displayMatrix.map((row, rowIndex)=>{
                            const searchEntries = displayMatrix[rowIndex].slice(0, rowIndex + 1);
                            const searchQueryParam = searchEntries.join("%2C");
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$MatrixCell, {
                                        style: {
                                            paddingLeft: "15px"
                                        },
                                        $row: rowIndex,
                                        $col: 0,
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
                                            message: "OEIS Row Lookup",
                                            side: "left",
                                            sideOffset: 5,
                                            arrowshiftX: "0",
                                            arrowshiftY: "0",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: `https://oeis.org/search?q=${searchQueryParam}&language=english&go=Search`,
                                                children: $9ae5a5ad10dcbca1$var$SearchSVG
                                            })
                                        })
                                    }, `${rowIndex},0`),
                                    row.map((num, colIndex)=>{
                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$MatrixCell, {
                                            $row: rowIndex + 1,
                                            $col: colIndex + 1,
                                            children: num
                                        }, `${rowIndex},${colIndex + 1}`);
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$RowSumsMatrixCell, {
                                        children: rowSums[rowIndex]
                                    }, `${rowIndex},${displayMatrix[0].length + 1}`),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9ae5a5ad10dcbca1$var$AlternatingRowSumsMatrixCell, {
                                        children: alternatingRowSums[rowIndex]
                                    }, `${rowIndex},${displayMatrix[0].length + 2}`)
                                ]
                            }, `row${rowIndex}`);
                        })
                    ]
                }, "matrixbody")
            }),
            shareButton
        ]
    });
}
var $9ae5a5ad10dcbca1$export$2e2bcd8739ae039 = $9ae5a5ad10dcbca1$var$Matrix;
const $9ae5a5ad10dcbca1$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-top: 40px;
  margin-left: ${(p)=>p.$leftmargin};
`;
const $9ae5a5ad10dcbca1$var$MatrixTable = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  margin-left: 100px;
  margin-top: 20px;
  border-spacing: 0px;
  border-collapse: collapse;
`;
const $9ae5a5ad10dcbca1$var$MatrixRow = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr``;
const $9ae5a5ad10dcbca1$var$MatrixCell = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  border: 1px solid var(--number-box-border-color);
  min-width: 60px;
  height: 50px;
  text-align: center;
  background-color: ${(p)=>p.$col === 0 || p.$row === 0 ? "var(--select-td-background)" : p.$row > 0 && p.$col > p.$row ? "var(--matrix-cell-background-color)" : "black"};

  background-image: ${(p)=>p.$col === 0 || p.$row === 0 ? "revert" : p.$col > p.$row ? "var(--box-gradient)" : "revert"};
  color: ${(p)=>p.$row > 0 && p.$col > p.$row ? "var(--number-box-font-color)" : "white"};
`;
const $9ae5a5ad10dcbca1$var$RowSumsMatrixCell = (0, $e484c752f3f06549$export$2e2bcd8739ae039)($9ae5a5ad10dcbca1$var$MatrixCell)`
  background-color: var(--matrix-cell-row-sums-background-color);
  background-image: var(--row-sums-box-gradient);
  color: var(--rows-sums-font-color);
`;
const $9ae5a5ad10dcbca1$var$AlternatingRowSumsMatrixCell = (0, $e484c752f3f06549$export$2e2bcd8739ae039)($9ae5a5ad10dcbca1$var$MatrixCell)`
  background-color: var(--matrix-cell-alternating-row-sums-background-color);
  background-image: var(--alternating-row-sums-box-gradient);
  color: var(--alternating-rows-sums-font-color);
`;
const $9ae5a5ad10dcbca1$var$StyledShareButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  z-index: 10000;
  margin-top: 55px;
  margin-left: 10px;
  width: 65px;
  text-align: center;
  /* width: fit-content; */
  height: 19px;
  border: 1px solid var(--submit-button-border);
  padding: 10px;
  border-radius: var(--number-box-border-radius);
  color: white;
  background-color: var(--submit-button-background);
  &:hover {
    background-image: revert;
    background-color: var(--hover-button-color);
    color: white;
  }
  &:active {
    background-color: var(--active-button-color);
    color: white;
  }
`;







var $bh6RR = parcelRequire("bh6RR");









function $e7fe450f374d2cb2$var$WindowControls({ sequenceId: sequenceId  }) {
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playClick] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($7e0db40af334407c$exports))), {
        volume: volume
    });
    const { sequenceLength: sequenceLength , gSequence: gSequence , fSequence: fSequence , handleTruncateSequence: handleTruncateSequence , handleAugmentSequence: handleAugmentSequence  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const sequence = sequenceId === "g" ? gSequence : fSequence;
    function handleClick(action) {
        action();
        playClick();
    }
    const numElements = Math.min(sequenceLength, fSequence.length, gSequence.length);
    const elements = sequence.slice(0, numElements).map((num, index)=>{
        const leftArrow = index === numElements - 1 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
            message: "Hide Last Term",
            side: "top",
            sideOffset: 5,
            arrowshiftX: "0",
            arrowshiftY: "0",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e7fe450f374d2cb2$var$Bubble, {
                onClick: ()=>handleClick(handleTruncateSequence),
                $isleft: "true",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$20bc5960c3c9eebb), {
                    width: "18",
                    height: "18"
                })
            })
        }) : "";
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: leftArrow
        }, `window-${index}-${num}`);
    });
    const prependZeroElement = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        style: {
            zIndex: 0
        }
    }, `window-first`);
    const shorterSequenceLength = Math.min(fSequence.length, gSequence.length);
    const numAugmentBoxes = shorterSequenceLength - sequenceLength;
    const boxes = (0, $6531107febf5e71a$export$d02631cccf789723)(numAugmentBoxes).map((index)=>{
        const rightArrow = index === 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
            message: "Reveal Next Term",
            side: "top",
            sideOffset: 5,
            arrowshiftX: "0",
            arrowshiftY: "0",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e7fe450f374d2cb2$var$Bubble, {
                onClick: ()=>handleClick(handleAugmentSequence),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$b837bd7eac09a33e), {
                    width: "18",
                    height: "18"
                })
            })
        }) : "";
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: rightArrow
        }, `window-augment-${index}`);
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($e7fe450f374d2cb2$var$Wrapper, {
        children: [
            prependZeroElement,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47c18933f59b2062$export$2e2bcd8739ae039), {}),
            elements,
            boxes
        ]
    });
}
var $e7fe450f374d2cb2$export$2e2bcd8739ae039 = $e7fe450f374d2cb2$var$WindowControls;
const $e7fe450f374d2cb2$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  color: var(--number-box-font-color);
`;
const $e7fe450f374d2cb2$var$Bubble = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background-color: var(--number-box-background-color);
  border: 2px solid var(--action-box-border-color);
  &:hover {
    background-color: var(--bubble-hover-background-color);
    color: white;
    border: 2px solid var(--bubble-hover-border-color);
  }
  margin-left: ${(p)=>p.$isleft ? "auto" : "0"};
  margin-right: ${(p)=>!p.$isleft ? "auto" : "0"};
  border-radius: 15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
`;






var $bh6RR = parcelRequire("bh6RR");




const $1d27f879c0ca4e16$var$AUTH_ENDPOINT = "https://31mb8vbzh2.execute-api.us-east-1.amazonaws.com/dev/";
function $1d27f879c0ca4e16$var$MatrixHeader() {
    const { matrixCreator: matrixCreator , matrixId: matrixId , title: title , comment: comment , createdAt: createdAt , creatorName: creatorName  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const { user: user , token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const [localTitle, setLocalTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(title);
    const [titleIsEditable, setTitleIsEditable] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [localComment, setLocalComment] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(comment);
    const [commentIsEditable, setCommentIsEditable] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [editWasRequested, setEditWasRequested] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [editWasCompleted, setEditWasCompleted] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    function handleRequest() {
        setEditWasRequested(true);
        setEditWasCompleted(false);
        setTitleIsEditable(false);
        setCommentIsEditable(false);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setLocalTitle(title);
    }, [
        title
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setLocalComment(comment);
    }, [
        comment
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        async function submitMatrixHeaderData(matrixIdentifier) {
            const URL = $1d27f879c0ca4e16$var$AUTH_ENDPOINT + `query?id=${matrixIdentifier}`;
            const HEADERS = {
                "Content-Type": "application/json",
                Authorization: token
            };
            const payload = {
                title: localTitle,
                comment: localComment
            };
            const request = new Request(URL, {
                method: "PUT",
                headers: HEADERS,
                timeout: 100000,
                body: JSON.stringify(payload)
            });
            const response = await fetch(request);
            const json = await response.json();
            return json;
        }
        if (editWasRequested && !editWasCompleted) {
            submitMatrixHeaderData(matrixId);
            setEditWasRequested(false);
            setEditWasCompleted(true);
        }
    }, [
        editWasRequested,
        editWasCompleted
    ]);
    if (!matrixId) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    const userIsMatrixCreator = user === matrixCreator;
    let titleHeader = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    const miniEditIcon = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($1d27f879c0ca4e16$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-square-pen",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M7.5 1.875H3.125a1.25 1.25 0 0 0-1.25 1.25v8.75a1.25 1.25 0 0 0 1.25 1.25h8.75a1.25 1.25 0 0 0 1.25-1.25v-4.375"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M11.4844 1.64062a1.32812 1.32812 0 1 1 1.875 1.875L7.5 9.375l-2.5 0.625 0.625-2.5Z"
            })
        ]
    });
    const editIcon = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($1d27f879c0ca4e16$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-square-pen",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z"
            })
        ]
    });
    if (userIsMatrixCreator) titleHeader = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            handleRequest();
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$TitleInput, {
            id: "title-field",
            value: localTitle,
            placeholder: "Give Your Matrix A Title!",
            onChange: (event)=>{
                setLocalTitle(event.target.value);
            },
            onBlur: (event)=>{
                handleRequest();
            }
        })
    });
    if (title !== "" && !titleIsEditable) titleHeader = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$TitleBox, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$StyledH1, {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                onClick: ()=>setTitleIsEditable(true),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$TitleSpan, {
                        children: userIsMatrixCreator ? editIcon : null
                    }),
                    userIsMatrixCreator ? " " : null,
                    localTitle
                ]
            })
        })
    });
    let commentHeader = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    if (userIsMatrixCreator) commentHeader = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            handleRequest();
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$CommentInput, {
            id: "comment-field",
            value: localComment,
            placeholder: "Add A Comment!",
            onChange: (event)=>{
                setLocalComment(event.target.value);
            },
            onBlur: (event)=>{
                handleRequest();
            }
        })
    });
    if (localComment !== "" && !commentIsEditable) commentHeader = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$CommentBox, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            onClick: ()=>setCommentIsEditable(true),
            children: [
                userIsMatrixCreator ? miniEditIcon : null,
                userIsMatrixCreator ? " " : null,
                localComment
            ]
        })
    });
    let attributionBox = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    if (creatorName && matrixCreator && createdAt) attributionBox = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($1d27f879c0ca4e16$var$AttributionBox, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$AttributionP, {
                children: `${creatorName} <${matrixCreator}>`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1d27f879c0ca4e16$var$AttributionP, {
                children: `${(0, $6531107febf5e71a$export$3ae94a2503e890a1)(createdAt)}`
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            titleHeader,
            commentHeader,
            attributionBox
        ]
    });
}
var $1d27f879c0ca4e16$export$2e2bcd8739ae039 = $1d27f879c0ca4e16$var$MatrixHeader;
const $1d27f879c0ca4e16$var$TitleSpan = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  cursor: pointer;
`;
const $1d27f879c0ca4e16$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  transform: translateY(2px);
`;
const $1d27f879c0ca4e16$var$TitleInput = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input`
  background-color: var(--matrix-header-field);
  padding: 12px;
  border: solid 1px var(--number-box-border-color);
  border-radius: 2px;
  min-width: 500px;
  display: inline;
  margin-bottom: 10px;
  font-size: 2rem;
`;
const $1d27f879c0ca4e16$var$TitleBox = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background-color: var(--matrix-header-field);
  padding: 12px;
  border: solid 1px var(--number-box-border-color);
  border-radius: 2px;
  min-width: 500px;
  margin-bottom: 10px;
  display: inline;
`;
const $1d27f879c0ca4e16$var$CommentInput = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input`
  background-color: var(--matrix-header-field);
  padding: 12px;
  border: solid 1px var(--number-box-border-color);
  border-radius: 2px;
  min-width: 500px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
`;
const $1d27f879c0ca4e16$var$CommentBox = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background-color: var(--matrix-header-field);
  padding: 12px;
  border: solid 1px var(--number-box-border-color);
  border-radius: 2px;
  min-width: 500px;
  max-width: 500px;
  margin-bottom: 10px;
`;
const $1d27f879c0ca4e16$var$AttributionBox = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  text-align: center;
  background-color: white;
  padding: 12px;
  border: solid 1px var(--number-box-border-color);
  border-radius: 10px;
`;
const $1d27f879c0ca4e16$var$StyledH1 = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h1`
  text-align: left;
`;
const $1d27f879c0ca4e16$var$AttributionP = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  cursor: default;
`;






var $bh6RR = parcelRequire("bh6RR");


function $b41e83e33df9b814$var$StatsDisplay() {
    const { stats: stats  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    if (!stats) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b41e83e33df9b814$var$Wrapper, {
        children: "Loading stats..."
    });
    const overallTotal = stats.overall;
    let statsString = `${overallTotal} matrices computed!`;
    if (stats.individual) statsString = `${overallTotal} matrices computed, ${stats.individual} by you!`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b41e83e33df9b814$var$Wrapper, {
        children: statsString
    });
}
var $b41e83e33df9b814$export$2e2bcd8739ae039 = $b41e83e33df9b814$var$StatsDisplay;
const $b41e83e33df9b814$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  z-index: 1000;
  width: 100%;
  background-image: linear-gradient(
    var(--background-gradient-top),
    var(--background-gradient-bottom)
  );
  text-align: center;
  font-family: 'Lato', sans-serif !important;
  font-size: 12px;
  border: 1px solid #aaa;
  padding: 2px;
`;






var $bh6RR = parcelRequire("bh6RR");






const $2bd0d9db8cc4915c$var$DEFAULT_URL = "riordancalculator.com";
const $2bd0d9db8cc4915c$var$AUTH_ENDPOINT = "https://31mb8vbzh2.execute-api.us-east-1.amazonaws.com/dev/";
function $2bd0d9db8cc4915c$var$ShareDialog() {
    const { isAuthenticated: isAuthenticated , token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const { matrix: matrix , shareMatrixId: shareMatrixId  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [linkIsCopied, setLinkIsCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [recipientEmail, setRecipientEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const dialogTitle = isAuthenticated ? "Copy Link or Send Email:" : "Copy Link";
    if (!matrix) return;
    const sendEmail = async (shareMatrixId)=>{
        const URL = $2bd0d9db8cc4915c$var$AUTH_ENDPOINT + `email?id=${shareMatrixId}&recipient=${recipientEmail}`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        setRecipientEmail("");
        const request = new Request(URL, {
            method: "GET",
            headers: HEADERS,
            timeout: 100000
        });
        const response = await fetch(request);
        const json = await response.json();
    };
    function handleClick(event) {
        const link = `${$2bd0d9db8cc4915c$var$DEFAULT_URL}/?${shareMatrixId}`;
        navigator.clipboard.writeText(link).then(()=>{
            setLinkIsCopied(true);
            setTimeout(()=>setLinkIsCopied(false), 2000);
        }).catch((err)=>{
            console.error("Failed to copy link: ", err);
        });
    }
    function handleSendEmail() {}
    const clipboardSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($2bd0d9db8cc4915c$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-clipboard-copy",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M21 14H11"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "m15 10-4 4 4 4"
            })
        ]
    });
    const linkText = !linkIsCopied ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            clipboardSVG,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: `${$2bd0d9db8cc4915c$var$DEFAULT_URL}/?${shareMatrixId}`
            })
        ]
    }) : "Link Copied to Clipboard!";
    const sendMailSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($2bd0d9db8cc4915c$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-send-horizontal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "m3 3 3 9-3 9 19-9Z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M6 12h16"
            })
        ]
    });
    const copyLinkOption = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
        className: "DialogFieldset",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "DialogLabel",
                htmlFor: "copylink",
                children: "Copy Link:"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: handleClick,
                className: "DialogParagraph",
                id: "copylink",
                children: linkText
            })
        ]
    });
    const emailOption = isAuthenticated ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("fieldset", {
        className: "DialogFieldset",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "DialogLabel",
                htmlFor: "email",
                children: "Recipient Email:"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                className: "DialogInput",
                id: "email",
                placeholder: "recipient@university.edu",
                value: recipientEmail,
                onChange: (event)=>setRecipientEmail(event.target.value)
            })
        ]
    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$be92b6f5f03c0fe9, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "DialogTrigger",
                    children: "Share"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$c6fdb837b070b4ff, {
                        className: "DialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$7c6e2c02157bb7d2, {
                        className: "DialogContent",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f99233281efd08a0, {
                                className: "DialogTitle",
                                children: dialogTitle
                            }),
                            copyLinkOption,
                            emailOption,
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    marginTop: 25,
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "DialogButton blue",
                                        onClick: ()=>sendEmail(shareMatrixId),
                                        children: sendMailSVG
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f39c2d165cd861fe, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "DialogIconButton",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$b7fa469a3cb3cd4f), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $2bd0d9db8cc4915c$export$2e2bcd8739ae039 = $2bd0d9db8cc4915c$var$ShareDialog;
const $2bd0d9db8cc4915c$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  cursor: pointer;
`;






var $bh6RR = parcelRequire("bh6RR");




function $1fb9bfaff3cf0814$var$StarSequence({ variant: variant  }) {
    const { matrix: matrix , metaMode: metaMode  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    if (!matrix) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    const parsedMatrix = JSON.parse(matrix);
    const sequence = parsedMatrix[`${variant} seq`];
    const title = `${variant.toUpperCase()}-sequence: `;
    const searchQueryParam = sequence.join("%2C");
    const displayOptions = {
        classic: {
            a: {
                display: true
            },
            b: {
                display: false
            },
            z: {
                display: true
            }
        },
        exponential: {
            a: {
                display: false
            },
            b: {
                display: false
            },
            z: {
                display: false
            }
        }
    };
    if (!displayOptions[metaMode][variant]["display"]) return;
    const elements = sequence.map((num, index)=>{
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$Wrapper, {
                    value: num,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$InnerContainer, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$InnerElement, {
                            children: num
                        })
                    })
                }, `star-${index}`)
            }, `star-${index}`)
        }, `star-${index}`);
    });
    const lookupElem = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$LookupWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$LookupInnerContainer, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
                        message: "OEIS Lookup",
                        side: "top",
                        sideOffset: 5,
                        arrowshiftX: "0",
                        arrowshiftY: "0",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: `https://oeis.org/search?q=${searchQueryParam}&language=english&go=Search`,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$LookupInnerElement, {
                                children: $1fb9bfaff3cf0814$var$SearchSVG
                            })
                        })
                    })
                })
            }, `star-lookup`)
        }, `star-lookup`)
    }, `star-lookup`);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$OuterOuterWrapper, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($1fb9bfaff3cf0814$var$OuterWrapper, {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($1fb9bfaff3cf0814$var$StyledH2, {
                    children: title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47c18933f59b2062$export$2e2bcd8739ae039), {}),
                lookupElem,
                elements
            ]
        })
    });
}
var $1fb9bfaff3cf0814$export$2e2bcd8739ae039 = $1fb9bfaff3cf0814$var$StarSequence;
const $1fb9bfaff3cf0814$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  &:visited {
    --link-color: : var(--number-box-font-color);
  }
  max-width: 100%;
`;
// const SearchSVG = (
//   <StyledSVG
//     xmlns='http://www.w3.org/2000/svg'
//     width='12'
//     height='12'
//     viewBox='0 0 12 12'
//     fill='none'
//     stroke='var(--number-box-font-color)'
//     strokeWidth='1.5'
//     strokeLinecap='round'
//     strokeLinejoin='round'
//     className='lucide lucide-search'
//   >
//     <circle cx='5.5' cy='5.5' r='4' />
//     <path d='m10.5 10.5-2.15-2.15' />
//   </StyledSVG>
// );
const $1fb9bfaff3cf0814$var$SearchSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($1fb9bfaff3cf0814$var$StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "var(--number-box-font-color)",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-search",
    children: [
        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
            cx: "7.2",
            cy: "7.2",
            r: "5.33"
        }),
        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "m14 14-2.85-2.85"
        })
    ]
});
const $1fb9bfaff3cf0814$var$StyledH2 = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h2`
  display: inline;
`;
const $1fb9bfaff3cf0814$var$OuterOuterWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-top: 30px;
  margin-left: 195px;
`;
const $1fb9bfaff3cf0814$var$OuterWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  margin-top: 10px;
  min-width: fit-content;
  /* padding-top: 10px; */
  /* padding-top: 100px; */
  color: var(--star-sequence-font-color);
`;
const $1fb9bfaff3cf0814$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: default;
  background-color: var(--number-box-background-color);
  border-radius: var(--number-box-border-radius);
  width: fit-content;
  min-width: var(--number-box-width);
  width: 100%;
  height: var(--number-box-height);
  margin: 1px;
  border: 1px solid var(--number-box-border-color);
  z-index: 1;
  /* padding: 10%; */
`;
const $1fb9bfaff3cf0814$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--number-box-font-color);
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $1fb9bfaff3cf0814$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
`;
const $1fb9bfaff3cf0814$var$LookupWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: default;
  background-color: var(--number-box-background-color);
  border-radius: var(--number-box-border-radius);
  width: fit-content;
  min-width: var(--number-box-width);
  width: 100%;
  height: var(--number-box-height);
  margin: 1px;
  border: 1px solid var(--number-box-border-color);
  z-index: 1;
  &:hover {
    background-color: var(--number-box-hover-background-color);
  }
  /* padding: 10%; */
`;
const $1fb9bfaff3cf0814$var$LookupInnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--number-box-font-color);
  width: fit-content;
  height: 100%;
  width: 100%;
  &:hover {
    color: var(--number-box-hover-font-color);
  }
`;
const $1fb9bfaff3cf0814$var$LookupInnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
`;





function $94e9b21e988f527f$var$Home() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexColumnWrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddb89bb066eb98c1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$HeaderDiv, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {
                    isHome: true
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$LeftDiv, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9d2eb9ae6fa932ec$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d27f879c0ca4e16$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bd0d9db8cc4915c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexRowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f5c926b02c7d71dd$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $820ec76912211d3a$export$7fe0cbe305f29bb4), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$TableWrapper, {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e7fe450f374d2cb2$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6204eef74ceda398$export$2e2bcd8739ae039), {
                                        sequenceId: "g"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6204eef74ceda398$export$2e2bcd8739ae039), {
                                        sequenceId: "f"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexRowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$LeftDiv, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $101b5d80c0473474$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$CenterDiv, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9ae5a5ad10dcbca1$export$2e2bcd8739ae039), {
                            variant: "default"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexRowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$LeftDiv, {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$CenterDiv, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9ae5a5ad10dcbca1$export$2e2bcd8739ae039), {
                            variant: "inverse"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexRowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$LeftDiv, {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$CenterDiv, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9ae5a5ad10dcbca1$export$2e2bcd8739ae039), {
                            variant: "stieltjes"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexRowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$LeftDiv, {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$CenterDiv, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1fb9bfaff3cf0814$export$2e2bcd8739ae039), {
                            variant: "a"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexRowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$LeftDiv, {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$CenterDiv, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1fb9bfaff3cf0814$export$2e2bcd8739ae039), {
                            variant: "b"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($94e9b21e988f527f$var$FlexRowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$LeftDiv, {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($94e9b21e988f527f$var$CenterDiv, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1fb9bfaff3cf0814$export$2e2bcd8739ae039), {
                            variant: "z"
                        })
                    })
                ]
            })
        ]
    });
}
var $94e9b21e988f527f$export$2e2bcd8739ae039 = $94e9b21e988f527f$var$Home;
const $94e9b21e988f527f$var$BottomSpace = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  height: 100px;
`;
const $94e9b21e988f527f$var$HeaderDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  align-self: flex-start;
  padding-left: 300px;
`;
const $94e9b21e988f527f$var$LeftDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  align-self: flex-start;
`;
const $94e9b21e988f527f$var$CenterDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  align-self: flex-start;
`;
const $94e9b21e988f527f$var$FlexColumnWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding-left: 35px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  /* background-color: hsl(240, 40%, 90%); */
  margin-left: 0px;
`;
const $94e9b21e988f527f$var$FlexRowWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-self: flex-start;
`;
const $94e9b21e988f527f$var$TableWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  margin-left: 10px;
  padding-top: 13px;
`;





parcelRequire("bh6RR");



function $6da03bd460616bd2$var$About() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($6da03bd460616bd2$var$FlexColumnWrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddb89bb066eb98c1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6da03bd460616bd2$var$HeaderDiv, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6da03bd460616bd2$var$VerticalSpace, {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($6da03bd460616bd2$var$P, {
                children: [
                    "The Riordan Calculator was created by",
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://jamesshapiro.com",
                        children: "James Shapiro"
                    }),
                    " in consultation with his father, Riordan expert",
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://en.wikipedia.org/wiki/Louis_Shapiro_(mathematician)",
                        children: "Louis Shapiro"
                    }),
                    ". It was signficantly upgraded in 2024 and is free to use. If this website helps you discover new results, I would appreciate if you mention it somewhere in your paper so that others can take advantage of the calculator. However, this is purely optional."
                ]
            })
        ]
    });
}
var $6da03bd460616bd2$export$2e2bcd8739ae039 = $6da03bd460616bd2$var$About;
const $6da03bd460616bd2$var$VerticalSpace = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  min-height: 150px;
`;
const $6da03bd460616bd2$var$P = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  a {
    text-decoration: none;
    color: blue;
  }
  max-width: 600px;
`;
const $6da03bd460616bd2$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-left: 10px;
  margin-top: 10px;
  z-index: 10;
`;
const $6da03bd460616bd2$var$HeaderDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  align-self: flex-start;
  padding-left: 300px;
`;
const $6da03bd460616bd2$var$FlexColumnWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding-left: 35px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  /* background-color: hsl(240, 40%, 90%); */
  margin-left: 0px;
`;






var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");






function $0d8aefb5b6472936$var$SequenceEditorNumberBox({ value: value , index: index , onSubmit: onSubmit , sequenceId: sequenceId , sequenceValue: sequenceValue , isFirst: isFirst , zIndex: zIndex , handleSequenceChange: handleSequenceChange  }) {
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [digits, setDigits] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(value);
    const [isSelected, setIsSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const divRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const [playWhoosh] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($10d37f55d23cc19a$exports))), {
        volume: volume
    });
    // const [playClick] = useSound(clickSound, { volume });
    const { targetBoxIndex: targetBoxIndex , setTargetBoxIndex: setTargetBoxIndex , handleSelectSequence: handleSelectSequence , tabWasPressed: tabWasPressed , setTabWasPressed: setTabWasPressed , handleTruncateSequence: handleTruncateSequence  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    function handleCloseOption() {
        if (isFirst) {
            handleSequenceChange(sequenceValue.slice(1));
            // handleLeftShift(sequenceId);
            playWhoosh();
        } else handleTruncateSequence();
        handleSelectSequence(sequenceId, "custom");
    }
    const [notMounting, setNotMounting] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setNotMounting(true);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (targetBoxIndex === index && buttonRef.current && notMounting && tabWasPressed) {
            buttonRef.current.click();
            setTabWasPressed(false);
        }
    }, [
        targetBoxIndex,
        index,
        notMounting,
        tabWasPressed
    ]);
    // setNumberBoxRefs((oldValue) => {
    //   return {
    //     index: buttonRef,
    //     ...oldValue,
    //   };
    // });
    const bodyStyles = getComputedStyle(document.body);
    const boxLength = bodyStyles.getPropertyValue("--number-box-width").replace("px", "");
    const minfontsize = "0.8rem";
    const maxfontsize = "1.1rem";
    const containerWidthPx = parseInt(boxLength);
    const maxWidthPerCharacter = containerWidthPx * 1.4 / digits.toString().length;
    const rootFontSizePx = 16;
    const maxfontsizeRem = `${maxWidthPerCharacter / rootFontSizePx}rem`;
    function handleClick(event) {
        if (!divRef.current) return;
        // Set some of the click area off-limits for the close bubble
        const { offsetWidth: width , offsetHeight: height  } = divRef.current;
        const rect = divRef.current.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        if (x > width / 8 && y < height / 8) return; // Ignore the click
        setIsSelected(true);
        setTargetBoxIndex(index);
        setNotMounting(true);
    }
    function handleBlur() {
        setIsSelected(false);
        onSubmit(index, digits);
        handleSelectSequence(sequenceId, "custom");
    }
    function handleKeyPress(value) {
        let cleaned = value.replace(/[^0-9]/g, "");
        if (value.startsWith("0") && value.length > 1) cleaned = value.slice(1);
        setDigits(cleaned);
    }
    const handleFocus = (event)=>{
        event.target.select();
    };
    const inputNumberBox = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            setIsSelected(false);
            onSubmit(index, digits);
            handleSelectSequence(sequenceId, "custom");
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8aefb5b6472936$var$StyledInput, {
            value: digits,
            $minfontsize: minfontsize,
            fontSize: maxfontsizeRem,
            $maxfontsize: maxfontsize,
            onChange: (event)=>handleKeyPress(event.target.value),
            onBlur: handleBlur,
            onFocus: handleFocus,
            autoFocus: true
        })
    });
    const boxContents = isSelected ? inputNumberBox : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8aefb5b6472936$var$InnerElement, {
        $minfontsize: minfontsize,
        fontSize: maxfontsizeRem,
        $maxfontsize: maxfontsize,
        ref: buttonRef,
        children: digits
    });
    const closeBubble = isFirst ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
        message: "Delete First Term",
        side: "top",
        sideOffset: 5,
        arrowshiftX: "0",
        arrowshiftY: "0",
        zidx: zIndex,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8aefb5b6472936$var$CloseBubble, {
            onClick: handleCloseOption,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 15 15",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                className: "lucide lucide-x",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M11.25 3.75 L3.75 11.25"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "m3.75 3.75 7.5 7.5"
                    })
                ]
            })
        })
    }) : null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8aefb5b6472936$var$Wrapper, {
        ref: divRef,
        onClick: (event)=>handleClick(event),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0d8aefb5b6472936$var$InnerContainer, {
            children: [
                closeBubble,
                boxContents
            ]
        })
    });
}
var $0d8aefb5b6472936$export$2e2bcd8739ae039 = $0d8aefb5b6472936$var$SequenceEditorNumberBox;
const $0d8aefb5b6472936$var$CloseBubble = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: absolute;
  background-color: var(--number-box-background-color);
  border: 2px dashed var(--action-box-border-color);
  &:hover {
    background-color: var(--bubble-hover-background-color);
    color: white;
    border: 2px dashed var(--bubble-hover-border-color);
  }
  border-radius: 15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  top: -20px;
  left: 37px;
  z-index: ${(p)=>p.zidx};

  display: flex;
  justify-content: center;
  align-items: center;
`;
const $0d8aefb5b6472936$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: 'text';
  background-color: var(--number-box-background-color);
  &:hover {
    background-color: var(--number-box-hover-background-color);
  }
  border-radius: var(--number-box-border-radius);
  width: fit-content;
  min-width: var(--number-box-width);
  width: 100%;
  height: var(--number-box-height);
  margin: 1px;
  border: 1px solid var(--number-box-border-color);
  z-index: 1;
  /* padding: 10%; */
`;
const $0d8aefb5b6472936$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--number-box-font-color);
  color: 'var(--number-box-font-color)';
  &:hover {
    color: 'var(--number-box-hover-font-color)';
  }
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $0d8aefb5b6472936$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
`;
const $0d8aefb5b6472936$var$StyledInput = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input`
  font-family: 'Lato', sans-serif;
  color: hsl(243, 85%, 40%);
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
  height: 100%;
  width: max(var(--number-box-width), var(--number-box-width));
  margin-left: 2px;
  text-align: center;

  line-height: normal;
  border: 1px solid var(--number-box-hover-font-color);
  background-color: white;
  box-sizing: border-box;
`;






var $bh6RR = parcelRequire("bh6RR");






function $35034af910f62c7c$var$SequenceEditorActionBox({ actionType: actionType , sequenceId: sequenceId , sequenceValue: sequenceValue , enabled: enabled  }) {
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playClick] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($7e0db40af334407c$exports))), {
        volume: volume
    });
    const { handleSelectSequence: handleSelectSequence , handleSequenceChange: handleSequenceChange  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const symbol = actionType === "prependZero" ? ">>" : "?";
    function handleClick() {
        if (actionType === "prependZero") // handleAddZero(sequenceId);
        handleSequenceChange(sequenceId, [
            0,
            ...sequenceValue
        ]);
        handleSelectSequence(sequenceId, "custom");
        playClick();
    }
    const onClickAction = enabled ? handleClick : null;
    let result = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($35034af910f62c7c$var$Wrapper, {
        $enabled: enabled,
        onClick: onClickAction,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($35034af910f62c7c$var$InnerContainer, {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($35034af910f62c7c$var$InnerContainer, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($35034af910f62c7c$var$InnerElement, {
                    children: symbol
                })
            })
        })
    });
    if (actionType === "prependZero") result = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
        message: "Prepend a Zero",
        side: "top",
        sideOffset: 5,
        arrowshiftX: "0",
        arrowshiftY: "0",
        children: result
    });
    if (!enabled && actionType === "prependZero") result = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    return result;
}
var $35034af910f62c7c$export$2e2bcd8739ae039 = $35034af910f62c7c$var$SequenceEditorActionBox;
const $35034af910f62c7c$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: ${(p)=>p.$enabled ? "pointer" : "default"};
  background-color: var(--number-box-background-color);
  &:hover {
    background-color: ${(p)=>p.$enabled ? "var(--number-box-hover-background-color)" : "var(--number-box-background-color)"};
    color: ${(p)=>p.$enabled ? "var(--number-box-hover-font-color)" : "var(--number-box-font-color)"};
  }
  border-radius: var(--number-box-border-radius);
  width: fit-content;
  min-width: var(--number-box-width);
  width: 100%;
  height: var(--number-box-height);
  margin: 1px;
  border: 2px dashed var(--number-box-border-color);
  z-index: 0;
  /* padding: 10%; */
`;
const $35034af910f62c7c$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--number-box-font-color);
  &:hover {
    color: var(--number-box-hover-font-color);
  }
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $35034af910f62c7c$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: 1rem;
`;








function $a2b1b7ace0f522a9$var$SequenceEditorSequence({ sequenceValues: sequenceValues , name: name , index: index = 0  }) {
    // const [sequence, setSequence] = React.useState([
    // 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    // ]);
    // const [sequenceLength, setSequenceLength] = React.useState(7);
    const { customSequence: customSequence , setCustomSequence: setCustomSequence , customSequenceLength: customSequenceLength  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    function handleNumberChange(index, newValue) {
        setCustomSequence((oldSequence)=>{
            const newSequence = [
                ...oldSequence
            ];
            newSequence[index] = parseInt(newValue);
            return newSequence;
        });
    }
    function handleSequenceChange(newSequence) {
        setCustomSequence(newSequence);
    }
    const elements = customSequence.slice(0, Math.min(customSequenceLength, customSequence.length)).map((num, index)=>{
        const isLast = index === customSequenceLength - 1;
        const isFirst = index === 0;
        const distanceToSequenceEnd = customSequence.length - 1 - index;
        const damping = isFirst ? 50 : Math.max(100 - 10 * index, 30);
        const seqZIndex = {
            zIndex: 10 + index,
            position: "relative"
        };
        const delta = 0;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ecb603c03d63940a$export$e25e478948902b8b).div, {
                layoutId: `${index}-${distanceToSequenceEnd}-to-last`,
                initial: true,
                animate: true,
                style: seqZIndex,
                // exit={{ opacity: 0, x: '300%' }}
                transition: {
                    type: "spring",
                    stiffness: 300,
                    // damping: 30 + 3 * index,
                    damping: damping
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0d8aefb5b6472936$export$2e2bcd8739ae039), {
                    value: num,
                    index: index + delta,
                    sequenceId: index,
                    sequenceValue: customSequence,
                    isFirst: isFirst,
                    isLast: isLast,
                    handleSequenceChange: handleSequenceChange,
                    onSubmit: handleNumberChange
                }, `${index + delta}-${num}`)
            }, `${index}-${distanceToSequenceEnd}-to-last`)
        }, `${index + delta}-${num}`);
    });
    const delta = 0;
    const prependZeroElement = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        style: {
            zIndex: 0
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ecb603c03d63940a$export$e25e478948902b8b).div, {
            layoutId: `seqed-${index}-prepend-box`,
            style: {
                zIndex: 0
            },
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 30
            },
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $35034af910f62c7c$export$2e2bcd8739ae039), {
                actionType: "prependZero",
                sequenceId: `seqed-${index}`,
                sequenceValue: customSequence,
                onSubmit: handleNumberChange,
                enabled: true
            }, `prependzero-${delta}`)
        }, `seqed-${index}-prepend-box`)
    }, `prependzero-${delta}`);
    const numAugmentBoxes = Math.max(customSequence.length - customSequenceLength, 0);
    const mysteryBoxes = (0, $6531107febf5e71a$export$d02631cccf789723)(numAugmentBoxes).map((index)=>{
        const distanceToSequenceEnd = customSequence.length - customSequenceLength - 1 - index;
        // const opacity = Math.max(1 - index * 0.25, 0.05);
        const opacity = Math.max(1.5 / (index + 1), 0.15);
        // const initOpacity = { opacity: Math.max(1 - (index - 1) * 0.25, 0.05) };
        // const endOpacity = { opacity: Math.max(1 - index * 0.25, 0.05) };
        const initOpacity = {
            opacity: Math.max(1.5 / (index + 1), 0.15)
        };
        const endOpacity = {
            opacity: Math.max(1.5 / (index + 1), 0.15)
        };
        const opacityTiming = {
            opacity: {
                duration: 0.7
            }
        };
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            style: {
                zIndex: 0,
                opacity: opacity
            },
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ecb603c03d63940a$export$e25e478948902b8b).div, {
                layoutId: `seqed-${index}-${distanceToSequenceEnd}-to-last`,
                style: {
                    zIndex: 0
                },
                initial: initOpacity,
                animate: endOpacity,
                transition: {
                    type: "spring",
                    stiffness: 600,
                    // damping: 15 + 5 * (sequenceLength + index),
                    damping: 45,
                    opacityTiming: opacityTiming
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $35034af910f62c7c$export$2e2bcd8739ae039), {
                    actionType: "augment",
                    sequenceId: `seqed-${index}`,
                    sequenceValue: sequenceValues
                }, `augment-${delta}`)
            }, `seqed-${index}-${distanceToSequenceEnd}-to-last`)
        }, `augment-${index}`);
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($a2b1b7ace0f522a9$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($a2b1b7ace0f522a9$var$SequenceTitle, {
                children: name
            }),
            prependZeroElement,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47c18933f59b2062$export$2e2bcd8739ae039), {}),
            elements,
            mysteryBoxes
        ]
    });
}
var $a2b1b7ace0f522a9$export$2e2bcd8739ae039 = $a2b1b7ace0f522a9$var$SequenceEditorSequence;
const $a2b1b7ace0f522a9$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  margin-top: 100px;
  color: var(--number-box-font-color);
`;
const $a2b1b7ace0f522a9$var$SequenceTitle = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  min-width: 160px;
`;











parcelRequire("bh6RR");

const $fe7c080c91dd702d$var$OPTIONS = [
    {
        id: "default",
        name: "Show/Hide Default Sequences"
    },
    {
        id: "add",
        name: "Add Custom Sequence"
    },
    {
        id: "custom",
        name: "Manage Custom Sequences"
    }
];
function $fe7c080c91dd702d$var$SequenceEditorSelectTable({ selectedOption: selectedOption , setSelectedOption: setSelectedOption  }) {
    function handleSelect(option) {
        setSelectedOption(option);
    }
    const check = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fe7c080c91dd702d$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-check",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M20 6 9 17l-5-5"
        })
    });
    function getRuntimesTable() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fe7c080c91dd702d$var$Table, {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fe7c080c91dd702d$var$TBody, {
                children: $fe7c080c91dd702d$var$OPTIONS.map((option)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($fe7c080c91dd702d$var$TR, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fe7c080c91dd702d$var$CheckTD, {
                                children: selectedOption === option.id ? check : null
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fe7c080c91dd702d$var$TD, {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fe7c080c91dd702d$var$Button, {
                                    id: option.id,
                                    onClick: ()=>handleSelect(option.id),
                                    children: option.name
                                })
                            })
                        ]
                    });
                })
            })
        });
    }
    const table = getRuntimesTable();
    return table;
}
var $fe7c080c91dd702d$export$2e2bcd8739ae039 = $fe7c080c91dd702d$var$SequenceEditorSelectTable;
const $fe7c080c91dd702d$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg``;
const $fe7c080c91dd702d$var$Table = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  margin-top: 10px;
  margin-left: 10px;
  padding: 20px;
  background-color: white;
  min-width: 300px;
  width: 100px;
  border-radius: 6px;
  border-collapse: collapse;
`;
const $fe7c080c91dd702d$var$TBody = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tbody`
  height: 100%;
  width: 100%;
`;
const $fe7c080c91dd702d$var$TR = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  height: 50px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  border-top: 1px solid var(--number-box-border-color);
  border-left: 1px solid var(--number-box-border-color);
  border-right: 1px solid var(--number-box-border-color);
  &:last-child {
    border-bottom: 1px solid var(--number-box-border-color);
  }
`;
const $fe7c080c91dd702d$var$CheckTD = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  height: 100%;
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $fe7c080c91dd702d$var$TD = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  height: 100%;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $fe7c080c91dd702d$var$Button = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  text-align: center;
  min-height: 100%;
  height: 100%;
  min-width: 100%;
`;






var $bh6RR = parcelRequire("bh6RR");









function $bc3872532bae7f7d$var$SequenceEditorWindowControls({}) {
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playClick] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($7e0db40af334407c$exports))), {
        volume: volume
    });
    const { customSequence: customSequence , customSequenceLength: customSequenceLength , setCustomSequenceLength: setCustomSequenceLength  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    function handleClick(action) {
        // action();
        playClick();
    }
    const numElements = Math.min(customSequenceLength + 1, customSequence.length);
    //const numElements = customSequence.length;
    const elements = customSequence.slice(0, numElements).map((num, index)=>{
        const leftArrow = index === numElements - 1 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
            message: "Hide Last Term",
            side: "top",
            sideOffset: 5,
            arrowshiftX: "0",
            arrowshiftY: "0",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bc3872532bae7f7d$var$Bubble, {
                onClick: ()=>{
                    setCustomSequenceLength((oldLength)=>oldLength - 1);
                    handleClick();
                },
                $isleft: "true",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$20bc5960c3c9eebb), {
                    width: "18",
                    height: "18"
                })
            })
        }) : "";
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: leftArrow
        }, `window-${index}-${num}`);
    });
    const prependZeroElement = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        style: {
            zIndex: 0
        }
    }, `window-first`);
    const shorterSequenceLength = customSequence.length;
    const numAugmentBoxes = shorterSequenceLength - customSequenceLength;
    const boxes = (0, $6531107febf5e71a$export$d02631cccf789723)(numAugmentBoxes).map((index)=>{
        const rightArrow = index === 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a91c365c46d765$export$2e2bcd8739ae039), {
            message: "Reveal Next Term",
            side: "top",
            sideOffset: 5,
            arrowshiftX: "0",
            arrowshiftY: "0",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bc3872532bae7f7d$var$Bubble, {
                onClick: ()=>{
                    setCustomSequenceLength((oldLength)=>oldLength + 1);
                    handleClick();
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$b837bd7eac09a33e), {
                    width: "18",
                    height: "18"
                })
            })
        }) : "";
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: rightArrow
        }, `window-augment-${index}`);
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($bc3872532bae7f7d$var$Wrapper, {
        children: [
            prependZeroElement,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47c18933f59b2062$export$2e2bcd8739ae039), {}),
            elements,
            boxes
        ]
    });
}
var $bc3872532bae7f7d$export$2e2bcd8739ae039 = $bc3872532bae7f7d$var$SequenceEditorWindowControls;
const $bc3872532bae7f7d$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr`
  color: var(--number-box-font-color);
`;
const $bc3872532bae7f7d$var$Bubble = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background-color: var(--number-box-background-color);
  border: 2px solid var(--action-box-border-color);
  &:hover {
    background-color: var(--bubble-hover-background-color);
    color: white;
    border: 2px solid var(--bubble-hover-border-color);
  }
  margin-left: ${(p)=>p.$isleft ? "auto" : "0"};
  margin-right: ${(p)=>!p.$isleft ? "auto" : "0"};
  border-radius: 15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
`;






var $bh6RR = parcelRequire("bh6RR");







function $4226fd213fac9c07$var$SequenceEditorSubmitButton() {
    const { customSequence: customSequence , customSequenceLength: customSequenceLength , addCustomSequence: addCustomSequence , customSequenceTitle: customSequenceTitle , setCustomSequenceTitle: setCustomSequenceTitle  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const { userSequences: userSequences , setUserSequences: setUserSequences  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const { volume: volume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $ab089d1227010d1f$export$8faa12814783780b));
    const [playSubmit] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($b4f6584b377a4cce$exports))), {
        volume: volume
    });
    const buttonContents = "Add Sequence";
    function handleAddSequence() {
        if (customSequenceTitle.length === 0) {
            window.alert("Sequence must have a title!");
            return;
        }
        const existingSequenceTitles = userSequences.map((sequence)=>sequence.name);
        if (existingSequenceTitles.includes(customSequenceTitle)) {
            window.alert("Sequence names must be unique. Choose a different title for your sequence!");
            return;
        }
        const prefixValues = customSequence.slice(0, customSequenceLength);
        addCustomSequence(prefixValues, customSequenceTitle);
        setUserSequences((oldValue)=>{
            return [
                ...oldValue,
                {
                    name: customSequenceTitle,
                    id: "dummy_id",
                    sequence: prefixValues
                }
            ];
        });
        setCustomSequenceTitle("");
        playSubmit();
        window.alert("sequence added successfully!");
    }
    return(// <StyledSubmitButton onClick={handleCompute}>Compute</StyledSubmitButton>
    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4226fd213fac9c07$var$StyledSubmitButton, {
        onClick: ()=>{
            handleAddSequence();
        },
        children: buttonContents
    }));
}
var $4226fd213fac9c07$export$2e2bcd8739ae039 = $4226fd213fac9c07$var$SequenceEditorSubmitButton;
const $4226fd213fac9c07$var$StyledSubmitButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  z-index: 10000;
  margin-top: 55px;
  min-width: 105px;
  width: fit-content;
  /* width: fit-content; */
  height: 19px;
  border: 1px solid var(--submit-button-border);
  padding: 10px;
  border-radius: var(--number-box-border-radius);
  color: white;
  background-color: var(--submit-button-background);
  &:hover {
    background-image: revert;
    background-color: var(--hover-button-color);
    color: white;
  }
  &:active {
    background-color: var(--active-button-color);
    color: white;
  }
`;






var $bh6RR = parcelRequire("bh6RR");





const $9ed10f9393c902ff$var$SequenceEditorConfirmDeleteSequenceDialog = ({ id: id  })=>{
    const { setIsAuthModalOpen: setIsAuthModalOpen , deleteSequence: deleteSequence , setUserSequences: setUserSequences  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const [dialogOpen, setDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    function handleDelete(id) {
        setUserSequences((oldValue)=>{
            return oldValue.filter((sequence)=>{
                return sequence.id !== id;
            });
        });
        deleteSequence(id);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    const garbageSVG24 = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9ed10f9393c902ff$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-trash-2",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M3 6h18"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("line", {
                x1: "10",
                x2: "10",
                y1: "11",
                y2: "17"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("line", {
                x1: "14",
                x2: "14",
                y1: "11",
                y2: "17"
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$be92b6f5f03c0fe9, {
        onOpenChange: ()=>{
            setDialogOpen((oldValue)=>{
                setIsAuthModalOpen(!oldValue);
                return !oldValue;
            });
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "Button violet",
                    children: garbageSVG24
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$c6fdb837b070b4ff, {
                        className: "DialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$7c6e2c02157bb7d2, {
                        className: "ConfirmDialogContent",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f99233281efd08a0, {
                                className: "ConfirmDialogTitle",
                                children: "WARNING: Deletes are permanent."
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    marginTop: 25,
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "Button red",
                                        onClick: ()=>handleDelete(id),
                                        children: "Delete"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f39c2d165cd861fe, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "ConfirmIconButton",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45e7c250d3003265$export$b7fa469a3cb3cd4f), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9ed10f9393c902ff$export$2e2bcd8739ae039 = $9ed10f9393c902ff$var$SequenceEditorConfirmDeleteSequenceDialog;
const $9ed10f9393c902ff$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  cursor: pointer;
`;




const $0c6f0832be47dd48$var$AUTH_ENDPOINT = "https://31mb8vbzh2.execute-api.us-east-1.amazonaws.com/dev/";
function $0c6f0832be47dd48$var$SequenceEditor() {
    const { userSequences: userSequences , userDefaultHiddenSequences: userDefaultHiddenSequences , setUserDefaultHiddenSequences: setUserDefaultHiddenSequences , token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $5a12233f233e4186$export$38ee920e59704589));
    const { customSequenceTitle: customSequenceTitle , setCustomSequenceTitle: setCustomSequenceTitle , setCustomSequence: setCustomSequence  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("default");
    const [oeisId, setOeisId] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const updateDefaults = async (sequenceId, displayOption)=>{
        const URL = $0c6f0832be47dd48$var$AUTH_ENDPOINT + `preset?sequence=${sequenceId}&display=${displayOption}`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const request = new Request(URL, {
            method: "PUT",
            headers: HEADERS,
            timeout: 100000
        });
        fetch(request);
    };
    const fetchOEIS = async (oeisId)=>{
        const URL = $0c6f0832be47dd48$var$AUTH_ENDPOINT + `oeis?oeis_id=A${oeisId}`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const request = new Request(URL, {
            method: "GET",
            headers: HEADERS,
            timeout: 100000
        });
        const response = await fetch(request);
        const json = await response.json();
        console.log(json.sequence);
        setCustomSequence(json.sequence.slice(0, 15));
        setCustomSequenceTitle((oldTitle)=>{
            return `${oldTitle}${oldTitle !== "" ? " " : ""}(A${oeisId})`;
        });
    };
    function getSequenceDisplay(sequenceTerms) {
        return [
            ...sequenceTerms,
            "..."
        ].map((term, index)=>{
            if (term.toString().length < 6) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$MiniNumberBoxWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$InnerContainer, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$InnerElement, {
                        children: term
                    })
                })
            }, `term-${index}`);
            else return null;
        });
    }
    const EyeOffSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0c6f0832be47dd48$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-eye-off",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M9.88 9.88a3 3 0 1 0 4.24 4.24"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    });
    const EyeOnSVG = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0c6f0832be47dd48$var$StyledSVG, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-eye",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
    const presetTable = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0c6f0832be47dd48$var$Table, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                            children: "Title"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                            children: "Sequence"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                            children: "Hide/Show"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                children: (0, $fd5756bdc716f509$export$98a7a12ae94b641).map((sequence, index)=>{
                    const sequenceName = sequence.name;
                    const sequenceId = sequence.id;
                    const sequenceSequence = sequence.sequence;
                    const displayTerms = getSequenceDisplay(sequenceSequence.slice(0, 15));
                    const hideIconPredicate = userDefaultHiddenSequences && Object.keys(userDefaultHiddenSequences).length > 0 && userDefaultHiddenSequences.includes(sequenceId);
                    const icon = hideIconPredicate ? EyeOffSVG : EyeOnSVG;
                    const hideShowOption = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$Preview, {
                        onClick: ()=>{
                            if (userDefaultHiddenSequences && Object.keys(userDefaultHiddenSequences).length > 0 && userDefaultHiddenSequences.includes(sequenceId)) {
                                updateDefaults(sequenceId, "true");
                                setUserDefaultHiddenSequences((oldValue)=>{
                                    const newValue = oldValue.filter((item)=>item !== sequenceId);
                                    return newValue;
                                });
                            } else {
                                updateDefaults(sequenceId, "false");
                                setUserDefaultHiddenSequences((oldValue)=>{
                                    console.log(`oldValue=${JSON.stringify(oldValue)}`);
                                    var newValue = [];
                                    if (oldValue && Object.keys(userDefaultHiddenSequences).length > 0) newValue = [
                                        ...oldValue
                                    ];
                                    newValue.push(sequenceId);
                                    return newValue;
                                });
                            }
                        },
                        children: icon
                    });
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                                children: sequenceName
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                                children: displayTerms
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                                children: sequence.id !== "catalan" && hideShowOption
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
    const customTable = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0c6f0832be47dd48$var$Table, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                            children: "Title"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                            children: "Sequence"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                            children: "Delete?"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                children: userSequences.map((sequence, index)=>{
                    const sequenceName = sequence.name;
                    const sequenceId = sequence.id;
                    const sequenceSequence = sequence.sequence;
                    const displayTerms = getSequenceDisplay(sequenceSequence.slice(0, 15));
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                                children: sequenceName
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                                children: displayTerms
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TDWrapper, {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9ed10f9393c902ff$export$2e2bcd8739ae039), {
                                    id: sequenceId
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
    const titleHeader = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TitleInput, {
            id: "title-field",
            value: customSequenceTitle,
            placeholder: "Give Your Sequence A Title!",
            onChange: (event)=>{
                setCustomSequenceTitle(event.target.value);
            }
        })
    });
    const oeisImport = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            if (oeisId.length !== 6) window.alert("OEIS ID must be exactly six digits long");
            fetchOEIS(oeisId);
            setOeisId("");
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$Aspan, {
                children: "A"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TitleInput, {
                id: "oeis-field",
                value: oeisId,
                placeholder: "123456 (Optional OEIS ID)",
                onChange: (event)=>{
                    if (event.target.value !== "" && !/^\d+$/.test(event.target.value)) return;
                    if (event.target.value.length > 6) return;
                    setOeisId(event.target.value);
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$StyledSubmitButton, {
                type: "submit",
                children: "Import"
            })
        ]
    });
    const customSequence = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$TableWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bc3872532bae7f7d$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2b1b7ace0f522a9$export$2e2bcd8739ae039), {})
                    ]
                })
            }),
            titleHeader,
            oeisImport,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4226fd213fac9c07$export$2e2bcd8739ae039), {})
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0c6f0832be47dd48$var$FlexColumnWrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddb89bb066eb98c1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$HeaderDiv, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0c6f0832be47dd48$var$VerticalSpace, {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe7c080c91dd702d$export$2e2bcd8739ae039), {
                selectedOption: selectedOption,
                setSelectedOption: setSelectedOption
            }),
            selectedOption === "default" && presetTable,
            selectedOption === "add" && customSequence,
            selectedOption === "custom" && customTable
        ]
    });
}
var $0c6f0832be47dd48$export$2e2bcd8739ae039 = $0c6f0832be47dd48$var$SequenceEditor;
const $0c6f0832be47dd48$var$Aspan = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-size: 36px;
`;
const $0c6f0832be47dd48$var$TitleInput = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input`
  background-color: var(--matrix-header-field);
  padding: 12px;
  border: solid 1px var(--number-box-border-color);
  border-radius: 2px;
  min-width: 500px;
  display: inline;
  margin-top: 50px;
  margin-bottom: 10px;
  font-size: 2rem;
`;
const $0c6f0832be47dd48$var$StyledSubmitButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  z-index: 10000;
  margin-top: 55px;
  margin-left: 10px;
  min-width: 50px;
  width: fit-content;
  /* width: fit-content; */
  height: 19px;
  border: 1px solid var(--submit-button-border);
  padding: 10px;
  border-radius: var(--number-box-border-radius);
  color: white;
  background-color: var(--submit-button-background);
  &:hover {
    background-image: revert;
    background-color: var(--hover-button-color);
    color: white;
  }
  &:active {
    background-color: var(--active-button-color);
    color: white;
  }
`;
const $0c6f0832be47dd48$var$TitleSpan = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  cursor: pointer;
`;
const $0c6f0832be47dd48$var$TitleBox = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background-color: var(--matrix-header-field);
  padding: 12px;
  border: solid 1px var(--number-box-border-color);
  border-radius: 2px;
  min-width: 500px;
  margin-bottom: 10px;
  display: inline;
`;
const $0c6f0832be47dd48$var$StyledHeader = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h1`
  text-align: left;
`;
const $0c6f0832be47dd48$var$TableWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  margin-left: 10px;
  padding-top: 13px;
`;
const $0c6f0832be47dd48$var$VerticalSpace = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  min-height: 50px;
`;
const $0c6f0832be47dd48$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-left: 10px;
  margin-top: 10px;
  z-index: 10;
`;
const $0c6f0832be47dd48$var$HeaderDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  align-self: flex-start;
  padding-left: 300px;
`;
const $0c6f0832be47dd48$var$FlexColumnWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding-left: 35px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  /* background-color: hsl(240, 40%, 90%); */
  margin-left: 0px;
`;
const $0c6f0832be47dd48$var$StyledSVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  cursor: pointer;
`;
const $0c6f0832be47dd48$var$Preview = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-left: 15px;
`;
const $0c6f0832be47dd48$var$Table = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  background-color: var(--user-history-cell-background);
  border-collapse: collapse;
  border: 1.5px solid var(--mini-number-box-border-color);
  width: fit-content;
  margin-top: 20px;
  margin-right: 30px;
  margin-bottom: 300px;
`;
const $0c6f0832be47dd48$var$TDWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  border: 1px solid var(--mini-number-box-border-color);
  padding: 8px;
`;
const $0c6f0832be47dd48$var$Permalink = (0, $e484c752f3f06549$export$2e2bcd8739ae039).a`
  text-decoration: none;
  padding-left: 20px;

  &:visited {
    color: blue;
    text-decoration: none;
  }
`;
const $0c6f0832be47dd48$var$MiniNumberBoxWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: inline-block;
  cursor: ${(p)=>p.disabled ? "default" : "text"};
  background-color: var(--mini-number-box-background-color);
  border-radius: var(--mini-number-box-border-radius);
  min-width: var(--mini-number-box-width);
  height: var(--mini-number-box-height);
  margin: 1px;
  border: 1px solid var(--mini-number-box-border-color);
  z-index: 1;
  /* padding: 10%; */
`;
const $0c6f0832be47dd48$var$InnerContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  color: var(--mini-number-box-font-color);
  color: var(--mini-number-box-font-color);
  width: fit-content;
  height: 100%;
  width: 100%;
`;
const $0c6f0832be47dd48$var$InnerElement = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  width: fit-content;
  font-size: clamp(
    ${(p)=>p.$minfontsize},
    ${(p)=>p.fontSize},
    ${(p)=>p.$maxfontsize}
  );
`;
const $0c6f0832be47dd48$var$MatrixTable = (0, $e484c752f3f06549$export$2e2bcd8739ae039).table`
  border-spacing: 0px;
  border-collapse: collapse;
`;
const $0c6f0832be47dd48$var$MatrixRow = (0, $e484c752f3f06549$export$2e2bcd8739ae039).tr``;
const $0c6f0832be47dd48$var$MatrixCell = (0, $e484c752f3f06549$export$2e2bcd8739ae039).td`
  border: 1px solid var(--number-box-border-color);
  min-width: 60px;
  height: 50px;
  text-align: center;
  background-color: ${(p)=>p.$col === 0 || p.$row === 0 ? "var(--select-td-background)" : p.$row > 0 && p.$col > p.$row ? "var(--matrix-cell-background-color)" : "black"};

  background-image: ${(p)=>p.$col === 0 || p.$row === 0 ? "revert" : p.$col > p.$row ? "var(--box-gradient)" : "revert"};
  color: ${(p)=>p.$row > 0 && p.$col > p.$row ? "var(--number-box-font-color)" : "white"};
`;





// import { withAuthenticator, Button, Heading } from '@aws-amplify/ui-react';
// import '@aws-amplify/ui-react/styles.css';
function $5c4c715ef872aa13$var$App() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a12233f233e4186$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7ead3b1a9a673b0a$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ab089d1227010d1f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $92e1a497b2510420$export$9ba4e89fdfa1fc54), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d3236c1ff5808711$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $13cf12438684a2af$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $425ef4756eb915c9$export$b5d5cf8927ab7262), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $425ef4756eb915c9$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/",
                                    component: (0, $94e9b21e988f527f$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $425ef4756eb915c9$export$e7b0ac011bb776c6), {
                                    path: "/about",
                                    component: (0, $6da03bd460616bd2$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $425ef4756eb915c9$export$e7b0ac011bb776c6), {
                                    path: "/sequences",
                                    component: (0, $0c6f0832be47dd48$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $425ef4756eb915c9$export$e7b0ac011bb776c6), {
                                    path: "/history",
                                    component: (0, $bee2c5aab3b83228$export$2e2bcd8739ae039)
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
var $5c4c715ef872aa13$export$2e2bcd8739ae039 = $5c4c715ef872aa13$var$App;






const $1f0dc3b9307be026$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.querySelector("#root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c4c715ef872aa13$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.578f358a.js.map
